import * as i0 from '@angular/core';
import { inject, Renderer2, ElementRef, ChangeDetectorRef, EventEmitter, Component, Input, Output, booleanAttribute, ChangeDetectionStrategy, ViewChild, InjectionToken, TemplateRef, HostBinding, ContentChildren, NgModule, Directive, Optional, Host, Inject, HostListener, Injectable, Self, ViewChildren, ViewEncapsulation, Pipe, HostAttributeToken, DestroyRef, APP_INITIALIZER, importProvidersFrom, makeEnvironmentProviders } from '@angular/core';
import { Collapse, Alert, Dropdown, CarouselBI, Modal, Notification, Popover, Tab, Tooltip, InputPassword, ProgressDonut, BackToTop, NavBarCollapsible, HeaderSticky, loadFonts } from 'bootstrap-italia';
import * as i1 from '@ngx-translate/core';
import { TranslateModule, TranslatePipe, TranslateLoader, TranslateService } from '@ngx-translate/core';
import * as i1$3 from '@angular/common';
import { NgTemplateOutlet, NgClass, DOCUMENT, AsyncPipe, LowerCasePipe, DatePipe, NgOptimizedImage, TitleCasePipe, JsonPipe, ViewportScroller } from '@angular/common';
import * as i1$4 from '@angular/router';
import { RouterLink, Router, NavigationEnd, Scroll, RouterLinkActive, RouterLinkWithHref } from '@angular/router';
import { startWith, Subject, filter, debounceTime, distinctUntilChanged, tap, switchMap, of, merge, map, Observable, take, forkJoin, BehaviorSubject, shareReplay, combineLatest, skip, AsyncSubject, withLatestFrom, delay, timer, takeWhile } from 'rxjs';
import { trigger, transition, style, animate } from '@angular/animations';
import * as i1$1 from '@angular/forms';
import { FormControl, Validators, ReactiveFormsModule, NgModel, FormControlName } from '@angular/forms';
import * as i1$2 from '@angular/platform-browser';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { provideHttpClient, HttpClient } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { map as map$1 } from 'rxjs/operators';
const _c0 = ["collapse"];
const _c1 = ["*"];
const _c2 = ["alertElement"];
const _c3 = [[["", "heading", ""]], "*"];
const _c4 = ["[heading]", "*"];
function ItAlertComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 3);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelement(2, "it-icon", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 1, "it.core.close-alert"));
  }
}
function ItAvatarGroupItemComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function ItAvatarGroupComponent_For_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ItAvatarGroupComponent_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtemplate(1, ItAvatarGroupComponent_For_2_ng_container_1_Template, 1, 0, "ng-container", 0);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const avatar_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", avatar_r1._implicitContent);
  }
}
function ItLinkComponent_Conditional_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ItLinkComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 3);
    i0.ɵɵtemplate(1, ItLinkComponent_Conditional_0_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const linkContent_r2 = i0.ɵɵreference(3);
    i0.ɵɵclassMap(ctx_r0.class);
    i0.ɵɵproperty("id", ctx_r0.id)("routerLink", ctx_r0.disabled ? null : ctx_r0.href);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", linkContent_r2);
  }
}
function ItLinkComponent_Conditional_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ItLinkComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 5);
    i0.ɵɵtemplate(1, ItLinkComponent_Conditional_1_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const linkContent_r2 = i0.ɵɵreference(3);
    i0.ɵɵclassMap(ctx_r0.class);
    i0.ɵɵproperty("id", ctx_r0.id);
    i0.ɵɵattribute("href", ctx_r0.disabled ? null : ctx_r0.href, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", linkContent_r2);
  }
}
function ItLinkComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function ItDropdownItemComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 0);
  }
}
function ItDropdownItemComponent_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "it-icon", 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("name", ctx_r0.iconName)("color", ctx_r0.isDark ? "light" : "primary")("svgClass", ctx_r0.iconPosition);
  }
}
function ItDropdownItemComponent_Conditional_2_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "it-icon", 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("name", ctx_r0.iconName)("color", ctx_r0.isDark ? "light" : "primary")("svgClass", ctx_r0.iconPosition);
  }
}
function ItDropdownItemComponent_Conditional_2_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 4);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "it.core.active"));
  }
}
function ItDropdownItemComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "it-link", 2);
    i0.ɵɵtemplate(1, ItDropdownItemComponent_Conditional_2_Conditional_1_Template, 1, 3, "it-icon", 3);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵprojection(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ItDropdownItemComponent_Conditional_2_Conditional_4_Template, 1, 3, "it-icon", 3)(5, ItDropdownItemComponent_Conditional_2_Conditional_5_Template, 3, 3, "span", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r0.linkClass);
    i0.ɵɵproperty("id", ctx_r0.id)("href", ctx_r0.href)("externalLink", ctx_r0.externalLink)("disabled", ctx_r0.disabled);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.iconName && ctx_r0.iconPosition === "left" ? 1 : -1);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r0.iconName && ctx_r0.iconPosition === "right" ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.active ? 5 : -1);
  }
}
const _c5 = ["dropdownButton"];
const _c6 = [[["", "listHeading", ""]], [["", "list", ""]], [["", "button", ""]]];
const _c7 = ["[listHeading]", "[list]", "[button]"];
function ItDropdownComponent_Conditional_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ItDropdownComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 8, 1);
    i0.ɵɵtemplate(2, ItDropdownComponent_Conditional_1_ng_container_2_Template, 1, 0, "ng-container", 9);
    i0.ɵɵelement(3, "it-icon", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const buttonContent_r2 = i0.ɵɵreference(10);
    i0.ɵɵclassMap(ctx_r0.buttonClass);
    i0.ɵɵproperty("id", ctx_r0.id);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", buttonContent_r2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("color", ctx_r0.color ? "light" : "primary");
  }
}
function ItDropdownComponent_Conditional_2_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ItDropdownComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 11, 1);
    i0.ɵɵtemplate(2, ItDropdownComponent_Conditional_2_ng_container_2_Template, 1, 0, "ng-container", 9);
    i0.ɵɵelement(3, "it-icon", 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const buttonContent_r2 = i0.ɵɵreference(10);
    i0.ɵɵclassProp("btn", ctx_r0.mode === "link")("btn-dropdown", ctx_r0.mode === "link")("nav-link", ctx_r0.mode === "nav");
    i0.ɵɵproperty("id", ctx_r0.id);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", buttonContent_r2);
  }
}
function ItDropdownComponent_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 2);
  }
}
function ItAvatarDropdownItemComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
const _c8 = [[["", "it-avatar-dropdown-toggle", ""]]];
const _c9 = ["[it-avatar-dropdown-toggle]"];
function ItAvatarDropdownComponent_For_4_Conditional_1_1_ng_template_0_Template(rf, ctx) {}
function ItAvatarDropdownComponent_For_4_Conditional_1_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ItAvatarDropdownComponent_For_4_Conditional_1_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function ItAvatarDropdownComponent_For_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 2);
    i0.ɵɵtemplate(1, ItAvatarDropdownComponent_For_4_Conditional_1_1_Template, 1, 0, null, 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("routerLink", item_r1.link);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", item_r1._implicitContent);
  }
}
function ItAvatarDropdownComponent_For_4_Conditional_2_1_ng_template_0_Template(rf, ctx) {}
function ItAvatarDropdownComponent_For_4_Conditional_2_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ItAvatarDropdownComponent_For_4_Conditional_2_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function ItAvatarDropdownComponent_For_4_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtemplate(1, ItAvatarDropdownComponent_For_4_Conditional_2_1_Template, 1, 0, null, 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", item_r1._implicitContent);
  }
}
function ItAvatarDropdownComponent_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtemplate(1, ItAvatarDropdownComponent_For_4_Conditional_1_Template, 2, 2, "a", 2)(2, ItAvatarDropdownComponent_For_4_Conditional_2_Template, 2, 1, "div", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵconditional(item_r1.link ? 1 : 2);
  }
}
const _c10 = ".link-list-wrapper[_ngcontent-%COMP%]{z-index:2;position:relative}a[_ngcontent-%COMP%]{cursor:pointer}[_nghost-%COMP%]     .dropdown-toggle{width:100%;height:100%}[_nghost-%COMP%]     .dropdown-toggle .icon{display:none}";
function ItProgressBarComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "span", 5);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 2, "it.core.progress"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r0.value, "% ");
  }
}
function ItProgressBarComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 6);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("progress-bar", ctx_r0.bgColor, "");
  }
}
function ItProgressBarComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 7);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("progress-bar", ctx_r0.bgColor, "");
    i0.ɵɵstyleProp("width", ctx_r0.value, "%");
    i0.ɵɵattribute("aria-valuenow", ctx_r0.value);
  }
}
const _c11 = ["itButton", "", "progress", ""];
function ItProgressButtonComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "it-progress-bar", 0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", ctx_r0.progressValue)("indeterminate", ctx_r0.isIndeterminate)("color", ctx_r0.progressColor);
  }
}
const _c12 = [[["", "bigText", ""]], "*"];
const _c13 = ["[bigText]", "*"];
function ItCalloutComponent_Conditional_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ItCalloutComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, ItCalloutComponent_Conditional_1_ng_container_1_Template, 1, 0, "ng-container", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const inner_r1 = i0.ɵɵreference(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", inner_r1);
  }
}
function ItCalloutComponent_Conditional_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ItCalloutComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ItCalloutComponent_Conditional_2_ng_container_0_Template, 1, 0, "ng-container", 2);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const inner_r1 = i0.ɵɵreference(4);
    i0.ɵɵproperty("ngTemplateOutlet", inner_r1);
  }
}
function ItCalloutComponent_ng_template_3_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.hiddenLabel);
  }
}
function ItCalloutComponent_ng_template_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelement(1, "it-icon", 5);
    i0.ɵɵtemplate(2, ItCalloutComponent_ng_template_3_Conditional_0_Conditional_2_Template, 2, 1, "span", 6);
    i0.ɵɵelementStart(3, "span", 7);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("labelWaria", ctx_r1.labelWaria)("name", ctx_r1.iconName);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.hiddenLabel ? 2 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.label);
  }
}
function ItCalloutComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ItCalloutComponent_ng_template_3_Conditional_0_Template, 5, 4, "div", 3);
    i0.ɵɵelementStart(1, "p", 4);
    i0.ɵɵprojection(2);
    i0.ɵɵelementEnd();
    i0.ɵɵprojection(3, 1);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r1.label ? 0 : -1);
  }
}
const _c14 = [[["", "beforeBody", ""]], "*"];
const _c15 = ["[beforeBody]", "*"];
function ItCardComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵprojection(2, 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate1("card-body ", ctx_r0.bodyClass, "");
  }
}
function ItCardComponent_Conditional_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ItCardComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, ItCardComponent_Conditional_2_ng_container_1_Template, 1, 0, "ng-container", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const cardContent_r2 = i0.ɵɵreference(1);
    i0.ɵɵclassMapInterpolate1("card ", ctx_r0.cardClass, "");
    i0.ɵɵclassProp("card-img", ctx_r0.hasImage)("card-teaser", ctx_r0.teaser)("no-after", ctx_r0.hasImage)("shadow", ctx_r0.shadow)("card-bg", ctx_r0.background)("card-big", ctx_r0.big)("border-bottom-card", ctx_r0.borderBottom)("rounded", ctx_r0.rounded);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", cardContent_r2);
  }
}
function ItCardComponent_Conditional_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ItCardComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a");
    i0.ɵɵtemplate(1, ItCardComponent_Conditional_3_ng_container_1_Template, 1, 0, "ng-container", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const cardContent_r2 = i0.ɵɵreference(1);
    i0.ɵɵclassMapInterpolate1("card special-card ", ctx_r0.cardClass, "");
    i0.ɵɵclassProp("card-img", ctx_r0.hasImage)("card-teaser", ctx_r0.teaser)("shadow", ctx_r0.shadow)("card-bg", ctx_r0.background)("card-big", ctx_r0.big)("no-after", ctx_r0.hasImage)("border-bottom-card", ctx_r0.borderBottom)("rounded", ctx_r0.rounded);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", cardContent_r2);
  }
}
function ItCarouselItemComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
const _c16 = ["carousel"];
function ItCarouselComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 4)(2, "h2");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.title);
  }
}
function ItCarouselComponent_Conditional_4_For_2_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ItCarouselComponent_Conditional_4_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 6)(1, "div", 7);
    i0.ɵɵtemplate(2, ItCarouselComponent_Conditional_4_For_2_ng_container_2_Template, 1, 0, "ng-container", 8);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r2 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("lined_slide", ctx_r0.lined);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", item_r2.htmlContent);
  }
}
function ItCarouselComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 3);
    i0.ɵɵrepeaterCreate(1, ItCarouselComponent_Conditional_4_For_2_Template, 3, 3, "li", 5, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r0.items);
  }
}
const _c17 = (a0, a1, a2, a3) => [a0, a1, a2, a3];
function ItChipComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 1);
    i0.ɵɵelement(1, "use");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵattribute("href", ctx_r0.iconHref)("href", ctx_r0.iconHref, null, "xlink");
  }
}
function ItChipComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelement(1, "img", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", ctx_r0.avatar, i0.ɵɵsanitizeUrl)("alt", ctx_r0.altAvatar);
  }
}
function ItChipComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 6);
    i0.ɵɵlistener("click", function ItChipComponent_Conditional_5_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.clickToClose());
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 7);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(3, "span", 8);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r0.disabled);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r0.iconCloseHref)("href", ctx_r0.iconCloseHref, null, "xlink");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(5, 5, "it.core.remove"), " ", ctx_r0.label, "");
  }
}
const _c18 = a0 => [a0, "show"];
function ItDimmerComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
    i0.ɵɵprojection(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("@fade", undefined)("ngClass", i0.ɵɵpureFunction1(2, _c18, ctx_r0.color));
  }
}
const _c19 = a0 => ({
  "single-button": a0
});
function ItListComponent_Conditional_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ItListComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "ul");
    i0.ɵɵtemplate(2, ItListComponent_Conditional_0_ng_container_2_Template, 1, 0, "ng-container", 3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const contentTpl_r2 = i0.ɵɵreference(3);
    i0.ɵɵclassMap(ctx_r0.linkList ? "link-list-wrapper" : "it-list-wrapper");
    i0.ɵɵclassProp("multiline", ctx_r0.multiline);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r0.linkList ? "link-list" : "it-list");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", contentTpl_r2);
  }
}
function ItListComponent_Conditional_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ItListComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 2);
    i0.ɵɵtemplate(1, ItListComponent_Conditional_1_ng_container_1_Template, 1, 0, "ng-container", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const contentTpl_r2 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", contentTpl_r2);
  }
}
function ItListComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
const _c20 = [[["", "icon", ""]], "*", [["", "action", ""]], [["", "metadata", ""]], [["", "multiple", ""]]];
const _c21 = ["[icon]", "*", "[action]", "[metadata]", "[multiple]"];
function ItListItemComponent_ng_template_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵelement(1, "img", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵattribute("src", ctx_r0.avatar, i0.ɵɵsanitizeUrl);
  }
}
function ItListItemComponent_ng_template_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelement(1, "img", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵattribute("src", ctx_r0.image, i0.ɵɵsanitizeUrl);
  }
}
function ItListItemComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, ItListItemComponent_ng_template_1_Conditional_2_Template, 2, 1, "div", 4)(3, ItListItemComponent_ng_template_1_Conditional_3_Template, 2, 1, "div", 5);
    i0.ɵɵelementStart(4, "div", 6);
    i0.ɵɵprojection(5, 1);
    i0.ɵɵprojection(6, 2);
    i0.ɵɵelementStart(7, "span", 7)(8, "span", 8);
    i0.ɵɵprojection(9, 3);
    i0.ɵɵelementEnd();
    i0.ɵɵprojection(10, 4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.avatar ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.image ? 3 : -1);
  }
}
function ItListItemComponent_Conditional_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ItListItemComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, ItListItemComponent_Conditional_3_ng_container_1_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const content_r2 = i0.ɵɵreference(2);
    i0.ɵɵclassMap(ctx_r0.itemClass);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", content_r2);
  }
}
function ItListItemComponent_Conditional_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ItListItemComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "it-link", 12);
    i0.ɵɵtemplate(1, ItListItemComponent_Conditional_4_ng_container_1_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const content_r2 = i0.ɵɵreference(2);
    i0.ɵɵclassMap(ctx_r0.itemClass);
    i0.ɵɵproperty("href", ctx_r0.href)("externalLink", !!ctx_r0.externalLink)("disabled", !!ctx_r0.disabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", content_r2);
  }
}
const _c22 = ["modalElement"];
const _c23 = [[["", "beforeTitle", ""]], [["", "modalTitle", ""]], [["", "description", ""]], "*", [["", "footer", ""]]];
const _c24 = ["[beforeTitle]", "[modalTitle]", "[description]", "*", "[footer]"];
function ItModalComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "button", 5);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 1, "it.core.close-modal"));
  }
}
const _forTrack0 = ($index, $item) => $item.id;
const _c25 = a0 => ({
  title: a0
});
function ItNotificationsComponent_For_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "it-icon", 3);
  }
  if (rf & 2) {
    const notification_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("name", notification_r1.icon);
  }
}
function ItNotificationsComponent_For_1_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const notification_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(notification_r1.message);
  }
}
function ItNotificationsComponent_For_1_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 5);
    i0.ɵɵlistener("click", function ItNotificationsComponent_For_1_Conditional_6_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const notification_r1 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.hideNotification(notification_r1.id));
    });
    i0.ɵɵelement(1, "it-icon", 6);
    i0.ɵɵelementStart(2, "span", 7);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const notification_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(4, 1, "it.core.close-notification", i0.ɵɵpureFunction1(4, _c25, notification_r1.title)));
  }
}
function ItNotificationsComponent_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "h2", 2);
    i0.ɵɵtemplate(2, ItNotificationsComponent_For_1_Conditional_2_Template, 1, 1, "it-icon", 3);
    i0.ɵɵelementContainerStart(3);
    i0.ɵɵtext(4);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, ItNotificationsComponent_For_1_Conditional_5_Template, 2, 1, "p")(6, ItNotificationsComponent_For_1_Conditional_6_Template, 5, 6, "button", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const notification_r1 = ctx.$implicit;
    i0.ɵɵclassMapInterpolate2("notification ", notification_r1.position, " ", notification_r1.type, "");
    i0.ɵɵclassProp("with-icon", !!notification_r1.icon)("dismissable", notification_r1.dismissible);
    i0.ɵɵproperty("id", notification_r1.id);
    i0.ɵɵattribute("aria-labelledby", notification_r1.id + "-title");
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", notification_r1.id + "-title");
    i0.ɵɵadvance();
    i0.ɵɵconditional(notification_r1.icon ? 2 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(notification_r1.title);
    i0.ɵɵadvance();
    i0.ɵɵconditional(notification_r1.message ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(notification_r1.dismissible ? 6 : -1);
  }
}
const _c26 = [[["", "prependText", ""]], [["", "append", ""]], [["", "appendText", ""]], [["", "error", ""]]];
const _c27 = ["[prependText]", "[append]", "[appendText]", "[error]"];
function ItInputComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const prependText_r2 = i0.ɵɵreference(3);
    i0.ɵɵclassProp("active", ctx_r0.isActiveLabel)("input-number-label", ctx_r0.type === "number")("empty-prepend-label", !prependText_r2.clientWidth);
    i0.ɵɵproperty("for", ctx_r0.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.label, " ");
  }
}
function ItInputComponent_Conditional_6_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 11);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.symbol);
  }
}
function ItInputComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵtemplate(0, ItInputComponent_Conditional_6_Conditional_0_Template, 2, 1, "span", 11);
    i0.ɵɵelementStart(1, "input", 12);
    i0.ɵɵlistener("blur", function ItInputComponent_Conditional_6_Template_input_blur_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.markAsTouched());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "span", 13)(3, "button", 14);
    i0.ɵɵlistener("click", function ItInputComponent_Conditional_6_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.incrementNumber());
    });
    i0.ɵɵelementStart(4, "span", 15);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "button", 16);
    i0.ɵɵlistener("click", function ItInputComponent_Conditional_6_Template_button_click_7_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.incrementNumber(true));
    });
    i0.ɵɵelementStart(8, "span", 15);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    let tmp_8_0;
    let tmp_9_0;
    let tmp_10_0;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.currency || ctx_r0.percentage ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("form-control", ctx_r0.readonly !== "plaintext")("form-control-plaintext", ctx_r0.readonly === "plaintext")("is-invalid", ctx_r0.isInvalid)("just-validate-success-field", ctx_r0.isValid);
    i0.ɵɵproperty("id", ctx_r0.id)("step", (tmp_8_0 = ctx_r0.step) !== null && tmp_8_0 !== undefined ? tmp_8_0 : null)("min", (tmp_9_0 = ctx_r0.min) !== null && tmp_9_0 !== undefined ? tmp_9_0 : "")("max", (tmp_10_0 = ctx_r0.max) !== null && tmp_10_0 !== undefined ? tmp_10_0 : "")("formControl", ctx_r0.control)("placeholder", ctx_r0.placeholder)("readonly", ctx_r0.isReadonly)("autocomplete", ctx_r0.autocomplete);
    i0.ɵɵattribute("aria-describedby", ctx_r0.id + "-description");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", !ctx_r0.control.enabled);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 22, "it.form.increase-value"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", !ctx_r0.control.enabled);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(10, 24, "it.form.decrease-value"));
  }
}
function ItInputComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 17);
    i0.ɵɵlistener("blur", function ItInputComponent_Conditional_7_Template_input_blur_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.markAsTouched());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("form-control", ctx_r0.readonly !== "plaintext")("form-control-plaintext", ctx_r0.readonly === "plaintext")("is-invalid", ctx_r0.isInvalid)("just-validate-success-field", ctx_r0.isValid);
    i0.ɵɵproperty("id", ctx_r0.id)("type", ctx_r0.type)("max", ctx_r0.type === "date" ? ctx_r0.maxDate : undefined)("min", ctx_r0.type === "date" ? ctx_r0.minDate : undefined)("formControl", ctx_r0.control)("placeholder", ctx_r0.placeholder)("readonly", ctx_r0.isReadonly)("autocomplete", ctx_r0.autocomplete);
    i0.ɵɵattribute("aria-describedby", ctx_r0.id + "-description");
  }
}
function ItInputComponent_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r0.id + "-description");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.description);
  }
}
function ItInputComponent_Conditional_13_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, ctx_r0.invalidMessage), " ");
  }
}
function ItInputComponent_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "div", null, 1);
    i0.ɵɵprojection(3, 3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ItInputComponent_Conditional_13_Conditional_4_Template, 2, 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const customError_r5 = i0.ɵɵreference(2);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r0.id + "-error");
    i0.ɵɵadvance(4);
    i0.ɵɵconditional(!customError_r5.hasChildNodes() ? 4 : -1);
  }
}
const _c28 = (a0, a1) => ({
  page: a0,
  total: a1
});
function ItPaginationComponent_Conditional_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "it-icon", 6);
  }
}
function ItPaginationComponent_Conditional_1_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, "it.core.previous"), " ");
  }
}
function ItPaginationComponent_Conditional_1_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 4)(1, "span", 9);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(3, "li", 4)(4, "span", 10);
    i0.ɵɵtext(5, "/");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "li", 4)(7, "span", 10);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "li", 11)(10, "a", 12);
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.currentPage + 1);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r1.pageNumbers);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(12, 3, "it.core.page-of-total", i0.ɵɵpureFunction2(6, _c28, ctx_r1.currentPage + 1, ctx_r1.pageNumbers)), " ");
  }
}
function ItPaginationComponent_Conditional_1_Conditional_9_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 4)(1, "span", 10);
    i0.ɵɵtext(2, "...");
    i0.ɵɵelementEnd()();
  }
}
function ItPaginationComponent_Conditional_1_Conditional_9_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 4)(1, "a", 5);
    i0.ɵɵlistener("click", function ItPaginationComponent_Conditional_1_Conditional_9_Conditional_0_Template_a_click_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.pageChange($event, 1));
    });
    i0.ɵɵtext(2, "1");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(3, ItPaginationComponent_Conditional_1_Conditional_9_Conditional_0_Conditional_3_Template, 3, 0, "li", 4);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r1.pages[0] >= 3 ? 3 : -1);
  }
}
function ItPaginationComponent_Conditional_1_Conditional_9_For_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 9)(1, "span", 14);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const page_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, "it.core.page"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", page_r4, " ");
  }
}
function ItPaginationComponent_Conditional_1_Conditional_9_For_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 5);
    i0.ɵɵlistener("click", function ItPaginationComponent_Conditional_1_Conditional_9_For_2_Conditional_2_Template_a_click_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const page_r4 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.pageChange($event, page_r4));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const page_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(page_r4);
  }
}
function ItPaginationComponent_Conditional_1_Conditional_9_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 4);
    i0.ɵɵtemplate(1, ItPaginationComponent_Conditional_1_Conditional_9_For_2_Conditional_1_Template, 5, 4, "a", 9)(2, ItPaginationComponent_Conditional_1_Conditional_9_For_2_Conditional_2_Template, 2, 1, "a", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const page_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵconditional(page_r4 === ctx_r1.currentPage + 1 ? 1 : 2);
  }
}
function ItPaginationComponent_Conditional_1_Conditional_9_Conditional_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 4)(1, "span", 10);
    i0.ɵɵtext(2, "...");
    i0.ɵɵelementEnd()();
  }
}
function ItPaginationComponent_Conditional_1_Conditional_9_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵtemplate(0, ItPaginationComponent_Conditional_1_Conditional_9_Conditional_3_Conditional_0_Template, 3, 0, "li", 4);
    i0.ɵɵelementStart(1, "li", 4)(2, "a", 5);
    i0.ɵɵlistener("click", function ItPaginationComponent_Conditional_1_Conditional_9_Conditional_3_Template_a_click_2_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.pageChange($event, ctx_r1.pageNumbers));
    });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵconditional(ctx_r1.pages[ctx_r1.pages.length - 1] < ctx_r1.pageNumbers - 1 ? 0 : -1);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.pageNumbers);
  }
}
function ItPaginationComponent_Conditional_1_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ItPaginationComponent_Conditional_1_Conditional_9_Conditional_0_Template, 4, 1);
    i0.ɵɵrepeaterCreate(1, ItPaginationComponent_Conditional_1_Conditional_9_For_2_Template, 3, 1, "li", 4, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵtemplate(3, ItPaginationComponent_Conditional_1_Conditional_9_Conditional_3_Template, 4, 2, "li", 4);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r1.pageNumbers > ctx_r1.visiblePages && ctx_r1.pages[0] >= 2 ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.pages);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.pageNumbers > ctx_r1.visiblePages && ctx_r1.pages[ctx_r1.pages.length - 1] < ctx_r1.pageNumbers ? 3 : -1);
  }
}
function ItPaginationComponent_Conditional_1_Conditional_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, "it.core.next"), " ");
  }
}
function ItPaginationComponent_Conditional_1_Conditional_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "it-icon", 8);
  }
}
function ItPaginationComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ul", 2)(1, "li", 4)(2, "a", 5);
    i0.ɵɵlistener("click", function ItPaginationComponent_Conditional_1_Template_a_click_2_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.pageChange($event, ctx_r1.currentPage));
    });
    i0.ɵɵtemplate(3, ItPaginationComponent_Conditional_1_Conditional_3_Template, 1, 0, "it-icon", 6);
    i0.ɵɵelementStart(4, "span", 7);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, ItPaginationComponent_Conditional_1_Conditional_7_Template, 2, 3);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(8, ItPaginationComponent_Conditional_1_Conditional_8_Template, 13, 9)(9, ItPaginationComponent_Conditional_1_Conditional_9_Template, 4, 2);
    i0.ɵɵelementStart(10, "li", 4)(11, "a", 5);
    i0.ɵɵlistener("click", function ItPaginationComponent_Conditional_1_Template_a_click_11_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.pageChange($event, ctx_r1.currentPage + 2));
    });
    i0.ɵɵelementStart(12, "span", 7);
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(15, ItPaginationComponent_Conditional_1_Conditional_15_Template, 2, 3)(16, ItPaginationComponent_Conditional_1_Conditional_16_Template, 1, 0, "it-icon", 8);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassProp("disabled", ctx_r1.currentPage < 1);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("text", ctx_r1.textLinks);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.textLinks ? 3 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 14, ctx_r1.textLinks ? "it.core.page" : "it.core.previous-page"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.textLinks ? 7 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.simpleMode ? 8 : 9);
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("disabled", ctx_r1.currentPage >= ctx_r1.pageNumbers - 1);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("text", ctx_r1.textLinks);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(14, 16, ctx_r1.textLinks ? "it.core.page" : "it.core.next-page"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.textLinks ? 15 : 16);
  }
}
function ItPaginationComponent_Conditional_2_For_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "it-dropdown-item", 18);
    i0.ɵɵlistener("click", function ItPaginationComponent_Conditional_2_For_7_Template_it_dropdown_item_click_0_listener($event) {
      const value_r8 = i0.ɵɵrestoreView(_r7).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.changerChange($event, value_r8));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "lowercase");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const value_r8 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", value_r8, " / ", i0.ɵɵpipeBind1(3, 4, i0.ɵɵpipeBind1(2, 2, "it.core.page")), " ");
  }
}
function ItPaginationComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "it-dropdown")(1, "span", 15);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "lowercase");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerStart(5, 16);
    i0.ɵɵrepeaterCreate(6, ItPaginationComponent_Conditional_2_For_7_Template, 4, 6, "it-dropdown-item", 17, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", ctx_r1.currentChanger, " / ", i0.ɵɵpipeBind1(4, 4, i0.ɵɵpipeBind1(3, 2, "it.core.page")), "");
    i0.ɵɵadvance(4);
    i0.ɵɵrepeater(ctx_r1.changerValues);
  }
}
function ItPaginationComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "it-input", 3);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("min", 1)("max", ctx_r1.pageNumbers)("label", i0.ɵɵpipeBind1(1, 4, "it.core.go-to") + "...")("formControl", ctx_r1.jumpToPage);
  }
}
function ItSpinnerComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 2)(1, "div", 2);
  }
}
function ItSteppersItemComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
const _c29 = (a0, a1) => ({
  current: a0,
  available: a1
});
function ItSteppersContainerComponent_Conditional_1_Conditional_1_For_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "it-icon", 7);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const step_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("labelWaria", i0.ɵɵpipeBind1(1, 2, "it.core.confirmed"))("name", step_r1.icon);
  }
}
function ItSteppersContainerComponent_Conditional_1_Conditional_1_For_2_Conditional_2_Conditional_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ItSteppersContainerComponent_Conditional_1_Conditional_1_For_2_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ItSteppersContainerComponent_Conditional_1_Conditional_1_For_2_Conditional_2_Conditional_1_ng_container_0_Template, 1, 0, "ng-container", 10);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(5);
    const checkIcon_r2 = i0.ɵɵreference(5);
    i0.ɵɵproperty("ngTemplateOutlet", checkIcon_r2);
  }
}
function ItSteppersContainerComponent_Conditional_1_Conditional_1_For_2_Conditional_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 9);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
  }
  if (rf & 2) {
    const ɵ$index_9_r3 = i0.ɵɵnextContext(2).$index;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(2, 2, "it.core.step"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ɵ$index_9_r3 + 1, " ");
  }
}
function ItSteppersContainerComponent_Conditional_1_Conditional_1_For_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵtemplate(1, ItSteppersContainerComponent_Conditional_1_Conditional_1_For_2_Conditional_2_Conditional_1_Template, 1, 1, "ng-container")(2, ItSteppersContainerComponent_Conditional_1_Conditional_1_For_2_Conditional_2_Conditional_2_Template, 4, 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ɵ$index_9_r3 = i0.ɵɵnextContext().$index;
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ɵ$index_9_r3 < ctx_r3.activeStep ? 1 : 2);
  }
}
function ItSteppersContainerComponent_Conditional_1_Conditional_1_For_2_Conditional_4_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ItSteppersContainerComponent_Conditional_1_Conditional_1_For_2_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ItSteppersContainerComponent_Conditional_1_Conditional_1_For_2_Conditional_4_ng_container_0_Template, 1, 0, "ng-container", 10);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(4);
    const checkIcon_r2 = i0.ɵɵreference(5);
    i0.ɵɵproperty("ngTemplateOutlet", checkIcon_r2);
  }
}
function ItSteppersContainerComponent_Conditional_1_Conditional_1_For_2_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 9);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "it.core.active"));
  }
}
function ItSteppersContainerComponent_Conditional_1_Conditional_1_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtemplate(1, ItSteppersContainerComponent_Conditional_1_Conditional_1_For_2_Conditional_1_Template, 2, 4, "it-icon", 7)(2, ItSteppersContainerComponent_Conditional_1_Conditional_1_For_2_Conditional_2_Template, 3, 1, "span", 8);
    i0.ɵɵtext(3);
    i0.ɵɵtemplate(4, ItSteppersContainerComponent_Conditional_1_Conditional_1_For_2_Conditional_4_Template, 1, 1, "ng-container")(5, ItSteppersContainerComponent_Conditional_1_Conditional_1_For_2_Conditional_5_Template, 3, 3, "span", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const step_r1 = ctx.$implicit;
    const ɵ$index_9_r3 = ctx.$index;
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("confirmed", ɵ$index_9_r3 < ctx_r3.activeStep)("active", ɵ$index_9_r3 === ctx_r3.activeStep)("no-line", ɵ$index_9_r3 === ctx_r3.activeStep && ctx_r3.steppersNumber);
    i0.ɵɵadvance();
    i0.ɵɵconditional(step_r1.icon && !ctx_r3.steppersNumber ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.steppersNumber ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", step_r1.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ɵ$index_9_r3 < ctx_r3.activeStep && !ctx_r3.steppersNumber ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ɵ$index_9_r3 === ctx_r3.activeStep ? 5 : -1);
  }
}
function ItSteppersContainerComponent_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul");
    i0.ɵɵrepeaterCreate(1, ItSteppersContainerComponent_Conditional_1_Conditional_1_For_2_Template, 6, 11, "li", 6, _forTrack0);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r3.steps);
  }
}
function ItSteppersContainerComponent_Conditional_1_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.activeStep + 1 + "/" + ctx_r3.steps.length, " ");
  }
}
function ItSteppersContainerComponent_Conditional_1_Conditional_2_Conditional_2_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ɵ$index_47_r5 = ctx.$index;
    const ctx_r3 = i0.ɵɵnextContext(4);
    i0.ɵɵclassProp("active", ɵ$index_47_r5 === ctx_r3.activeStep);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ɵ$index_47_r5 + 1);
  }
}
function ItSteppersContainerComponent_Conditional_1_Conditional_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, ItSteppersContainerComponent_Conditional_1_Conditional_2_Conditional_2_For_1_Template, 2, 3, "span", 11, _forTrack0);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵrepeater(ctx_r3.steps);
  }
}
function ItSteppersContainerComponent_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 5);
    i0.ɵɵtemplate(1, ItSteppersContainerComponent_Conditional_1_Conditional_2_Conditional_1_Template, 1, 1)(2, ItSteppersContainerComponent_Conditional_1_Conditional_2_Conditional_2_Template, 2, 0);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r3.steppersNumber ? 1 : 2);
  }
}
function ItSteppersContainerComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, ItSteppersContainerComponent_Conditional_1_Conditional_1_Template, 3, 0, "ul")(2, ItSteppersContainerComponent_Conditional_1_Conditional_2_Template, 3, 1, "span", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.steps ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.steps ? 2 : -1);
  }
}
function ItSteppersContainerComponent_Conditional_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ItSteppersContainerComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtemplate(1, ItSteppersContainerComponent_Conditional_2_ng_container_1_Template, 1, 0, "ng-container", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx.htmlContent);
  }
}
function ItSteppersContainerComponent_Conditional_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 16);
    i0.ɵɵlistener("click", function ItSteppersContainerComponent_Conditional_3_Conditional_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.backClick.emit(ctx_r3.activeStep));
    });
    i0.ɵɵelement(1, "it-icon", 17);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r3.disableBackButton);
    i0.ɵɵadvance();
    i0.ɵɵproperty("labelWaria", i0.ɵɵpipeBind1(2, 3, "it.core.back"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 5, "it.core.back"), " ");
  }
}
function ItSteppersContainerComponent_Conditional_3_Conditional_2_Conditional_0_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li")(1, "span", 9);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ɵ$index_73_r7 = ctx.$index;
    const ctx_r3 = i0.ɵɵnextContext(4);
    i0.ɵɵclassProp("done", ɵ$index_73_r7 < ctx_r3.activeStep);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind2(3, 4, "it.core.step-of", i0.ɵɵpureFunction2(9, _c29, ctx_r3.activeStep + 1, ctx_r3.steps == null ? null : ctx_r3.steps.length)), " ", ɵ$index_73_r7 < ctx_r3.activeStep ? "- " + i0.ɵɵpipeBind1(4, 7, "it.core.confirmed") : "", " ");
  }
}
function ItSteppersContainerComponent_Conditional_3_Conditional_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 18);
    i0.ɵɵrepeaterCreate(1, ItSteppersContainerComponent_Conditional_3_Conditional_2_Conditional_0_For_2_Template, 5, 12, "li", 20, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r3.steps);
  }
}
function ItSteppersContainerComponent_Conditional_3_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelement(1, "it-progress-bar", 21);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("color", ctx_r3.progressColor)("value", ctx_r3.activeStep / ((ctx_r3.steps == null ? null : ctx_r3.steps.length) || 1) * 100);
  }
}
function ItSteppersContainerComponent_Conditional_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ItSteppersContainerComponent_Conditional_3_Conditional_2_Conditional_0_Template, 3, 0, "ul", 18)(1, ItSteppersContainerComponent_Conditional_3_Conditional_2_Conditional_1_Template, 2, 2, "div", 19);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r3.progressStyle === "dots" ? 0 : 1);
  }
}
function ItSteppersContainerComponent_Conditional_3_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 22);
    i0.ɵɵlistener("click", function ItSteppersContainerComponent_Conditional_3_Conditional_3_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.saveClick.emit(ctx_r3.activeStep));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("progress", ctx_r3.saveLoading)("disabled", ctx_r3.saveLoading || ctx_r3.disableSaveButton);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 3, "it.general.save"), " ");
  }
}
function ItSteppersContainerComponent_Conditional_3_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 23);
    i0.ɵɵlistener("click", function ItSteppersContainerComponent_Conditional_3_Conditional_4_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.forwardClick.emit(ctx_r3.activeStep));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelement(3, "it-icon", 24);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r3.disableForwardButton);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 3, "it.core.forward"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("labelWaria", i0.ɵɵpipeBind1(4, 5, "it.core.forward"));
  }
}
function ItSteppersContainerComponent_Conditional_3_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 25);
    i0.ɵɵlistener("click", function ItSteppersContainerComponent_Conditional_3_Conditional_5_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.confirmClick.emit(ctx_r3.activeStep));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("progress", ctx_r3.confirmLoading)("disabled", ctx_r3.confirmLoading || ctx_r3.disableConfirmButton);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 3, "it.core.confirm"), " ");
  }
}
function ItSteppersContainerComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "nav", 4);
    i0.ɵɵtemplate(1, ItSteppersContainerComponent_Conditional_3_Conditional_1_Template, 5, 7, "button", 12)(2, ItSteppersContainerComponent_Conditional_3_Conditional_2_Template, 2, 1)(3, ItSteppersContainerComponent_Conditional_3_Conditional_3_Template, 3, 5, "button", 13)(4, ItSteppersContainerComponent_Conditional_3_Conditional_4_Template, 5, 7, "button", 14)(5, ItSteppersContainerComponent_Conditional_3_Conditional_5_Template, 3, 5, "button", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.showBackButton ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!!ctx_r3.progressStyle && ctx_r3.steps ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.showSaveButton ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.showForwardButton ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.showConfirmButton ? 5 : -1);
  }
}
function ItSteppersContainerComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "it-icon", 26);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementStart(2, "span", 9);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("labelWaria", i0.ɵɵpipeBind1(1, 2, "it.core.confirmed"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 4, "it.core.confirmed"));
  }
}
function ItTabItemComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
const _c30 = ["tabNavLinks"];
function ItTabContainerComponent_Conditional_0_For_2_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "it-icon", 6);
  }
  if (rf & 2) {
    const tab_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("name", tab_r2.icon);
  }
}
function ItTabContainerComponent_Conditional_0_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 4)(1, "a", 5, 0);
    i0.ɵɵlistener("click", function ItTabContainerComponent_Conditional_0_For_2_Template_a_click_1_listener() {
      const tab_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onTab(tab_r2));
    });
    i0.ɵɵtemplate(3, ItTabContainerComponent_Conditional_0_For_2_Conditional_3_Template, 1, 1, "it-icon", 6);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const tab_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵclassProp("active", tab_r2.active)("disabled", tab_r2.disabled);
    i0.ɵɵproperty("id", tab_r2.id + "-tab-link");
    i0.ɵɵattribute("href", "#" + tab_r2.id + "-tab", i0.ɵɵsanitizeUrl)("aria-controls", tab_r2.id + "-tab");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(tab_r2.icon ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", tab_r2.label, " ");
  }
}
function ItTabContainerComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 3);
    i0.ɵɵrepeaterCreate(1, ItTabContainerComponent_Conditional_0_For_2_Template, 5, 9, "li", 4, _forTrack0);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("auto", ctx_r2.auto)("nav-tabs-icon-text", ctx_r2.iconText)("nav-dark", ctx_r2.dark);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r2.tabs);
  }
}
function ItTabContainerComponent_Conditional_1_For_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ItTabContainerComponent_Conditional_1_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtemplate(1, ItTabContainerComponent_Conditional_1_For_2_ng_container_1_Template, 1, 0, "ng-container", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_11_0;
    const tab_r4 = ctx.$implicit;
    i0.ɵɵclassMapInterpolate1("tab-pane p-4 fade ", (tmp_11_0 = tab_r4.class) !== null && tmp_11_0 !== undefined ? tmp_11_0 : "", "");
    i0.ɵɵclassProp("active", tab_r4.active)("show", tab_r4.active);
    i0.ɵɵproperty("id", tab_r4.id + "-tab");
    i0.ɵɵattribute("aria-labelledby", tab_r4.id + "-tab-link");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", tab_r4.htmlContent);
  }
}
function ItTabContainerComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵrepeaterCreate(1, ItTabContainerComponent_Conditional_1_For_2_Template, 2, 10, "div", 7, _forTrack0);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r2.tabs);
  }
}
const _c31 = [[["", "caption", ""]], [["", "thead", ""]], [["", "tbody", ""]], [["", "tfoot", ""]]];
const _c32 = ["[caption]", "[thead]", "[tbody]", "[tfoot]"];
const _c33 = ["it-sort-header", ""];
const _c34 = (a0, a1) => ({
  "it-evidence": a0,
  "it-now": a1
});
function ItTimelineItemComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 1);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "it.timeline.today"));
  }
}
function ItTimelineItemComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "it-icon", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", ctx_r0.pinIcon)("title", ctx_r0.pinIconTitle);
    i0.ɵɵattribute("role", ctx_r0.pinIconTitle ? "img" : null);
  }
}
function ItTimelineItemComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "it-icon", 5);
  }
}
function ItTimelineItemComponent_Conditional_12_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "a", 16);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.categoryLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("href", ctx_r0.categoryLink, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.categoryTitle);
  }
}
function ItTimelineItemComponent_Conditional_12_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "span", 17);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "date");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.dateLabel);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(4, 2, ctx_r0.eventDate, ctx_r0.dateFormat));
  }
}
function ItTimelineItemComponent_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, ItTimelineItemComponent_Conditional_12_Conditional_1_Template, 4, 3)(2, ItTimelineItemComponent_Conditional_12_Conditional_2_Template, 5, 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.categoryTitle ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.eventDate ? 2 : -1);
  }
}
function ItTimelineItemComponent_Conditional_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.signature);
  }
}
function ItTimelineItemComponent_Conditional_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 14)(1, "span", 18);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 15);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "it-icon", 19);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("href", ctx_r0.readMoreLink, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 3, "it.timeline.read-more"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(6, 5, "it.timeline.read-more-on", i0.ɵɵpureFunction1(8, _c25, ctx_r0.title)));
  }
}
function ItTimelineComponent_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelement(1, "it-timeline-item", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const element_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("title", element_r1.title)("text", element_r1.text)("signature", element_r1.signature)("pinType", element_r1.pin == null ? null : element_r1.pin.type)("pinIcon", element_r1.pin == null ? null : element_r1.pin.icon)("pinText", element_r1.pin == null ? null : element_r1.pin.text)("eventDate", element_r1.eventDate)("dateFormat", ctx_r1.dateFormat)("categoryTitle", element_r1.category == null ? null : element_r1.category.title)("categoryLink", element_r1.category == null ? null : element_r1.category.link)("showReadMore", !!(element_r1.link == null ? null : element_r1.link.length))("readMoreLink", element_r1.link);
  }
}
const _c35 = ["*", [["", "error", ""]], [["", "label", ""]]];
const _c36 = ["*", "[error]", "[label]"];
function ItCheckboxComponent_Conditional_2_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ItCheckboxComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5)(1, "label", 8);
    i0.ɵɵtemplate(2, ItCheckboxComponent_Conditional_2_ng_container_2_Template, 1, 0, "ng-container", 9);
    i0.ɵɵelementStart(3, "input", 10);
    i0.ɵɵlistener("click", function ItCheckboxComponent_Conditional_2_Template_input_click_3_listener($event) {
      i0.ɵɵrestoreView(_r1);
      return i0.ɵɵresetView($event.stopPropagation());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "span", 11);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const htmlLabel_r3 = i0.ɵɵreference(10);
    i0.ɵɵadvance();
    i0.ɵɵproperty("for", ctx_r1.id);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", htmlLabel_r3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r1.id)("formControl", ctx_r1.control);
    i0.ɵɵattribute("aria-describedby", ctx_r1.id + "-help");
  }
}
function ItCheckboxComponent_Conditional_3_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ItCheckboxComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 12);
    i0.ɵɵlistener("click", function ItCheckboxComponent_Conditional_3_Template_input_click_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      return i0.ɵɵresetView($event.stopPropagation());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(1, "label", 13);
    i0.ɵɵtemplate(2, ItCheckboxComponent_Conditional_3_ng_container_2_Template, 1, 0, "ng-container", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const htmlLabel_r3 = i0.ɵɵreference(10);
    i0.ɵɵclassProp("is-invalid", ctx_r1.isInvalid)("is-valid", ctx_r1.isValid)("semi-checked", ctx_r1.indeterminate);
    i0.ɵɵproperty("id", ctx_r1.id)("formControl", ctx_r1.control);
    i0.ɵɵattribute("aria-describedby", ctx_r1.id + "-help");
    i0.ɵɵadvance();
    i0.ɵɵproperty("for", ctx_r1.id);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", htmlLabel_r3);
  }
}
function ItCheckboxComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 6);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r1.id + "-help");
  }
}
function ItCheckboxComponent_Conditional_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ItCheckboxComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, ItCheckboxComponent_Conditional_5_ng_container_1_Template, 1, 0, "ng-container", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const error_r5 = i0.ɵɵreference(8);
    i0.ɵɵproperty("id", ctx_r1.id + "-error");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", error_r5);
  }
}
function ItCheckboxComponent_Conditional_6_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ItCheckboxComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, ItCheckboxComponent_Conditional_6_ng_container_1_Template, 1, 0, "ng-container", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const error_r5 = i0.ɵɵreference(8);
    i0.ɵɵproperty("id", ctx_r1.id + "-error");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", error_r5);
  }
}
function ItCheckboxComponent_ng_template_7_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, ctx_r1.invalidMessage), " ");
  }
}
function ItCheckboxComponent_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", null, 2);
    i0.ɵɵprojection(2, 1);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, ItCheckboxComponent_ng_template_7_Conditional_3_Template, 2, 3);
  }
  if (rf & 2) {
    const customError_r6 = i0.ɵɵreference(1);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(!customError_r6.hasChildNodes() ? 3 : -1);
  }
}
function ItCheckboxComponent_ng_template_9_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.label, " ");
  }
}
function ItCheckboxComponent_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", null, 3);
    i0.ɵɵprojection(2, 2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, ItCheckboxComponent_ng_template_9_Conditional_3_Template, 1, 1);
  }
  if (rf & 2) {
    const customLabel_r7 = i0.ɵɵreference(1);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(!customLabel_r7.hasChildNodes() ? 3 : -1);
  }
}
const _c37 = ["input"];
const _c38 = [[["", "error", ""]]];
const _c39 = ["[error]"];
function ItPasswordInputComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("active", !!ctx_r0.control.value || !!ctx_r0.placeholder);
    i0.ɵɵproperty("for", ctx_r0.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.label);
  }
}
function ItPasswordInputComponent_Conditional_7_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, ctx_r0.invalidMessage), " ");
  }
}
function ItPasswordInputComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "div", null, 1);
    i0.ɵɵprojection(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ItPasswordInputComponent_Conditional_7_Conditional_4_Template, 2, 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const customError_r2 = i0.ɵɵreference(2);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r0.id + "-error");
    i0.ɵɵadvance(4);
    i0.ɵɵconditional(!customError_r2.hasChildNodes() ? 4 : -1);
  }
}
function ItPasswordInputComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 9);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r0.id + "-description");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.description !== true ? ctx_r0.description : i0.ɵɵpipeBind1(2, 2, ctx_r0.strengthMeterDescription), " ");
  }
}
function ItPasswordInputComponent_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "small", 13);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 14)(9, "div", 15);
    i0.ɵɵelement(10, "div", 16)(11, "div", 16)(12, "div", 16)(13, "div", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(14, "div", 17);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r0.id + "-description");
    i0.ɵɵattribute("data-bs-short-pass", i0.ɵɵpipeBind1(2, 6, "it.form.password-strength-meter.password-short"))("data-bs-bad-pas", i0.ɵɵpipeBind1(3, 8, "it.form.password-strength-meter.password-bad"))("data-bs-good-pass", i0.ɵɵpipeBind1(4, 10, "it.form.password-strength-meter.password-good"))("data-bs-strong-pass", i0.ɵɵpipeBind1(5, 12, "it.form.password-strength-meter.password-strong"));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.description !== undefined && ctx_r0.description !== true ? ctx_r0.description : i0.ɵɵpipeBind1(7, 14, ctx_r0.strengthMeterDescription), " ");
  }
}
const _c40 = [[["", "label", ""]], "*", [["", "error", ""]], [["", "error", ""]]];
const _c41 = ["[label]", "*", "[error]", "[error]"];
function ItRadioButtonComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.label, " ");
  }
}
function ItRadioButtonComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 5);
    i0.ɵɵprojection(1, 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r0.id + "-help");
  }
}
function ItRadioButtonComponent_Conditional_9_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, ctx_r0.invalidMessage), " ");
  }
}
function ItRadioButtonComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "div", null, 1);
    i0.ɵɵprojection(3, 2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ItRadioButtonComponent_Conditional_9_Conditional_4_Template, 2, 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const customError_r2 = i0.ɵɵreference(2);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r0.id + "-error");
    i0.ɵɵadvance(4);
    i0.ɵɵconditional(!customError_r2.hasChildNodes() ? 4 : -1);
  }
}
function ItRadioButtonComponent_Conditional_10_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, ctx_r0.invalidMessage), " ");
  }
}
function ItRadioButtonComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "div", null, 1);
    i0.ɵɵprojection(3, 3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ItRadioButtonComponent_Conditional_10_Conditional_4_Template, 2, 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const customError_r3 = i0.ɵɵreference(2);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r0.id + "-error");
    i0.ɵɵadvance(4);
    i0.ɵɵconditional(!customError_r3.hasChildNodes() ? 4 : -1);
  }
}
const _c42 = ["slider"];
function ItRangeComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("for", ctx_r0.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.label);
  }
}
const _c43 = (a0, a1) => ({
  current: a0,
  total: a1
});
function ItRatingComponent_For_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "input", 2);
    i0.ɵɵelementStart(1, "label", 3);
    i0.ɵɵelement(2, "it-icon", 4);
    i0.ɵɵelementStart(3, "span", 1);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const starValue_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r1.id + "-" + starValue_r1)("name", ctx_r1.id)("value", starValue_r1)("formControl", ctx_r1.control);
    i0.ɵɵattribute("aria-hidden", ctx_r1.control.disabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("for", ctx_r1.id + "-" + starValue_r1);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(5, 7, "it.core.rate-star", i0.ɵɵpureFunction2(10, _c43, starValue_r1, ctx_r1.stars.length)), " ");
  }
}
const _c44 = ["*", [["", "error", ""]]];
const _c45 = ["*", "[error]"];
const _forTrack1 = ($index, $item) => $item.value;
function ItSelectComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("for", ctx_r0.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.label);
  }
}
function ItSelectComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngValue", null);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.defaultOption, " ");
  }
}
function ItSelectComponent_Conditional_5_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_13_0;
    const option_r2 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r0.optionIsDisabled(option_r2))("ngValue", option_r2.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", (tmp_13_0 = option_r2.text) !== null && tmp_13_0 !== undefined ? tmp_13_0 : option_r2.value, " ");
  }
}
function ItSelectComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, ItSelectComponent_Conditional_5_For_1_Template, 2, 3, "option", 7, _forTrack1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(ctx_r0.options);
  }
}
function ItSelectComponent_Conditional_6_For_1_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_23_0;
    const option_r3 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("disabled", ctx_r0.optionIsDisabled(option_r3))("ngValue", option_r3.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", (tmp_23_0 = option_r3.text) !== null && tmp_23_0 !== undefined ? tmp_23_0 : option_r3.value, " ");
  }
}
function ItSelectComponent_Conditional_6_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "optgroup", 8);
    i0.ɵɵrepeaterCreate(1, ItSelectComponent_Conditional_6_For_1_For_2_Template, 2, 3, "option", 7, _forTrack1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const group_r4 = ctx.$implicit;
    i0.ɵɵproperty("label", group_r4.label);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(group_r4.options);
  }
}
function ItSelectComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, ItSelectComponent_Conditional_6_For_1_Template, 3, 1, "optgroup", 8, i0.ɵɵrepeaterTrackByIdentity);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(ctx_r0.groups);
  }
}
function ItSelectComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r0.id + "-description");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.description);
  }
}
function ItSelectComponent_Conditional_8_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, ctx_r0.invalidMessage), " ");
  }
}
function ItSelectComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "div", null, 0);
    i0.ɵɵprojection(3, 1);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ItSelectComponent_Conditional_8_Conditional_4_Template, 2, 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const customError_r5 = i0.ɵɵreference(2);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r0.id + "-error");
    i0.ɵɵadvance(4);
    i0.ɵɵconditional(!customError_r5.hasChildNodes() ? 4 : -1);
  }
}
function ItTextareaComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("active", !!ctx_r0.control.value || !!ctx_r0.placeholder);
    i0.ɵɵproperty("for", ctx_r0.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.label);
  }
}
function ItTextareaComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r0.id + "-description");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.description);
  }
}
function ItTextareaComponent_Conditional_4_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, ctx_r0.invalidMessage), " ");
  }
}
function ItTextareaComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "div", null, 0);
    i0.ɵɵprojection(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ItTextareaComponent_Conditional_4_Conditional_4_Template, 2, 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const customError_r2 = i0.ɵɵreference(2);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r0.id + "-error");
    i0.ɵɵadvance(4);
    i0.ɵɵconditional(!customError_r2.hasChildNodes() ? 4 : -1);
  }
}
const _c46 = ["donutElement"];
function ItUploadDragDropComponent_Conditional_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "it.form.upload-loading"));
  }
}
function ItUploadDragDropComponent_Conditional_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "it.form.upload-complete"));
  }
}
function ItUploadDragDropComponent_Conditional_17_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementStart(3, "input", 11);
    i0.ɵɵlistener("change", function ItUploadDragDropComponent_Conditional_17_Template_input_change_3_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onLoadFile($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "label", 12);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 5, "it.form.upload-or"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", ctx_r1.id)("accept", ctx_r1.accept);
    i0.ɵɵadvance();
    i0.ɵɵproperty("for", ctx_r1.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 7, "it.form.upload-select-device"));
  }
}
const _c47 = a0 => ({
  name: a0
});
function ItUploadFileListComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 1);
    i0.ɵɵlistener("change", function ItUploadFileListComponent_Conditional_0_Template_input_change_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onLoadFiles($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(1, "label", 2);
    i0.ɵɵelement(2, "it-icon", 3);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r1.id)("accept", ctx_r1.accept)("multiple", ctx_r1.multiple);
    i0.ɵɵadvance();
    i0.ɵɵproperty("for", ctx_r1.id);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 5, "it.form.upload"));
  }
}
function ItUploadFileListComponent_Conditional_1_For_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelement(1, "img", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("alt", item_r3.file.name);
    i0.ɵɵattribute("src", ctx_r1.previewImages.get(item_r3.id), i0.ɵɵsanitizeUrl);
  }
}
function ItUploadFileListComponent_Conditional_1_For_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "it-icon", 8);
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("color", !item_r3.error ? item_r3.progress ? "secondary" : "primary" : "danger");
  }
}
function ItUploadFileListComponent_Conditional_1_For_2_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 16);
    i0.ɵɵlistener("click", function ItUploadFileListComponent_Conditional_1_For_2_Conditional_10_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const item_r3 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.deleteItem.emit(item_r3));
    });
    i0.ɵɵelementStart(1, "span", 10);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "it-icon", 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(3, 1, "it.form.delete-file", i0.ɵɵpureFunction1(4, _c47, item_r3.file.name)));
  }
}
function ItUploadFileListComponent_Conditional_1_For_2_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 13)(1, "span", 10);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "it-icon", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "it.form.upload-complete"));
  }
}
function ItUploadFileListComponent_Conditional_1_For_2_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "it-progress-bar", 14);
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("value", item_r3.progress);
  }
}
function ItUploadFileListComponent_Conditional_1_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 6);
    i0.ɵɵtemplate(1, ItUploadFileListComponent_Conditional_1_For_2_Conditional_1_Template, 2, 2, "div", 7)(2, ItUploadFileListComponent_Conditional_1_For_2_Conditional_2_Template, 1, 1, "it-icon", 8);
    i0.ɵɵelementStart(3, "p", 9)(4, "span", 10);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(7);
    i0.ɵɵelementStart(8, "span", 11);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(10, ItUploadFileListComponent_Conditional_1_For_2_Conditional_10_Template, 5, 6, "button", 12)(11, ItUploadFileListComponent_Conditional_1_For_2_Conditional_11_Template, 5, 3, "button", 13)(12, ItUploadFileListComponent_Conditional_1_For_2_Conditional_12_Template, 1, 1, "it-progress-bar", 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("error", item_r3.error)("uploading", !item_r3.error && item_r3.progress !== undefined && item_r3.progress > 0 && item_r3.progress < 100)("success", !item_r3.error && (!item_r3.progress || item_r3.progress >= 100));
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.images ? 1 : 2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("itTooltip", item_r3.tooltip);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(6, 14, "it.form.uploaded-file", i0.ɵɵpureFunction1(17, _c47, item_r3.file.name)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", item_r3.file.name, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.getFileSize(item_r3.file));
    i0.ɵɵadvance();
    i0.ɵɵconditional(item_r3.removable && (!item_r3.progress || item_r3.progress < 100) ? 10 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!item_r3.removable && !item_r3.progress || item_r3.progress !== undefined && item_r3.progress >= 100 ? 11 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!item_r3.error && item_r3.progress !== undefined && item_r3.progress > 0 && item_r3.progress < 100 ? 12 : -1);
  }
}
function ItUploadFileListComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 4);
    i0.ɵɵrepeaterCreate(1, ItUploadFileListComponent_Conditional_1_For_2_Template, 13, 19, "li", 5, _forTrack0);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("upload-file-list-image", ctx_r1.images);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.fileList);
  }
}
function ItAutocompleteComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("visually-hidden", !ctx_r0.isActiveLabel)("active", ctx_r0.isActiveLabel);
    i0.ɵɵproperty("for", ctx_r0.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.label, " ");
  }
}
function ItAutocompleteComponent_Conditional_5_For_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelement(1, "img", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const entry_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", entry_r3.avatarSrcPath, i0.ɵɵsanitizeUrl)("alt", entry_r3.avatarAltText);
  }
}
function ItAutocompleteComponent_Conditional_5_For_2_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "it-icon", 12);
  }
  if (rf & 2) {
    const entry_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("name", entry_r3.icon);
  }
}
function ItAutocompleteComponent_Conditional_5_For_2_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "em");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const entry_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(entry_r3.label);
  }
}
function ItAutocompleteComponent_Conditional_5_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "a", 10);
    i0.ɵɵlistener("click", function ItAutocompleteComponent_Conditional_5_For_2_Template_a_click_1_listener($event) {
      const entry_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onEntryClick(entry_r3, $event));
    });
    i0.ɵɵtemplate(2, ItAutocompleteComponent_Conditional_5_For_2_Conditional_2_Template, 2, 2, "div", 11)(3, ItAutocompleteComponent_Conditional_5_For_2_Conditional_3_Template, 1, 1, "it-icon", 12);
    i0.ɵɵelementStart(4, "span", 13);
    i0.ɵɵelement(5, "span", 14);
    i0.ɵɵpipe(6, "itMarkMatchingText");
    i0.ɵɵtemplate(7, ItAutocompleteComponent_Conditional_5_For_2_Conditional_7_Template, 2, 1, "em");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const entry_r3 = ctx.$implicit;
    const autocomplete_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("href", entry_r3.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵconditional(entry_r3.avatarSrcPath ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(entry_r3.icon ? 3 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(6, 5, entry_r3.value, autocomplete_r4.searchedValue), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(entry_r3.label ? 7 : -1);
  }
}
function ItAutocompleteComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 9);
    i0.ɵɵrepeaterCreate(1, ItAutocompleteComponent_Conditional_5_For_2_Template, 8, 8, "li", null, i0.ɵɵcomponentInstance().autocompleteItemTrackByValueFn, true);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const autocomplete_r4 = ctx;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("autocomplete-list-show", (autocomplete_r4.relatedEntries == null ? null : autocomplete_r4.relatedEntries.length) && ctx_r0.showAutocompletion);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(autocomplete_r4.relatedEntries);
  }
}
function ItAutocompleteComponent_Conditional_7_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, ctx_r0.invalidMessage), " ");
  }
}
function ItAutocompleteComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7)(1, "div", null, 0);
    i0.ɵɵprojection(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ItAutocompleteComponent_Conditional_7_Conditional_4_Template, 2, 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const customError_r5 = i0.ɵɵreference(2);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r0.id + "-error");
    i0.ɵɵadvance(4);
    i0.ɵɵconditional(!customError_r5.hasChildNodes() ? 4 : -1);
  }
}
const _c48 = ["selectAllCheckbox"];
function ItTransferListComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const numberOfItems_r2 = ctx;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", numberOfItems_r2.length, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 2, numberOfItems_r2.length === 1 ? "it.transfer.item" : "it.transfer.items"), "");
  }
}
function ItTransferListComponent_For_16_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "input", 10);
    i0.ɵɵlistener("click", function ItTransferListComponent_For_16_Template_input_click_1_listener() {
      const item_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.checkboxSelectionHandler(item_r4));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "label", 5)(3, "span")(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const item_r4 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r4.instanceId, "-", item_r4.value, "");
    i0.ɵɵproperty("checked", item_r4.selected);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("for", "", ctx_r4.instanceId, "-", item_r4.value, "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(item_r4.text);
  }
}
const _c49 = a0 => ({
  active: a0
});
function ItTransferComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("active", !!ctx_r0.control.value);
    i0.ɵɵproperty("for", ctx_r0.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.label);
  }
}
function ItBackButtonComponent_Conditional_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ItBackButtonComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 3);
    i0.ɵɵlistener("click", function ItBackButtonComponent_Conditional_0_Template_a_click_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.goBack($event));
    });
    i0.ɵɵtemplate(1, ItBackButtonComponent_Conditional_0_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const content_r3 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", content_r3);
  }
}
function ItBackButtonComponent_Conditional_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ItBackButtonComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 5);
    i0.ɵɵlistener("click", function ItBackButtonComponent_Conditional_1_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.goBack($event));
    });
    i0.ɵɵtemplate(1, ItBackButtonComponent_Conditional_1_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const content_r3 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", content_r3);
  }
}
function ItBackButtonComponent_ng_template_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "it-icon", 7);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("me-2", ctx_r1.showText);
    i0.ɵɵproperty("name", ctx_r1.direction === "left" ? "arrow-left" : "arrow-up")("color", ctx_r1.buttonStyle === "link" ? "primary" : "white");
  }
}
function ItBackButtonComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ItBackButtonComponent_ng_template_2_Conditional_0_Template, 1, 4, "it-icon", 6);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r1.showIcon ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("visually-hidden", !ctx_r1.showText);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, ctx_r1.direction === "left" ? "it.navigation.go-back" : "it.navigation.upper-level"), " ");
  }
}
const _c50 = ["backToTop"];
function ItBreadcrumbItemComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function ItBreadcrumbComponent_Conditional_2_For_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "it-icon", 5);
  }
  if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("name", item_r1.iconName)("color", ctx_r1.dark ? "white" : "secondary");
  }
}
function ItBreadcrumbComponent_Conditional_2_For_2_Conditional_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ItBreadcrumbComponent_Conditional_2_For_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "it-link", 8);
    i0.ɵɵtemplate(1, ItBreadcrumbComponent_Conditional_2_For_2_Conditional_2_ng_container_1_Template, 1, 0, "ng-container", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵclassMap(item_r1.class);
    i0.ɵɵproperty("href", item_r1.href)("externalLink", item_r1.externalLink)("disabled", item_r1.disabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", item_r1.htmlContent);
  }
}
function ItBreadcrumbComponent_Conditional_2_For_2_Conditional_3_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ItBreadcrumbComponent_Conditional_2_For_2_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ItBreadcrumbComponent_Conditional_2_For_2_Conditional_3_ng_container_0_Template, 1, 0, "ng-container", 9);
  }
  if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngTemplateOutlet", item_r1.htmlContent);
  }
}
function ItBreadcrumbComponent_Conditional_2_For_2_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.separator);
  }
}
function ItBreadcrumbComponent_Conditional_2_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 4);
    i0.ɵɵtemplate(1, ItBreadcrumbComponent_Conditional_2_For_2_Conditional_1_Template, 1, 2, "it-icon", 5)(2, ItBreadcrumbComponent_Conditional_2_For_2_Conditional_2_Template, 2, 6, "it-link", 6)(3, ItBreadcrumbComponent_Conditional_2_For_2_Conditional_3_Template, 1, 1, "ng-container")(4, ItBreadcrumbComponent_Conditional_2_For_2_Conditional_4_Template, 2, 1, "span", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const ɵ$index_7_r3 = ctx.$index;
    const ɵ$count_7_r4 = ctx.$count;
    i0.ɵɵclassProp("active", item_r1.active);
    i0.ɵɵattribute("aria-current", item_r1.active ? "page" : null);
    i0.ɵɵadvance();
    i0.ɵɵconditional(item_r1.iconName ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!item_r1.active && !(ɵ$index_7_r3 === ɵ$count_7_r4 - 1) ? 2 : 3);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!(ɵ$index_7_r3 === ɵ$count_7_r4 - 1) ? 4 : -1);
  }
}
function ItBreadcrumbComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ol", 2);
    i0.ɵɵrepeaterCreate(1, ItBreadcrumbComponent_Conditional_2_For_2_Template, 5, 6, "li", 3, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("dark", ctx_r1.dark)("px-3", ctx_r1.dark);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.items);
  }
}
const _c51 = ["collapseButton"];
const _c52 = ["collapseView"];
const _c53 = [[["", "navItems", ""]]];
const _c54 = ["[navItems]"];
const _c55 = ["headerWrapper"];
const _c56 = [[["", "brand", ""]], [["", "rightZone", ""]], [["", "navItems", ""]], [["", "slimLinkList", ""]], [["", "slimRightZone", ""]]];
const _c57 = ["[brand]", "[rightZone]", "[navItems]", "[slimLinkList]", "[slimRightZone]"];
function ItHeaderComponent_Conditional_2_Conditional_18_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24)(1, "a", 26);
    i0.ɵɵlistener("click", function ItHeaderComponent_Conditional_2_Conditional_18_Template_a_click_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.emitLoginClick($event));
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "it.navigation.login"), " ");
  }
}
function ItHeaderComponent_Conditional_2_Conditional_19_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 27);
    i0.ɵɵlistener("click", function ItHeaderComponent_Conditional_2_Conditional_19_Template_a_click_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.emitLoginClick($event));
    });
    i0.ɵɵelementStart(1, "span", 28);
    i0.ɵɵelement(2, "it-icon", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 30);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 1, "it.navigation.full-login"));
  }
}
function ItHeaderComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15)(1, "div", 16)(2, "div", 6)(3, "div", 7)(4, "div", 17)(5, "a", 18);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 19)(8, "nav");
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementStart(10, "a", 20)(11, "span");
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(13, "it-icon", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 22);
    i0.ɵɵprojection(15, 3);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(16, "div", 23);
    i0.ɵɵprojection(17, 4);
    i0.ɵɵtemplate(18, ItHeaderComponent_Conditional_2_Conditional_18_Template, 4, 3, "div", 24)(19, ItHeaderComponent_Conditional_2_Conditional_19_Template, 6, 3, "a", 25);
    i0.ɵɵelementEnd()()()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("theme-light", ctx_r1.light);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("href", ctx_r1.slimTitleLink, i0.ɵɵsanitizeUrl)("target", ctx_r1.slimTitleLink !== "#" ? "_blank" : "_self");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.slimTitle, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(9, 9, "it.navigation.secondary-navigation"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r1.slimTitle);
    i0.ɵɵadvance(6);
    i0.ɵɵconditional(ctx_r1.loginStyle === "default" ? 18 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.loginStyle === "full" ? 19 : -1);
  }
}
function ItHeaderComponent_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11)(1, "span", 31);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "a", 32);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵlistener("click", function ItHeaderComponent_Conditional_13_Template_a_click_4_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.emitSearchClick($event));
    });
    i0.ɵɵelement(6, "it-icon", 33);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, "it.navigation.search"));
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(5, 4, "it.navigation.website-search"));
  }
}
const _c58 = [[["", "megamenuLinkList", ""]], [["", "megamenuLeftZone", ""]], [["", "megamenuHeadingLink", ""]], [["", "megamenuFooter", ""]]];
const _c59 = ["[megamenuLinkList]", "[megamenuLeftZone]", "[megamenuHeadingLink]", "[megamenuFooter]"];
function ItMegamenuComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 1)(2, "div", 6)(3, "div", 7);
    i0.ɵɵprojection(4, 1);
    i0.ɵɵelementEnd()()()();
  }
}
function ItMegamenuComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵprojection(1, 2);
    i0.ɵɵelementEnd();
  }
}
function ItMegamenuComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div")(2, "div", 8);
    i0.ɵɵprojection(3, 3);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("col-xs-12", ctx_r0.mode === "right-section")("col-lg-4", ctx_r0.mode === "right-section")("px-0", ctx_r0.mode === "right-section");
    i0.ɵɵadvance();
    i0.ɵɵclassProp("it-footer-link-wrapper", ctx_r0.footer)("it-footer-link-wrapper-vertical", ctx_r0.mode === "right-section");
    i0.ɵɵadvance();
    i0.ɵɵclassProp("flex-lg-row", ctx_r0.mode !== "right-section");
  }
}
const _c60 = ["rtl"];
const _c61 = () => [];
const _forTrack2 = ($index, $item) => $item.href;
function ItNavscrollListItemsComponent_For_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "it-navscroll-list-items", 3);
  }
  if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("items", item_r1.childs);
  }
}
function ItNavscrollListItemsComponent_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 1);
    i0.ɵɵelement(1, "it-navscroll-list-item", 2);
    i0.ɵɵtemplate(2, ItNavscrollListItemsComponent_For_2_Conditional_2_Template, 1, 1, "it-navscroll-list-items", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("item", item_r1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((item_r1.childs == null ? null : item_r1.childs.length) ? 2 : -1);
  }
}
const _c62 = ["toggleButtonRef"];
const _c63 = a0 => ({
  "it-navscroll-sticky-mobile": a0
});
const _c64 = a0 => ({
  items: a0
});
const _c65 = a0 => ({
  item: a0,
  level: 1
});
const _c66 = (a0, a1) => ({
  item: a0,
  level: a1
});
function ItNavscrollComponent_ng_container_36_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ItNavscrollComponent_ng_template_37_For_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ItNavscrollComponent_ng_template_37_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ItNavscrollComponent_ng_template_37_For_1_ng_container_0_Template, 1, 0, "ng-container", 25);
  }
  if (rf & 2) {
    const item_r1 = ctx.$implicit;
    i0.ɵɵnextContext(2);
    const paragraphTemplate_r2 = i0.ɵɵreference(40);
    i0.ɵɵproperty("ngTemplateOutlet", paragraphTemplate_r2)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c65, item_r1));
  }
}
function ItNavscrollComponent_ng_template_37_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, ItNavscrollComponent_ng_template_37_For_1_Template, 1, 4, "ng-container", null, _forTrack2);
  }
  if (rf & 2) {
    const items_r3 = ctx.items;
    i0.ɵɵrepeater(items_r3);
  }
}
function ItNavscrollComponent_ng_template_39_Case_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 26);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext().item;
    i0.ɵɵpropertyInterpolate("id", item_r4.href);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r4.title);
  }
}
function ItNavscrollComponent_ng_template_39_Case_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 26);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext().item;
    i0.ɵɵpropertyInterpolate("id", item_r4.href);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r4.title);
  }
}
function ItNavscrollComponent_ng_template_39_Case_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h4", 26);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext().item;
    i0.ɵɵpropertyInterpolate("id", item_r4.href);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r4.title);
  }
}
function ItNavscrollComponent_ng_template_39_Case_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h5", 26);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext().item;
    i0.ɵɵpropertyInterpolate("id", item_r4.href);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r4.title);
  }
}
function ItNavscrollComponent_ng_template_39_Case_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h6", 26);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext().item;
    i0.ɵɵpropertyInterpolate("id", item_r4.href);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r4.title);
  }
}
function ItNavscrollComponent_ng_template_39_For_8_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ItNavscrollComponent_ng_template_39_For_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ItNavscrollComponent_ng_template_39_For_8_ng_container_0_Template, 1, 0, "ng-container", 25);
  }
  if (rf & 2) {
    const item_r5 = ctx.$implicit;
    const nextLevel_r6 = i0.ɵɵnextContext().level+1;
    i0.ɵɵnextContext();
    const paragraphTemplate_r2 = i0.ɵɵreference(40);
    i0.ɵɵproperty("ngTemplateOutlet", paragraphTemplate_r2)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c66, item_r5, nextLevel_r6));
  }
}
function ItNavscrollComponent_ng_template_39_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ItNavscrollComponent_ng_template_39_Case_0_Template, 2, 2, "h2", 26)(1, ItNavscrollComponent_ng_template_39_Case_1_Template, 2, 2, "h3", 26)(2, ItNavscrollComponent_ng_template_39_Case_2_Template, 2, 2, "h4", 26)(3, ItNavscrollComponent_ng_template_39_Case_3_Template, 2, 2, "h5", 26)(4, ItNavscrollComponent_ng_template_39_Case_4_Template, 2, 2, "h6", 26);
    i0.ɵɵelementStart(5, "p");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵrepeaterCreate(7, ItNavscrollComponent_ng_template_39_For_8_Template, 1, 5, "ng-container", null, _forTrack2);
  }
  if (rf & 2) {
    let tmp_7_0;
    const item_r4 = ctx.item;
    const level_r7 = ctx.level;
    i0.ɵɵconditional((tmp_7_0 = level_r7) === 1 ? 0 : tmp_7_0 === 2 ? 1 : tmp_7_0 === 3 ? 2 : tmp_7_0 === 4 ? 3 : 4);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(item_r4.text);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(item_r4.childs);
  }
}
const _c67 = ["*", [["", "secondary", ""]]];
const _c68 = ["*", "[secondary]"];
function ItSidebarComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h3");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.header);
  }
}
function ItErrorPageComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h1");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.errorCode);
  }
}
function ItErrorPageComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, "it.utils.error-page." + ctx_r0.errorCode + ".title"), " ");
  }
}
function ItErrorPageComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, ctx_r0.errorTitle || "it.errors.generic"), " ");
  }
}
function ItErrorPageComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, "it.utils.error-page." + ctx_r0.errorCode + ".description"), " ");
  }
}
function ItErrorPageComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, ctx_r0.errorDescription || "it.errors.generic-support-message"), " ");
  }
}
function ItErrorPageComponent_Conditional_8_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "it-back-button");
  }
}
function ItErrorPageComponent_Conditional_8_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 3);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 2, "it.utils.error-page.go-to-homepage"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "it.utils.error-page.go-to-homepage"), " ");
  }
}
function ItErrorPageComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, ItErrorPageComponent_Conditional_8_Conditional_1_Template, 1, 0, "it-back-button")(2, ItErrorPageComponent_Conditional_8_Conditional_2_Template, 4, 6, "a", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.showBackButton ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.showHomeButton ? 2 : -1);
  }
}
const _forTrack3 = ($index, $item) => $item.code;
const _c69 = a0 => ({
  lang: a0
});
function ItLanguageSwitcherComponent_Conditional_10_For_2_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 2);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "it.utils.selected"), " ");
  }
}
function ItLanguageSwitcherComponent_Conditional_10_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "it-dropdown-item", 5);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵlistener("click", function ItLanguageSwitcherComponent_Conditional_10_For_2_Template_it_dropdown_item_click_0_listener() {
      const lang_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.changeLanguage(lang_r2.code));
    });
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, ItLanguageSwitcherComponent_Conditional_10_For_2_Conditional_3_Template, 3, 3, "span", 2);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_11_0;
    let tmp_13_0;
    const lang_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("active", lang_r2.code === ((tmp_11_0 = i0.ɵɵpipeBind1(1, 3, ctx_r2.currentLang$)) == null ? null : tmp_11_0.code));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", lang_r2.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(lang_r2.code === ((tmp_13_0 = i0.ɵɵpipeBind1(4, 5, ctx_r2.currentLang$)) == null ? null : tmp_13_0.code) ? 3 : -1);
  }
}
function ItLanguageSwitcherComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 3);
    i0.ɵɵrepeaterCreate(1, ItLanguageSwitcherComponent_Conditional_10_For_2_Template, 5, 7, "it-dropdown-item", 4, _forTrack3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r2.availableLanguages);
  }
}
function ItSkiplinkComponent_Conditional_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ItSkiplinkComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "nav", 1)(1, "ul");
    i0.ɵɵtemplate(2, ItSkiplinkComponent_Conditional_0_ng_container_2_Template, 1, 0, "ng-container", 2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const linkContent_r1 = i0.ɵɵreference(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", linkContent_r1);
  }
}
function ItSkiplinkComponent_Conditional_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ItSkiplinkComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, ItSkiplinkComponent_Conditional_1_ng_container_1_Template, 1, 0, "ng-container", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const linkContent_r1 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", linkContent_r1);
  }
}
function ItSkiplinkComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function ItSkiplinkItemComponent_Conditional_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ItSkiplinkItemComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 1)(1, "it-link", 3);
    i0.ɵɵtemplate(2, ItSkiplinkItemComponent_Conditional_0_ng_container_2_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const linkContent_r2 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("href", ctx_r0.href)("externalLink", ctx_r0.externalLink);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", linkContent_r2);
  }
}
function ItSkiplinkItemComponent_Conditional_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ItSkiplinkItemComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "it-link", 2);
    i0.ɵɵtemplate(1, ItSkiplinkItemComponent_Conditional_1_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const linkContent_r2 = i0.ɵɵreference(3);
    i0.ɵɵproperty("href", ctx_r0.href)("externalLink", ctx_r0.externalLink);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", linkContent_r2);
  }
}
function ItSkiplinkItemComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
class ItAbstractComponent {
  /**
   * Counter of active instances
   * @private
   */
  static {
    this.instances = 0;
  }
  constructor() {
    /**
     * The element ID
     */
    this.id = this.getDefaultId();
    this._renderer = inject(Renderer2);
    this._elementRef = inject(ElementRef);
    this._changeDetectorRef = inject(ChangeDetectorRef);
    this.valueChanges = new EventEmitter();
  }
  ngAfterViewInit() {
    this._renderer.removeAttribute(this._elementRef.nativeElement, 'id');
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  ngOnChanges(changes) {
    this.valueChanges.next(); // The inputs were changed
  }
  /**
   * Generate unique id for components
   * @private
   */
  getDefaultId() {
    const name = this.constructor.name.replace('Component', '');
    const kebabName = name.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs) => (ofs ? '-' : '') + $.toLowerCase());
    return `${kebabName}-${ItAbstractComponent.instances++}`;
  }
  static {
    this.ɵfac = function ItAbstractComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItAbstractComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItAbstractComponent,
      selectors: [["ng-component"]],
      inputs: {
        id: "id"
      },
      outputs: {
        valueChanges: "valueChanges"
      },
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 0,
      vars: 0,
      template: function ItAbstractComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItAbstractComponent, [{
    type: Component,
    args: [{
      template: ''
    }]
  }], () => [], {
    id: [{
      type: Input
    }],
    valueChanges: [{
      type: Output
    }]
  });
})();

/**
 * Transforms a value (typically a string) to a boolean.
 * Intended to be used as a transform function of an input.
 *
 *  @usageNotes
 *  ```typescript
 *  @Input({ transform: booleanAttribute }) status?: boolean;
 *  ```
 * @param {BooleanInput} value Value to be transformed.
 *
 * @publicApi
 */
function inputToBoolean(value) {
  // Wrap `@angular/core` function to force value type, for ide hits
  return booleanAttribute(value);
}
class ItCollapseComponent extends ItAbstractComponent {
  constructor() {
    super(...arguments);
    /**
     * Custom class
     */
    this.class = '';
    /**
     * This event fires immediately when the show method is called.
     */
    this.showEvent = new EventEmitter();
    /**
     * This event is triggered when the tooltip has been made visible to the user (it will wait for the CSS transitions to complete).
     */
    this.shownEvent = new EventEmitter();
    /**
     * This event fires immediately when the hide method is called.
     */
    this.hideEvent = new EventEmitter();
    /**
     * This event is raised when the tooltip has finished being hidden from the user (it will wait for the CSS transitions to complete).
     */
    this.hiddenEvent = new EventEmitter();
    this.open = false;
  }
  ngAfterViewInit() {
    super.ngAfterViewInit();
    this._renderer.removeAttribute(this._elementRef.nativeElement, 'class');
    if (this.collapseDiv) {
      const element = this.collapseDiv.nativeElement;
      this.collapse = Collapse.getOrCreateInstance(element, {
        toggle: this.opened
      });
      element.addEventListener('show.bs.collapse', event => {
        this.open = true;
        this.showEvent.emit(event);
      });
      element.addEventListener('shown.bs.collapse', event => {
        this.open = true;
        this.shownEvent.emit(event);
      });
      element.addEventListener('hide.bs.collapse', event => {
        this.open = false;
        this.hideEvent.emit(event);
      });
      element.addEventListener('hidden.bs.collapse', event => {
        this.open = false;
        this.hiddenEvent.emit(event);
      });
    }
  }
  /**
   * Shows if collapse is open or not
   */
  isOpen() {
    return this.open;
  }
  /**
   * Shows a resealable item
   * NOTE: Returns to the caller before the collapsable element has actually been shown (onShown event).
   */
  show() {
    this.collapse?.show();
  }
  /**
   * Hides a resealable item
   * NOTE: Returns to the caller before the collapsable element has actually been hidden (onHidden Event)
   */
  hide() {
    this.collapse?.hide();
  }
  /**
   * Toggle a collapsible item to show or hide it.
   * NOTE: Returns to the caller before the collapsable element has actually been shown or hidden (onShown and onHidden events)
   */
  toggle() {
    this.collapse?.toggle();
  }
  /**
   * Eliminates the possibility of an item being resealable
   */
  dispose() {
    this.collapse?.dispose();
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵItCollapseComponent_BaseFactory;
      return function ItCollapseComponent_Factory(__ngFactoryType__) {
        return (ɵItCollapseComponent_BaseFactory || (ɵItCollapseComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ItCollapseComponent)))(__ngFactoryType__ || ItCollapseComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItCollapseComponent,
      selectors: [["it-collapse"]],
      viewQuery: function ItCollapseComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.collapseDiv = _t.first);
        }
      },
      inputs: {
        multi: [2, "multi", "multi", inputToBoolean],
        opened: [2, "opened", "opened", inputToBoolean],
        class: "class"
      },
      outputs: {
        showEvent: "showEvent",
        shownEvent: "shownEvent",
        hideEvent: "hideEvent",
        hiddenEvent: "hiddenEvent"
      },
      exportAs: ["itCollapse"],
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c1,
      decls: 3,
      vars: 6,
      consts: [["collapse", ""], [3, "id"]],
      template: function ItCollapseComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 1, 0);
          i0.ɵɵprojection(2);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵclassMapInterpolate1("collapse ", ctx.class, "");
          i0.ɵɵclassProp("multi-collapse", ctx.multi);
          i0.ɵɵproperty("id", ctx.id);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItCollapseComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-collapse',
      exportAs: 'itCollapse',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [],
      template: "<div [id]=\"id\" class=\"collapse {{ class }}\" [class.multi-collapse]=\"multi\" #collapse>\n  <ng-content></ng-content>\n</div>\n"
    }]
  }], null, {
    multi: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    opened: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    class: [{
      type: Input
    }],
    showEvent: [{
      type: Output
    }],
    shownEvent: [{
      type: Output
    }],
    hideEvent: [{
      type: Output
    }],
    hiddenEvent: [{
      type: Output
    }],
    collapseDiv: [{
      type: ViewChild,
      args: ['collapse']
    }]
  });
})();

/**
 * Accordion
 * @description Build vertically collapsible accordions based on Collapse.
 */
class ItAccordionComponent extends ItCollapseComponent {
  constructor() {
    super(...arguments);
    this.isCollapsed = true;
  }
  ngAfterViewInit() {
    super.ngAfterViewInit();
    this._renderer.removeAttribute(this._elementRef.nativeElement, 'title');
    this.isCollapsed = !this.opened;
    this.hideEvent.subscribe(() => {
      this.isCollapsed = true;
      this._changeDetectorRef.detectChanges();
    });
    this.showEvent.subscribe(() => {
      this.isCollapsed = false;
      this._changeDetectorRef.detectChanges();
    });
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵItAccordionComponent_BaseFactory;
      return function ItAccordionComponent_Factory(__ngFactoryType__) {
        return (ɵItAccordionComponent_BaseFactory || (ɵItAccordionComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ItAccordionComponent)))(__ngFactoryType__ || ItAccordionComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItAccordionComponent,
      selectors: [["it-accordion"]],
      viewQuery: function ItAccordionComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.collapseDiv = _t.first);
        }
      },
      inputs: {
        title: "title"
      },
      exportAs: ["itAccordion"],
      standalone: true,
      features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c1,
      decls: 9,
      vars: 14,
      consts: [["collapse", ""], [1, "accordion"], [1, "accordion-item"], [1, "accordion-header", 3, "id"], ["type", "button", "data-bs-toggle", "collapse", 1, "accordion-button"], ["role", "region", 3, "id"], [1, "accordion-body"]],
      template: function ItAccordionComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "h2", 3)(3, "button", 4);
          i0.ɵɵtext(4);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(5, "div", 5, 0)(7, "div", 6);
          i0.ɵɵprojection(8);
          i0.ɵɵelementEnd()()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵpropertyInterpolate1("id", "collapse-", ctx.id, "-heading");
          i0.ɵɵadvance();
          i0.ɵɵclassProp("collapsed", ctx.isCollapsed);
          i0.ɵɵattribute("data-bs-target", "#collapse-" + ctx.id)("aria-controls", "collapse-" + ctx.id)("aria-expanded", ctx.opened ? "true" : "false");
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", ctx.title, " ");
          i0.ɵɵadvance();
          i0.ɵɵclassMapInterpolate1("accordion-collapse collapse ", ctx.class, "");
          i0.ɵɵpropertyInterpolate1("id", "collapse-", ctx.id, "");
          i0.ɵɵattribute("aria-labelledby", "collapse-" + ctx.id + "-heading");
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItAccordionComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-accordion',
      exportAs: 'itAccordion',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [],
      template: "<div class=\"accordion\">\n  <div class=\"accordion-item\">\n    <h2 class=\"accordion-header\" id=\"collapse-{{ id }}-heading\">\n      <button\n        class=\"accordion-button\"\n        type=\"button\"\n        data-bs-toggle=\"collapse\"\n        [class.collapsed]=\"isCollapsed\"\n        [attr.data-bs-target]=\"'#collapse-' + id\"\n        [attr.aria-controls]=\"'collapse-' + id\"\n        [attr.aria-expanded]=\"opened ? 'true' : 'false'\">\n        {{ title }}\n      </button>\n    </h2>\n\n    <div\n      #collapse\n      id=\"collapse-{{ id }}\"\n      role=\"region\"\n      class=\"accordion-collapse collapse {{ class }}\"\n      [attr.aria-labelledby]=\"'collapse-' + id + '-heading'\">\n      <div class=\"accordion-body\">\n        <ng-content></ng-content>\n      </div>\n    </div>\n  </div>\n</div>\n"
    }]
  }], null, {
    title: [{
      type: Input,
      args: [{
        required: true
      }]
    }],
    collapseDiv: [{
      type: ViewChild,
      args: ['collapse']
    }]
  });
})();

/**
 * The bootstrap-italia asset folder path
 * @default ./bootstrap-italia
 */
const IT_ASSET_BASE_PATH = new InjectionToken('it-asset-base-path');
class ItIconComponent {
  /**
   * Return the icon href
   */
  get iconHref() {
    return `${this.assetBasePath}/dist/svg/sprites.svg#it-${this.name}`;
  }
  /**
   * Return the icon class
   */
  get iconClass() {
    let iconClass = 'icon';
    if (this.size) {
      iconClass += ` icon-${this.size}`;
    }
    if (this.color) {
      iconClass += ` icon-${this.color}`;
    }
    if (this.padded) {
      iconClass += ` icon-padded`;
    }
    if (this.svgClass) {
      iconClass += ` ${this.svgClass}`;
    }
    return iconClass;
  }
  get isAriaHidden() {
    return this.labelWaria == undefined;
  }
  constructor() {
    this.assetBasePath = inject(IT_ASSET_BASE_PATH);
  }
  static {
    this.ɵfac = function ItIconComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItIconComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItIconComponent,
      selectors: [["it-icon"]],
      inputs: {
        name: "name",
        size: "size",
        color: "color",
        padded: [2, "padded", "padded", inputToBoolean],
        svgClass: "svgClass",
        labelWaria: "labelWaria"
      },
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵStandaloneFeature],
      decls: 2,
      vars: 6,
      template: function ItIconComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵnamespaceSVG();
          i0.ɵɵelementStart(0, "svg");
          i0.ɵɵelement(1, "use");
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.iconClass);
          i0.ɵɵattribute("aria-hidden", ctx.isAriaHidden)("aria-label", ctx.labelWaria);
          i0.ɵɵadvance();
          i0.ɵɵattribute("href", ctx.iconHref)("href", ctx.iconHref, null, "xlink");
        }
      },
      styles: ["[_nghost-%COMP%]{display:contents}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItIconComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-icon',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [],
      template: "<svg [attr.aria-hidden]=\"isAriaHidden\" [attr.aria-label]=\"labelWaria\" [class]=\"iconClass\">\n  <use [attr.href]=\"iconHref\" [attr.xlink:href]=\"iconHref\"></use>\n</svg>\n",
      styles: [":host{display:contents}\n"]
    }]
  }], () => [], {
    name: [{
      type: Input,
      args: [{
        required: true
      }]
    }],
    size: [{
      type: Input
    }],
    color: [{
      type: Input
    }],
    padded: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    svgClass: [{
      type: Input
    }],
    labelWaria: [{
      type: Input
    }]
  });
})();

/**
 * Alert
 * @description You can provide feedback to the user via alert messages.
 */
class ItAlertComponent extends ItAbstractComponent {
  constructor() {
    super(...arguments);
    /**
     * The alert color
     * @default info
     */
    this.color = 'info';
    /**
     * This event fires immediately when the instance's close method is called.
     */
    this.closeEvent = new EventEmitter();
    /**
     * This event fires when the alert has been closed (it will wait for CSS transitions to complete).
     */
    this.closedEvent = new EventEmitter();
  }
  ngAfterViewInit() {
    super.ngAfterViewInit();
    if (this.alertElement) {
      const element = this.alertElement.nativeElement;
      this.alert = Alert.getOrCreateInstance(element);
      element.addEventListener('close.bs.alert', event => this.closeEvent.emit(event));
      element.addEventListener('closed.bs.alert', event => this.closedEvent.emit(event));
    }
  }
  /**
   * Close an alert by removing it from the DOM.
   * If the `.fade` and `.show` classes are present in the element, the alert will be closed with a disappearing effect.
   */
  close() {
    this.alert?.close();
  }
  /**
   * The alert is removed
   */
  dispose() {
    this.alert?.dispose();
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵItAlertComponent_BaseFactory;
      return function ItAlertComponent_Factory(__ngFactoryType__) {
        return (ɵItAlertComponent_BaseFactory || (ɵItAlertComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ItAlertComponent)))(__ngFactoryType__ || ItAlertComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItAlertComponent,
      selectors: [["it-alert"]],
      viewQuery: function ItAlertComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c2, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.alertElement = _t.first);
        }
      },
      inputs: {
        color: "color",
        dismissible: [2, "dismissible", "dismissible", inputToBoolean]
      },
      outputs: {
        closeEvent: "closeEvent",
        closedEvent: "closedEvent"
      },
      exportAs: ["itAlert"],
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c4,
      decls: 6,
      vars: 10,
      consts: [["alertElement", ""], ["role", "alert"], [1, "alert-heading"], ["type", "button", "data-bs-dismiss", "alert", 1, "btn-close"], ["name", "close"]],
      template: function ItAlertComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c3);
          i0.ɵɵelementStart(0, "div", 1, 0)(2, "h4", 2);
          i0.ɵɵprojection(3);
          i0.ɵɵelementEnd();
          i0.ɵɵprojection(4, 1);
          i0.ɵɵtemplate(5, ItAlertComponent_Conditional_5_Template, 3, 3, "button", 3);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵclassMapInterpolate1("alert alert-", ctx.color, "");
          i0.ɵɵclassProp("alert-dismissible", ctx.dismissible)("fade", ctx.dismissible)("show", ctx.dismissible);
          i0.ɵɵadvance(5);
          i0.ɵɵconditional(ctx.dismissible ? 5 : -1);
        }
      },
      dependencies: [TranslateModule, i1.TranslatePipe, ItIconComponent],
      styles: [".alert-heading[_ngcontent-%COMP%]:empty{display:none}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItAlertComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-alert',
      exportAs: 'itAlert',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [TranslateModule, ItIconComponent],
      template: "<div\n  #alertElement\n  class=\"alert alert-{{ color }}\"\n  [class.alert-dismissible]=\"dismissible\"\n  [class.fade]=\"dismissible\"\n  [class.show]=\"dismissible\"\n  role=\"alert\">\n  <h4 class=\"alert-heading\">\n    <ng-content select=\"[heading]\"></ng-content>\n  </h4>\n\n  <ng-content></ng-content>\n\n  @if (dismissible) {\n    <button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"alert\" [attr.aria-label]=\"'it.core.close-alert' | translate\">\n      <it-icon name=\"close\"></it-icon>\n    </button>\n  }\n</div>\n",
      styles: [".alert-heading:empty{display:none}\n"]
    }]
  }], null, {
    color: [{
      type: Input
    }],
    dismissible: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    closeEvent: [{
      type: Output
    }],
    closedEvent: [{
      type: Output
    }],
    alertElement: [{
      type: ViewChild,
      args: ['alertElement']
    }]
  });
})();
class ItAvatarGroupItemComponent {
  static {
    this.ɵfac = function ItAvatarGroupItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItAvatarGroupItemComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItAvatarGroupItemComponent,
      selectors: [["it-avatar-item"]],
      viewQuery: function ItAvatarGroupItemComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(TemplateRef, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._implicitContent = _t.first);
        }
      },
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function ItAvatarGroupItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, ItAvatarGroupItemComponent_ng_template_0_Template, 1, 0, "ng-template");
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItAvatarGroupItemComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-avatar-item',
      template: '<ng-template><ng-content></ng-content></ng-template>'
    }]
  }], null, {
    _implicitContent: [{
      type: ViewChild,
      args: [TemplateRef, {
        static: true
      }]
    }]
  });
})();
class ItAvatarGroupComponent {
  constructor() {
    this.linkList = false;
  }
  static {
    this.ɵfac = function ItAvatarGroupComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItAvatarGroupComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItAvatarGroupComponent,
      selectors: [["it-avatar-group"]],
      contentQueries: function ItAvatarGroupComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, ItAvatarGroupItemComponent, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.avatars = _t);
        }
      },
      hostVars: 2,
      hostBindings: function ItAvatarGroupComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("link-list-wrapper", ctx.linkList);
        }
      },
      inputs: {
        linkList: [2, "linkList", "linkList", inputToBoolean]
      },
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵStandaloneFeature],
      decls: 3,
      vars: 2,
      consts: [[4, "ngTemplateOutlet"]],
      template: function ItAvatarGroupComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "ul");
          i0.ɵɵrepeaterCreate(1, ItAvatarGroupComponent_For_2_Template, 2, 1, "li", null, i0.ɵɵrepeaterTrackByIdentity);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.linkList ? "link-list avatar-group" : "avatar-group-stacked");
          i0.ɵɵadvance();
          i0.ɵɵrepeater(ctx.avatars);
        }
      },
      dependencies: [NgTemplateOutlet],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItAvatarGroupComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-avatar-group',
      imports: [NgTemplateOutlet],
      template: "<ul [class]=\"linkList ? 'link-list avatar-group' : 'avatar-group-stacked'\">\n  @for (avatar of avatars; track avatar) {\n    <li>\n      <ng-container *ngTemplateOutlet=\"avatar._implicitContent\"></ng-container>\n    </li>\n  }\n</ul>\n"
    }]
  }], null, {
    linkList: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }, {
      type: HostBinding,
      args: ['class.link-list-wrapper']
    }],
    avatars: [{
      type: ContentChildren,
      args: [ItAvatarGroupItemComponent]
    }]
  });
})();
class ItLinkComponent extends ItAbstractComponent {
  constructor() {
    super(...arguments);
    /**
     * Custom class
     */
    this.class = '';
  }
  ngAfterViewInit() {
    super.ngAfterViewInit();
    this._renderer.removeAttribute(this._elementRef.nativeElement, 'class');
  }
  ngOnChanges(changes) {
    super.ngOnChanges(changes);
    if (changes['class']) {
      this._changeDetectorRef.markForCheck();
    }
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵItLinkComponent_BaseFactory;
      return function ItLinkComponent_Factory(__ngFactoryType__) {
        return (ɵItLinkComponent_BaseFactory || (ɵItLinkComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ItLinkComponent)))(__ngFactoryType__ || ItLinkComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItLinkComponent,
      selectors: [["it-link"]],
      inputs: {
        href: "href",
        externalLink: [2, "externalLink", "externalLink", inputToBoolean],
        disabled: [2, "disabled", "disabled", inputToBoolean],
        class: "class"
      },
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c1,
      decls: 4,
      vars: 1,
      consts: [["linkContent", ""], [3, "id", "class", "routerLink"], [3, "id", "class"], [3, "id", "routerLink"], [4, "ngTemplateOutlet"], [3, "id"]],
      template: function ItLinkComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, ItLinkComponent_Conditional_0_Template, 2, 5, "a", 1)(1, ItLinkComponent_Conditional_1_Template, 2, 5, "a", 2)(2, ItLinkComponent_ng_template_2_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵconditional(!ctx.externalLink ? 0 : 1);
        }
      },
      dependencies: [RouterLink, NgTemplateOutlet],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItLinkComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-link',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [RouterLink, NgTemplateOutlet],
      template: "@if (!externalLink) {\n  <a [id]=\"id\" [class]=\"class\" [routerLink]=\"(disabled ? null : href)!\">\n    <ng-container *ngTemplateOutlet=\"linkContent\"></ng-container>\n  </a>\n} @else {\n  <a [id]=\"id\" [class]=\"class\" [attr.href]=\"disabled ? null : href\">\n    <ng-container *ngTemplateOutlet=\"linkContent\"></ng-container>\n  </a>\n}\n\n<ng-template #linkContent>\n  <ng-content></ng-content>\n</ng-template>\n"
    }]
  }], null, {
    href: [{
      type: Input
    }],
    externalLink: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    disabled: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    class: [{
      type: Input
    }]
  });
})();
class ItDropdownItemComponent extends ItLinkComponent {
  constructor() {
    super(...arguments);
    /**
     * The icon position
     * @default right
     */
    this.iconPosition = 'right';
    /**
     * Change icon color if menu is dark
     * @default false
     */
    this.isDark = false;
  }
  get linkClass() {
    let linkClass = `list-item ${this.active ? 'active' : 'dropdown-item'}`;
    if (this.disabled) {
      linkClass += ' disabled';
    }
    if (this.large) {
      linkClass += ' large';
    }
    if (this.iconName) {
      linkClass += ` ${this.iconPosition === 'right' ? 'right-icon' : 'left-icon'}`;
    }
    return linkClass;
  }
  setDark(dark) {
    if (this.isDark !== dark) {
      this.isDark = dark;
      this._changeDetectorRef.detectChanges();
    }
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵItDropdownItemComponent_BaseFactory;
      return function ItDropdownItemComponent_Factory(__ngFactoryType__) {
        return (ɵItDropdownItemComponent_BaseFactory || (ɵItDropdownItemComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ItDropdownItemComponent)))(__ngFactoryType__ || ItDropdownItemComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItDropdownItemComponent,
      selectors: [["it-dropdown-item"]],
      inputs: {
        divider: [2, "divider", "divider", inputToBoolean],
        active: [2, "active", "active", inputToBoolean],
        large: [2, "large", "large", inputToBoolean],
        iconName: "iconName",
        iconPosition: "iconPosition"
      },
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c1,
      decls: 3,
      vars: 1,
      consts: [[1, "divider"], [3, "class", "id", "href", "externalLink", "disabled"], [3, "id", "href", "externalLink", "disabled"], ["size", "sm", 3, "name", "color", "svgClass"], [1, "visually-hidden"]],
      template: function ItDropdownItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "li");
          i0.ɵɵtemplate(1, ItDropdownItemComponent_Conditional_1_Template, 1, 0, "span", 0)(2, ItDropdownItemComponent_Conditional_2_Template, 6, 9, "it-link", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.divider ? 1 : 2);
        }
      },
      dependencies: [ItIconComponent, TranslateModule, i1.TranslatePipe, ItLinkComponent],
      styles: [".list-item.disabled[_ngcontent-%COMP%]{pointer-events:none;cursor:default}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItDropdownItemComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-dropdown-item',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [ItIconComponent, TranslateModule, ItLinkComponent],
      template: "<li>\n  @if (divider) {\n    <span class=\"divider\"></span>\n  } @else {\n    <it-link [class]=\"linkClass\" [id]=\"id\" [href]=\"href\" [externalLink]=\"externalLink\" [disabled]=\"disabled\">\n      @if (iconName && iconPosition === 'left') {\n        <it-icon size=\"sm\" [name]=\"iconName\" [color]=\"isDark ? 'light' : 'primary'\" [svgClass]=\"iconPosition\"></it-icon>\n      }\n      <span><ng-content></ng-content></span>\n      @if (iconName && iconPosition === 'right') {\n        <it-icon size=\"sm\" [name]=\"iconName\" [color]=\"isDark ? 'light' : 'primary'\" [svgClass]=\"iconPosition\"></it-icon>\n      }\n      @if (active) {\n        <span class=\"visually-hidden\">{{ 'it.core.active' | translate }}</span>\n      }\n    </it-link>\n  }\n</li>\n",
      styles: [".list-item.disabled{pointer-events:none;cursor:default}\n"]
    }]
  }], null, {
    divider: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    active: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    large: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    iconName: [{
      type: Input
    }],
    iconPosition: [{
      type: Input
    }]
  });
})();
class ItDropdownComponent extends ItAbstractComponent {
  constructor() {
    super(...arguments);
    /**
     * Dropdown mode
     */
    this.mode = 'button';
    /**
     * Fires immediately when the show instance method is called.
     */
    this.showEvent = new EventEmitter();
    /**
     * Fired when the dropdown has been made visible to the user and CSS transitions have completed.
     */
    this.shownEvent = new EventEmitter();
    /**
     * Fires immediately when the hide instance method has been called.
     */
    this.hideEvent = new EventEmitter();
    /**
     * Fired when the dropdown has finished being hidden from the user and CSS transitions have completed.
     */
    this.hiddenEvent = new EventEmitter();
  }
  get buttonClass() {
    let btnClass = 'btn dropdown-toggle';
    if (this.color) {
      btnClass += ` btn-${this.color}`;
    } else {
      btnClass += ` btn-dropdown`;
    }
    return btnClass;
  }
  ngOnChanges(changes) {
    if (changes['dark'] && !changes['dark'].firstChange) {
      this.setDarkItems();
    }
    if (changes['mode'] && !changes['mode'].firstChange) {
      this.updateListeners();
    }
    super.ngOnChanges(changes);
  }
  ngAfterViewInit() {
    super.ngAfterViewInit();
    this.setDarkItems();
    this.updateListeners();
  }
  /**
   * Set child items dark mode
   * @private
   */
  setDarkItems() {
    if (this.dark !== undefined) {
      this.items?.forEach(item => {
        item.setDark(!!this.dark);
      });
    }
  }
  updateListeners() {
    if (this.dropdownButton) {
      const element = this.dropdownButton.nativeElement;
      this.dropdown = Dropdown.getOrCreateInstance(element);
      element.addEventListener('show.bs.dropdown', event => this.showEvent.emit(event));
      element.addEventListener('shown.bs.dropdown', event => this.shownEvent.emit(event));
      element.addEventListener('hide.bs.dropdown', event => this.hideEvent.emit(event));
      element.addEventListener('hidden.bs.dropdown', event => this.hiddenEvent.emit(event));
    }
  }
  /**
   * Toggles the dropdown menu of a given navbar or tabbed navigation.
   */
  toggle() {
    this.dropdown?.toggle();
  }
  /**
   * Shows the dropdown menu of a given navbar or tabbed navigation.
   */
  show() {
    this.dropdown?.show();
  }
  /**
   * Hides the dropdown menu of a given navbar or tabbed navigation.
   */
  hide() {
    this.dropdown?.hide();
  }
  /**
   * Updates the position of an element's dropdown.
   */
  update() {
    this.dropdown?.update();
  }
  /**
   * Destroys an element's dropdown. (Removes stored data on the DOM element)
   */
  dispose() {
    this.dropdown?.dispose();
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵItDropdownComponent_BaseFactory;
      return function ItDropdownComponent_Factory(__ngFactoryType__) {
        return (ɵItDropdownComponent_BaseFactory || (ɵItDropdownComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ItDropdownComponent)))(__ngFactoryType__ || ItDropdownComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItDropdownComponent,
      selectors: [["it-dropdown"]],
      contentQueries: function ItDropdownComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, ItDropdownItemComponent, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.items = _t);
        }
      },
      viewQuery: function ItDropdownComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c5, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dropdownButton = _t.first);
        }
      },
      inputs: {
        mode: "mode",
        color: "color",
        direction: "direction",
        fullWidth: [2, "fullWidth", "fullWidth", inputToBoolean],
        megamenu: [2, "megamenu", "megamenu", inputToBoolean],
        dark: [2, "dark", "dark", inputToBoolean]
      },
      outputs: {
        showEvent: "showEvent",
        shownEvent: "shownEvent",
        hideEvent: "hideEvent",
        hiddenEvent: "hiddenEvent"
      },
      exportAs: ["itDropdown"],
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c7,
      decls: 11,
      vars: 13,
      consts: [["buttonContent", ""], ["dropdownButton", ""], ["type", "button", "data-bs-toggle", "dropdown", "aria-haspopup", "true", "aria-expanded", "false", 3, "id", "class"], ["role", "button", "data-bs-toggle", "dropdown", "aria-haspopup", "true", "aria-expanded", "false", 1, "dropdown-toggle", 3, "id", "btn", "btn-dropdown", "nav-link"], [1, "dropdown-menu"], [1, "link-list-wrapper"], [1, "link-list-heading"], [1, "link-list"], ["type", "button", "data-bs-toggle", "dropdown", "aria-haspopup", "true", "aria-expanded", "false", 3, "id"], [4, "ngTemplateOutlet"], ["svgClass", "icon-expand", "name", "expand", "size", "sm", 3, "color"], ["role", "button", "data-bs-toggle", "dropdown", "aria-haspopup", "true", "aria-expanded", "false", 1, "dropdown-toggle", 3, "id"], ["svgClass", "icon-expand", "name", "expand", "size", "sm"]],
      template: function ItDropdownComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c6);
          i0.ɵɵelementStart(0, "div");
          i0.ɵɵtemplate(1, ItDropdownComponent_Conditional_1_Template, 4, 5, "button", 2)(2, ItDropdownComponent_Conditional_2_Template, 4, 8, "a", 3);
          i0.ɵɵelementStart(3, "div", 4)(4, "div", 5)(5, "div", 6);
          i0.ɵɵprojection(6);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(7, "ul", 7);
          i0.ɵɵprojection(8, 1);
          i0.ɵɵelementEnd()()()();
          i0.ɵɵtemplate(9, ItDropdownComponent_ng_template_9_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵclassMapInterpolate1("dropdown ", ctx.direction, "");
          i0.ɵɵclassProp("nav-item", ctx.mode === "nav")("megamenu", ctx.megamenu);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.mode === "button" ? 1 : 2);
          i0.ɵɵadvance(2);
          i0.ɵɵclassProp("full-width", ctx.fullWidth)("dark", ctx.dark);
          i0.ɵɵattribute("aria-labelledby", ctx.id);
        }
      },
      dependencies: [ItIconComponent, NgTemplateOutlet],
      styles: [".link-list-heading[_ngcontent-%COMP%]:empty{display:none}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItDropdownComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-dropdown',
      exportAs: 'itDropdown',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [ItIconComponent, NgTemplateOutlet],
      template: "<div class=\"dropdown {{ direction }}\" [class.nav-item]=\"mode === 'nav'\" [class.megamenu]=\"megamenu\">\n  @if (mode === 'button') {\n    <button\n      #dropdownButton\n      [id]=\"id\"\n      [class]=\"buttonClass\"\n      type=\"button\"\n      data-bs-toggle=\"dropdown\"\n      aria-haspopup=\"true\"\n      aria-expanded=\"false\">\n      <ng-container *ngTemplateOutlet=\"buttonContent\"></ng-container>\n      <it-icon svgClass=\"icon-expand\" name=\"expand\" size=\"sm\" [color]=\"this.color ? 'light' : 'primary'\"></it-icon>\n    </button>\n  } @else {\n    <a\n      #dropdownButton\n      [id]=\"id\"\n      [class.btn]=\"mode === 'link'\"\n      [class.btn-dropdown]=\"mode === 'link'\"\n      [class.nav-link]=\"mode === 'nav'\"\n      class=\"dropdown-toggle\"\n      role=\"button\"\n      data-bs-toggle=\"dropdown\"\n      aria-haspopup=\"true\"\n      aria-expanded=\"false\">\n      <ng-container *ngTemplateOutlet=\"buttonContent\"></ng-container>\n      <it-icon svgClass=\"icon-expand\" name=\"expand\" size=\"sm\"></it-icon>\n    </a>\n  }\n\n  <div class=\"dropdown-menu\" [class.full-width]=\"fullWidth\" [class.dark]=\"dark\" [attr.aria-labelledby]=\"id\">\n    <div class=\"link-list-wrapper\">\n      <div class=\"link-list-heading\">\n        <ng-content select=\"[listHeading]\"></ng-content>\n      </div>\n      <ul class=\"link-list\">\n        <ng-content select=\"[list]\"></ng-content>\n      </ul>\n    </div>\n  </div>\n</div>\n\n<ng-template #buttonContent>\n  <ng-content select=\"[button]\"></ng-content>\n</ng-template>\n",
      styles: [".link-list-heading:empty{display:none}\n"]
    }]
  }], null, {
    mode: [{
      type: Input
    }],
    color: [{
      type: Input
    }],
    direction: [{
      type: Input
    }],
    fullWidth: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    megamenu: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    dark: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    items: [{
      type: ContentChildren,
      args: [ItDropdownItemComponent]
    }],
    showEvent: [{
      type: Output
    }],
    shownEvent: [{
      type: Output
    }],
    hideEvent: [{
      type: Output
    }],
    hiddenEvent: [{
      type: Output
    }],
    dropdownButton: [{
      type: ViewChild,
      args: ['dropdownButton']
    }]
  });
})();
const dropdownComponents = [ItDropdownComponent, ItDropdownItemComponent];
class ItDropdownModule {
  static {
    this.ɵfac = function ItDropdownModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItDropdownModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ItDropdownModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [ItDropdownItemComponent]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItDropdownModule, [{
    type: NgModule,
    args: [{
      imports: dropdownComponents,
      exports: dropdownComponents
    }]
  }], null, null);
})();
class ItAvatarDropdownItemComponent {
  static {
    this.ɵfac = function ItAvatarDropdownItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItAvatarDropdownItemComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItAvatarDropdownItemComponent,
      selectors: [["it-avatar-dropdown-item"]],
      viewQuery: function ItAvatarDropdownItemComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(TemplateRef, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._implicitContent = _t.first);
        }
      },
      inputs: {
        link: "link",
        title: "title",
        accesskey: "accesskey",
        tabindex: "tabindex"
      },
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function ItAvatarDropdownItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, ItAvatarDropdownItemComponent_ng_template_0_Template, 1, 0, "ng-template");
        }
      },
      styles: [".link-list-wrapper[_ngcontent-%COMP%]{z-index:2;position:relative}a[_ngcontent-%COMP%]{cursor:pointer}[_nghost-%COMP%]     .dropdown-toggle{width:100%;height:100%}[_nghost-%COMP%]     .dropdown-toggle .icon{display:none}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItAvatarDropdownItemComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-avatar-dropdown-item',
      template: '<ng-template><ng-content></ng-content></ng-template>',
      imports: [NgTemplateOutlet],
      styles: [".link-list-wrapper{z-index:2;position:relative}a{cursor:pointer}:host ::ng-deep .dropdown-toggle{width:100%;height:100%}:host ::ng-deep .dropdown-toggle .icon{display:none}\n"]
    }]
  }], null, {
    _implicitContent: [{
      type: ViewChild,
      args: [TemplateRef, {
        static: true
      }]
    }],
    link: [{
      type: Input
    }],
    title: [{
      type: Input
    }],
    accesskey: [{
      type: Input
    }],
    tabindex: [{
      type: Input
    }]
  });
})();
class ItAvatarDropdownComponent {
  constructor() {
    this.componentClass = 'avatar avatar-dropdown';
  }
  static {
    this.ɵfac = function ItAvatarDropdownComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItAvatarDropdownComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItAvatarDropdownComponent,
      selectors: [["it-avatar-dropdown"]],
      contentQueries: function ItAvatarDropdownComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, ItAvatarDropdownItemComponent, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.items = _t);
        }
      },
      hostVars: 2,
      hostBindings: function ItAvatarDropdownComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.componentClass);
        }
      },
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c9,
      decls: 5,
      vars: 0,
      consts: [["id", "dropdown", 1, "dropdown"], ["list", "", 1, "dropdown-menu"], ["title", "item.title", "accesskey", "item.accesskey", "tabindex", "item.tabindex", 1, "dropdown-item", "list-item", 3, "routerLink"], [1, "dropdown-item", "list-item"], [4, "ngTemplateOutlet"]],
      template: function ItAvatarDropdownComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c8);
          i0.ɵɵelementStart(0, "it-dropdown", 0);
          i0.ɵɵprojection(1, 0, ["button", ""]);
          i0.ɵɵelementContainerStart(2, 1);
          i0.ɵɵrepeaterCreate(3, ItAvatarDropdownComponent_For_4_Template, 3, 1, "li", null, i0.ɵɵrepeaterTrackByIdentity);
          i0.ɵɵelementContainerEnd();
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance(3);
          i0.ɵɵrepeater(ctx.items);
        }
      },
      dependencies: [ItDropdownModule, ItDropdownComponent, NgTemplateOutlet, RouterLink],
      styles: [_c10]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItAvatarDropdownComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-avatar-dropdown',
      imports: [ItDropdownModule, NgTemplateOutlet, RouterLink],
      template: "<it-dropdown id=\"dropdown\" class=\"dropdown\">\n  <ng-content button select=\"[it-avatar-dropdown-toggle]\"></ng-content>\n  <ng-container list class=\"dropdown-menu\">\n    @for (item of items; track item) {\n      <li>\n        @if (item.link) {\n          <a\n            [routerLink]=\"item.link\"\n            class=\"dropdown-item list-item\"\n            title=\"item.title\"\n            accesskey=\"item.accesskey\"\n            tabindex=\"item.tabindex\">\n            <ng-template *ngTemplateOutlet=\"item._implicitContent\"></ng-template>\n          </a>\n        } @else {\n          <div class=\"dropdown-item list-item\">\n            <ng-template *ngTemplateOutlet=\"item._implicitContent\"></ng-template>\n          </div>\n        }\n      </li>\n    }\n  </ng-container>\n</it-dropdown>\n",
      styles: [".link-list-wrapper{z-index:2;position:relative}a{cursor:pointer}:host ::ng-deep .dropdown-toggle{width:100%;height:100%}:host ::ng-deep .dropdown-toggle .icon{display:none}\n"]
    }]
  }], null, {
    componentClass: [{
      type: HostBinding,
      args: ['class']
    }],
    items: [{
      type: ContentChildren,
      args: [ItAvatarDropdownItemComponent]
    }]
  });
})();
var ColorsEnum;
(function (ColorsEnum) {
  ColorsEnum["primary"] = "primary";
  ColorsEnum["secondary"] = "secondary";
  ColorsEnum["success"] = "success";
  ColorsEnum["danger"] = "danger";
  ColorsEnum["warning"] = "warning";
  ColorsEnum["green"] = "green";
  ColorsEnum["orange"] = "orange";
  ColorsEnum["red"] = "red";
})(ColorsEnum || (ColorsEnum = {}));
var SizesEnum;
(function (SizesEnum) {
  SizesEnum["xs"] = "size-xs";
  SizesEnum["sm"] = "size-sm";
  SizesEnum["lg"] = "size-lg";
  SizesEnum["xl"] = "size-xl";
  SizesEnum["xxl"] = "size-xxl";
})(SizesEnum || (SizesEnum = {}));
class ItAvatarDirective {
  /**
   * Indica il colore dell'avatar. Può assumere i valori:
   * <ul>
   * <li> primary
   * <li> secondary
   * <li> green
   * <li> orange
   * <li> red
   * </ul>
   */
  get color() {
    return this._color;
  }
  set color(value) {
    const colorsKey = value;
    if (ColorsEnum[colorsKey]) {
      this._color = ColorsEnum[colorsKey];
    } else {
      this._color = undefined;
    }
  }
  /**
   * Indica la grandezza dell'avatar. Può assumere i valori:
   * <ul>
   * <li> xs
   * <li> sm
   * <li> lg
   * <li> xl
   * <li> xxl
   * </ul>
   */
  get size() {
    return this._size;
  }
  set size(value) {
    const sizesKey = value;
    if (SizesEnum[sizesKey]) {
      this._size = SizesEnum[sizesKey];
    } else {
      this._size = undefined;
    }
  }
  get hostClasses() {
    let cssClass = 'avatar';
    if (this.size) {
      cssClass += ` ${this.size}`;
    }
    if (this.color) {
      cssClass += ` avatar-${this.color}`;
    }
    return cssClass;
  }
  static {
    this.ɵfac = function ItAvatarDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItAvatarDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ItAvatarDirective,
      selectors: [["", "itAvatar", ""]],
      hostVars: 2,
      hostBindings: function ItAvatarDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses);
        }
      },
      inputs: {
        color: "color",
        size: "size"
      },
      exportAs: ["itAvatar"],
      standalone: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItAvatarDirective, [{
    type: Directive,
    args: [{
      standalone: true,
      selector: '[itAvatar]',
      exportAs: 'itAvatar'
    }]
  }], null, {
    color: [{
      type: Input
    }],
    size: [{
      type: Input
    }],
    hostClasses: [{
      type: HostBinding,
      args: ['class']
    }]
  });
})();
const avatarComponents = [ItAvatarGroupItemComponent, ItAvatarGroupComponent, ItAvatarDropdownComponent, ItAvatarDropdownItemComponent, ItAvatarDirective];
class ItAvatarModule {
  static {
    this.ɵfac = function ItAvatarModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItAvatarModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ItAvatarModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [ItAvatarDropdownComponent]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItAvatarModule, [{
    type: NgModule,
    args: [{
      imports: avatarComponents,
      exports: avatarComponents
    }]
  }], null, null);
})();

/**
 * Badge
 * @description Useful for small counters and labels
 */
class ItBadgeDirective {
  get badgeClass() {
    let badgeClass = 'badge';
    if (this.rounded) {
      badgeClass += ` rounded-pill`;
    }
    if (this.color) {
      badgeClass += ` bg-${this.color}`;
    }
    return badgeClass;
  }
  static {
    this.ɵfac = function ItBadgeDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItBadgeDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ItBadgeDirective,
      selectors: [["", "itBadge", ""]],
      hostVars: 2,
      hostBindings: function ItBadgeDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.badgeClass);
        }
      },
      inputs: {
        color: [0, "itBadge", "color"],
        rounded: [2, "rounded", "rounded", inputToBoolean]
      },
      exportAs: ["itBadge"],
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItBadgeDirective, [{
    type: Directive,
    args: [{
      standalone: true,
      selector: '[itBadge]',
      exportAs: 'itBadge'
    }]
  }], null, {
    color: [{
      type: Input,
      args: ['itBadge']
    }],
    rounded: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    badgeClass: [{
      type: HostBinding,
      args: ['class']
    }]
  });
})();
class ItProgressBarComponent {
  /**
   * Return the background color
   */
  get bgColor() {
    if (!this.color) {
      return '';
    }
    return ` bg-${this.color}`;
  }
  static {
    this.ɵfac = function ItProgressBarComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItProgressBarComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItProgressBarComponent,
      selectors: [["it-progress-bar"]],
      inputs: {
        value: "value",
        showLabel: [2, "showLabel", "showLabel", inputToBoolean],
        indeterminate: [2, "indeterminate", "indeterminate", inputToBoolean],
        color: "color"
      },
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵStandaloneFeature],
      decls: 5,
      vars: 6,
      consts: [[1, "progress-bar-wrapper"], [1, "progress-bar-label"], [1, "progress"], ["role", "progressbar", 3, "class"], ["role", "progressbar", "aria-valuemin", "0", "aria-valuemax", "100", 3, "class", "width"], [1, "visually-hidden"], ["role", "progressbar"], ["role", "progressbar", "aria-valuemin", "0", "aria-valuemax", "100"]],
      template: function ItProgressBarComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, ItProgressBarComponent_Conditional_1_Template, 5, 4, "div", 1);
          i0.ɵɵelementStart(2, "div", 2);
          i0.ɵɵtemplate(3, ItProgressBarComponent_Conditional_3_Template, 1, 3, "div", 3)(4, ItProgressBarComponent_Conditional_4_Template, 1, 6, "div", 4);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.showLabel ? 1 : -1);
          i0.ɵɵadvance();
          i0.ɵɵclassProp("progress-color", !!ctx.color)("progress-indeterminate", ctx.indeterminate);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.indeterminate ? 3 : 4);
        }
      },
      dependencies: [TranslateModule, i1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItProgressBarComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-progress-bar',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [TranslateModule],
      template: "<div class=\"progress-bar-wrapper\">\n  @if (showLabel) {\n    <div class=\"progress-bar-label\">\n      <span class=\"visually-hidden\">{{ 'it.core.progress' | translate }} </span>{{ value }}%\n    </div>\n  }\n  <div class=\"progress\" [class.progress-color]=\"!!color\" [class.progress-indeterminate]=\"indeterminate\">\n    @if (indeterminate) {\n      <div class=\"progress-bar{{ bgColor }}\" role=\"progressbar\"></div>\n    } @else {\n      <div\n        class=\"progress-bar{{ bgColor }}\"\n        role=\"progressbar\"\n        [style.width.%]=\"value\"\n        [attr.aria-valuenow]=\"value\"\n        aria-valuemin=\"0\"\n        aria-valuemax=\"100\"></div>\n    }\n  </div>\n</div>\n"
    }]
  }], null, {
    value: [{
      type: Input,
      args: [{
        required: true
      }]
    }],
    showLabel: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    indeterminate: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    color: [{
      type: Input
    }]
  });
})();
class ItProgressButtonComponent {
  get isProgress() {
    return typeof this.progress === 'number' || !!this.progress;
  }
  get progressValue() {
    return typeof this.progress === 'number' ? this.progress : 0;
  }
  get isIndeterminate() {
    return typeof this.progress !== 'number' && !!this.progress;
  }
  static {
    this.ɵfac = function ItProgressButtonComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItProgressButtonComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItProgressButtonComponent,
      selectors: [["button", "itButton", "", "progress", ""]],
      inputs: {
        progress: "progress",
        progressColor: "progressColor"
      },
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      attrs: _c11,
      ngContentSelectors: _c1,
      decls: 2,
      vars: 1,
      consts: [[3, "value", "indeterminate", "color"]],
      template: function ItProgressButtonComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
          i0.ɵɵtemplate(1, ItProgressButtonComponent_Conditional_1_Template, 1, 3, "it-progress-bar", 0);
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.isProgress ? 1 : -1);
        }
      },
      dependencies: [ItProgressBarComponent],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItProgressButtonComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'button[itButton][progress]',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [ItProgressBarComponent],
      template: "<ng-content></ng-content>\n\n@if (isProgress) {\n  <it-progress-bar [value]=\"progressValue\" [indeterminate]=\"isIndeterminate\" [color]=\"progressColor\"></it-progress-bar>\n}\n"
    }]
  }], null, {
    progress: [{
      type: Input
    }],
    progressColor: [{
      type: Input
    }]
  });
})();

/**
 * Button
 * @description Bootstrap italia custom button styles
 */
class ItButtonDirective {
  constructor(progressButtonComponent) {
    this.progressButtonComponent = progressButtonComponent;
    /**
     * The type attribute
     * @default button
     */
    this.type = 'button';
  }
  get hostClasses() {
    let cssClass = 'btn';
    if (this.color) {
      cssClass += ` btn-${this.color}`;
    }
    if (this.size) {
      cssClass += ` btn-${this.size}`;
    }
    if (this.block) {
      cssClass += ' btn-block';
    }
    if (this.disabled) {
      cssClass += ' disabled';
    }
    if (this.icons?.length && !this.progressButtonComponent) {
      cssClass += ' btn-icon';
    }
    if (this.progressButtonComponent) {
      cssClass += ' btn-progress';
    }
    return cssClass;
  }
  static {
    this.ɵfac = function ItButtonDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItButtonDirective)(i0.ɵɵdirectiveInject(ItProgressButtonComponent, 9));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ItButtonDirective,
      selectors: [["", "itButton", ""]],
      contentQueries: function ItButtonDirective_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, ItIconComponent, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.icons = _t);
        }
      },
      hostVars: 4,
      hostBindings: function ItButtonDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵhostProperty("disabled", ctx.disabled)("type", ctx.type);
          i0.ɵɵclassMap(ctx.hostClasses);
        }
      },
      inputs: {
        color: [0, "itButton", "color"],
        size: "size",
        block: "block",
        disabled: [2, "disabled", "disabled", inputToBoolean],
        type: "type"
      },
      exportAs: ["itButton"],
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItButtonDirective, [{
    type: Directive,
    args: [{
      standalone: true,
      selector: '[itButton]',
      exportAs: 'itButton'
    }]
  }], () => [{
    type: ItProgressButtonComponent,
    decorators: [{
      type: Optional
    }, {
      type: Host
    }]
  }], {
    color: [{
      type: Input,
      args: ['itButton']
    }],
    size: [{
      type: Input
    }],
    block: [{
      type: Input
    }],
    disabled: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }, {
      type: HostBinding,
      args: ['disabled']
    }],
    type: [{
      type: Input
    }, {
      type: HostBinding,
      args: ['type']
    }],
    icons: [{
      type: ContentChildren,
      args: [ItIconComponent]
    }],
    hostClasses: [{
      type: HostBinding,
      args: ['class']
    }]
  });
})();

/**
 * Callout
 * @description Callouts can be used to highlight certain parts of the text that require particular attention. They may contain error messages, warnings, hints, etc.
 */
class ItCalloutComponent {
  constructor() {
    /**
     * Callout appearance
     * - <b>default</b>
     * - <b>highlight</b>: Callout version with border only on the left side
     * - <b>more</b>: It looks radically different from the other styles available and is suitable for more extensive texts
     * @default default
     */
    this.appearance = 'default';
    /**
     * The input label even get labelWaria icon
     * @default undefined
     */
    this.labelWaria = undefined;
  }
  get iconName() {
    if (this.icon) {
      return this.icon;
    }
    if (this.appearance === 'more') {
      return 'zoom-in';
    }
    switch (this.color) {
      case 'success':
        return 'check-circle';
      case 'warning':
        return 'help-circle';
      case 'danger':
        return 'close-circle';
      case 'important':
      case 'note':
      default:
        return 'info-circle';
    }
  }
  static {
    this.ɵfac = function ItCalloutComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItCalloutComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItCalloutComponent,
      selectors: [["it-callout"]],
      inputs: {
        label: "label",
        hiddenLabel: "hiddenLabel",
        color: "color",
        appearance: "appearance",
        icon: "icon",
        labelWaria: "labelWaria"
      },
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c13,
      decls: 5,
      vars: 8,
      consts: [["inner", ""], [1, "callout-inner"], [4, "ngTemplateOutlet"], [1, "callout-title"], [1, "callout-big-text"], [3, "labelWaria", "name"], [1, "visually-hidden"], [1, "text"]],
      template: function ItCalloutComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c12);
          i0.ɵɵelementStart(0, "div");
          i0.ɵɵtemplate(1, ItCalloutComponent_Conditional_1_Template, 2, 1, "div", 1)(2, ItCalloutComponent_Conditional_2_Template, 1, 1, "ng-container");
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(3, ItCalloutComponent_ng_template_3_Template, 4, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵclassMapInterpolate1("callout ", ctx.color, "");
          i0.ɵɵclassProp("callout-highlight", ctx.appearance === "highlight")("callout-more", ctx.appearance === "more");
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.appearance === "default" ? 1 : 2);
        }
      },
      dependencies: [NgTemplateOutlet, ItIconComponent],
      styles: [".callout-big-text[_ngcontent-%COMP%]:empty{display:none}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItCalloutComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-callout',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [NgTemplateOutlet, ItIconComponent],
      template: "<div class=\"callout {{ color }}\" [class.callout-highlight]=\"appearance === 'highlight'\" [class.callout-more]=\"appearance === 'more'\">\n  @if (appearance === 'default') {\n    <div class=\"callout-inner\">\n      <ng-container *ngTemplateOutlet=\"inner\"></ng-container>\n    </div>\n  } @else {\n    <ng-container *ngTemplateOutlet=\"inner\"></ng-container>\n  }\n</div>\n\n<ng-template #inner>\n  @if (label) {\n    <div class=\"callout-title\">\n      <it-icon [labelWaria]=\"labelWaria\" [name]=\"iconName\"></it-icon>\n      @if (hiddenLabel) {\n        <span class=\"visually-hidden\">{{ hiddenLabel }}</span>\n      }\n      <span class=\"text\">{{ label }}</span>\n    </div>\n  }\n  <p class=\"callout-big-text\">\n    <ng-content select=\"[bigText]\"></ng-content>\n  </p>\n  <ng-content></ng-content>\n</ng-template>\n",
      styles: [".callout-big-text:empty{display:none}\n"]
    }]
  }], null, {
    label: [{
      type: Input
    }],
    hiddenLabel: [{
      type: Input
    }],
    color: [{
      type: Input
    }],
    appearance: [{
      type: Input
    }],
    icon: [{
      type: Input
    }],
    labelWaria: [{
      type: Input
    }]
  });
})();

/**
 * Card
 * @description A container of texts and images with many options and variations.
 */
class ItCardComponent extends ItAbstractComponent {
  constructor() {
    super(...arguments);
    /**
     * Custom card class
     * @default ''
     */
    this.cardClass = '';
    /**
     * Custom card body class
     * @default ''
     */
    this.bodyClass = '';
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵItCardComponent_BaseFactory;
      return function ItCardComponent_Factory(__ngFactoryType__) {
        return (ɵItCardComponent_BaseFactory || (ɵItCardComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ItCardComponent)))(__ngFactoryType__ || ItCardComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItCardComponent,
      selectors: [["it-card"]],
      inputs: {
        teaser: [2, "teaser", "teaser", inputToBoolean],
        special: [2, "special", "special", inputToBoolean],
        hasImage: [2, "hasImage", "hasImage", inputToBoolean],
        rounded: [2, "rounded", "rounded", inputToBoolean],
        shadow: [2, "shadow", "shadow", inputToBoolean],
        background: [2, "background", "background", inputToBoolean],
        borderBottom: [2, "borderBottom", "borderBottom", inputToBoolean],
        big: [2, "big", "big", inputToBoolean],
        cardClass: "cardClass",
        bodyClass: "bodyClass"
      },
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c15,
      decls: 4,
      vars: 1,
      consts: [["cardContent", ""], [3, "class", "card-img", "card-teaser", "no-after", "shadow", "card-bg", "card-big", "border-bottom-card", "rounded"], [3, "class", "card-img", "card-teaser", "shadow", "card-bg", "card-big", "no-after", "border-bottom-card", "rounded"], [4, "ngTemplateOutlet"]],
      template: function ItCardComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c14);
          i0.ɵɵtemplate(0, ItCardComponent_ng_template_0_Template, 3, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, ItCardComponent_Conditional_2_Template, 2, 20, "div", 1)(3, ItCardComponent_Conditional_3_Template, 2, 20, "a", 2);
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(!ctx.special ? 2 : 3);
        }
      },
      dependencies: [NgTemplateOutlet],
      styles: [".card-body[_ngcontent-%COMP%]:empty{display:none}  .row [class*=col-] .card,   .row [class*=col-] .card-wrapper{height:100%}  .card-wrapper.card-teaser-wrapper it-card{flex-direction:row;align-items:flex-start;flex:0 0 100%;flex-wrap:wrap;margin:16px 0}@media (min-width: 768px){  .card-wrapper.card-teaser-wrapper it-card{flex:0 0 49%}}[_nghost-%COMP%]{width:100%}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItCardComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-card',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [NgTemplateOutlet],
      template: "<ng-template #cardContent>\n  <ng-content select=\"[beforeBody]\"></ng-content>\n\n  <div class=\"card-body {{ bodyClass }}\">\n    <ng-content></ng-content>\n  </div>\n</ng-template>\n\n@if (!special) {\n  <div\n    class=\"card {{ cardClass }}\"\n    [class.card-img]=\"hasImage\"\n    [class.card-teaser]=\"teaser\"\n    [class.no-after]=\"hasImage\"\n    [class.shadow]=\"shadow\"\n    [class.card-bg]=\"background\"\n    [class.card-big]=\"big\"\n    [class.border-bottom-card]=\"borderBottom\"\n    [class.rounded]=\"rounded\">\n    <ng-container *ngTemplateOutlet=\"cardContent\"></ng-container>\n  </div>\n} @else {\n  <a\n    class=\"card special-card {{ cardClass }}\"\n    [class.card-img]=\"hasImage\"\n    [class.card-teaser]=\"teaser\"\n    [class.shadow]=\"shadow\"\n    [class.card-bg]=\"background\"\n    [class.card-big]=\"big\"\n    [class.no-after]=\"hasImage\"\n    [class.border-bottom-card]=\"borderBottom\"\n    [class.rounded]=\"rounded\">\n    <ng-container *ngTemplateOutlet=\"cardContent\"></ng-container>\n  </a>\n}\n",
      styles: [".card-body:empty{display:none}::ng-deep .row [class*=col-] .card,::ng-deep .row [class*=col-] .card-wrapper{height:100%}::ng-deep .card-wrapper.card-teaser-wrapper it-card{flex-direction:row;align-items:flex-start;flex:0 0 100%;flex-wrap:wrap;margin:16px 0}@media (min-width: 768px){::ng-deep .card-wrapper.card-teaser-wrapper it-card{flex:0 0 49%}}:host{width:100%}\n"]
    }]
  }], null, {
    teaser: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    special: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    hasImage: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    rounded: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    shadow: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    background: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    borderBottom: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    big: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    cardClass: [{
      type: Input
    }],
    bodyClass: [{
      type: Input
    }]
  });
})();

/**
 * Carousel Item
 * @description element, image or text slide of carousel
 */
class ItCarouselItemComponent extends ItAbstractComponent {
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵItCarouselItemComponent_BaseFactory;
      return function ItCarouselItemComponent_Factory(__ngFactoryType__) {
        return (ɵItCarouselItemComponent_BaseFactory || (ɵItCarouselItemComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ItCarouselItemComponent)))(__ngFactoryType__ || ItCarouselItemComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItCarouselItemComponent,
      selectors: [["it-carousel-item"]],
      viewQuery: function ItCarouselItemComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(TemplateRef, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.htmlContent = _t.first);
        }
      },
      standalone: true,
      features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function ItCarouselItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, ItCarouselItemComponent_ng_template_0_Template, 1, 0, "ng-template");
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItCarouselItemComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-carousel-item',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [],
      template: "<ng-template>\n  <ng-content></ng-content>\n</ng-template>\n"
    }]
  }], null, {
    htmlContent: [{
      type: ViewChild,
      args: [TemplateRef]
    }]
  });
})();

/**
 * Carousel
 * @description A presentation component for scrolling through elements, images or text slides.
 */
class ItCarouselComponent {
  get typeClass() {
    const typeClass = 'it-carousel-landscape-abstract';
    return this.type === 'default' ? typeClass : typeClass + `-${this.type}`;
  }
  constructor(_changeDetectorRef) {
    this._changeDetectorRef = _changeDetectorRef;
    /**
     * The carousel type
     * @default default
     */
    this.type = 'default';
    /**
     * Custom class in splide__track element
     * @default ''
     */
    this.trackClass = '';
  }
  ngAfterViewInit() {
    this.carousel = CarouselBI.getOrCreateInstance(this.carouselDiv.nativeElement);
    this.items?.changes.pipe(
    // When carousel items changes (dynamic add/remove)
    startWith(undefined)).subscribe(() => {
      this.itemSubscriptions?.forEach(sub => sub.unsubscribe()); // Remove old subscriptions
      this.itemSubscriptions = this.items?.map(item => item.valueChanges.subscribe(() => {
        this._changeDetectorRef.detectChanges(); // DetectChanges when carousel item attributes changes
      }));
      this._changeDetectorRef.detectChanges(); // Force update html render
    });
  }
  ngOnDestroy() {
    this.itemSubscriptions?.forEach(item => item.unsubscribe());
  }
  /**
   * Removes CarouselBI features
   */
  dispose() {
    this.carousel?.dispose();
  }
  static {
    this.ɵfac = function ItCarouselComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItCarouselComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItCarouselComponent,
      selectors: [["it-carousel"]],
      contentQueries: function ItCarouselComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, ItCarouselItemComponent, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.items = _t);
        }
      },
      viewQuery: function ItCarouselComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c16, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.carouselDiv = _t.first);
        }
      },
      inputs: {
        title: "title",
        type: "type",
        trackClass: "trackClass",
        fullCarousel: [2, "fullCarousel", "fullCarousel", inputToBoolean],
        bigImg: [2, "bigImg", "bigImg", inputToBoolean],
        standardImage: [2, "standardImage", "standardImage", inputToBoolean],
        lined: [2, "lined", "lined", inputToBoolean]
      },
      exportAs: ["itCarousel"],
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵStandaloneFeature],
      decls: 5,
      vars: 14,
      consts: [["carousel", ""], ["data-bs-carousel-splide", ""], [1, "it-header-block"], [1, "splide__list"], [1, "it-header-block-title"], [1, "splide__slide", 3, "lined_slide"], [1, "splide__slide"], [1, "it-single-slide-wrapper"], [4, "ngTemplateOutlet"]],
      template: function ItCarouselComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 1, 0);
          i0.ɵɵtemplate(2, ItCarouselComponent_Conditional_2_Template, 4, 1, "div", 2);
          i0.ɵɵelementStart(3, "div");
          i0.ɵɵtemplate(4, ItCarouselComponent_Conditional_4_Template, 3, 0, "ul", 3);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵclassMapInterpolate1("it-carousel-wrapper splide ", ctx.typeClass, "");
          i0.ɵɵclassProp("it-full-carousel", ctx.fullCarousel)("it-big-img", ctx.bigImg)("it-standard-image", ctx.standardImage);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx.title ? 2 : -1);
          i0.ɵɵadvance();
          i0.ɵɵclassMapInterpolate1("splide__track ", ctx.trackClass, "");
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.items ? 4 : -1);
        }
      },
      dependencies: [NgTemplateOutlet],
      styles: [".splide__container[_ngcontent-%COMP%]{box-sizing:border-box;position:relative}.splide__list[_ngcontent-%COMP%]{-webkit-backface-visibility:hidden;backface-visibility:hidden;display:-ms-flexbox;display:flex;height:100%;margin:0!important;padding:0!important;transform-style:preserve-3d}.splide.is-initialized[_ngcontent-%COMP%]:not(.is-active)   .splide__list[_ngcontent-%COMP%]{display:block}.splide__pagination[_ngcontent-%COMP%]{-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:center;justify-content:center;margin:0;pointer-events:none}.splide__pagination[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{display:inline-block;line-height:1;list-style-type:none;margin:0;pointer-events:auto}.splide__progress__bar[_ngcontent-%COMP%]{width:0}.splide[_ngcontent-%COMP%]{outline:none;position:relative;visibility:hidden}.splide.is-initialized[_ngcontent-%COMP%], .splide.is-rendered[_ngcontent-%COMP%]{visibility:visible}.splide__slide[_ngcontent-%COMP%]{-webkit-backface-visibility:hidden;backface-visibility:hidden;box-sizing:border-box;-ms-flex-negative:0;flex-shrink:0;list-style-type:none!important;margin:0;outline:none;position:relative}.splide__slide[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{vertical-align:bottom}.splide__slider[_ngcontent-%COMP%]{position:relative}.splide__spinner[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_splide-loading 1s linear infinite;border:2px solid #999;border-left-color:transparent;border-radius:50%;contain:strict;display:inline-block;height:20px;inset:0;margin:auto;position:absolute;width:20px}.splide__track[_ngcontent-%COMP%]{overflow:hidden;position:relative;z-index:0}@keyframes _ngcontent-%COMP%_splide-loading{0%{transform:rotate(0)}to{transform:rotate(1turn)}}.splide--draggable[_ngcontent-%COMP%] > .splide__slider[_ngcontent-%COMP%] > .splide__track[_ngcontent-%COMP%], .splide--draggable[_ngcontent-%COMP%] > .splide__track[_ngcontent-%COMP%]{-webkit-user-select:none;-ms-user-select:none;user-select:none}.splide--fade[_ngcontent-%COMP%] > .splide__slider[_ngcontent-%COMP%] > .splide__track[_ngcontent-%COMP%] > .splide__list[_ngcontent-%COMP%], .splide--fade[_ngcontent-%COMP%] > .splide__track[_ngcontent-%COMP%] > .splide__list[_ngcontent-%COMP%]{display:block}.splide--fade[_ngcontent-%COMP%] > .splide__slider[_ngcontent-%COMP%] > .splide__track[_ngcontent-%COMP%] > .splide__list[_ngcontent-%COMP%] > .splide__slide[_ngcontent-%COMP%], .splide--fade[_ngcontent-%COMP%] > .splide__track[_ngcontent-%COMP%] > .splide__list[_ngcontent-%COMP%] > .splide__slide[_ngcontent-%COMP%]{left:0;opacity:0;position:absolute;top:0;z-index:0}.splide--fade[_ngcontent-%COMP%] > .splide__slider[_ngcontent-%COMP%] > .splide__track[_ngcontent-%COMP%] > .splide__list[_ngcontent-%COMP%] > .splide__slide.is-active[_ngcontent-%COMP%], .splide--fade[_ngcontent-%COMP%] > .splide__track[_ngcontent-%COMP%] > .splide__list[_ngcontent-%COMP%] > .splide__slide.is-active[_ngcontent-%COMP%]{opacity:1;position:relative;z-index:1}.splide--rtl[_ngcontent-%COMP%]{direction:rtl}.splide--ttb.is-active[_ngcontent-%COMP%] > .splide__slider[_ngcontent-%COMP%] > .splide__track[_ngcontent-%COMP%] > .splide__list[_ngcontent-%COMP%], .splide--ttb.is-active[_ngcontent-%COMP%] > .splide__track[_ngcontent-%COMP%] > .splide__list[_ngcontent-%COMP%]{display:block}.splide__arrow[_ngcontent-%COMP%]{-ms-flex-align:center;align-items:center;background:#ccc;border:0;border-radius:50%;cursor:pointer;display:-ms-flexbox;display:flex;height:2em;-ms-flex-pack:center;justify-content:center;opacity:.7;padding:0;position:absolute;top:50%;transform:translateY(-50%);width:2em;z-index:1}.splide__arrow[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{fill:#000;height:1.2em;width:1.2em}.splide__arrow[_ngcontent-%COMP%]:hover{opacity:.9}.splide__arrow[_ngcontent-%COMP%]:focus{outline:none}.splide__arrow--prev[_ngcontent-%COMP%]{left:1em}.splide__arrow--prev[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{transform:scaleX(-1)}.splide__arrow--next[_ngcontent-%COMP%]{right:1em}.splide__pagination[_ngcontent-%COMP%]{bottom:.5em;left:0;padding:0 1em;position:absolute;right:0;z-index:1}.splide__pagination__page[_ngcontent-%COMP%]{background:#ccc;border:0;border-radius:50%;display:inline-block;height:8px;margin:3px;opacity:.7;padding:0;transition:transform .2s linear;width:8px}.splide__pagination__page.is-active[_ngcontent-%COMP%]{background:#fff;transform:scale(1.4)}.splide__pagination__page[_ngcontent-%COMP%]:hover{cursor:pointer;opacity:.9}.splide__pagination__page[_ngcontent-%COMP%]:focus{outline:none}.splide__progress__bar[_ngcontent-%COMP%]{background:#ccc;height:3px}.splide--nav[_ngcontent-%COMP%] > .splide__slider[_ngcontent-%COMP%] > .splide__track[_ngcontent-%COMP%] > .splide__list[_ngcontent-%COMP%] > .splide__slide[_ngcontent-%COMP%], .splide--nav[_ngcontent-%COMP%] > .splide__track[_ngcontent-%COMP%] > .splide__list[_ngcontent-%COMP%] > .splide__slide[_ngcontent-%COMP%]{border:3px solid transparent;cursor:pointer}.splide--nav[_ngcontent-%COMP%] > .splide__slider[_ngcontent-%COMP%] > .splide__track[_ngcontent-%COMP%] > .splide__list[_ngcontent-%COMP%] > .splide__slide.is-active[_ngcontent-%COMP%], .splide--nav[_ngcontent-%COMP%] > .splide__track[_ngcontent-%COMP%] > .splide__list[_ngcontent-%COMP%] > .splide__slide.is-active[_ngcontent-%COMP%]{border:3px solid #000}.splide--nav[_ngcontent-%COMP%] > .splide__slider[_ngcontent-%COMP%] > .splide__track[_ngcontent-%COMP%] > .splide__list[_ngcontent-%COMP%] > .splide__slide[_ngcontent-%COMP%]:focus, .splide--nav[_ngcontent-%COMP%] > .splide__track[_ngcontent-%COMP%] > .splide__list[_ngcontent-%COMP%] > .splide__slide[_ngcontent-%COMP%]:focus{outline:none}.splide--rtl[_ngcontent-%COMP%] > .splide__arrows[_ngcontent-%COMP%]   .splide__arrow--prev[_ngcontent-%COMP%], .splide--rtl[_ngcontent-%COMP%] > .splide__slider[_ngcontent-%COMP%] > .splide__track[_ngcontent-%COMP%] > .splide__arrows[_ngcontent-%COMP%]   .splide__arrow--prev[_ngcontent-%COMP%], .splide--rtl[_ngcontent-%COMP%] > .splide__track[_ngcontent-%COMP%] > .splide__arrows[_ngcontent-%COMP%]   .splide__arrow--prev[_ngcontent-%COMP%]{left:auto;right:1em}.splide--rtl[_ngcontent-%COMP%] > .splide__arrows[_ngcontent-%COMP%]   .splide__arrow--prev[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%], .splide--rtl[_ngcontent-%COMP%] > .splide__slider[_ngcontent-%COMP%] > .splide__track[_ngcontent-%COMP%] > .splide__arrows[_ngcontent-%COMP%]   .splide__arrow--prev[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%], .splide--rtl[_ngcontent-%COMP%] > .splide__track[_ngcontent-%COMP%] > .splide__arrows[_ngcontent-%COMP%]   .splide__arrow--prev[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{transform:scaleX(1)}.splide--rtl[_ngcontent-%COMP%] > .splide__arrows[_ngcontent-%COMP%]   .splide__arrow--next[_ngcontent-%COMP%], .splide--rtl[_ngcontent-%COMP%] > .splide__slider[_ngcontent-%COMP%] > .splide__track[_ngcontent-%COMP%] > .splide__arrows[_ngcontent-%COMP%]   .splide__arrow--next[_ngcontent-%COMP%], .splide--rtl[_ngcontent-%COMP%] > .splide__track[_ngcontent-%COMP%] > .splide__arrows[_ngcontent-%COMP%]   .splide__arrow--next[_ngcontent-%COMP%]{left:1em;right:auto}.splide--rtl[_ngcontent-%COMP%] > .splide__arrows[_ngcontent-%COMP%]   .splide__arrow--next[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%], .splide--rtl[_ngcontent-%COMP%] > .splide__slider[_ngcontent-%COMP%] > .splide__track[_ngcontent-%COMP%] > .splide__arrows[_ngcontent-%COMP%]   .splide__arrow--next[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%], .splide--rtl[_ngcontent-%COMP%] > .splide__track[_ngcontent-%COMP%] > .splide__arrows[_ngcontent-%COMP%]   .splide__arrow--next[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{transform:scaleX(-1)}.splide--ttb[_ngcontent-%COMP%] > .splide__arrows[_ngcontent-%COMP%]   .splide__arrow[_ngcontent-%COMP%], .splide--ttb[_ngcontent-%COMP%] > .splide__slider[_ngcontent-%COMP%] > .splide__track[_ngcontent-%COMP%] > .splide__arrows[_ngcontent-%COMP%]   .splide__arrow[_ngcontent-%COMP%], .splide--ttb[_ngcontent-%COMP%] > .splide__track[_ngcontent-%COMP%] > .splide__arrows[_ngcontent-%COMP%]   .splide__arrow[_ngcontent-%COMP%]{left:50%;transform:translate(-50%)}.splide--ttb[_ngcontent-%COMP%] > .splide__arrows[_ngcontent-%COMP%]   .splide__arrow--prev[_ngcontent-%COMP%], .splide--ttb[_ngcontent-%COMP%] > .splide__slider[_ngcontent-%COMP%] > .splide__track[_ngcontent-%COMP%] > .splide__arrows[_ngcontent-%COMP%]   .splide__arrow--prev[_ngcontent-%COMP%], .splide--ttb[_ngcontent-%COMP%] > .splide__track[_ngcontent-%COMP%] > .splide__arrows[_ngcontent-%COMP%]   .splide__arrow--prev[_ngcontent-%COMP%]{top:1em}.splide--ttb[_ngcontent-%COMP%] > .splide__arrows[_ngcontent-%COMP%]   .splide__arrow--prev[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%], .splide--ttb[_ngcontent-%COMP%] > .splide__slider[_ngcontent-%COMP%] > .splide__track[_ngcontent-%COMP%] > .splide__arrows[_ngcontent-%COMP%]   .splide__arrow--prev[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%], .splide--ttb[_ngcontent-%COMP%] > .splide__track[_ngcontent-%COMP%] > .splide__arrows[_ngcontent-%COMP%]   .splide__arrow--prev[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{transform:rotate(-90deg)}.splide--ttb[_ngcontent-%COMP%] > .splide__arrows[_ngcontent-%COMP%]   .splide__arrow--next[_ngcontent-%COMP%], .splide--ttb[_ngcontent-%COMP%] > .splide__slider[_ngcontent-%COMP%] > .splide__track[_ngcontent-%COMP%] > .splide__arrows[_ngcontent-%COMP%]   .splide__arrow--next[_ngcontent-%COMP%], .splide--ttb[_ngcontent-%COMP%] > .splide__track[_ngcontent-%COMP%] > .splide__arrows[_ngcontent-%COMP%]   .splide__arrow--next[_ngcontent-%COMP%]{bottom:1em;top:auto}.splide--ttb[_ngcontent-%COMP%] > .splide__arrows[_ngcontent-%COMP%]   .splide__arrow--next[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%], .splide--ttb[_ngcontent-%COMP%] > .splide__slider[_ngcontent-%COMP%] > .splide__track[_ngcontent-%COMP%] > .splide__arrows[_ngcontent-%COMP%]   .splide__arrow--next[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%], .splide--ttb[_ngcontent-%COMP%] > .splide__track[_ngcontent-%COMP%] > .splide__arrows[_ngcontent-%COMP%]   .splide__arrow--next[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{transform:rotate(90deg)}.splide--ttb[_ngcontent-%COMP%] > .splide__pagination[_ngcontent-%COMP%], .splide--ttb[_ngcontent-%COMP%] > .splide__slider[_ngcontent-%COMP%] > .splide__pagination[_ngcontent-%COMP%]{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;inset:0 .5em 0 auto;padding:1em 0}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItCarouselComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-carousel',
      exportAs: 'itCarousel',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [NgTemplateOutlet],
      template: "<div\n  #carousel\n  class=\"it-carousel-wrapper splide {{ typeClass }}\"\n  [class.it-full-carousel]=\"fullCarousel\"\n  [class.it-big-img]=\"bigImg\"\n  [class.it-standard-image]=\"standardImage\"\n  data-bs-carousel-splide>\n  @if (title) {\n    <div class=\"it-header-block\">\n      <div class=\"it-header-block-title\">\n        <h2>{{ title }}</h2>\n      </div>\n    </div>\n  }\n\n  <div class=\"splide__track {{ trackClass }}\">\n    @if (items) {\n      <ul class=\"splide__list\">\n        @for (item of items; track item) {\n          <li class=\"splide__slide\" [class.lined_slide]=\"lined\">\n            <div class=\"it-single-slide-wrapper\">\n              <ng-container *ngTemplateOutlet=\"item.htmlContent\"></ng-container>\n            </div>\n          </li>\n        }\n      </ul>\n    }\n  </div>\n</div>\n",
      styles: [".splide__container{box-sizing:border-box;position:relative}.splide__list{-webkit-backface-visibility:hidden;backface-visibility:hidden;display:-ms-flexbox;display:flex;height:100%;margin:0!important;padding:0!important;transform-style:preserve-3d}.splide.is-initialized:not(.is-active) .splide__list{display:block}.splide__pagination{-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:center;justify-content:center;margin:0;pointer-events:none}.splide__pagination li{display:inline-block;line-height:1;list-style-type:none;margin:0;pointer-events:auto}.splide__progress__bar{width:0}.splide{outline:none;position:relative;visibility:hidden}.splide.is-initialized,.splide.is-rendered{visibility:visible}.splide__slide{-webkit-backface-visibility:hidden;backface-visibility:hidden;box-sizing:border-box;-ms-flex-negative:0;flex-shrink:0;list-style-type:none!important;margin:0;outline:none;position:relative}.splide__slide img{vertical-align:bottom}.splide__slider{position:relative}.splide__spinner{animation:splide-loading 1s linear infinite;border:2px solid #999;border-left-color:transparent;border-radius:50%;contain:strict;display:inline-block;height:20px;inset:0;margin:auto;position:absolute;width:20px}.splide__track{overflow:hidden;position:relative;z-index:0}@keyframes splide-loading{0%{transform:rotate(0)}to{transform:rotate(1turn)}}.splide--draggable>.splide__slider>.splide__track,.splide--draggable>.splide__track{-webkit-user-select:none;-ms-user-select:none;user-select:none}.splide--fade>.splide__slider>.splide__track>.splide__list,.splide--fade>.splide__track>.splide__list{display:block}.splide--fade>.splide__slider>.splide__track>.splide__list>.splide__slide,.splide--fade>.splide__track>.splide__list>.splide__slide{left:0;opacity:0;position:absolute;top:0;z-index:0}.splide--fade>.splide__slider>.splide__track>.splide__list>.splide__slide.is-active,.splide--fade>.splide__track>.splide__list>.splide__slide.is-active{opacity:1;position:relative;z-index:1}.splide--rtl{direction:rtl}.splide--ttb.is-active>.splide__slider>.splide__track>.splide__list,.splide--ttb.is-active>.splide__track>.splide__list{display:block}.splide__arrow{-ms-flex-align:center;align-items:center;background:#ccc;border:0;border-radius:50%;cursor:pointer;display:-ms-flexbox;display:flex;height:2em;-ms-flex-pack:center;justify-content:center;opacity:.7;padding:0;position:absolute;top:50%;transform:translateY(-50%);width:2em;z-index:1}.splide__arrow svg{fill:#000;height:1.2em;width:1.2em}.splide__arrow:hover{opacity:.9}.splide__arrow:focus{outline:none}.splide__arrow--prev{left:1em}.splide__arrow--prev svg{transform:scaleX(-1)}.splide__arrow--next{right:1em}.splide__pagination{bottom:.5em;left:0;padding:0 1em;position:absolute;right:0;z-index:1}.splide__pagination__page{background:#ccc;border:0;border-radius:50%;display:inline-block;height:8px;margin:3px;opacity:.7;padding:0;transition:transform .2s linear;width:8px}.splide__pagination__page.is-active{background:#fff;transform:scale(1.4)}.splide__pagination__page:hover{cursor:pointer;opacity:.9}.splide__pagination__page:focus{outline:none}.splide__progress__bar{background:#ccc;height:3px}.splide--nav>.splide__slider>.splide__track>.splide__list>.splide__slide,.splide--nav>.splide__track>.splide__list>.splide__slide{border:3px solid transparent;cursor:pointer}.splide--nav>.splide__slider>.splide__track>.splide__list>.splide__slide.is-active,.splide--nav>.splide__track>.splide__list>.splide__slide.is-active{border:3px solid #000}.splide--nav>.splide__slider>.splide__track>.splide__list>.splide__slide:focus,.splide--nav>.splide__track>.splide__list>.splide__slide:focus{outline:none}.splide--rtl>.splide__arrows .splide__arrow--prev,.splide--rtl>.splide__slider>.splide__track>.splide__arrows .splide__arrow--prev,.splide--rtl>.splide__track>.splide__arrows .splide__arrow--prev{left:auto;right:1em}.splide--rtl>.splide__arrows .splide__arrow--prev svg,.splide--rtl>.splide__slider>.splide__track>.splide__arrows .splide__arrow--prev svg,.splide--rtl>.splide__track>.splide__arrows .splide__arrow--prev svg{transform:scaleX(1)}.splide--rtl>.splide__arrows .splide__arrow--next,.splide--rtl>.splide__slider>.splide__track>.splide__arrows .splide__arrow--next,.splide--rtl>.splide__track>.splide__arrows .splide__arrow--next{left:1em;right:auto}.splide--rtl>.splide__arrows .splide__arrow--next svg,.splide--rtl>.splide__slider>.splide__track>.splide__arrows .splide__arrow--next svg,.splide--rtl>.splide__track>.splide__arrows .splide__arrow--next svg{transform:scaleX(-1)}.splide--ttb>.splide__arrows .splide__arrow,.splide--ttb>.splide__slider>.splide__track>.splide__arrows .splide__arrow,.splide--ttb>.splide__track>.splide__arrows .splide__arrow{left:50%;transform:translate(-50%)}.splide--ttb>.splide__arrows .splide__arrow--prev,.splide--ttb>.splide__slider>.splide__track>.splide__arrows .splide__arrow--prev,.splide--ttb>.splide__track>.splide__arrows .splide__arrow--prev{top:1em}.splide--ttb>.splide__arrows .splide__arrow--prev svg,.splide--ttb>.splide__slider>.splide__track>.splide__arrows .splide__arrow--prev svg,.splide--ttb>.splide__track>.splide__arrows .splide__arrow--prev svg{transform:rotate(-90deg)}.splide--ttb>.splide__arrows .splide__arrow--next,.splide--ttb>.splide__slider>.splide__track>.splide__arrows .splide__arrow--next,.splide--ttb>.splide__track>.splide__arrows .splide__arrow--next{bottom:1em;top:auto}.splide--ttb>.splide__arrows .splide__arrow--next svg,.splide--ttb>.splide__slider>.splide__track>.splide__arrows .splide__arrow--next svg,.splide--ttb>.splide__track>.splide__arrows .splide__arrow--next svg{transform:rotate(90deg)}.splide--ttb>.splide__pagination,.splide--ttb>.splide__slider>.splide__pagination{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;inset:0 .5em 0 auto;padding:1em 0}\n"]
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }], {
    title: [{
      type: Input
    }],
    type: [{
      type: Input
    }],
    trackClass: [{
      type: Input
    }],
    fullCarousel: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    bigImg: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    standardImage: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    lined: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    items: [{
      type: ContentChildren,
      args: [ItCarouselItemComponent]
    }],
    carouselDiv: [{
      type: ViewChild,
      args: ['carousel']
    }]
  });
})();
const carouselComponents = [ItCarouselComponent, ItCarouselItemComponent];
class ItCarouselModule {
  static {
    this.ɵfac = function ItCarouselModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItCarouselModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ItCarouselModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItCarouselModule, [{
    type: NgModule,
    args: [{
      imports: carouselComponents,
      exports: carouselComponents
    }]
  }], null, null);
})();
class ItChipComponent {
  /**
   * Indica la label
   */
  set label(value) {
    this._label = value;
  }
  get label() {
    return this._label;
  }
  /**
   * Indica se mostrate il pulante di chisura
   */
  set showCloseButton(value) {
    this._showCloseButton = value;
  }
  get showCloseButton() {
    return this._showCloseButton;
  }
  /**
   * Indica il size
   */
  set size(value) {
    this._size = value;
  }
  get size() {
    return this._size;
  }
  /**
   * Indica il colore della chip
   */
  set color(value) {
    this._color = value;
  }
  get color() {
    return this._color;
  }
  /**
   * Indica se la chip è disabilitata
   */
  set disabled(value) {
    this._disabled = value;
  }
  get disabled() {
    return this._disabled;
  }
  /**
   * Indica il nome dell'icona, se valorizzata viene mostrata
   */
  set icon(value) {
    this._icon = value;
  }
  get icon() {
    return this._icon;
  }
  /**
   * Indica l'url dell'avatar, se valorizzata viene mostrata
   */
  set avatar(value) {
    this._avatar = value;
  }
  get avatar() {
    return this._avatar;
  }
  /**
   * Indica il valore da aggiungere al parametro alt, di default ''
   */
  set altAvatar(value) {
    this._altAvatar = value;
  }
  get altAvatar() {
    return this._altAvatar;
  }
  /**
   * Return the icon href
   */
  get iconHref() {
    return `${this.assetBasePath}/dist/svg/sprites.svg#it-${this._icon}`;
  }
  /**
   * Return the close icon href
   */
  get iconCloseHref() {
    return `${this.assetBasePath}/dist/svg/sprites.svg#it-${this.iconClose}`;
  }
  constructor() {
    this._label = '';
    this._showCloseButton = false;
    this._size = '';
    this._color = undefined;
    this._disabled = false;
    this._icon = undefined;
    this._avatar = undefined;
    this._altAvatar = '';
    /**
     * Evento emesso al click sul bottone di chiusura
     */
    this.closeEvent = new EventEmitter();
    this.iconClose = 'close';
    this.assetBasePath = inject(IT_ASSET_BASE_PATH);
  }
  clickToClose() {
    this.closeEvent.emit();
  }
  static {
    this.ɵfac = function ItChipComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItChipComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItChipComponent,
      selectors: [["it-chip"]],
      inputs: {
        label: "label",
        showCloseButton: "showCloseButton",
        size: "size",
        color: "color",
        disabled: "disabled",
        icon: "icon",
        avatar: "avatar",
        altAvatar: "altAvatar"
      },
      outputs: {
        closeEvent: "closeEvent"
      },
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      decls: 6,
      vars: 10,
      consts: [[1, "chip", 3, "ngClass"], [1, "icon", "icon-xs"], [1, "avatar", "size-xs"], [1, "chip-label"], [3, "disabled"], [3, "src", "alt"], [3, "click", "disabled"], [1, "icon"], [1, "visually-hidden"]],
      template: function ItChipComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, ItChipComponent_Conditional_1_Template, 2, 2, ":svg:svg", 1)(2, ItChipComponent_Conditional_2_Template, 2, 2, "div", 2);
          i0.ɵɵelementStart(3, "span", 3);
          i0.ɵɵtext(4);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(5, ItChipComponent_Conditional_5_Template, 6, 7, "button", 4);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction4(5, _c17, !ctx.showCloseButton ? "chip-simple" : "alert", ctx.size === "lg" ? "chip-lg" : "", ctx.color ? "chip-" + ctx.color : "", ctx.disabled ? "chip-disabled" : ""));
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.icon ? 1 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.avatar ? 2 : -1);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(ctx.label);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.showCloseButton ? 5 : -1);
        }
      },
      dependencies: [NgClass, TranslateModule, i1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItChipComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-chip',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [NgClass, TranslateModule],
      template: "<div\n  class=\"chip\"\n  [ngClass]=\"[\n    !showCloseButton ? 'chip-simple' : 'alert',\n    size === 'lg' ? 'chip-lg' : '',\n    color ? 'chip-' + color : '',\n    disabled ? 'chip-disabled' : '',\n  ]\">\n  @if (icon) {\n    <svg class=\"icon icon-xs\">\n      <use [attr.href]=\"iconHref\" [attr.xlink:href]=\"iconHref\"></use>\n    </svg>\n  }\n  @if (avatar) {\n    <div class=\"avatar size-xs\"><img [src]=\"avatar\" [alt]=\"altAvatar\" /></div>\n  }\n  <span class=\"chip-label\">{{ label }}</span>\n  @if (showCloseButton) {\n    <button (click)=\"clickToClose()\" [disabled]=\"disabled\">\n      <svg class=\"icon\">\n        <use [attr.href]=\"iconCloseHref\" [attr.xlink:href]=\"iconCloseHref\"></use>\n      </svg>\n      <span class=\"visually-hidden\">{{ 'it.core.remove' | translate }} {{ label }}</span>\n    </button>\n  }\n</div>\n"
    }]
  }], () => [], {
    label: [{
      type: Input
    }],
    showCloseButton: [{
      type: Input
    }],
    size: [{
      type: Input
    }],
    color: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    icon: [{
      type: Input
    }],
    avatar: [{
      type: Input
    }],
    altAvatar: [{
      type: Input
    }],
    closeEvent: [{
      type: Output
    }]
  });
})();
class ItDimmerComponent {
  /**
   * Dimmer status
   * @default false
   */
  set active(value) {
    this._active = value;
  }
  get active() {
    return this._active;
  }
  /**
   * Colore del dimmer
   * @default ''
   */
  set color(value) {
    this._color = value;
  }
  get color() {
    return this._color;
  }
  constructor(elementRef) {
    this.elementRef = elementRef;
    this._active = false;
    this._color = '';
  }
  ngOnInit() {
    this.elementRef?.nativeElement?.parentElement?.classList?.add('dimmable');
  }
  static {
    this.ɵfac = function ItDimmerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItDimmerComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItDimmerComponent,
      selectors: [["it-dimmer"]],
      inputs: {
        active: "active",
        color: "color"
      },
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c1,
      decls: 1,
      vars: 1,
      consts: [[1, "dimmer", 3, "ngClass"], [1, "dimmer-inner"]],
      template: function ItDimmerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, ItDimmerComponent_Conditional_0_Template, 3, 4, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx.active ? 0 : -1);
        }
      },
      dependencies: [NgClass],
      encapsulation: 2,
      data: {
        animation: [trigger('fade', [transition(':enter', [style({
          opacity: 0
        }), animate('150ms', style({
          opacity: 0.9
        }))]), transition(':leave', [animate('150ms', style({
          opacity: 0
        }))])])]
      },
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItDimmerComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-dimmer',
      changeDetection: ChangeDetectionStrategy.OnPush,
      animations: [trigger('fade', [transition(':enter', [style({
        opacity: 0
      }), animate('150ms', style({
        opacity: 0.9
      }))]), transition(':leave', [animate('150ms', style({
        opacity: 0
      }))])])],
      imports: [NgClass],
      template: "@if (active) {\n  <div class=\"dimmer\" @fade [ngClass]=\"[color, 'show']\">\n    <div class=\"dimmer-inner\">\n      <ng-content></ng-content>\n    </div>\n  </div>\n}\n"
    }]
  }], () => [{
    type: i0.ElementRef
  }], {
    active: [{
      type: Input
    }],
    color: [{
      type: Input
    }]
  });
})();
class ItDimmerIconComponent {
  static {
    this.ɵfac = function ItDimmerIconComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItDimmerIconComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItDimmerIconComponent,
      selectors: [["it-dimmer-icon"]],
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c1,
      decls: 2,
      vars: 0,
      consts: [[1, "dimmer-icon"]],
      template: function ItDimmerIconComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵprojection(1);
          i0.ɵɵelementEnd();
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItDimmerIconComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-dimmer-icon',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [],
      template: "<div class=\"dimmer-icon\">\n  <ng-content></ng-content>\n</div>\n"
    }]
  }], null, null);
})();
class ItDimmerButtonsComponent {
  constructor() {
    this._hasOneButton = false;
  }
  /**
   * Indica se abbiamo 1 solo bottone
   * @default false
   */
  set hasOneButton(value) {
    this._hasOneButton = value;
  }
  get hasOneButton() {
    return this._hasOneButton;
  }
  static {
    this.ɵfac = function ItDimmerButtonsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItDimmerButtonsComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItDimmerButtonsComponent,
      selectors: [["it-dimmer-buttons"]],
      inputs: {
        hasOneButton: "hasOneButton"
      },
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c1,
      decls: 2,
      vars: 3,
      consts: [[1, "dimmer-buttons", "bg-dark", 3, "ngClass"]],
      template: function ItDimmerButtonsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵprojection(1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c19, ctx.hasOneButton));
        }
      },
      dependencies: [NgClass],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItDimmerButtonsComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-dimmer-buttons',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [NgClass],
      template: "<div class=\"dimmer-buttons bg-dark\" [ngClass]=\"{ 'single-button': hasOneButton }\">\n  <ng-content></ng-content>\n</div>\n"
    }]
  }], null, {
    hasOneButton: [{
      type: Input
    }]
  });
})();
const dimmerComponents = [ItDimmerComponent, ItDimmerIconComponent, ItDimmerButtonsComponent];
class ItDimmerModule {
  static {
    this.ɵfac = function ItDimmerModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItDimmerModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ItDimmerModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItDimmerModule, [{
    type: NgModule,
    args: [{
      imports: dimmerComponents,
      exports: dimmerComponents
    }]
  }], null, null);
})();
class ItForwardDirective {
  /**
   * Indica, se HTMLElement, l'elemento a cui navigare, o se stringa, il selettore che selezionerà l'elemento a cui navigare.
   */
  set itForward(value) {
    this._itForward = value;
  }
  get itForward() {
    return this._itForward;
  }
  constructor(document) {
    this.document = document;
    this._itForward = undefined;
  }
  onClick(event) {
    event.preventDefault();
    if (this.itForward) {
      if (typeof this.itForward === 'string') {
        this.document?.querySelector(this.itForward)?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest'
        });
      } else if (this.itForward instanceof HTMLElement) {
        this.itForward.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest'
        });
      }
    }
  }
  static {
    this.ɵfac = function ItForwardDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItForwardDirective)(i0.ɵɵdirectiveInject(DOCUMENT));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ItForwardDirective,
      selectors: [["", "itForward", ""]],
      hostAttrs: [1, "forward"],
      hostBindings: function ItForwardDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function ItForwardDirective_click_HostBindingHandler($event) {
            return ctx.onClick($event);
          });
        }
      },
      inputs: {
        itForward: "itForward"
      },
      standalone: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItForwardDirective, [{
    type: Directive,
    args: [{
      standalone: true,
      selector: '[itForward]',
      // eslint-disable-next-line @angular-eslint/no-host-metadata-property
      host: {
        class: 'forward'
      }
    }]
  }], () => [{
    type: Document,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }], {
    itForward: [{
      type: Input
    }],
    onClick: [{
      type: HostListener,
      args: ['click', ['$event']]
    }]
  });
})();
class ItListComponent {
  static {
    this.ɵfac = function ItListComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItListComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItListComponent,
      selectors: [["it-list"]],
      inputs: {
        linkList: [2, "linkList", "linkList", inputToBoolean],
        linkSubList: [2, "linkSubList", "linkSubList", inputToBoolean],
        multiline: [2, "multiline", "multiline", inputToBoolean]
      },
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c1,
      decls: 4,
      vars: 2,
      consts: [["contentTpl", ""], [3, "multiline", "class"], [1, "link-sublist"], [4, "ngTemplateOutlet"]],
      template: function ItListComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, ItListComponent_Conditional_0_Template, 3, 7, "div", 1)(1, ItListComponent_Conditional_1_Template, 2, 1, "ul", 2)(2, ItListComponent_ng_template_2_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵconditional(!ctx.linkSubList ? 0 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.linkSubList ? 1 : -1);
        }
      },
      dependencies: [NgTemplateOutlet],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItListComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-list',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [NgTemplateOutlet],
      template: "@if (!linkSubList) {\n  <div [class.multiline]=\"multiline\" [class]=\"linkList ? 'link-list-wrapper' : 'it-list-wrapper'\">\n    <ul [class]=\"linkList ? 'link-list' : 'it-list'\">\n      <ng-container *ngTemplateOutlet=\"contentTpl\"></ng-container>\n    </ul>\n  </div>\n}\n@if (linkSubList) {\n  <ul class=\"link-sublist\">\n    <ng-container *ngTemplateOutlet=\"contentTpl\"></ng-container>\n  </ul>\n}\n<ng-template #contentTpl><ng-content></ng-content></ng-template>\n"
    }]
  }], null, {
    linkList: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    linkSubList: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    multiline: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }]
  });
})();
class ItListItemComponent extends ItLinkComponent {
  constructor(elRef) {
    super();
    this.elRef = elRef;
  }
  get itemClass() {
    const inSidebar = this.elRef.nativeElement.closest('.sidebar-linklist-wrapper') ? true : false;
    let itemClass = 'list-item';
    if (this.disabled) {
      itemClass += ` disabled`;
    }
    if (this.active) {
      itemClass += ` active`;
    }
    if (this.size) {
      itemClass += ` ${this.size}`;
    }
    if (this.iconLeft) {
      itemClass += inSidebar ? ` left-icon` : ` icon-left`;
    }
    if (this.iconRight) {
      itemClass += inSidebar ? ` right-icon` : ` icon-right`;
    }
    if (this.class) {
      itemClass += ` ${this.class}`;
    }
    return itemClass;
  }
  static {
    this.ɵfac = function ItListItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItListItemComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItListItemComponent,
      selectors: [["it-list-item"]],
      inputs: {
        active: [2, "active", "active", inputToBoolean],
        size: "size",
        iconLeft: [2, "iconLeft", "iconLeft", inputToBoolean],
        iconRight: [2, "iconRight", "iconRight", inputToBoolean],
        avatar: "avatar",
        image: "image"
      },
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c21,
      decls: 5,
      vars: 1,
      consts: [["content", ""], [3, "class"], [3, "class", "href", "externalLink", "disabled"], [1, "it-rounded-icon"], [1, "avatar", "size-lg"], [1, "it-thumb"], [1, "it-right-zone"], [1, "it-multiple"], [1, "metadata"], ["alt", "avatar"], ["alt", "thumb"], [4, "ngTemplateOutlet"], [3, "href", "externalLink", "disabled"]],
      template: function ItListItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c20);
          i0.ɵɵelementStart(0, "li");
          i0.ɵɵtemplate(1, ItListItemComponent_ng_template_1_Template, 11, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(3, ItListItemComponent_Conditional_3_Template, 2, 3, "div", 1)(4, ItListItemComponent_Conditional_4_Template, 2, 6, "it-link", 2);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance(3);
          i0.ɵɵconditional(!ctx.href ? 3 : 4);
        }
      },
      dependencies: [NgTemplateOutlet, ItLinkComponent],
      styles: [".metadata[_ngcontent-%COMP%]:empty, .it-rounded-icon[_ngcontent-%COMP%]:empty{display:none}[_nghost-%COMP%]     it-icon+.it-multiple{display:none!important}[_nghost-%COMP%]     .list-item-title-icon-wrapper+.it-multiple{display:none!important}[_nghost-%COMP%]     p+.it-multiple{display:none!important}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItListItemComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-list-item',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [NgTemplateOutlet, ItLinkComponent],
      template: "<li>\n  <ng-template #content>\n    <div class=\"it-rounded-icon\">\n      <ng-content select=\"[icon]\"></ng-content>\n    </div>\n\n    @if (avatar) {\n      <div class=\"avatar size-lg\">\n        <img [attr.src]=\"avatar\" alt=\"avatar\" />\n      </div>\n    }\n\n    @if (image) {\n      <div class=\"it-thumb\">\n        <img [attr.src]=\"image\" alt=\"thumb\" />\n      </div>\n    }\n\n    <div class=\"it-right-zone\">\n      <ng-content></ng-content>\n      <ng-content select=\"[action]\"></ng-content>\n\n      <span class=\"it-multiple\">\n        <span class=\"metadata\">\n          <ng-content select=\"[metadata]\"></ng-content>\n        </span>\n\n        <ng-content select=\"[multiple]\"></ng-content>\n      </span>\n    </div>\n  </ng-template>\n\n  @if (!href) {\n    <div [class]=\"itemClass\">\n      <ng-container *ngTemplateOutlet=\"content\"></ng-container>\n    </div>\n  } @else {\n    <it-link [class]=\"itemClass\" [href]=\"href\" [externalLink]=\"!!externalLink\" [disabled]=\"!!disabled\">\n      <ng-container *ngTemplateOutlet=\"content\"></ng-container>\n    </it-link>\n  }\n</li>\n",
      styles: [".metadata:empty,.it-rounded-icon:empty{display:none}:host ::ng-deep it-icon+.it-multiple{display:none!important}:host ::ng-deep .list-item-title-icon-wrapper+.it-multiple{display:none!important}:host ::ng-deep p+.it-multiple{display:none!important}\n"]
    }]
  }], () => [{
    type: i0.ElementRef
  }], {
    active: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    size: [{
      type: Input
    }],
    iconLeft: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    iconRight: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    avatar: [{
      type: Input
    }],
    image: [{
      type: Input
    }]
  });
})();
const listComponents = [ItListComponent, ItListItemComponent];
class ItListModule {
  static {
    this.ɵfac = function ItListModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItListModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ItListModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItListModule, [{
    type: NgModule,
    args: [{
      imports: listComponents,
      exports: listComponents
    }]
  }], null, null);
})();

/**
 * Modal windows
 * @description To show featured content, notifications to users, or personalized content.
 */
class ItModalComponent extends ItAbstractComponent {
  constructor() {
    super(...arguments);
    /**
     * Show/Hide close button on header
     * @default true
     */
    this.closeButton = true;
    /**
     * To have modals that appear with fades
     * @default true
     */
    this.fade = true;
    /**
     * Includes a modal-backdrop element. Alternatively, specify static for a backdrop which doesn’t close the modal when clicked.
     * @default true
     */
    this.backdrop = true;
    /**
     * Puts the focus on the modal when initialized.
     * @default true
     */
    this.focus = true;
    /**
     * Closes the modal when escape key is pressed.
     * @default true
     */
    this.keyboard = true;
    /**
     * This event fires immediately when the instance method show is called.
     */
    this.showEvent = new EventEmitter();
    /**
     * This event fires when the modal has been made visible to the user (it will wait for CSS transitions to complete).
     */
    this.shownEvent = new EventEmitter();
    /**
     * This event is raised immediately when the instance method hide has been called.
     */
    this.hideEvent = new EventEmitter();
    /**
     * This event fires when the modal has finished hiding from the user (it will wait for CSS transitions to complete).
     */
    this.hiddenEvent = new EventEmitter();
    /**
     * This event is fired when the modal is displayed, its background is static and a click outside the modal or a press
     * of the esc key occurs and data-bs-keyboard is set to false.
     */
    this.hidePreventedEvent = new EventEmitter();
  }
  ngAfterViewInit() {
    super.ngAfterViewInit();
    this._renderer.removeAttribute(this._elementRef.nativeElement, 'title');
    if (this.modalElement) {
      const element = this.modalElement.nativeElement;
      this.modal = Modal.getOrCreateInstance(element, {
        ...this.options,
        backdrop: this.backdrop === 'static' ? 'static' : this.backdrop,
        focus: this.focus,
        keyboard: this.keyboard
      });
      element.addEventListener('show.bs.modal', event => this.showEvent.emit(event));
      element.addEventListener('shown.bs.modal', event => this.shownEvent.emit(event));
      element.addEventListener('hide.bs.modal', event => this.hideEvent.emit(event));
      element.addEventListener('hidden.bs.modal', event => this.hiddenEvent.emit(event));
      element.addEventListener('hidePrevented.bs.modal', event => this.hidePreventedEvent.emit(event));
    }
  }
  get modalClass() {
    let modalClass = 'modal';
    if (this.fade) {
      modalClass += ` fade`;
    }
    if (this.alertModal) {
      modalClass += ` alert-modal`;
    }
    if (this.dialogLinkList) {
      modalClass += ` it-dialog-link-list`;
    }
    if (this.popconfirm) {
      modalClass += ` popconfirm-modal`;
    }
    if (this.scrollable) {
      modalClass += ` it-dialog-scrollable`;
    }
    return modalClass;
  }
  get dialogClass() {
    let dialogClass = 'modal-dialog';
    if (this.alignment) {
      dialogClass += ` modal-dialog-${this.alignment}`;
    }
    if (this.size) {
      dialogClass += ` modal-${this.size}`;
    }
    return dialogClass;
  }
  /**
   * Manually activate/deactivate a modal. Returns to the caller before the modal has actually been shown or hidden
   */
  toggle() {
    this.modal?.toggle();
  }
  /**
   * Manually open a modal. Returns to the caller before the modal has actually been displayed
   */
  show() {
    this.modal?.show();
  }
  /**
   * Manually hide a modal. Returns to the caller before the modal has actually been hidden
   */
  hide() {
    this.modal?.hide();
  }
  /**
   * Manually reposition the modal if the height of the modal changes when it is opened (in case a scroll bar appears).
   */
  handleUpdate() {
    this.modal?.handleUpdate();
  }
  /**
   * Destroys the modal of an element.
   */
  dispose() {
    this.modal?.dispose();
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵItModalComponent_BaseFactory;
      return function ItModalComponent_Factory(__ngFactoryType__) {
        return (ɵItModalComponent_BaseFactory || (ɵItModalComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ItModalComponent)))(__ngFactoryType__ || ItModalComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItModalComponent,
      selectors: [["it-modal"]],
      viewQuery: function ItModalComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c22, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.modalElement = _t.first);
        }
      },
      inputs: {
        closeButton: [2, "closeButton", "closeButton", inputToBoolean],
        alertModal: [2, "alertModal", "alertModal", inputToBoolean],
        dialogLinkList: [2, "dialogLinkList", "dialogLinkList", inputToBoolean],
        popconfirm: [2, "popconfirm", "popconfirm", inputToBoolean],
        scrollable: [2, "scrollable", "scrollable", inputToBoolean],
        fade: [2, "fade", "fade", inputToBoolean],
        alignment: "alignment",
        size: "size",
        backdrop: "backdrop",
        focus: [2, "focus", "focus", inputToBoolean],
        keyboard: [2, "keyboard", "keyboard", inputToBoolean],
        footerShadow: [2, "footerShadow", "footerShadow", inputToBoolean],
        options: "options"
      },
      outputs: {
        showEvent: "showEvent",
        shownEvent: "shownEvent",
        hideEvent: "hideEvent",
        hiddenEvent: "hiddenEvent",
        hidePreventedEvent: "hidePreventedEvent"
      },
      exportAs: ["itModal"],
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c24,
      decls: 15,
      vars: 14,
      consts: [["modalElement", ""], ["tabindex", "-1", "role", "dialog", "aria-hidden", "true", 3, "id"], ["role", "document", 1, "modal-content"], [1, "modal-header"], [1, "modal-title", "h5", 3, "id"], ["type", "button", "data-bs-dismiss", "modal", 1, "btn-close"], [1, "modal-body"], [3, "id"], [1, "modal-footer"]],
      template: function ItModalComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c23);
          i0.ɵɵelementStart(0, "div", 1, 0)(2, "div")(3, "div", 2)(4, "div", 3);
          i0.ɵɵprojection(5);
          i0.ɵɵelementStart(6, "h2", 4);
          i0.ɵɵprojection(7, 1);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(8, ItModalComponent_Conditional_8_Template, 2, 3, "button", 5);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(9, "div", 6)(10, "div", 7);
          i0.ɵɵprojection(11, 2);
          i0.ɵɵelementEnd();
          i0.ɵɵprojection(12, 3);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(13, "div", 8);
          i0.ɵɵprojection(14, 4);
          i0.ɵɵelementEnd()()()();
        }
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.modalClass);
          i0.ɵɵproperty("id", ctx.id);
          i0.ɵɵattribute("aria-labelledby", ctx.id + "-title")("aria-describedby", ctx.id + "-description");
          i0.ɵɵadvance(2);
          i0.ɵɵclassMap(ctx.dialogClass);
          i0.ɵɵadvance(4);
          i0.ɵɵpropertyInterpolate1("id", "", ctx.id, "-title");
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx.closeButton ? 8 : -1);
          i0.ɵɵadvance(2);
          i0.ɵɵpropertyInterpolate1("id", "", ctx.id, "-description");
          i0.ɵɵadvance(3);
          i0.ɵɵclassProp("modal-footer-shadow", ctx.footerShadow);
        }
      },
      dependencies: [TranslateModule, i1.TranslatePipe],
      styles: [".modal-footer[_ngcontent-%COMP%]:empty{display:none}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItModalComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-modal',
      exportAs: 'itModal',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [TranslateModule],
      template: "<div\n  #modalElement\n  [id]=\"id\"\n  [class]=\"modalClass\"\n  tabindex=\"-1\"\n  role=\"dialog\"\n  aria-hidden=\"true\"\n  [attr.aria-labelledby]=\"id + '-title'\"\n  [attr.aria-describedby]=\"id + '-description'\">\n  <div [class]=\"dialogClass\">\n    <div class=\"modal-content\" role=\"document\">\n      <div class=\"modal-header\">\n        <ng-content select=\"[beforeTitle]\"></ng-content>\n\n        <h2 class=\"modal-title h5\" id=\"{{ id }}-title\">\n          <ng-content select=\"[modalTitle]\"></ng-content>\n        </h2>\n\n        @if (closeButton) {\n          <button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" [attr.aria-label]=\"'it.core.close-modal' | translate\"></button>\n        }\n      </div>\n\n      <div class=\"modal-body\">\n        <div id=\"{{ id }}-description\">\n          <ng-content select=\"[description]\"></ng-content>\n        </div>\n        <ng-content></ng-content>\n      </div>\n\n      <div class=\"modal-footer\" [class.modal-footer-shadow]=\"footerShadow\">\n        <ng-content select=\"[footer]\"></ng-content>\n      </div>\n    </div>\n  </div>\n</div>\n",
      styles: [".modal-footer:empty{display:none}\n"]
    }]
  }], null, {
    closeButton: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    alertModal: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    dialogLinkList: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    popconfirm: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    scrollable: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    fade: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    alignment: [{
      type: Input
    }],
    size: [{
      type: Input
    }],
    backdrop: [{
      type: Input
    }],
    focus: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    keyboard: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    footerShadow: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    options: [{
      type: Input
    }],
    showEvent: [{
      type: Output
    }],
    shownEvent: [{
      type: Output
    }],
    hideEvent: [{
      type: Output
    }],
    hiddenEvent: [{
      type: Output
    }],
    hidePreventedEvent: [{
      type: Output
    }],
    modalElement: [{
      type: ViewChild,
      args: ['modalElement', {
        static: false
      }]
    }]
  });
})();
var NotificationType;
(function (NotificationType) {
  NotificationType["Standard"] = "standard";
  NotificationType["Success"] = "success";
  NotificationType["Error"] = "error";
  NotificationType["Info"] = "info";
  NotificationType["Warning"] = "warning";
})(NotificationType || (NotificationType = {}));
var NotificationPosition;
(function (NotificationPosition) {
  NotificationPosition["Top"] = "top-fix mt-3";
  NotificationPosition["Bottom"] = "bottom-fix mb-3";
  NotificationPosition["Left"] = "left-fix ms-3";
  NotificationPosition["Right"] = "right-fix me-3";
})(NotificationPosition || (NotificationPosition = {}));
class ItNotificationService {
  constructor() {
    this.subject = new Subject();
  }
  /**
   * Listen on notification arrived
   * @param filterType filter type of notification
   */
  onNotification(filterType) {
    return this.subject.asObservable().pipe(filter(n => n && (!filterType || n.type === filterType)));
  }
  /**
   * Show new notification
   * @param notification notification
   */
  addNotification(notification) {
    this.subject.next(notification);
  }
  /**
   * Create new Standard notification
   * @param title notification title
   * @param message notification message
   * @param dismissible notification dismissible
   * @param duration notification duration (milliseconds)
   * @param position notification position
   */
  standard(title, message, dismissible, duration, position) {
    this.addNotification({
      type: NotificationType.Standard,
      message,
      title,
      duration,
      dismissible,
      position
    });
  }
  /**
   * Create new Success notification
   * @param title notification title
   * @param message notification message
   * @param dismissible notification dismissible
   * @param duration notification duration (milliseconds)
   * @param position notification position
   */
  success(title, message, dismissible, duration, position) {
    this.addNotification({
      type: NotificationType.Success,
      message,
      title,
      duration,
      dismissible,
      position
    });
  }
  /**
   * Create new Error notification
   * @param title notification title
   * @param message notification message
   * @param dismissible notification dismissible
   * @param duration notification duration (milliseconds)
   * @param position notification position
   */
  error(title, message, dismissible, duration, position) {
    this.addNotification({
      type: NotificationType.Error,
      message,
      title,
      duration,
      dismissible,
      position
    });
  }
  /**
   * Create new Warning notification
   * @param title notification title
   * @param message notification message
   * @param dismissible notification dismissible
   * @param duration notification duration (milliseconds)
   * @param position notification position
   */
  warning(title, message, dismissible, duration, position) {
    this.addNotification({
      type: NotificationType.Warning,
      message,
      title,
      duration,
      dismissible,
      position
    });
  }
  /**
   * Create new Info notification
   * @param title notification title
   * @param message notification message
   * @param dismissible notification dismissible
   * @param duration notification duration (milliseconds)
   * @param position notification position
   */
  info(title, message, dismissible, duration, position) {
    this.addNotification({
      type: NotificationType.Info,
      message,
      title,
      duration,
      dismissible,
      position
    });
  }
  static {
    this.ɵfac = function ItNotificationService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItNotificationService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ItNotificationService,
      factory: ItNotificationService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItNotificationService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
class ItNotificationsComponent {
  constructor(_changeDetectorRef, _notificationService) {
    this._changeDetectorRef = _changeDetectorRef;
    this._notificationService = _notificationService;
    /**
     * Default notifications duration (milliseconds)
     * @default 8000
     */
    this.duration = 8000;
    /**
     * Default notifications is dismissible
     * @default true
     */
    this.dismissible = true;
    this.notificationCount = 0;
    this.notifications = [];
    this.subscription = this._notificationService.onNotification().subscribe(notification => {
      if (!notification.duration) {
        notification.duration = this.duration; // Add duration if not is set
      }
      if (!notification.position && this.position) {
        notification.position = this.position; // Add position if not is set
      }
      if (notification.dismissible === undefined && this.dismissible) {
        notification.dismissible = true; // Add dismissible if not is set
      }
      if (!notification.icon) {
        notification.icon = this.getNotificationIcon(notification);
      }
      const newNotification = {
        ...notification,
        id: `${notification.type}-${this.notificationCount++}-notification`
      };
      this.notifications.push(newNotification);
      this._changeDetectorRef.detectChanges();
      setTimeout(() => {
        // Show the notification
        new Notification(document.getElementById(newNotification.id), {
          timeout: notification.duration
        }).show();
        // Clear notification after the duration
        setTimeout(() => {
          const index = this.notifications.findIndex(n => n.id === newNotification.id);
          if (index > -1) {
            this.notifications.splice(index, 1);
            if (!this.notifications.length) {
              this.notificationCount = 0;
            }
            this._changeDetectorRef.detectChanges();
          }
        }, notification.duration);
      }, 200);
    });
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  get NotificationType() {
    return NotificationType;
  }
  /**
   * Hide the notification
   * @param id
   */
  hideNotification(id) {
    Notification.getInstance(document.getElementById(id))?.hide();
  }
  /**
   * Retrieve the icon name by notification type
   * @param notification the notification
   * @protected
   */
  getNotificationIcon(notification) {
    switch (notification.type) {
      case NotificationType.Success:
        return 'check-circle';
      case NotificationType.Error:
        return 'close-circle';
      case NotificationType.Warning:
        return 'error';
      case NotificationType.Info:
        return 'info-circle';
      case NotificationType.Standard:
      default:
        return undefined;
    }
  }
  static {
    this.ɵfac = function ItNotificationsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItNotificationsComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(ItNotificationService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItNotificationsComponent,
      selectors: [["it-notifications"]],
      inputs: {
        duration: "duration",
        position: "position",
        dismissible: [2, "dismissible", "dismissible", inputToBoolean]
      },
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵStandaloneFeature],
      decls: 2,
      vars: 0,
      consts: [["role", "alert", 3, "id", "class", "with-icon", "dismissable"], ["role", "alert", 3, "id"], [1, "h5", 3, "id"], [3, "name"], ["type", "button", 1, "btn", "notification-close"], ["type", "button", 1, "btn", "notification-close", 3, "click"], ["name", "close"], [1, "visually-hidden"]],
      template: function ItNotificationsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵrepeaterCreate(0, ItNotificationsComponent_For_1_Template, 7, 15, "div", 0, _forTrack0);
        }
        if (rf & 2) {
          i0.ɵɵrepeater(ctx.notifications);
        }
      },
      dependencies: [ItIconComponent, TranslateModule, i1.TranslatePipe],
      styles: [".notification[_ngcontent-%COMP%]{z-index:10000}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItNotificationsComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-notifications',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [ItIconComponent, TranslateModule],
      template: "@for (notification of notifications; track notification.id) {\n  <div\n    [id]=\"notification.id\"\n    class=\"notification {{ notification.position }} {{ notification.type }}\"\n    [class.with-icon]=\"!!notification.icon\"\n    [class.dismissable]=\"notification.dismissible\"\n    role=\"alert\"\n    [attr.aria-labelledby]=\"notification.id + '-title'\">\n    <h2 [id]=\"notification.id + '-title'\" class=\"h5\">\n      @if (notification.icon) {\n        <it-icon [name]=\"notification.icon\"></it-icon>\n      }\n      <ng-container>{{ notification.title }}</ng-container>\n    </h2>\n    @if (notification.message) {\n      <p>{{ notification.message }}</p>\n    }\n    @if (notification.dismissible) {\n      <button type=\"button\" class=\"btn notification-close\" (click)=\"hideNotification(notification.id)\">\n        <it-icon name=\"close\"></it-icon>\n        <span class=\"visually-hidden\">{{ 'it.core.close-notification' | translate: { title: notification.title } }}</span>\n      </button>\n    }\n  </div>\n}\n",
      styles: [".notification{z-index:10000}\n"]
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }, {
    type: ItNotificationService
  }], {
    duration: [{
      type: Input
    }],
    position: [{
      type: Input
    }],
    dismissible: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }]
  });
})();
class ItAbstractFormComponent extends ItAbstractComponent {
  /**
   * Set the disabled state
   */
  set disabled(isDisabled) {
    this.setDisabledState(isDisabled);
  }
  constructor(_translateService, _ngControl) {
    super();
    this._translateService = _translateService;
    this._ngControl = _ngControl;
    /**
     * Validation color display mode (validation triggered if field is touched or not pristine)
     * - <b>true</b>: Always show the validation color
     * - <b>false</b>: Never show validation color
     * - <b>only-valid</b>: Show only valid validation color
     * - <b>only-invalid</b>: Show only invalid validation color
     * @default <b>true</b>: Always show the validation color
     */
    this.validationMode = true;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    this.onChange = _ => {};
    this.onTouched = () => {};
    this.control = new FormControl();
    this._ngControl && (this._ngControl.valueAccessor = this);
  }
  /**
   * Check if field is invalid (Validation failed)
   */
  get isInvalid() {
    if (this.validationMode === 'only-valid' || this.validationMode !== 'only-invalid' && !this.validationMode) {
      return undefined;
    }
    if (this._ngControl) {
      return this._ngControl.invalid === true && (!this._ngControl.pristine || this._ngControl.touched === true);
    }
    return this.control.invalid && (!this.control.pristine || this.control.touched);
  }
  /**
   * Check if field is valid (Validation successful)
   */
  get isValid() {
    if (this.validationMode === 'only-invalid' || this.validationMode !== 'only-valid' && !this.validationMode) {
      return undefined;
    }
    if (this._ngControl) {
      return this._ngControl.valid === true && (!this._ngControl.pristine || this._ngControl.touched === true);
    }
    return this.control.valid && (!this.control.pristine || this.control.touched);
  }
  /**
   * Return the invalid message string from TranslateService
   */
  get invalidMessage() {
    if (this.hasError('required')) {
      return this._translateService.get('it.errors.required-field');
    }
    return this._translateService.get('it.errors.invalid-field');
  }
  ngOnInit() {
    if (this._ngControl?.control) {
      this.control.setValidators(this._ngControl.control.validator);
    }
  }
  registerOnChange(fn) {
    this.control.valueChanges.subscribe(fn);
    this.onChange = fn;
  }
  registerOnTouched(fn) {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled) {
    if (isDisabled) {
      return this.control.disable();
    }
    this.control.enable();
  }
  writeValue(value) {
    this.control.setValue(value, {
      emitEvent: false
    });
    this._changeDetectorRef.detectChanges();
  }
  /**
   * Mark the control as touched
   */
  markAsTouched() {
    if (!this.control.touched) {
      this.onTouched();
    }
  }
  /**
   * Fired to check if form control is touched
   */
  ngDoCheck() {
    if (this._ngControl?.control) {
      const ngControl = this._ngControl.control;
      if (this.control.touched !== ngControl.touched) {
        if (ngControl.touched) {
          this.control.markAsTouched();
        } else {
          this.control.markAsUntouched();
        }
      }
      if (this.control.pristine !== ngControl.pristine) {
        if (ngControl.pristine) {
          this.control.markAsPristine();
        } else {
          this.control.markAsDirty();
        }
      }
    }
    this._changeDetectorRef.detectChanges();
  }
  /**
   * Add the validators in control and parent control
   * @param validators the validators
   * @protected
   */
  addValidators(validators) {
    if (!Array.isArray(validators)) {
      validators = [validators];
    }
    validators.forEach(validator => {
      if (!this.control.hasValidator(validator)) {
        this.control.addValidators(validator);
      }
      if (this._ngControl?.control && !this._ngControl.control.hasValidator(validator)) {
        this._ngControl.control.addValidators(validator);
      }
    });
  }
  /**
   * Reports whether the control with the given path has the error specified. <br/>
   * If the control is not present, false is returned.
   * @param errorCode The code of the error to check
   * @param path A list of control names that designates how to move from the current control
   * to the control that should be queried for errors.
   * @returns whether the given error is present in the control at the given path.
   */
  hasError(errorCode, path) {
    if (this._ngControl) {
      return this._ngControl.hasError(errorCode, path);
    }
    return this.control.hasError(errorCode, path);
  }
  /**
   * Reports error data for the control with the given path.
   * @param errorCode The code of the error to check
   * @param path A list of control names that designates how to move from the current control
   * to the control that should be queried for errors.
   * @returns error data for that particular error. If the control or error is not present,
   * null is returned.
   */
  getError(errorCode, path) {
    if (this._ngControl) {
      return this._ngControl.getError(errorCode, path);
    }
    return this.control.getError(errorCode, path);
  }
  static {
    this.ɵfac = function ItAbstractFormComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItAbstractFormComponent)(i0.ɵɵdirectiveInject(i1.TranslateService), i0.ɵɵdirectiveInject(i1$1.NgControl, 10));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItAbstractFormComponent,
      selectors: [["ng-component"]],
      inputs: {
        label: "label",
        validationMode: "validationMode",
        disabled: [2, "disabled", "disabled", inputToBoolean]
      },
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function ItAbstractFormComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItAbstractFormComponent, [{
    type: Component,
    args: [{
      template: ''
    }]
  }], () => [{
    type: i1.TranslateService
  }, {
    type: i1$1.NgControl,
    decorators: [{
      type: Self
    }, {
      type: Optional
    }]
  }], {
    label: [{
      type: Input
    }],
    validationMode: [{
      type: Input
    }],
    disabled: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }]
  });
})();

/**
 * General Email Regex (RFC 5322 Official Standard)
 * http://emailregex.com/
 */
const EMAIL_REGEX = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
/**
 * Phone number Regex
 */
const PHONE_NUMBER_REGEX = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{3})(?: *x(\d+))?\s*$/;
/**
 * URL Regex
 */
const URL_REGEX = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/;
/**
 * The italian tax code Regex (Codice Fiscale)
 */
const ITALIAN_TAX_CODE_REGEX = /^[A-Za-z]{6}[0-9]{2}[A-Za-z]{1}[0-9]{2}[A-Za-z]{1}[0-9]{3}[A-Za-z]{1}$/i;
/**
 * The VAT number Regex (Partita iva)
 */
const VAT_NUMBER_REGEX = /^[0-9]{11}$/;
/**
 * Italian CAP Regex
 */
const CAP_REGEX = /^[0-9]{5}$/;
/**
 * Italian Plate Regex
 */
const PLATE_REGEX = /^[A-Za-z]{2}\d{3}[A-Za-z]{2}$/i;
/**
 * IBAN Regex
 * https://blog.marketto.it/en/2018/06/validate-any-country-iban/
 */
const IBAN_REGEX = /^(?:(?:IT|SM)\d{2}[A-Z]\d{22}|CY\d{2}[A-Z]\d{23}|NL\d{2}[A-Z]{4}\d{10}|LV\d{2}[A-Z]{4}\d{13}|(?:BG|BH|GB|IE)\d{2}[A-Z]{4}\d{14}|GI\d{2}[A-Z]{4}\d{15}|RO\d{2}[A-Z]{4}\d{16}|KW\d{2}[A-Z]{4}\d{22}|MT\d{2}[A-Z]{4}\d{23}|NO\d{13}|(?:DK|FI|GL|FO)\d{16}|MK\d{17}|(?:AT|EE|KZ|LU|XK)\d{18}|(?:BA|HR|LI|CH|CR)\d{19}|(?:GE|DE|LT|ME|RS)\d{20}|IL\d{21}|(?:AD|CZ|ES|MD|SA)\d{22}|PT\d{23}|(?:BE|IS)\d{24}|(?:FR|MR|MC)\d{25}|(?:AL|DO|LB|PL)\d{26}|(?:AZ|HU)\d{27}|(?:GR|MU)\d{28})$/i;
class ItValidators {
  static {
    this.SpecialCharacterPattern = '!@#$%&*_+=;:|,.';
  }
  /**
   * Static pattern validator with custom error
   * @param regex
   * @param error
   */
  static customPattern(regex, error) {
    return control => {
      if (!control.value) {
        // if control is empty return no error
        return null;
      }
      // test the value of the control against the regexp supplied
      const valid = regex.test(control.value);
      // if true, return no error (no error), else return error passed in the second parameter
      return valid ? null : error;
    };
  }
  /**
   * Set Validator if the condition is satisfied
   * @param validator the validator to apply if the condition is true
   * @param condition the condition
   */
  static conditional(validator, condition) {
    return formControl => {
      if (!formControl.parent) {
        return null;
      }
      if (condition(formControl)) {
        return validator(formControl);
      }
      return null;
    };
  }
  /**
   * Check whether our password and confirm password are a match
   * @param control
   * @param passwordControlName the password formControlName
   * @param confirmControlName the confirmPassword formControlName
   */
  static passwordMatch(control, passwordControlName = 'password', confirmControlName = 'confirmPassword') {
    const confirmControl = control.get(confirmControlName); // confirmPassword form control
    if (!confirmControl) {
      return null;
    }
    const passwordControl = control.get(passwordControlName); // password form control
    const password = passwordControl?.value; // get password from our password form control
    // compare is the password match
    if (password && !confirmControl.value || confirmControl.value && password !== confirmControl.value) {
      // if they don't match, set an error in our confirmPassword form control
      confirmControl?.setErrors({
        noPasswordMatch: true
      });
      confirmControl?.markAsTouched();
      return control;
    }
    if (password && passwordControl?.touched) {
      confirmControl?.markAsTouched();
    }
    return null;
  }
  /**
   * Password validator
   * @param minLength minimum password length - default 10
   * @param hasNumber check whether the entered password has a number - default true
   * @param hasCapitalCase check whether the entered password has upper case letter - default true
   * @param hasSmallCase check whether the entered password has a lower-case letter - default true
   * @param hasSpecialCharacters check whether the entered password has a special character - default true
   * @param required the field is required - default true
   */
  static password(minLength = 10, hasNumber = true, hasCapitalCase = true, hasSmallCase = true, hasSpecialCharacters = true, required = true) {
    const validators = [Validators.minLength(minLength)];
    if (hasNumber) {
      validators.push(ItValidators.customPattern(/\d/, {
        hasNumber
      }));
    }
    if (hasCapitalCase) {
      validators.push(ItValidators.customPattern(/[A-Z]/, {
        hasCapitalCase
      }));
    }
    if (hasSmallCase) {
      validators.push(ItValidators.customPattern(/[a-z]/, {
        hasSmallCase
      }));
    }
    if (hasSpecialCharacters) {
      validators.push(ItValidators.customPattern(new RegExp(`[${ItValidators.SpecialCharacterPattern}]`), {
        hasSpecialCharacters
      }));
    }
    if (required) {
      validators.push(Validators.required);
    }
    return Validators.compose(validators);
  }
  /**
   * Email validator
   */
  static get email() {
    return Validators.compose([Validators.email, ItValidators.customPattern(EMAIL_REGEX, {
      invalidEmail: true
    })]);
  }
  /**
   * Phone number validator
   */
  static get tel() {
    return ItValidators.customPattern(PHONE_NUMBER_REGEX, {
      invalidTel: true
    });
  }
  /**
   * URL validator
   */
  static get url() {
    return ItValidators.customPattern(URL_REGEX, {
      invalidUrl: true
    });
  }
  /**
   * Italian Tax Code validator
   */
  static get taxCode() {
    return ItValidators.customPattern(ITALIAN_TAX_CODE_REGEX, {
      invalidTaxCode: true
    });
  }
  /**
   * VAT Number validator
   */
  static get vatNumber() {
    return ItValidators.customPattern(VAT_NUMBER_REGEX, {
      invalidVatNumber: true
    });
  }
  /**
   * Italian Postal Code validator (CAP)
   */
  static get cap() {
    return ItValidators.customPattern(CAP_REGEX, {
      invalidCap: true
    });
  }
  /**
   * IBAN validator
   */
  static get iban() {
    return ItValidators.customPattern(IBAN_REGEX, {
      invalidIban: true
    });
  }
  /**
   * Italian plate validator
   */
  static get plate() {
    return ItValidators.customPattern(PLATE_REGEX, {
      invalidPlate: true
    });
  }
  /**
   * Check if value is a valid RegExp
   */
  static get regExp() {
    return control => {
      try {
        if (control?.value) {
          new RegExp(control.value);
        }
      } catch (e) {
        return {
          invalidRegex: true
        };
      }
      return null;
    };
  }
}
class ItInputComponent extends ItAbstractFormComponent {
  constructor() {
    super(...arguments);
    /**
     * The input type
     * @default text
     */
    this.type = 'text';
    /**
     * The input placeholder
     */
    this.placeholder = '';
    /**
     * The max date value [Used only in type = 'date']
     * @default '9999-12-31'
     * @example 'yyyy-mm-dd'
     */
    this.maxDate = '9999-12-31';
  }
  get isActiveLabel() {
    const value = this.control.value;
    if (!!value && value !== 0 || value === 0 || !!this.placeholder) {
      return true;
    }
    if (this.type === 'number' && (!!this.currency || !!this.percentage)) {
      return true;
    }
    return this.type === 'date' || this.type === 'time' || this.type === 'color';
  }
  /**
   * Check is readonly field
   */
  get isReadonly() {
    return this.readonly === 'plaintext' || !!this.readonly;
  }
  /**
   * Return the invalid message string from TranslateService
   */
  get invalidMessage() {
    if (this.hasError('min') && this.min) {
      return this._translateService.get('it.errors.min-invalid', {
        min: this.min
      });
    }
    if (this.hasError('max') && this.max) {
      return this._translateService.get('it.errors.max-invalid', {
        max: this.max
      });
    }
    if (this.hasError('minlength')) {
      const error = this.getError('minlength');
      return this._translateService.get('it.errors.min-length-invalid', {
        min: error.requiredLength
      });
    }
    if (this.hasError('maxlength')) {
      const error = this.getError('maxlength');
      return this._translateService.get('it.errors.max-length-invalid', {
        max: error.requiredLength
      });
    }
    if (this.hasError('email') || this.hasError('invalidEmail')) {
      return this._translateService.get('it.errors.email-invalid');
    }
    if (this.hasError('invalidTel')) {
      return this._translateService.get('it.errors.tel-invalid');
    }
    if (this.hasError('invalidUrl')) {
      return this._translateService.get('it.errors.url-invalid');
    }
    if (this.hasError('invalidTaxCode')) {
      return this._translateService.get('it.errors.tax-code-invalid');
    }
    if (this.hasError('invalidVatNumber')) {
      return this._translateService.get('it.errors.vat-number-invalid');
    }
    if (this.hasError('invalidCap')) {
      return this._translateService.get('it.errors.cap-invalid');
    }
    if (this.hasError('invalidIban')) {
      return this._translateService.get('it.errors.iban-invalid');
    }
    if (this.hasError('invalidPlate')) {
      return this._translateService.get('it.errors.plate-invalid');
    }
    if (this.hasError('invalidRegex')) {
      return this._translateService.get('it.errors.regex-invalid');
    }
    if (this.hasError('pattern')) {
      const error = this.getError('pattern');
      return this._translateService.get('it.errors.pattern-invalid', {
        pattern: error.requiredPattern
      });
    }
    return super.invalidMessage;
  }
  ngOnInit() {
    super.ngOnInit();
    const validators = [];
    switch (this.type) {
      case 'number':
        if (this.percentage) {
          this.min = this.min || 0;
          this.max = this.max || 100;
        }
        // Dynamic min/max validators
        validators.push(control => this.min ? Validators.min(this.min)(control) : null);
        validators.push(control => this.max ? Validators.max(this.max)(control) : null);
        break;
      case 'email':
        validators.push(ItValidators.email);
        break;
      case 'tel':
        validators.push(ItValidators.tel);
        break;
      case 'url':
        validators.push(ItValidators.url);
        break;
    }
    this.addValidators(validators);
  }
  /**
   * Increment or decrease the input number value of step
   * @param decrease true to decrease value
   */
  incrementNumber(decrease = false) {
    if (this.type !== 'number') {
      return;
    }
    const step = this.step === 'any' ? 1 : this.step ?? 1;
    let value = Number(this.control.value);
    value = (isNaN(value) ? 0 : value) + (decrease ? -step : step);
    value = Math.round(value * 1e12) / 1e12; // prevent js decimal error
    if (this.min !== undefined && value < this.min) {
      value = this.min;
    } else if (this.max !== undefined && value > this.max) {
      value = this.max;
    }
    this.control.setValue(value);
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵItInputComponent_BaseFactory;
      return function ItInputComponent_Factory(__ngFactoryType__) {
        return (ɵItInputComponent_BaseFactory || (ɵItInputComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ItInputComponent)))(__ngFactoryType__ || ItInputComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItInputComponent,
      selectors: [["it-input"]],
      inputs: {
        type: "type",
        placeholder: "placeholder",
        description: "description",
        readonly: "readonly",
        maxDate: "maxDate",
        minDate: "minDate",
        max: "max",
        min: "min",
        step: "step",
        currency: [2, "currency", "currency", inputToBoolean],
        percentage: [2, "percentage", "percentage", inputToBoolean],
        symbol: "symbol",
        adaptive: [2, "adaptive", "adaptive", inputToBoolean],
        autocomplete: "autocomplete"
      },
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c27,
      decls: 14,
      vars: 14,
      consts: [["prependText", ""], ["customError", ""], [1, "form-group"], [1, "input-group"], [1, "input-group-text"], [3, "for", "active", "input-number-label", "empty-prepend-label"], [3, "id", "type", "max", "min", "form-control", "form-control-plaintext", "is-invalid", "just-validate-success-field", "formControl", "placeholder", "readonly", "autocomplete"], [1, "input-group-append"], [1, "form-text", 3, "id"], [1, "form-feedback", "just-validate-error-label", 3, "id"], [3, "for"], [1, "input-group-text", "fw-semibold"], ["type", "number", 3, "blur", "id", "step", "min", "max", "formControl", "placeholder", "readonly", "autocomplete"], [1, "input-group-text", "align-buttons", "flex-column"], ["type", "button", 1, "input-number-add", 3, "click", "disabled"], [1, "visually-hidden"], ["type", "button", 1, "input-number-sub", 3, "click", "disabled"], [3, "blur", "id", "type", "max", "min", "formControl", "placeholder", "readonly", "autocomplete"]],
      template: function ItInputComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c26);
          i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "span", 4, 0);
          i0.ɵɵprojection(4);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(5, ItInputComponent_Conditional_5_Template, 2, 8, "label", 5)(6, ItInputComponent_Conditional_6_Template, 11, 26)(7, ItInputComponent_Conditional_7_Template, 1, 17, "input", 6);
          i0.ɵɵelementStart(8, "div", 7);
          i0.ɵɵprojection(9, 1);
          i0.ɵɵelementStart(10, "div", 4);
          i0.ɵɵprojection(11, 2);
          i0.ɵɵelementEnd()()();
          i0.ɵɵtemplate(12, ItInputComponent_Conditional_12_Template, 2, 2, "small", 8)(13, ItInputComponent_Conditional_13_Template, 5, 2, "div", 9);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵclassProp("disabled", !ctx.control.enabled)("input-number", ctx.type === "number")("input-number-currency", ctx.currency)("input-number-percentage", ctx.percentage)("input-number-adaptive", ctx.adaptive);
          i0.ɵɵadvance(4);
          i0.ɵɵconditional(ctx.label ? 5 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.type === "number" ? 6 : 7);
          i0.ɵɵadvance(6);
          i0.ɵɵconditional(ctx.description ? 12 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.isInvalid ? 13 : -1);
        }
      },
      dependencies: [ReactiveFormsModule, i1$1.DefaultValueAccessor, i1$1.NumberValueAccessor, i1$1.NgControlStatus, i1$1.MinValidator, i1$1.MaxValidator, i1$1.FormControlDirective, TranslateModule, i1.TranslatePipe, AsyncPipe],
      styles: [".form-group[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{z-index:1000}.form-group[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus:not(.focus--mouse){box-shadow:inherit!important;border-color:inherit!important}.form-group[_ngcontent-%COMP%]   .input-number[_ngcontent-%COMP%]   .align-buttons[_ngcontent-%COMP%]{height:100%}.form-group[_ngcontent-%COMP%]   .input-group-text[_ngcontent-%COMP%]:empty{display:none}.form-group[_ngcontent-%COMP%]   label.empty-prepend-label[_ngcontent-%COMP%]{left:auto!important;max-width:100%!important}.form-group[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]:not(.active):has( + input[_ngcontent-%COMP%]:-webkit-autofill){transform:translateY(-75%)}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItInputComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-input',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [ReactiveFormsModule, TranslateModule, AsyncPipe],
      template: "<div class=\"form-group\">\n  <div\n    class=\"input-group\"\n    [class.disabled]=\"!control.enabled\"\n    [class.input-number]=\"type === 'number'\"\n    [class.input-number-currency]=\"currency\"\n    [class.input-number-percentage]=\"percentage\"\n    [class.input-number-adaptive]=\"adaptive\">\n    <span class=\"input-group-text\" #prependText>\n      <ng-content select=\"[prependText]\"></ng-content>\n    </span>\n\n    @if (label) {\n      <label\n        [for]=\"id\"\n        [class.active]=\"isActiveLabel\"\n        [class.input-number-label]=\"type === 'number'\"\n        [class.empty-prepend-label]=\"!prependText.clientWidth\">\n        {{ label }}\n      </label>\n    }\n\n    @if (type === 'number') {\n      @if (currency || percentage) {\n        <span class=\"input-group-text fw-semibold\">{{ symbol }}</span>\n      }\n      <input\n        type=\"number\"\n        [id]=\"id\"\n        [step]=\"step ?? null\"\n        [min]=\"min ?? ''\"\n        [max]=\"max ?? ''\"\n        [class.form-control]=\"readonly !== 'plaintext'\"\n        [class.form-control-plaintext]=\"readonly === 'plaintext'\"\n        [class.is-invalid]=\"isInvalid\"\n        [class.just-validate-success-field]=\"isValid\"\n        [formControl]=\"control\"\n        [placeholder]=\"placeholder\"\n        [readonly]=\"isReadonly\"\n        [autocomplete]=\"autocomplete\"\n        [attr.aria-describedby]=\"id + '-description'\"\n        (blur)=\"markAsTouched()\" />\n      <span class=\"input-group-text align-buttons flex-column\">\n        <button type=\"button\" class=\"input-number-add\" [disabled]=\"!control.enabled\" (click)=\"incrementNumber()\">\n          <span class=\"visually-hidden\">{{ 'it.form.increase-value' | translate }}</span>\n        </button>\n        <button type=\"button\" class=\"input-number-sub\" [disabled]=\"!control.enabled\" (click)=\"incrementNumber(true)\">\n          <span class=\"visually-hidden\">{{ 'it.form.decrease-value' | translate }}</span>\n        </button>\n      </span>\n    } @else {\n      <input\n        [id]=\"id\"\n        [type]=\"type\"\n        [max]=\"type === 'date' ? maxDate : undefined\"\n        [min]=\"type === 'date' ? minDate : undefined\"\n        [class.form-control]=\"readonly !== 'plaintext'\"\n        [class.form-control-plaintext]=\"readonly === 'plaintext'\"\n        [class.is-invalid]=\"isInvalid\"\n        [class.just-validate-success-field]=\"isValid\"\n        [formControl]=\"control\"\n        [placeholder]=\"placeholder\"\n        [readonly]=\"isReadonly\"\n        [autocomplete]=\"autocomplete\"\n        [attr.aria-describedby]=\"id + '-description'\"\n        (blur)=\"markAsTouched()\" />\n    }\n\n    <div class=\"input-group-append\">\n      <ng-content select=\"[append]\"></ng-content>\n\n      <div class=\"input-group-text\">\n        <ng-content select=\"[appendText]\"></ng-content>\n      </div>\n    </div>\n  </div>\n\n  @if (description) {\n    <small [id]=\"id + '-description'\" class=\"form-text\">{{ description }}</small>\n  }\n\n  @if (isInvalid) {\n    <div class=\"form-feedback just-validate-error-label\" [id]=\"id + '-error'\">\n      <div #customError>\n        <ng-content select=\"[error]\"></ng-content>\n      </div>\n      @if (!customError.hasChildNodes()) {\n        {{ invalidMessage | async }}\n      }\n    </div>\n  }\n</div>\n",
      styles: [".form-group label{z-index:1000}.form-group input:focus:not(.focus--mouse){box-shadow:inherit!important;border-color:inherit!important}.form-group .input-number .align-buttons{height:100%}.form-group .input-group-text:empty{display:none}.form-group label.empty-prepend-label{left:auto!important;max-width:100%!important}.form-group label:not(.active):has(+input:-webkit-autofill){transform:translateY(-75%)}\n"]
    }]
  }], null, {
    type: [{
      type: Input
    }],
    placeholder: [{
      type: Input
    }],
    description: [{
      type: Input
    }],
    readonly: [{
      type: Input
    }],
    maxDate: [{
      type: Input
    }],
    minDate: [{
      type: Input
    }],
    max: [{
      type: Input
    }],
    min: [{
      type: Input
    }],
    step: [{
      type: Input
    }],
    currency: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    percentage: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    symbol: [{
      type: Input
    }],
    adaptive: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    autocomplete: [{
      type: Input
    }]
  });
})();
class ItPaginationComponent {
  constructor() {
    /**
     * Number of pages closest to the current one to display
     * @default 5
     */
    this.visiblePages = 5;
    /**
     * Available Changer values
     * @default [10, 25, 50, 100]
     */
    this.changerValues = [10, 25, 50, 100];
    /**
     * Fired when page is changed. Emit the new index of page
     */
    this.pageEvent = new EventEmitter();
    /**
     * Fired when changer is changed. Emit the new changer value
     */
    this.changerEvent = new EventEmitter();
    /**
     * The pages
     * @protected
     */
    this.pages = [];
    /**
     * Jump to page input
     * @protected
     */
    this.jumpToPage = new FormControl(null);
    this.jumpToPage.valueChanges.pipe(debounceTime(300),
    // Delay filter data after time span has passed without another source emission
    distinctUntilChanged(), filter(value => !!value && this.jumpToPage.valid)).subscribe(value => {
      this.pageEvent.emit(value - 1);
    });
  }
  ngOnChanges(changes) {
    this.pages = this.calculatePages();
    if (changes['currentPage']) {
      this.jumpToPage.setValue(null, {
        emitEvent: false
      });
    }
  }
  /**
   * Create array to generate pagination of `visiblePages` element
   */
  calculatePages() {
    if (this.simpleMode) {
      return [this.currentPage];
    }
    const length = this.pageNumbers > this.visiblePages ? this.visiblePages : this.pageNumbers;
    const halfVisiblePages = Math.floor(this.visiblePages / 2);
    let start = this.currentPage > halfVisiblePages && this.pageNumbers > this.visiblePages ? this.currentPage - halfVisiblePages + 1 : 1;
    if (this.pageNumbers > this.visiblePages) {
      if (this.currentPage + 1 >= this.pageNumbers) {
        start -= halfVisiblePages;
      } else if (this.currentPage >= this.pageNumbers - halfVisiblePages) {
        start -= this.pageNumbers - (this.currentPage + 1);
      }
    }
    return Array.from({
      length
    }, (_, i) => i + start);
  }
  /**
   * On click page change
   * @param event click event
   * @param newPage the new page of table
   */
  pageChange(event, newPage) {
    event.preventDefault();
    this.pageEvent.emit(newPage - 1); // emit new page index
  }
  /**
   * On click changer
   * @param event click event
   * @param value the new changer value
   */
  changerChange(event, value) {
    event.preventDefault();
    this.changerEvent.emit(value); // emit new changer value
  }
  static {
    this.ɵfac = function ItPaginationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItPaginationComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItPaginationComponent,
      selectors: [["it-pagination"]],
      inputs: {
        currentPage: "currentPage",
        pageNumbers: "pageNumbers",
        visiblePages: "visiblePages",
        alignment: "alignment",
        simpleMode: [2, "simpleMode", "simpleMode", inputToBoolean],
        textLinks: [2, "textLinks", "textLinks", inputToBoolean],
        currentChanger: "currentChanger",
        changerValues: "changerValues",
        showJumpToPage: [2, "showJumpToPage", "showJumpToPage", inputToBoolean]
      },
      outputs: {
        pageEvent: "pageEvent",
        changerEvent: "changerEvent"
      },
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c1,
      decls: 7,
      vars: 11,
      consts: [["totalNumberText", ""], [1, "pagination-wrapper"], [1, "pagination"], ["type", "number", 3, "min", "max", "label", "formControl"], [1, "page-item"], ["href", "#", 1, "page-link", 3, "click"], ["name", "chevron-left", "color", "primary"], [1, "visually-hidden"], ["name", "chevron-right", "color", "primary"], ["aria-current", "page", 1, "page-link"], [1, "page-link"], [1, "page-item", "visually-hidden"], ["href", "#", "aria-current", "page", 1, "page-link"], ["href", "#", 1, "page-link"], [1, "d-inline-block", "d-sm-none"], ["button", ""], ["list", ""], ["href", "#", "externalLink", "true"], ["href", "#", "externalLink", "true", 3, "click"]],
      template: function ItPaginationComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "nav", 1);
          i0.ɵɵtemplate(1, ItPaginationComponent_Conditional_1_Template, 17, 18, "ul", 2)(2, ItPaginationComponent_Conditional_2_Template, 8, 6, "it-dropdown")(3, ItPaginationComponent_Conditional_3_Template, 2, 6, "it-input", 3);
          i0.ɵɵelementStart(4, "p", null, 0);
          i0.ɵɵprojection(6);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          const totalNumberText_r9 = i0.ɵɵreference(5);
          i0.ɵɵclassProp("justify-content-center", ctx.alignment === "center")("justify-content-end", ctx.alignment === "end")("pagination-total", totalNumberText_r9.hasChildNodes());
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.pages.length ? 1 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.currentChanger !== undefined ? 2 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.showJumpToPage ? 3 : -1);
          i0.ɵɵadvance();
          i0.ɵɵclassProp("d-none", !totalNumberText_r9.hasChildNodes());
        }
      },
      dependencies: [ItIconComponent, TranslateModule, i1.TranslatePipe, LowerCasePipe, ItDropdownModule, ItDropdownComponent, ItDropdownItemComponent, ItInputComponent, ReactiveFormsModule, i1$1.NgControlStatus, i1$1.FormControlDirective],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItPaginationComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-pagination',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [ItIconComponent, TranslateModule, LowerCasePipe, ItDropdownModule, ItInputComponent, ReactiveFormsModule],
      template: "<nav\n  class=\"pagination-wrapper\"\n  [class.justify-content-center]=\"alignment === 'center'\"\n  [class.justify-content-end]=\"alignment === 'end'\"\n  [class.pagination-total]=\"totalNumberText.hasChildNodes()\">\n  @if (pages.length) {\n    <ul class=\"pagination\">\n      <li class=\"page-item\" [class.disabled]=\"currentPage < 1\">\n        <a class=\"page-link\" [class.text]=\"textLinks\" href=\"#\" (click)=\"pageChange($event, currentPage)\">\n          @if (!textLinks) {\n            <it-icon name=\"chevron-left\" color=\"primary\"></it-icon>\n          }\n          <span class=\"visually-hidden\">\n            {{ (textLinks ? 'it.core.page' : 'it.core.previous-page') | translate }}\n          </span>\n          @if (textLinks) {\n            {{ 'it.core.previous' | translate }}\n          }\n        </a>\n      </li>\n      @if (simpleMode) {\n        <li class=\"page-item\">\n          <span class=\"page-link\" aria-current=\"page\">{{ currentPage + 1 }}</span>\n        </li>\n        <li class=\"page-item\"><span class=\"page-link\">/</span></li>\n        <li class=\"page-item\">\n          <span class=\"page-link\">{{ pageNumbers }}</span>\n        </li>\n        <li class=\"page-item visually-hidden\">\n          <a class=\"page-link\" href=\"#\" aria-current=\"page\">\n            {{ 'it.core.page-of-total' | translate: { page: currentPage + 1, total: pageNumbers } }}\n          </a>\n        </li>\n      } @else {\n        @if (pageNumbers > visiblePages && pages[0] >= 2) {\n          <li class=\"page-item\">\n            <a class=\"page-link\" href=\"#\" (click)=\"pageChange($event, 1)\">1</a>\n          </li>\n          @if (pages[0] >= 3) {\n            <li class=\"page-item\">\n              <span class=\"page-link\">...</span>\n            </li>\n          }\n        }\n        @for (page of pages; track page) {\n          <li class=\"page-item\">\n            @if (page === currentPage + 1) {\n              <a class=\"page-link\" aria-current=\"page\">\n                <span class=\"d-inline-block d-sm-none\">{{ 'it.core.page' | translate }}</span> {{ page }}\n              </a>\n            } @else {\n              <a class=\"page-link\" href=\"#\" (click)=\"pageChange($event, page)\">{{ page }}</a>\n            }\n          </li>\n        }\n        @if (pageNumbers > visiblePages && pages[pages.length - 1] < pageNumbers) {\n          @if (pages[pages.length - 1] < pageNumbers - 1) {\n            <li class=\"page-item\">\n              <span class=\"page-link\">...</span>\n            </li>\n          }\n          <li class=\"page-item\">\n            <a class=\"page-link\" href=\"#\" (click)=\"pageChange($event, pageNumbers)\">{{ pageNumbers }}</a>\n          </li>\n        }\n      }\n      <li class=\"page-item\" [class.disabled]=\"currentPage >= pageNumbers - 1\">\n        <a class=\"page-link\" [class.text]=\"textLinks\" href=\"#\" (click)=\"pageChange($event, currentPage + 2)\">\n          <span class=\"visually-hidden\">\n            {{ (textLinks ? 'it.core.page' : 'it.core.next-page') | translate }}\n          </span>\n          @if (textLinks) {\n            {{ 'it.core.next' | translate }}\n          } @else {\n            <it-icon name=\"chevron-right\" color=\"primary\"></it-icon>\n          }\n        </a>\n      </li>\n    </ul>\n  }\n\n  @if (currentChanger !== undefined) {\n    <it-dropdown>\n      <span button>{{ currentChanger }} / {{ 'it.core.page' | translate | lowercase }}</span>\n      <ng-container list>\n        @for (value of changerValues; track value) {\n          <it-dropdown-item href=\"#\" externalLink=\"true\" (click)=\"changerChange($event, value)\">\n            {{ value }} / {{ 'it.core.page' | translate | lowercase }}\n          </it-dropdown-item>\n        }\n      </ng-container>\n    </it-dropdown>\n  }\n\n  @if (showJumpToPage) {\n    <it-input\n      type=\"number\"\n      [min]=\"1\"\n      [max]=\"pageNumbers\"\n      [label]=\"('it.core.go-to' | translate) + '...'\"\n      [formControl]=\"jumpToPage\"></it-input>\n  }\n\n  <p [class.d-none]=\"!totalNumberText.hasChildNodes()\" #totalNumberText>\n    <ng-content></ng-content>\n  </p>\n</nav>\n"
    }]
  }], () => [], {
    currentPage: [{
      type: Input,
      args: [{
        required: true
      }]
    }],
    pageNumbers: [{
      type: Input,
      args: [{
        required: true
      }]
    }],
    visiblePages: [{
      type: Input
    }],
    alignment: [{
      type: Input
    }],
    simpleMode: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    textLinks: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    currentChanger: [{
      type: Input
    }],
    changerValues: [{
      type: Input
    }],
    showJumpToPage: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    pageEvent: [{
      type: Output
    }],
    changerEvent: [{
      type: Output
    }]
  });
})();
class ItPopoverDirective {
  /**
   * Define the popover content
   * @param content the popover content
   */
  set content(content) {
    this.element.setAttribute('data-bs-content', content);
  }
  /**
   * Define the popover title
   * @param title the popover title
   */
  set popoverTitle(title) {
    if (title) {
      this.element.setAttribute('title', title);
      this.element.setAttribute('data-bs-original-title', title);
    }
  }
  /**
   * Define the popover placement
   * @param placement
   */
  set popoverPlacement(placement) {
    this.element.setAttribute('data-bs-placement', placement);
  }
  /**
   * Appends the popover to a specific element.
   * @param container
   */
  set popoverContainer(container) {
    if (container) {
      this.element.setAttribute('data-bs-container', container);
    }
  }
  /**
   * Indicates whether the title contains html
   * @param html true if contain html
   */
  set popoverHtml(html) {
    this.element.setAttribute('data-bs-html', html ? 'true' : 'false');
  }
  /**
   * How popover is triggered
   * - 'hover': To open the Popover on hover of the mouse over the element
   * - 'focus': To ignore popovers on the user's next click of an element other than the toggle element.
   * @param trigger
   */
  set popoverTrigger(trigger) {
    if (trigger) {
      this.element.setAttribute('data-bs-trigger', trigger);
    }
  }
  constructor(_elementRef) {
    this._elementRef = _elementRef;
    /**
     * This event fires immediately when the show method is called.
     */
    this.showEvent = new EventEmitter();
    /**
     * This event is triggered when the tooltip has been made visible to the user (it will wait for the CSS transitions to complete).
     */
    this.shownEvent = new EventEmitter();
    /**
     * This event fires immediately when the hide method is called.
     */
    this.hideEvent = new EventEmitter();
    /**
     * This event is raised when the tooltip has finished being hidden from the user (it will wait for the CSS transitions to complete).
     */
    this.hiddenEvent = new EventEmitter();
    /**
     * This event fires after the show event when the tooltip template has been added to the DOM.
     */
    this.insertedEvent = new EventEmitter();
    this.element = this._elementRef.nativeElement;
  }
  ngAfterViewInit() {
    this.element.setAttribute('data-bs-toggle', 'popover');
    this.popover = Popover.getOrCreateInstance(this.element);
    this.element.addEventListener('show.bs.popover', event => this.showEvent.emit(event));
    this.element.addEventListener('shown.bs.popover', event => this.shownEvent.emit(event));
    this.element.addEventListener('hide.bs.popover', event => this.hideEvent.emit(event));
    this.element.addEventListener('hidden.bs.popover', event => this.hiddenEvent.emit(event));
    this.element.addEventListener('inserted.bs.popover', event => this.insertedEvent.emit(event));
  }
  ngOnDestroy() {
    this.dispose();
  }
  /**
   * Shows the popover of an item.
   */
  show() {
    this.popover?.show();
  }
  /**
   * Hide the popover of an element.
   */
  hide() {
    this.popover?.hide();
  }
  /**
   * Activate / Deactivate the popover of an element
   */
  toggle() {
    this.popover?.toggle();
  }
  /**
   * Hides and destroys the popover of an element.
   */
  dispose() {
    this.popover?.dispose();
  }
  /**
   * Gives the popover of an element a chance to be shown.
   */
  enable() {
    this.popover?.enable();
  }
  /**
   * Removes the ability to show the popover of an element.
   */
  disable() {
    this.popover?.disable();
  }
  /**
   * Toggles the possibility that the popover of an element is shown or hidden.
   */
  toggleEnabled() {
    this.popover?.disable();
  }
  /**
   * Updates the position of an element's popover.
   */
  update() {
    this.popover?.disable();
  }
  static {
    this.ɵfac = function ItPopoverDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItPopoverDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ItPopoverDirective,
      selectors: [["", "itPopover", ""]],
      inputs: {
        content: [0, "itPopover", "content"],
        popoverTitle: "popoverTitle",
        popoverPlacement: "popoverPlacement",
        popoverContainer: "popoverContainer",
        popoverHtml: [2, "popoverHtml", "popoverHtml", inputToBoolean],
        popoverTrigger: "popoverTrigger"
      },
      outputs: {
        showEvent: "showEvent",
        shownEvent: "shownEvent",
        hideEvent: "hideEvent",
        hiddenEvent: "hiddenEvent",
        insertedEvent: "insertedEvent"
      },
      exportAs: ["itPopover"],
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItPopoverDirective, [{
    type: Directive,
    args: [{
      standalone: true,
      selector: '[itPopover]',
      exportAs: 'itPopover'
    }]
  }], () => [{
    type: i0.ElementRef
  }], {
    content: [{
      type: Input,
      args: ['itPopover']
    }],
    popoverTitle: [{
      type: Input
    }],
    popoverPlacement: [{
      type: Input
    }],
    popoverContainer: [{
      type: Input
    }],
    popoverHtml: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    popoverTrigger: [{
      type: Input
    }],
    showEvent: [{
      type: Output
    }],
    shownEvent: [{
      type: Output
    }],
    hideEvent: [{
      type: Output
    }],
    hiddenEvent: [{
      type: Output
    }],
    insertedEvent: [{
      type: Output
    }]
  });
})();
class ItSpinnerComponent {
  constructor() {
    /**
     * The spinner is active
     * @default true
     */
    this.active = true;
  }
  static {
    this.ɵfac = function ItSpinnerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItSpinnerComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItSpinnerComponent,
      selectors: [["it-spinner"]],
      inputs: {
        active: [2, "active", "active", inputToBoolean],
        small: [2, "small", "small", inputToBoolean],
        double: [2, "double", "double", inputToBoolean]
      },
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵStandaloneFeature],
      decls: 5,
      vars: 10,
      consts: [[1, "progress-spinner"], [1, "visually-hidden"], [1, "progress-spinner-inner"]],
      template: function ItSpinnerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, ItSpinnerComponent_Conditional_1_Template, 2, 0);
          i0.ɵɵelementStart(2, "span", 1);
          i0.ɵɵtext(3);
          i0.ɵɵpipe(4, "translate");
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵclassProp("progress-spinner-double", ctx.double)("progress-spinner-active", ctx.active)("size-sm", ctx.small);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.double ? 1 : -1);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(4, 8, "it.core.loading"), "...");
        }
      },
      dependencies: [TranslateModule, i1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItSpinnerComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-spinner',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [TranslateModule],
      template: "<div class=\"progress-spinner\" [class.progress-spinner-double]=\"double\" [class.progress-spinner-active]=\"active\" [class.size-sm]=\"small\">\n  @if (double) {\n    <div class=\"progress-spinner-inner\"></div>\n    <div class=\"progress-spinner-inner\"></div>\n  }\n  <span class=\"visually-hidden\">{{ 'it.core.loading' | translate }}...</span>\n</div>\n"
    }]
  }], null, {
    active: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    small: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    double: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }]
  });
})();
class ItSteppersItemComponent extends ItAbstractComponent {
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵItSteppersItemComponent_BaseFactory;
      return function ItSteppersItemComponent_Factory(__ngFactoryType__) {
        return (ɵItSteppersItemComponent_BaseFactory || (ɵItSteppersItemComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ItSteppersItemComponent)))(__ngFactoryType__ || ItSteppersItemComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItSteppersItemComponent,
      selectors: [["it-steppers-item"]],
      viewQuery: function ItSteppersItemComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(TemplateRef, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.htmlContent = _t.first);
        }
      },
      inputs: {
        label: "label",
        icon: "icon"
      },
      standalone: true,
      features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function ItSteppersItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, ItSteppersItemComponent_ng_template_0_Template, 1, 0, "ng-template");
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItSteppersItemComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-steppers-item',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [],
      template: "<ng-template>\n  <ng-content></ng-content>\n</ng-template>\n"
    }]
  }], null, {
    label: [{
      type: Input,
      args: [{
        required: true
      }]
    }],
    icon: [{
      type: Input
    }],
    htmlContent: [{
      type: ViewChild,
      args: [TemplateRef]
    }]
  });
})();
class ItSteppersContainerComponent {
  constructor(_changeDetectorRef) {
    this._changeDetectorRef = _changeDetectorRef;
    /**
     * Show the stepper header
     * @default true
     */
    this.showHeader = true;
    /**
     * Show the back button
     * @default true
     */
    this.showBackButton = true;
    /**
     * Show the forward button
     * @default true
     */
    this.showForwardButton = true;
    this.backClick = new EventEmitter();
    this.forwardClick = new EventEmitter();
    this.confirmClick = new EventEmitter();
    this.saveClick = new EventEmitter();
  }
  ngAfterViewInit() {
    this.steps?.changes.pipe(
    // When steps changes (dynamic add/remove)
    startWith(undefined)).subscribe(() => {
      this.stepsSubscriptions?.forEach(sub => sub.unsubscribe()); // Remove old subscriptions
      this.stepsSubscriptions = this.steps?.map(step => step.valueChanges.subscribe(() => {
        this._changeDetectorRef.detectChanges(); // DetectChanges when step attributes changes
      }));
      this._changeDetectorRef.detectChanges(); // Force update html render
    });
  }
  ngOnDestroy() {
    this.stepsSubscriptions?.forEach(step => step.unsubscribe());
  }
  static {
    this.ɵfac = function ItSteppersContainerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItSteppersContainerComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItSteppersContainerComponent,
      selectors: [["it-steppers-container"]],
      contentQueries: function ItSteppersContainerComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, ItSteppersItemComponent, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.steps = _t);
        }
      },
      inputs: {
        activeStep: "activeStep",
        showHeader: [2, "showHeader", "showHeader", inputToBoolean],
        dark: [2, "dark", "dark", inputToBoolean],
        steppersNumber: [2, "steppersNumber", "steppersNumber", inputToBoolean],
        progressStyle: "progressStyle",
        progressColor: "progressColor",
        showBackButton: [2, "showBackButton", "showBackButton", inputToBoolean],
        disableBackButton: [2, "disableBackButton", "disableBackButton", inputToBoolean],
        showForwardButton: [2, "showForwardButton", "showForwardButton", inputToBoolean],
        disableForwardButton: [2, "disableForwardButton", "disableForwardButton", inputToBoolean],
        showConfirmButton: [2, "showConfirmButton", "showConfirmButton", inputToBoolean],
        disableConfirmButton: [2, "disableConfirmButton", "disableConfirmButton", inputToBoolean],
        confirmLoading: [2, "confirmLoading", "confirmLoading", inputToBoolean],
        showSaveButton: [2, "showSaveButton", "showSaveButton", inputToBoolean],
        disableSaveButton: [2, "disableSaveButton", "disableSaveButton", inputToBoolean],
        saveLoading: [2, "saveLoading", "saveLoading", inputToBoolean]
      },
      outputs: {
        backClick: "backClick",
        forwardClick: "forwardClick",
        confirmClick: "confirmClick",
        saveClick: "saveClick"
      },
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵStandaloneFeature],
      decls: 6,
      vars: 5,
      consts: [["checkIcon", ""], [1, "steppers"], [1, "steppers-header"], ["aria-live", "polite", 1, "steppers-content"], [1, "steppers-nav"], ["aria-hidden", "true", 1, "steppers-index"], [3, "confirmed", "active", "no-line"], [3, "labelWaria", "name"], [1, "steppers-number"], [1, "visually-hidden"], [4, "ngTemplateOutlet"], [3, "active"], ["type", "button", "itButton", "outline-primary", "size", "sm", 1, "steppers-btn-prev", 3, "disabled"], ["type", "button", "itButton", "primary", "size", "sm", 1, "steppers-btn-save", 3, "progress", "disabled"], ["type", "button", "itButton", "outline-primary", "size", "sm", 1, "steppers-btn-next", 3, "disabled"], ["type", "button", "itButton", "primary", "size", "sm", 1, "steppers-btn-confirm", "d-lg-block", 3, "progress", "disabled"], ["type", "button", "itButton", "outline-primary", "size", "sm", 1, "steppers-btn-prev", 3, "click", "disabled"], ["name", "chevron-left", "color", "primary", 3, "labelWaria"], [1, "steppers-dots"], [1, "steppers-progress"], [3, "done"], [3, "color", "value"], ["type", "button", "itButton", "primary", "size", "sm", 1, "steppers-btn-save", 3, "click", "progress", "disabled"], ["type", "button", "itButton", "outline-primary", "size", "sm", 1, "steppers-btn-next", 3, "click", "disabled"], ["name", "chevron-right", "color", "primary", 3, "labelWaria"], ["type", "button", "itButton", "primary", "size", "sm", 1, "steppers-btn-confirm", "d-lg-block", 3, "click", "progress", "disabled"], ["name", "check", 1, "steppers-success", 3, "labelWaria"]],
      template: function ItSteppersContainerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 1);
          i0.ɵɵtemplate(1, ItSteppersContainerComponent_Conditional_1_Template, 3, 2, "div", 2)(2, ItSteppersContainerComponent_Conditional_2_Template, 2, 1, "div", 3)(3, ItSteppersContainerComponent_Conditional_3_Template, 6, 5, "nav", 4);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(4, ItSteppersContainerComponent_ng_template_4_Template, 5, 6, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          let tmp_3_0;
          i0.ɵɵclassProp("bg-dark", ctx.dark);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.showHeader ? 1 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional((tmp_3_0 = ctx.steps == null ? null : ctx.steps.get(ctx.activeStep)) ? 2 : -1, tmp_3_0);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.showBackButton || ctx.showSaveButton || ctx.showForwardButton || ctx.showConfirmButton || !!ctx.progressStyle ? 3 : -1);
        }
      },
      dependencies: [ItIconComponent, NgTemplateOutlet, TranslateModule, i1.TranslatePipe, ItButtonDirective, ItProgressBarComponent, ItProgressButtonComponent],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItSteppersContainerComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-steppers-container',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [ItIconComponent, NgTemplateOutlet, TranslateModule, ItButtonDirective, ItProgressBarComponent, ItProgressButtonComponent],
      template: "<div class=\"steppers\" [class.bg-dark]=\"dark\">\n  @if (showHeader) {\n    <div class=\"steppers-header\">\n      @if (steps) {\n        <ul>\n          @for (step of steps; track step.id; let i = $index) {\n            <li [class.confirmed]=\"i < activeStep\" [class.active]=\"i === activeStep\" [class.no-line]=\"i === activeStep && steppersNumber\">\n              @if (step.icon && !steppersNumber) {\n                <it-icon [labelWaria]=\"'it.core.confirmed' | translate\" [name]=\"step.icon\"></it-icon>\n              }\n              @if (steppersNumber) {\n                <span class=\"steppers-number\">\n                  @if (i < activeStep) {\n                    <ng-container *ngTemplateOutlet=\"checkIcon\"></ng-container>\n                  } @else {\n                    <span class=\"visually-hidden\">{{ 'it.core.step' | translate }} </span>{{ i + 1 }}\n                  }\n                </span>\n              }\n              {{ step.label }}\n              @if (i < activeStep && !steppersNumber) {\n                <ng-container *ngTemplateOutlet=\"checkIcon\"></ng-container>\n              }\n              @if (i === activeStep) {\n                <span class=\"visually-hidden\">{{ 'it.core.active' | translate }}</span>\n              }\n            </li>\n          }\n        </ul>\n      }\n      @if (steps) {\n        <span class=\"steppers-index\" aria-hidden=\"true\">\n          @if (!steppersNumber) {\n            {{ activeStep + 1 + '/' + steps.length }}\n          } @else {\n            @for (step of steps; track step.id; let i = $index) {\n              <span [class.active]=\"i === activeStep\">{{ i + 1 }}</span>\n            }\n          }\n        </span>\n      }\n    </div>\n  }\n\n  @if (steps?.get(activeStep); as step) {\n    <div class=\"steppers-content\" aria-live=\"polite\">\n      <ng-container *ngTemplateOutlet=\"step.htmlContent\"></ng-container>\n    </div>\n  }\n\n  @if (showBackButton || showSaveButton || showForwardButton || showConfirmButton || !!progressStyle) {\n    <nav class=\"steppers-nav\">\n      @if (showBackButton) {\n        <button\n          type=\"button\"\n          itButton=\"outline-primary\"\n          size=\"sm\"\n          class=\"steppers-btn-prev\"\n          [disabled]=\"disableBackButton\"\n          (click)=\"backClick.emit(activeStep)\">\n          <it-icon [labelWaria]=\"'it.core.back' | translate\" name=\"chevron-left\" color=\"primary\"></it-icon>\n          {{ 'it.core.back' | translate }}\n        </button>\n      }\n      @if (!!progressStyle && steps) {\n        @if (progressStyle === 'dots') {\n          <ul class=\"steppers-dots\">\n            @for (step of steps; track step; let i = $index) {\n              <li [class.done]=\"i < activeStep\">\n                <span class=\"visually-hidden\">\n                  {{ 'it.core.step-of' | translate: { current: activeStep + 1, available: steps?.length } }}\n                  {{ i < activeStep ? '- ' + ('it.core.confirmed' | translate) : '' }}\n                </span>\n              </li>\n            }\n          </ul>\n        } @else {\n          <div class=\"steppers-progress\">\n            <it-progress-bar [color]=\"progressColor\" [value]=\"(activeStep / (steps?.length || 1)) * 100\"></it-progress-bar>\n          </div>\n        }\n      }\n      @if (showSaveButton) {\n        <button\n          type=\"button\"\n          itButton=\"primary\"\n          size=\"sm\"\n          class=\"steppers-btn-save\"\n          [progress]=\"saveLoading\"\n          [disabled]=\"saveLoading || disableSaveButton\"\n          (click)=\"saveClick.emit(activeStep)\">\n          {{ 'it.general.save' | translate }}\n        </button>\n      }\n      @if (showForwardButton) {\n        <button\n          type=\"button\"\n          itButton=\"outline-primary\"\n          size=\"sm\"\n          class=\"steppers-btn-next\"\n          [disabled]=\"disableForwardButton\"\n          (click)=\"forwardClick.emit(activeStep)\">\n          {{ 'it.core.forward' | translate }}\n          <it-icon [labelWaria]=\"'it.core.forward' | translate\" name=\"chevron-right\" color=\"primary\"></it-icon>\n        </button>\n      }\n      @if (showConfirmButton) {\n        <button\n          type=\"button\"\n          itButton=\"primary\"\n          size=\"sm\"\n          class=\"steppers-btn-confirm d-lg-block\"\n          [progress]=\"confirmLoading\"\n          [disabled]=\"confirmLoading || disableConfirmButton\"\n          (click)=\"confirmClick.emit(activeStep)\">\n          {{ 'it.core.confirm' | translate }}\n        </button>\n      }\n    </nav>\n  }\n</div>\n\n<ng-template #checkIcon>\n  <it-icon [labelWaria]=\"'it.core.confirmed' | translate\" name=\"check\" class=\"steppers-success\"></it-icon>\n  <span class=\"visually-hidden\">{{ 'it.core.confirmed' | translate }}</span>\n</ng-template>\n"
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }], {
    activeStep: [{
      type: Input,
      args: [{
        required: true
      }]
    }],
    showHeader: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    dark: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    steppersNumber: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    progressStyle: [{
      type: Input
    }],
    progressColor: [{
      type: Input
    }],
    showBackButton: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    disableBackButton: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    showForwardButton: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    disableForwardButton: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    showConfirmButton: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    disableConfirmButton: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    confirmLoading: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    showSaveButton: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    disableSaveButton: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    saveLoading: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    steps: [{
      type: ContentChildren,
      args: [ItSteppersItemComponent]
    }],
    backClick: [{
      type: Output
    }],
    forwardClick: [{
      type: Output
    }],
    confirmClick: [{
      type: Output
    }],
    saveClick: [{
      type: Output
    }]
  });
})();
const steppersComponents = [ItSteppersContainerComponent, ItSteppersItemComponent];
class ItSteppersModule {
  static {
    this.ɵfac = function ItSteppersModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItSteppersModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ItSteppersModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [ItSteppersContainerComponent]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItSteppersModule, [{
    type: NgModule,
    args: [{
      imports: steppersComponents,
      exports: steppersComponents
    }]
  }], null, null);
})();
class ItTabItemComponent extends ItAbstractComponent {
  constructor() {
    super(...arguments);
    /**
     * Custom class
     */
    this.class = '';
  }
  ngAfterViewInit() {
    super.ngAfterViewInit();
    this._renderer.removeAttribute(this._elementRef.nativeElement, 'class');
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵItTabItemComponent_BaseFactory;
      return function ItTabItemComponent_Factory(__ngFactoryType__) {
        return (ɵItTabItemComponent_BaseFactory || (ɵItTabItemComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ItTabItemComponent)))(__ngFactoryType__ || ItTabItemComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItTabItemComponent,
      selectors: [["it-tab-item"]],
      viewQuery: function ItTabItemComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(TemplateRef, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.htmlContent = _t.first);
        }
      },
      inputs: {
        label: "label",
        icon: "icon",
        active: [2, "active", "active", inputToBoolean],
        disabled: [2, "disabled", "disabled", inputToBoolean],
        class: "class"
      },
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function ItTabItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, ItTabItemComponent_ng_template_0_Template, 1, 0, "ng-template");
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItTabItemComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-tab-item',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [],
      template: "<ng-template>\n  <ng-content></ng-content>\n</ng-template>\n"
    }]
  }], null, {
    label: [{
      type: Input
    }],
    icon: [{
      type: Input
    }],
    active: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    disabled: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    class: [{
      type: Input
    }],
    htmlContent: [{
      type: ViewChild,
      args: [TemplateRef]
    }]
  });
})();
class ItTabContainerComponent extends ItAbstractComponent {
  constructor() {
    super();
    this.tabSelected = new EventEmitter();
  }
  ngAfterViewInit() {
    super.ngAfterViewInit();
    this.tabs?.changes.pipe(
    // When tabs changes (dynamic add/remove)
    startWith(undefined), tap(() => {
      this.tabSubscriptions?.forEach(sub => sub.unsubscribe()); // Remove old subscriptions
      this.tabSubscriptions = this.tabs?.map(tab => tab.valueChanges.subscribe(() => {
        this._changeDetectorRef.detectChanges(); // DetectChanges when tab-item attributes changes
      }));
      this._changeDetectorRef.detectChanges(); // Force update html render
    }), switchMap(() => this.tabNavLinks?.changes.pipe(startWith(undefined)) || of(undefined))).subscribe(() => {
      // Init tabs from bootstrap-italia
      this.tabNavLinks?.forEach(tabNavLink => {
        const triggerEl = tabNavLink.nativeElement,
          tabTrigger = Tab.getOrCreateInstance(triggerEl);
        if (triggerEl.getAttribute('tab-listener') !== 'true') {
          triggerEl.addEventListener('click', event => {
            event.preventDefault();
            tabTrigger.show();
            this._changeDetectorRef.detectChanges();
          });
          triggerEl.setAttribute('tab-listener', 'true'); // Prevents multiple insertion of the listener
        }
      });
    });
  }
  ngOnDestroy() {
    this.tabSubscriptions?.forEach(sub => sub.unsubscribe());
  }
  onTab(tab) {
    this.tabSelected.emit(tab);
  }
  static {
    this.ɵfac = function ItTabContainerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItTabContainerComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItTabContainerComponent,
      selectors: [["it-tab-container"]],
      contentQueries: function ItTabContainerComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, ItTabItemComponent, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tabs = _t);
        }
      },
      viewQuery: function ItTabContainerComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c30, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tabNavLinks = _t);
        }
      },
      inputs: {
        auto: [2, "auto", "auto", inputToBoolean],
        iconText: [2, "iconText", "iconText", inputToBoolean],
        dark: [2, "dark", "dark", inputToBoolean]
      },
      outputs: {
        tabSelected: "tabSelected"
      },
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
      decls: 2,
      vars: 2,
      consts: [["tabNavLinks", ""], ["role", "tablist", 1, "nav", "nav-tabs", 3, "auto", "nav-tabs-icon-text", "nav-dark"], [1, "tab-content"], ["role", "tablist", 1, "nav", "nav-tabs"], [1, "nav-item"], ["role", "tab", 1, "nav-link", 3, "click", "id"], [1, "me-2", 3, "name"], ["role", "tabpanel", 3, "id", "class", "active", "show"], ["role", "tabpanel", 3, "id"], [4, "ngTemplateOutlet"]],
      template: function ItTabContainerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ItTabContainerComponent_Conditional_0_Template, 3, 6, "ul", 1)(1, ItTabContainerComponent_Conditional_1_Template, 3, 0, "div", 2);
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx.tabs ? 0 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.tabs ? 1 : -1);
        }
      },
      dependencies: [ItIconComponent, NgTemplateOutlet],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItTabContainerComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-tab-container',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [ItIconComponent, NgTemplateOutlet],
      template: "@if (tabs) {\n  <ul class=\"nav nav-tabs\" [class.auto]=\"auto\" [class.nav-tabs-icon-text]=\"iconText\" [class.nav-dark]=\"dark\" role=\"tablist\">\n    @for (tab of tabs; track tab.id) {\n      <li class=\"nav-item\">\n        <a\n          #tabNavLinks\n          [id]=\"tab.id + '-tab-link'\"\n          role=\"tab\"\n          class=\"nav-link\"\n          [class.active]=\"tab.active\"\n          [class.disabled]=\"tab.disabled\"\n          [attr.href]=\"'#' + tab.id + '-tab'\"\n          [attr.aria-controls]=\"tab.id + '-tab'\"\n          (click)=\"onTab(tab)\">\n          @if (tab.icon) {\n            <it-icon [name]=\"tab.icon\" class=\"me-2\"></it-icon>\n          }\n          {{ tab.label }}\n        </a>\n      </li>\n    }\n  </ul>\n}\n\n@if (tabs) {\n  <div class=\"tab-content\">\n    @for (tab of tabs; track tab.id) {\n      <div\n        [id]=\"tab.id + '-tab'\"\n        class=\"tab-pane p-4 fade {{ tab.class ?? '' }}\"\n        [class.active]=\"tab.active\"\n        [class.show]=\"tab.active\"\n        role=\"tabpanel\"\n        [attr.aria-labelledby]=\"tab.id + '-tab-link'\">\n        <ng-container *ngTemplateOutlet=\"tab.htmlContent\"></ng-container>\n      </div>\n    }\n  </div>\n}\n"
    }]
  }], () => [], {
    auto: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    iconText: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    dark: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    tabs: [{
      type: ContentChildren,
      args: [ItTabItemComponent]
    }],
    tabNavLinks: [{
      type: ViewChildren,
      args: ['tabNavLinks']
    }],
    tabSelected: [{
      type: Output
    }]
  });
})();
const tabComponents = [ItTabContainerComponent, ItTabItemComponent];
class ItTabModule {
  static {
    this.ɵfac = function ItTabModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItTabModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ItTabModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItTabModule, [{
    type: NgModule,
    args: [{
      imports: tabComponents,
      exports: tabComponents
    }]
  }], null, null);
})();
class ItTableComponent {
  constructor() {
    /**
     * Responsive tables allow you to scroll tables horizontally with ease.
     * @default responsive
     */
    this.responsive = 'responsive';
  }
  static {
    this.ɵfac = function ItTableComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItTableComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItTableComponent,
      selectors: [["it-table"]],
      inputs: {
        color: "color",
        headColor: "headColor",
        alignment: "alignment",
        striped: [2, "striped", "striped", inputToBoolean],
        hover: [2, "hover", "hover", inputToBoolean],
        bordered: [2, "bordered", "bordered", inputToBoolean],
        borderless: [2, "borderless", "borderless", inputToBoolean],
        compact: [2, "compact", "compact", inputToBoolean],
        captionTop: [2, "captionTop", "captionTop", inputToBoolean],
        responsive: "responsive"
      },
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c32,
      decls: 10,
      vars: 20,
      template: function ItTableComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c31);
          i0.ɵɵelementStart(0, "div")(1, "table")(2, "caption");
          i0.ɵɵprojection(3);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(4, "thead");
          i0.ɵɵprojection(5, 1);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(6, "tbody");
          i0.ɵɵprojection(7, 2);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(8, "tfoot");
          i0.ɵɵprojection(9, 3);
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.responsive ? "table-" + ctx.responsive : undefined);
          i0.ɵɵadvance();
          i0.ɵɵclassMapInterpolate2("table", ctx.color ? " table-" + ctx.color : "", "", ctx.alignment ? " " + ctx.alignment : "", "");
          i0.ɵɵclassProp("table-striped", ctx.striped)("table-hover", ctx.hover)("table-bordered", ctx.bordered)("table-borderless", ctx.borderless)("table-sm", ctx.compact)("caption-top", ctx.captionTop);
          i0.ɵɵadvance(3);
          i0.ɵɵclassMap(ctx.headColor ? "table-" + ctx.headColor : undefined);
        }
      },
      styles: ["caption[_ngcontent-%COMP%]:empty{display:none}caption[_ngcontent-%COMP%]:empty ~ thead[_ngcontent-%COMP%]{border-top:none!important}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItTableComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-table',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [],
      template: "<div [class]=\"responsive ? 'table-' + responsive : undefined\">\n  <table\n    class=\"table{{ color ? ' table-' + color : '' }}{{ alignment ? ' ' + alignment : '' }}\"\n    [class.table-striped]=\"striped\"\n    [class.table-hover]=\"hover\"\n    [class.table-bordered]=\"bordered\"\n    [class.table-borderless]=\"borderless\"\n    [class.table-sm]=\"compact\"\n    [class.caption-top]=\"captionTop\">\n    <caption>\n      <ng-content select=\"[caption]\"></ng-content>\n    </caption>\n    <thead [class]=\"headColor ? 'table-' + headColor : undefined\">\n      <ng-content select=\"[thead]\"></ng-content>\n    </thead>\n    <tbody>\n      <ng-content select=\"[tbody]\"></ng-content>\n    </tbody>\n    <tfoot>\n      <ng-content select=\"[tfoot]\"></ng-content>\n    </tfoot>\n  </table>\n</div>\n",
      styles: ["caption:empty{display:none}caption:empty~thead{border-top:none!important}\n"]
    }]
  }], null, {
    color: [{
      type: Input
    }],
    headColor: [{
      type: Input
    }],
    alignment: [{
      type: Input
    }],
    striped: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    hover: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    bordered: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    borderless: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    compact: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    captionTop: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    responsive: [{
      type: Input
    }]
  });
})();

/**
 * Injection token to be used to override the default options for `it-sort`.
 */
const IT_SORT_DEFAULT_OPTIONS = new InjectionToken('IT_SORT_DEFAULT_OPTIONS');
class ItSortDirective {
  /** The sort direction of the currently active ItSortable. */
  get direction() {
    return this._direction;
  }
  set direction(direction) {
    this._direction = direction;
  }
  constructor(_defaultOptions) {
    this._defaultOptions = _defaultOptions;
    /**
     * The direction to set when an MatSortable is initially sorted.
     * May be overridden by the MatSortable's sort start.
     */
    this.start = 'asc';
    /** Whether the sortable is disabled. */
    this.sortDisabled = false;
    /** Event emitted when the user changes either the active sort or sort direction. */
    this.sortChange = new EventEmitter();
    this.sortDirectiveClass = 'it-sort';
    /** Collection of all registered sortables that this directive manages. */
    this.sortables = new Map();
    /** Used to notify any child components listening to state changes. */
    this._stateChanges = new Subject();
  }
  /**
   * Register function to be used by the contained ItSortables. Adds the ItSortable to the
   * collection of ItSortables.
   */
  register(sortable) {
    this.sortables.set(sortable.id, sortable);
  }
  /**
   * Unregister function to be used by the contained ItSortables. Removes the ItSortable from the
   * collection of contained ItSortables.
   */
  deregister(sortable) {
    this.sortables.delete(sortable.id);
  }
  /** Sets the active sort id and determines the new sort direction. */
  sort(sortable) {
    if (this.active != sortable.id) {
      this.active = sortable.id;
      this.direction = sortable.start ? sortable.start : this.start;
    } else {
      this.direction = this.getNextSortDirection(sortable);
    }
    this.sortChange.emit({
      active: this.active,
      direction: this.direction
    });
  }
  /** Returns the next sort direction of the active sortable, checking for potential overrides. */
  getNextSortDirection(sortable) {
    if (!sortable) {
      return undefined;
    }
    // Get the sort direction cycle with the potential sortable overrides.
    const disableClear = sortable?.disableSortClear ?? this.disableSortClear ?? !!this._defaultOptions?.disableClear;
    const sortDirectionCycle = getSortDirectionCycle(sortable.start || this.start, disableClear);
    // Get and return the next direction in the cycle
    let nextDirectionIndex = sortDirectionCycle.indexOf(this.direction) + 1;
    if (nextDirectionIndex >= sortDirectionCycle.length) {
      nextDirectionIndex = 0;
    }
    return sortDirectionCycle[nextDirectionIndex];
  }
  ngOnChanges() {
    this._stateChanges.next();
  }
  ngOnDestroy() {
    this._stateChanges.complete();
  }
  static {
    this.ɵfac = function ItSortDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItSortDirective)(i0.ɵɵdirectiveInject(IT_SORT_DEFAULT_OPTIONS, 8));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ItSortDirective,
      selectors: [["", "itSort", ""]],
      hostVars: 2,
      hostBindings: function ItSortDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.sortDirectiveClass);
        }
      },
      inputs: {
        active: [0, "itSortActive", "active"],
        start: [0, "itSortStart", "start"],
        direction: [0, "itSortDirection", "direction"],
        disableSortClear: [2, "disableSortClear", "disableSortClear", booleanAttribute],
        sortDisabled: [2, "sortDisabled", "sortDisabled", booleanAttribute]
      },
      outputs: {
        sortChange: "sortChange"
      },
      exportAs: ["itSort"],
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵNgOnChangesFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItSortDirective, [{
    type: Directive,
    args: [{
      standalone: true,
      selector: '[itSort]',
      exportAs: 'itSort'
    }]
  }], () => [{
    type: undefined,
    decorators: [{
      type: Optional
    }, {
      type: Inject,
      args: [IT_SORT_DEFAULT_OPTIONS]
    }]
  }], {
    active: [{
      type: Input,
      args: ['itSortActive']
    }],
    start: [{
      type: Input,
      args: ['itSortStart']
    }],
    direction: [{
      type: Input,
      args: ['itSortDirection']
    }],
    disableSortClear: [{
      type: Input,
      args: [{
        transform: booleanAttribute
      }]
    }],
    sortDisabled: [{
      type: Input,
      args: [{
        transform: booleanAttribute
      }]
    }],
    sortChange: [{
      type: Output
    }],
    sortDirectiveClass: [{
      type: HostBinding,
      args: ['class']
    }]
  });
})();
/** Returns the sort direction cycle to use given the provided parameters of order and clear. */
function getSortDirectionCycle(start, disableClear) {
  const sortOrder = ['asc', 'desc'];
  if (start == 'desc') {
    sortOrder.reverse();
  }
  if (!disableClear) {
    sortOrder.push(undefined);
  }
  return sortOrder;
}

/**
 * Applies sorting behavior (click to change sort) and styles to an element, including an
 * arrow to display the current sort direction.
 *
 * Must be provided with an id and contained within a parent ItSort directive.
 *
 * If used on header cells in a CdkTable, it will automatically default its id from its containing
 * column definition.
 */
class ItSortHeaderComponent {
  constructor(_changeDetectorRef,
  // `SortDirective` is not optionally injected, but just asserted manually w/ better error.
  _sort, defaultOptions) {
    this._changeDetectorRef = _changeDetectorRef;
    this._sort = _sort;
    /** Sets the position of the arrow that displays when sorted. */
    this.arrowPosition = 'after';
    /** whether the sort header is disabled. */
    this.sortDisabled = false;
    this.sortHeaderClass = 'it-sort-header';
    if (defaultOptions?.arrowPosition) {
      this.arrowPosition = defaultOptions?.arrowPosition;
    }
    this._handleStateChanges();
  }
  ngOnInit() {
    // Initialize the direction of the arrow and set the view state to be immediately that state.
    this.updateArrowDirection();
    this._sort.register(this);
  }
  ngOnDestroy() {
    this._sort.deregister(this);
    this._rerenderSubscription?.unsubscribe();
  }
  _handleClick() {
    if (!this.isDisabled) {
      this._sort.sort(this);
    }
  }
  /**
   * Whether this MatSortHeader is currently sorted in either ascending or descending order.
   */
  get isSorted() {
    return this._sort.active == this.id && (this._sort.direction === 'asc' || this._sort.direction === 'desc');
  }
  /**
   * Returns the icon class by the arrow direction
   */
  get arrowIconClass() {
    return `${this._arrowDirection == 'asc' ? 'arrow-up' : 'arrow-down'}`;
  }
  /**
   * Updates the direction the arrow should be pointing. If it is not sorted, the arrow should be
   * facing the start direction. Otherwise if it is sorted, the arrow should point in the currently
   * active sorted direction. The reason this is updated through a function is because the direction
   * should only be changed at specific times - when deactivated but the hint is displayed and when
   * the sort is active and the direction changes. Otherwise the arrow's direction should linger
   * in cases such as the sort becoming deactivated but we want to animate the arrow away while
   * preserving its direction, even though the next sort direction is actually different and should
   * only be changed once the arrow displays again (hint or activation).
   */
  updateArrowDirection() {
    this._arrowDirection = this.isSorted ? this._sort.direction : this.start || this._sort.start;
  }
  get isDisabled() {
    return this._sort.sortDisabled || this.sortDisabled;
  }
  /**
   * Gets the aria-sort attribute that should be applied to this sort header. If this header
   * is not sorted, returns null so that the attribute is removed from the host element. Aria spec
   * says that the aria-sort property should only be present on one header at a time, so removing
   * ensures this is true.
   */
  get ariaSortAttribute() {
    if (!this.isSorted) {
      return 'none';
    }
    return this._sort.direction == 'asc' ? 'ascending' : 'descending';
  }
  /** Handles changes in the sorting state. */
  _handleStateChanges() {
    this._rerenderSubscription = merge(this._sort.sortChange, this._sort._stateChanges).subscribe(() => {
      if (this.isSorted) {
        this.updateArrowDirection();
      }
      this._changeDetectorRef.markForCheck();
    });
  }
  static {
    this.ɵfac = function ItSortHeaderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItSortHeaderComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(ItSortDirective, 8), i0.ɵɵdirectiveInject(IT_SORT_DEFAULT_OPTIONS, 8));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItSortHeaderComponent,
      selectors: [["", "it-sort-header", ""]],
      hostVars: 5,
      hostBindings: function ItSortHeaderComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function ItSortHeaderComponent_click_HostBindingHandler() {
            return ctx._handleClick();
          });
        }
        if (rf & 2) {
          i0.ɵɵattribute("aria-sort", ctx.ariaSortAttribute);
          i0.ɵɵclassMap(ctx.sortHeaderClass);
          i0.ɵɵclassProp("it-sort-header-disabled", ctx.isDisabled);
        }
      },
      inputs: {
        id: [0, "it-sort-header", "id"],
        arrowPosition: "arrowPosition",
        start: "start",
        sortDisabled: [2, "sortDisabled", "sortDisabled", booleanAttribute],
        disableSortClear: [2, "disableSortClear", "disableSortClear", booleanAttribute]
      },
      exportAs: ["itSortHeader"],
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵStandaloneFeature],
      attrs: _c33,
      ngContentSelectors: _c1,
      decls: 4,
      vars: 7,
      consts: [[1, "it-sort-header-container", "it-focus-indicator"], [1, "it-sort-header-content"], ["size", "sm", 1, "it-sort-arrow", 3, "name"]],
      template: function ItSortHeaderComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
          i0.ɵɵprojection(2);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(3, "it-icon", 2);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵclassProp("it-sort-header-sorted", ctx.isSorted)("it-sort-header-position-before", ctx.arrowPosition === "before");
          i0.ɵɵattribute("tabindex", ctx.isDisabled ? null : 0)("role", ctx.isDisabled ? null : "button");
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("name", ctx.arrowIconClass);
        }
      },
      dependencies: [ItIconComponent],
      styles: [".it-sort-header-container{display:flex;cursor:pointer;align-items:center;justify-content:space-between;letter-spacing:normal;outline:0}.it-sort-header-disabled .it-sort-header-container{cursor:default}.it-sort-header-disabled .it-sort-header-container .it-sort-arrow{opacity:0!important;fill-opacity:0!important}.it-sort-header-container:before{margin:-5px}.it-sort-header-container.it-sort-header-position-before{flex-direction:row-reverse;justify-content:left;gap:.5rem}.it-sort-header-container .it-sort-arrow{opacity:0;fill-opacity:0;transition:fill-opacity .3s ease-out,opacity .3s ease-out;-moz-transition:fill-opacity .3s ease-out,opacity .3s ease-out;-webkit-transition:fill-opacity .3s ease-out,opacity .3s ease-out;-o-transition:fill-opacity .3s ease-out,opacity .3s ease-out}.it-sort-header-container:hover .it-sort-arrow{opacity:.5;fill-opacity:.5}.it-sort-header-container.it-sort-header-sorted .it-sort-arrow{opacity:1!important;fill-opacity:1!important}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItSortHeaderComponent, [{
    type: Component,
    args: [{
      selector: '[it-sort-header]',
      exportAs: 'itSortHeader',
      standalone: true,
      imports: [ItIconComponent],
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      template: "<!--\n  We set the `tabindex` on an element inside the table header, rather than the header itself,\n  because of a bug in NVDA where having a `tabindex` on a `th` breaks keyboard navigation in the\n  table (see https://github.com/nvaccess/nvda/issues/7718). This allows for the header to both\n  be focusable, and have screen readers read out its `aria-sort` state. We prefer this approach\n  over having a button with an `aria-label` inside the header, because the button's `aria-label`\n  will be read out as the user is navigating the table's cell (see #13012).\n\n  The approach is based off of: https://dequeuniversity.com/library/aria/tables/sf-sortable-grid\n-->\n<div\n  class=\"it-sort-header-container it-focus-indicator\"\n  [class.it-sort-header-sorted]=\"isSorted\"\n  [class.it-sort-header-position-before]=\"arrowPosition === 'before'\"\n  [attr.tabindex]=\"isDisabled ? null : 0\"\n  [attr.role]=\"isDisabled ? null : 'button'\">\n  <!--\n    We have to keep it due to a large number of screenshot diff failures. It should be removed eventually.\n    Note that the difference isn't visible with a shorter header, but once it breaks up into multiple lines, this element\n    causes it to be center-aligned, whereas removing it will keep the text to the left.\n  -->\n  <div class=\"it-sort-header-content\">\n    <ng-content></ng-content>\n  </div>\n\n  <it-icon class=\"it-sort-arrow\" size=\"sm\" [name]=\"arrowIconClass\" />\n</div>\n",
      styles: [".it-sort-header-container{display:flex;cursor:pointer;align-items:center;justify-content:space-between;letter-spacing:normal;outline:0}.it-sort-header-disabled .it-sort-header-container{cursor:default}.it-sort-header-disabled .it-sort-header-container .it-sort-arrow{opacity:0!important;fill-opacity:0!important}.it-sort-header-container:before{margin:-5px}.it-sort-header-container.it-sort-header-position-before{flex-direction:row-reverse;justify-content:left;gap:.5rem}.it-sort-header-container .it-sort-arrow{opacity:0;fill-opacity:0;transition:fill-opacity .3s ease-out,opacity .3s ease-out;-moz-transition:fill-opacity .3s ease-out,opacity .3s ease-out;-webkit-transition:fill-opacity .3s ease-out,opacity .3s ease-out;-o-transition:fill-opacity .3s ease-out,opacity .3s ease-out}.it-sort-header-container:hover .it-sort-arrow{opacity:.5;fill-opacity:.5}.it-sort-header-container.it-sort-header-sorted .it-sort-arrow{opacity:1!important;fill-opacity:1!important}\n"]
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }, {
    type: ItSortDirective,
    decorators: [{
      type: Optional
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Optional
    }, {
      type: Inject,
      args: [IT_SORT_DEFAULT_OPTIONS]
    }]
  }], {
    id: [{
      type: Input,
      args: ['it-sort-header']
    }],
    arrowPosition: [{
      type: Input
    }],
    start: [{
      type: Input
    }],
    sortDisabled: [{
      type: Input,
      args: [{
        transform: booleanAttribute
      }]
    }],
    disableSortClear: [{
      type: Input,
      args: [{
        transform: booleanAttribute
      }]
    }],
    sortHeaderClass: [{
      type: HostBinding,
      args: ['class']
    }],
    _handleClick: [{
      type: HostListener,
      args: ['click']
    }],
    isDisabled: [{
      type: HostBinding,
      args: ['class.it-sort-header-disabled']
    }],
    ariaSortAttribute: [{
      type: HostBinding,
      args: ['attr.aria-sort']
    }]
  });
})();
const tableComponents = [ItTableComponent, ItSortDirective, ItSortHeaderComponent];
class ItTableModule {
  static {
    this.ɵfac = function ItTableModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItTableModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ItTableModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItTableModule, [{
    type: NgModule,
    args: [{
      imports: tableComponents,
      exports: tableComponents
    }]
  }], null, null);
})();

/**
 * Timeline Item
 * @description Represents a single event for Timeline component.
 */
class ItTimelineItemComponent extends ItAbstractComponent {
  constructor() {
    super(...arguments);
    /**
     * Timeline element reference date format
     * @default dd/MM/yyyy
     */
    this.dateFormat = 'dd/MM/yyyy';
    /**
     * Timeline element PIN type
     * @default none
     */
    this.pinType = 'default';
    /**
     * Timeline element PIN icon
     * @default code-circle
     */
    this.pinIcon = 'code-circle';
    /**
     * Timeline element category label
     */
    this.categoryLabel = 'Categoria evento: ';
    /**
     * Timeline element date label
     */
    this.dateLabel = 'Data evento: ';
    /**
     * Timeline element show detail link
     * @default false
     */
    this.showReadMore = false;
    /** Timeline element detail link
     * @default #
     */
    this.readMoreLink = '#';
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵItTimelineItemComponent_BaseFactory;
      return function ItTimelineItemComponent_Factory(__ngFactoryType__) {
        return (ɵItTimelineItemComponent_BaseFactory || (ɵItTimelineItemComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ItTimelineItemComponent)))(__ngFactoryType__ || ItTimelineItemComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItTimelineItemComponent,
      selectors: [["it-timeline-item"]],
      inputs: {
        title: "title",
        text: "text",
        signature: "signature",
        eventDate: "eventDate",
        dateFormat: "dateFormat",
        pinText: "pinText",
        pinType: "pinType",
        pinIcon: "pinIcon",
        pinIconTitle: "pinIconTitle",
        categoryLabel: "categoryLabel",
        dateLabel: "dateLabel",
        categoryTitle: "categoryTitle",
        categoryLink: "categoryLink",
        showReadMore: [2, "showReadMore", "showReadMore", inputToBoolean],
        readMoreLink: "readMoreLink"
      },
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
      decls: 19,
      vars: 12,
      consts: [[1, "timeline-element"], [1, "it-now-label", "d-none", "d-lg-flex"], [1, "it-pin-wrapper", 3, "ngClass"], [1, "pin-icon"], [3, "name", "title"], ["name", "code-circle"], [1, "pin-text"], [1, "card-wrapper"], [1, "card"], [1, "card-body"], [1, "category-top"], [1, "card-title"], [1, "card-text"], [1, "card-signature"], [1, "read-more", 3, "href"], [1, "visually-hidden"], [1, "category", 3, "href"], [1, "data"], [1, "text"], ["name", "arrow-right"]],
      template: function ItTimelineItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, ItTimelineItemComponent_Conditional_1_Template, 3, 3, "span", 1);
          i0.ɵɵelementStart(2, "h3", 2)(3, "div", 3);
          i0.ɵɵtemplate(4, ItTimelineItemComponent_Conditional_4_Template, 1, 3, "it-icon", 4)(5, ItTimelineItemComponent_Conditional_5_Template, 1, 0, "it-icon", 5);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(6, "div", 6)(7, "span");
          i0.ɵɵtext(8);
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(9, "div", 7)(10, "div", 8)(11, "div", 9);
          i0.ɵɵtemplate(12, ItTimelineItemComponent_Conditional_12_Template, 3, 2, "div", 10);
          i0.ɵɵelementStart(13, "h4", 11);
          i0.ɵɵtext(14);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(15, "p", 12);
          i0.ɵɵtext(16);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(17, ItTimelineItemComponent_Conditional_17_Template, 2, 1, "span", 13)(18, ItTimelineItemComponent_Conditional_18_Template, 8, 10, "a", 14);
          i0.ɵɵelementEnd()()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.pinType === "now" ? 1 : -1);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(9, _c34, ctx.pinType === "evidence", ctx.pinType === "now"));
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx.pinIcon ? 4 : 5);
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate(ctx.pinText);
          i0.ɵɵadvance(4);
          i0.ɵɵconditional(ctx.categoryTitle && ctx.categoryLink || ctx.eventDate ? 12 : -1);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(ctx.title);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(ctx.text);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.signature ? 17 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.showReadMore ? 18 : -1);
        }
      },
      dependencies: [ItIconComponent, DatePipe, TranslateModule, i1.TranslatePipe, NgClass],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItTimelineItemComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-timeline-item',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [ItIconComponent, DatePipe, TranslateModule, NgClass],
      template: "<div class=\"timeline-element\">\n  @if (pinType === 'now') {\n    <span class=\"it-now-label d-none d-lg-flex\">{{ 'it.timeline.today' | translate }}</span>\n  }\n  <h3 class=\"it-pin-wrapper\" [ngClass]=\"{ 'it-evidence': pinType === 'evidence', 'it-now': pinType === 'now' }\">\n    <div class=\"pin-icon\">\n      @if (pinIcon) {\n        <it-icon [name]=\"pinIcon\" [title]=\"pinIconTitle\" [attr.role]=\"pinIconTitle ? 'img' : null\"></it-icon>\n      } @else {\n        <it-icon name=\"code-circle\"></it-icon>\n      }\n    </div>\n    <div class=\"pin-text\">\n      <span>{{ pinText }}</span>\n    </div>\n  </h3>\n  <div class=\"card-wrapper\">\n    <div class=\"card\">\n      <div class=\"card-body\">\n        @if ((categoryTitle && categoryLink) || eventDate) {\n          <div class=\"category-top\">\n            @if (categoryTitle) {\n              <span class=\"visually-hidden\">{{ categoryLabel }}</span>\n              <a class=\"category\" [href]=\"categoryLink\">{{ categoryTitle }}</a>\n            }\n            @if (eventDate) {\n              <span class=\"visually-hidden\">{{ dateLabel }}</span>\n              <span class=\"data\">{{ eventDate | date: dateFormat }}</span>\n            }\n          </div>\n        }\n        <h4 class=\"card-title\">{{ title }}</h4>\n        <p class=\"card-text\">{{ text }}</p>\n        @if (signature) {\n          <span class=\"card-signature\">{{ signature }}</span>\n        }\n        @if (showReadMore) {\n          <a class=\"read-more\" [href]=\"readMoreLink\">\n            <span class=\"text\">{{ 'it.timeline.read-more' | translate }}</span>\n            <span class=\"visually-hidden\">{{ 'it.timeline.read-more-on' | translate: { title: title } }}</span>\n            <it-icon name=\"arrow-right\"></it-icon>\n          </a>\n        }\n      </div>\n    </div>\n  </div>\n</div>\n"
    }]
  }], null, {
    title: [{
      type: Input,
      args: [{
        required: true
      }]
    }],
    text: [{
      type: Input,
      args: [{
        required: true
      }]
    }],
    signature: [{
      type: Input
    }],
    eventDate: [{
      type: Input
    }],
    dateFormat: [{
      type: Input
    }],
    pinText: [{
      type: Input,
      args: [{
        required: true
      }]
    }],
    pinType: [{
      type: Input
    }],
    pinIcon: [{
      type: Input
    }],
    pinIconTitle: [{
      type: Input
    }],
    categoryLabel: [{
      type: Input
    }],
    dateLabel: [{
      type: Input
    }],
    categoryTitle: [{
      type: Input
    }],
    categoryLink: [{
      type: Input
    }],
    showReadMore: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    readMoreLink: [{
      type: Input
    }]
  });
})();

/**
 * Timeline
 * @description Build timeline for chronological representation of events.
 */
class ItTimelineComponent extends ItAbstractComponent {
  constructor() {
    super(...arguments);
    /**
     * Timeline elements array
     * @default []
     */
    this.timelineElements = [];
    /**
     * Default date format for timeline element reference date
     * @default dd/MM/yyyy
     */
    this.dateFormat = 'dd/MM/yyyy';
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵItTimelineComponent_BaseFactory;
      return function ItTimelineComponent_Factory(__ngFactoryType__) {
        return (ɵItTimelineComponent_BaseFactory || (ɵItTimelineComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ItTimelineComponent)))(__ngFactoryType__ || ItTimelineComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItTimelineComponent,
      selectors: [["it-timeline"]],
      inputs: {
        timelineElements: "timelineElements",
        dateFormat: "dateFormat"
      },
      standalone: true,
      features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
      decls: 4,
      vars: 0,
      consts: [[1, "it-timeline-wrapper"], [1, "row"], [1, "col-12"], [3, "title", "text", "signature", "pinType", "pinIcon", "pinText", "eventDate", "dateFormat", "categoryTitle", "categoryLink", "showReadMore", "readMoreLink"]],
      template: function ItTimelineComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
          i0.ɵɵrepeaterCreate(2, ItTimelineComponent_For_3_Template, 2, 12, "div", 2, i0.ɵɵrepeaterTrackByIndex);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵrepeater(ctx.timelineElements);
        }
      },
      dependencies: [TranslateModule, ItTimelineItemComponent],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItTimelineComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-timeline',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [ItIconComponent, TranslateModule, ItTimelineItemComponent],
      template: "<div class=\"it-timeline-wrapper\">\n  <div class=\"row\">\n    @for (element of timelineElements; track $index) {\n      <div class=\"col-12\">\n        <it-timeline-item\n          [title]=\"element.title\"\n          [text]=\"element.text\"\n          [signature]=\"element.signature\"\n          [pinType]=\"element.pin?.type\"\n          [pinIcon]=\"element.pin?.icon\"\n          [pinText]=\"element.pin?.text\"\n          [eventDate]=\"element.eventDate\"\n          [dateFormat]=\"dateFormat\"\n          [categoryTitle]=\"element.category?.title\"\n          [categoryLink]=\"element.category?.link\"\n          [showReadMore]=\"!!element.link?.length\"\n          [readMoreLink]=\"element.link\" />\n      </div>\n    }\n  </div>\n</div>\n"
    }]
  }], null, {
    timelineElements: [{
      type: Input
    }],
    dateFormat: [{
      type: Input
    }]
  });
})();
const timelineComponents = [ItTimelineComponent, ItTimelineItemComponent];
class ItTimelineModule {
  static {
    this.ɵfac = function ItTimelineModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItTimelineModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ItTimelineModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [timelineComponents]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItTimelineModule, [{
    type: NgModule,
    args: [{
      imports: timelineComponents,
      exports: timelineComponents
    }]
  }], null, null);
})();
class ItTooltipDirective {
  /**
   * Define the tooltip title
   * @param title the tooltip title
   */
  set title(title) {
    if (title) {
      // this.element.setAttribute("title", title);
      this.element.setAttribute('data-bs-original-title', title);
    }
  }
  /**
   * Define the tooltip placement
   * @param placement
   */
  set tooltipPlacement(placement) {
    this.element.setAttribute('data-bs-placement', placement);
  }
  /**
   * Indicates whether the title contains html
   * @param html true if contain html
   */
  set tooltipHtml(html) {
    this.element.setAttribute('data-bs-html', html ? 'true' : 'false');
  }
  constructor(_elementRef) {
    this._elementRef = _elementRef;
    /**
     * This event fires immediately when the show method is called.
     */
    this.showEvent = new EventEmitter();
    /**
     * This event is triggered when the tooltip has been made visible to the user (it will wait for the CSS transitions to complete).
     */
    this.shownEvent = new EventEmitter();
    /**
     * This event fires immediately when the hide method is called.
     */
    this.hideEvent = new EventEmitter();
    /**
     * This event is raised when the tooltip has finished being hidden from the user (it will wait for the CSS transitions to complete).
     */
    this.hiddenEvent = new EventEmitter();
    /**
     * This event fires after the show event when the tooltip template has been added to the DOM.
     */
    this.insertedEvent = new EventEmitter();
    this.element = this._elementRef.nativeElement;
  }
  ngAfterViewInit() {
    this.element.setAttribute('data-bs-toggle', 'tooltip');
    this.tooltip = Tooltip.getOrCreateInstance(this.element);
    this.element.addEventListener('show.bs.tooltip', event => this.showEvent.emit(event));
    this.element.addEventListener('shown.bs.tooltip', event => this.shownEvent.emit(event));
    this.element.addEventListener('hide.bs.tooltip', event => this.hideEvent.emit(event));
    this.element.addEventListener('hidden.bs.tooltip', event => this.hiddenEvent.emit(event));
    this.element.addEventListener('inserted.bs.tooltip', event => this.insertedEvent.emit(event));
  }
  ngOnDestroy() {
    this.dispose();
  }
  /**
   * Shows the tooltip of an item.
   */
  show() {
    this.tooltip?.show();
  }
  /**
   * Hide the tooltip of an element.
   */
  hide() {
    this.tooltip?.hide();
  }
  /**
   * Activate / Deactivate the tooltip of an element
   */
  toggle() {
    this.tooltip?.toggle();
  }
  /**
   * Hides and destroys the tooltip of an element.
   */
  dispose() {
    this.tooltip?.dispose();
  }
  /**
   * Gives the tooltip of an element a chance to be shown.
   */
  enable() {
    this.tooltip?.enable();
  }
  /**
   * Removes the ability to show the tooltip of an element.
   */
  disable() {
    this.tooltip?.disable();
  }
  /**
   * Toggles the possibility that the tooltip of an element is shown or hidden.
   */
  toggleEnabled() {
    this.tooltip?.disable();
  }
  /**
   * Updates the position of an element's tooltip.
   */
  update() {
    this.tooltip?.disable();
  }
  static {
    this.ɵfac = function ItTooltipDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItTooltipDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ItTooltipDirective,
      selectors: [["", "itTooltip", ""]],
      inputs: {
        title: [0, "itTooltip", "title"],
        tooltipPlacement: "tooltipPlacement",
        tooltipHtml: [2, "tooltipHtml", "tooltipHtml", inputToBoolean]
      },
      outputs: {
        showEvent: "showEvent",
        shownEvent: "shownEvent",
        hideEvent: "hideEvent",
        hiddenEvent: "hiddenEvent",
        insertedEvent: "insertedEvent"
      },
      exportAs: ["itTooltip"],
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItTooltipDirective, [{
    type: Directive,
    args: [{
      standalone: true,
      selector: '[itTooltip]',
      exportAs: 'itTooltip'
    }]
  }], () => [{
    type: i0.ElementRef
  }], {
    title: [{
      type: Input,
      args: ['itTooltip']
    }],
    tooltipPlacement: [{
      type: Input
    }],
    tooltipHtml: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    showEvent: [{
      type: Output
    }],
    shownEvent: [{
      type: Output
    }],
    hideEvent: [{
      type: Output
    }],
    hiddenEvent: [{
      type: Output
    }],
    insertedEvent: [{
      type: Output
    }]
  });
})();
class ItCheckboxComponent extends ItAbstractFormComponent {
  ngOnInit() {
    super.ngOnInit();
    this.markAsChecked();
  }
  ngOnChanges(changes) {
    if (changes['checked']) {
      this.markAsChecked();
    }
  }
  markAsChecked() {
    if (this.control.value || this.checked === undefined) {
      return;
    }
    const value = this.checked;
    this.writeValue(value);
    return this.onChange(value);
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵItCheckboxComponent_BaseFactory;
      return function ItCheckboxComponent_Factory(__ngFactoryType__) {
        return (ɵItCheckboxComponent_BaseFactory || (ɵItCheckboxComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ItCheckboxComponent)))(__ngFactoryType__ || ItCheckboxComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItCheckboxComponent,
      selectors: [["it-checkbox"]],
      inputs: {
        toggle: [2, "toggle", "toggle", inputToBoolean],
        inline: [2, "inline", "inline", inputToBoolean],
        group: [2, "group", "group", inputToBoolean],
        checked: [2, "checked", "checked", inputToBoolean],
        indeterminate: [2, "indeterminate", "indeterminate", inputToBoolean]
      },
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c36,
      decls: 11,
      vars: 8,
      consts: [["error", ""], ["htmlLabel", ""], ["customError", ""], ["customLabel", ""], [1, "form-check"], [1, "toggles"], [1, "form-text", 3, "id"], [1, "form-feedback", "just-validate-error-label", 3, "id"], [3, "for"], [4, "ngTemplateOutlet"], ["type", "checkbox", 3, "click", "id", "formControl"], [1, "lever"], ["type", "checkbox", 1, "form-check-input", 3, "click", "id", "formControl"], [1, "form-check-label", 3, "for"]],
      template: function ItCheckboxComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c35);
          i0.ɵɵelementContainerStart(0);
          i0.ɵɵelementStart(1, "div", 4);
          i0.ɵɵtemplate(2, ItCheckboxComponent_Conditional_2_Template, 5, 5, "div", 5)(3, ItCheckboxComponent_Conditional_3_Template, 3, 11)(4, ItCheckboxComponent_Conditional_4_Template, 2, 1, "small", 6)(5, ItCheckboxComponent_Conditional_5_Template, 2, 2, "div", 7);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(6, ItCheckboxComponent_Conditional_6_Template, 2, 2, "div", 7);
          i0.ɵɵelementContainerEnd();
          i0.ɵɵtemplate(7, ItCheckboxComponent_ng_template_7_Template, 4, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(9, ItCheckboxComponent_ng_template_9_Template, 4, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵclassProp("form-check-group", ctx.group)("form-check-inline", ctx.inline);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.toggle ? 2 : 3);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx.group ? 4 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.isInvalid && ctx.group ? 5 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.isInvalid && !ctx.group ? 6 : -1);
        }
      },
      dependencies: [NgTemplateOutlet, ReactiveFormsModule, i1$1.CheckboxControlValueAccessor, i1$1.NgControlStatus, i1$1.FormControlDirective, AsyncPipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItCheckboxComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-checkbox',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [NgTemplateOutlet, ReactiveFormsModule, AsyncPipe],
      template: "<ng-container>\n  <div class=\"form-check\" [class.form-check-group]=\"group\" [class.form-check-inline]=\"inline\">\n    @if (toggle) {\n      <div class=\"toggles\">\n        <label [for]=\"id\">\n          <ng-container *ngTemplateOutlet=\"htmlLabel\"></ng-container>\n          <input\n            [id]=\"id\"\n            type=\"checkbox\"\n            [formControl]=\"control\"\n            [attr.aria-describedby]=\"id + '-help'\"\n            (click)=\"$event.stopPropagation()\" />\n          <span class=\"lever\"></span>\n        </label>\n      </div>\n    } @else {\n      <input\n        [id]=\"id\"\n        type=\"checkbox\"\n        class=\"form-check-input\"\n        [class.is-invalid]=\"isInvalid\"\n        [class.is-valid]=\"isValid\"\n        [class.semi-checked]=\"indeterminate\"\n        [formControl]=\"control\"\n        [attr.aria-describedby]=\"id + '-help'\"\n        (click)=\"$event.stopPropagation()\" />\n      <label class=\"form-check-label\" [for]=\"id\">\n        <ng-container *ngTemplateOutlet=\"htmlLabel\"></ng-container>\n      </label>\n    }\n\n    @if (group) {\n      <small [id]=\"id + '-help'\" class=\"form-text\">\n        <ng-content></ng-content>\n      </small>\n    }\n\n    @if (isInvalid && group) {\n      <div class=\"form-feedback just-validate-error-label\" [id]=\"id + '-error'\">\n        <ng-container *ngTemplateOutlet=\"error\"></ng-container>\n      </div>\n    }\n  </div>\n\n  @if (isInvalid && !group) {\n    <div class=\"form-feedback just-validate-error-label\" [id]=\"id + '-error'\">\n      <ng-container *ngTemplateOutlet=\"error\"></ng-container>\n    </div>\n  }\n</ng-container>\n\n<ng-template #error>\n  <div #customError>\n    <ng-content select=\"[error]\"></ng-content>\n  </div>\n  @if (!customError.hasChildNodes()) {\n    {{ invalidMessage | async }}\n  }\n</ng-template>\n\n<ng-template #htmlLabel>\n  <div #customLabel>\n    <ng-content select=\"[label]\"></ng-content>\n  </div>\n  @if (!customLabel.hasChildNodes()) {\n    {{ label }}\n  }\n</ng-template>\n"
    }]
  }], null, {
    toggle: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    inline: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    group: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    checked: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    indeterminate: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }]
  });
})();
class ItPasswordInputComponent extends ItAbstractFormComponent {
  constructor() {
    super(...arguments);
    /**
     * The field is required
     * @default true
     */
    this.required = true;
    /**
     * The password minimum length
     * @default 10
     */
    this.minLength = 10;
    /**
     * The password must contain at least one number
     * @default true
     */
    this.useNumber = true;
    /**
     * The password must contain at least one uppercase character
     * @default true
     */
    this.useCapitalCase = true;
    /**
     * The password must contain at least one lowercase character
     * @default true
     */
    this.useSmallCase = true;
    /**
     * The password must contain at least one special character
     * @default true
     */
    this.useSpecialCharacters = true;
    /**
     * The input placeholder
     */
    this.placeholder = '';
  }
  ngOnInit() {
    super.ngOnInit();
    if (!this.confirmPasswordField) {
      this.addValidators(ItValidators.password(this.minLength, this.useNumber, this.useCapitalCase, this.useSmallCase, this.useSpecialCharacters, this.required));
    } else if (this.required) {
      this.addValidators(Validators.required);
    }
  }
  ngAfterViewInit() {
    super.ngAfterViewInit();
    if (this.inputElement) {
      this.inputPasswordBs = InputPassword.getOrCreateInstance(this.inputElement.nativeElement, {
        showText: this.isStrengthMeter,
        minimumLength: this.minLength
      });
    }
  }
  get isStrengthMeter() {
    return !this.confirmPasswordField && !!this.showStrengthMeter;
  }
  /**
   * Return the invalid message string from TranslateService
   */
  get invalidMessage() {
    if (this.hasError('noPasswordMatch')) {
      return this._translateService.get('it.errors.password-no-match');
    }
    if (this.hasError('minlength')) {
      return this._translateService.get('it.errors.password-min-length', {
        minLength: this.minLength
      });
    }
    if (this.hasError('hasNumber')) {
      return this._translateService.get('it.errors.password-number');
    }
    if (this.hasError('hasCapitalCase')) {
      return this._translateService.get('it.errors.password-capital-case');
    }
    if (this.hasError('hasSmallCase')) {
      return this._translateService.get('it.errors.password-capital-case');
    }
    if (this.hasError('hasSpecialCharacters')) {
      return this._translateService.get('it.errors.password-special-character');
    }
    return super.invalidMessage;
  }
  /**
   * Retrieve the default StrengthMeter description message from TranslateService
   */
  get strengthMeterDescription() {
    const keys = ['it.form.password-strength-meter.description.default'];
    if (this.useNumber) {
      keys.push('it.form.password-strength-meter.description.number');
    }
    if (this.useCapitalCase) {
      keys.push('it.form.password-strength-meter.description.capital-case');
    }
    if (this.useSpecialCharacters) {
      keys.push('it.form.password-strength-meter.description.special-character');
    }
    return this._translateService.get(keys, {
      minLength: this.minLength
    }).pipe(map(labels => Object.values(labels).join(', ')));
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵItPasswordInputComponent_BaseFactory;
      return function ItPasswordInputComponent_Factory(__ngFactoryType__) {
        return (ɵItPasswordInputComponent_BaseFactory || (ɵItPasswordInputComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ItPasswordInputComponent)))(__ngFactoryType__ || ItPasswordInputComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItPasswordInputComponent,
      selectors: [["it-password-input"]],
      viewQuery: function ItPasswordInputComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c37, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputElement = _t.first);
        }
      },
      inputs: {
        required: "required",
        minLength: "minLength",
        useNumber: "useNumber",
        useCapitalCase: "useCapitalCase",
        useSmallCase: "useSmallCase",
        useSpecialCharacters: "useSpecialCharacters",
        placeholder: "placeholder",
        description: "description",
        showStrengthMeter: [2, "showStrengthMeter", "showStrengthMeter", inputToBoolean],
        confirmPasswordField: [2, "confirmPasswordField", "confirmPasswordField", inputToBoolean],
        autocomplete: "autocomplete"
      },
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c39,
      decls: 13,
      vars: 16,
      consts: [["input", ""], ["customError", ""], [1, "form-group"], [3, "for", "active"], ["type", "password", 1, "form-control", "input-password", 3, "id", "formControl", "placeholder", "autocomplete"], ["aria-hidden", "true", 1, "password-icon"], ["name", "password-visible", "size", "sm", 1, "password-icon-visible"], ["name", "password-invisible", "size", "sm", 1, "password-icon-invisible", "d-none"], [1, "form-feedback", "just-validate-error-label", 3, "id"], [1, "form-text", 3, "id"], [1, "password-caps", "form-text", "text-warning", "position-absolute", "bg-white", "w-100"], [1, "password-strength-meter"], [3, "for"], [1, "form-text", "text-muted", 3, "id"], [1, "password-meter", "progress", "rounded-0", "position-absolute"], [1, "row", "position-absolute", "w-100", "m-0"], [1, "col-3", "border-start", "border-end", "border-white"], ["role", "progressbar", "aria-valuenow", "0", "aria-valuemin", "0", "aria-valuemax", "100", 1, "progress-bar", "bg-muted"]],
      template: function ItPasswordInputComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c38);
          i0.ɵɵelementStart(0, "div", 2);
          i0.ɵɵtemplate(1, ItPasswordInputComponent_Conditional_1_Template, 2, 4, "label", 3);
          i0.ɵɵelement(2, "input", 4, 0);
          i0.ɵɵelementStart(4, "span", 5);
          i0.ɵɵelement(5, "it-icon", 6)(6, "it-icon", 7);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(7, ItPasswordInputComponent_Conditional_7_Template, 5, 2, "div", 8)(8, ItPasswordInputComponent_Conditional_8_Template, 3, 4, "small", 9);
          i0.ɵɵelementStart(9, "small", 10);
          i0.ɵɵtext(10);
          i0.ɵɵpipe(11, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(12, ItPasswordInputComponent_Conditional_12_Template, 15, 16, "div", 11);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.label ? 1 : -1);
          i0.ɵɵadvance();
          i0.ɵɵclassProp("is-invalid", ctx.isInvalid)("is-valid", ctx.isValid);
          i0.ɵɵproperty("id", ctx.id)("formControl", ctx.control)("placeholder", ctx.placeholder)("autocomplete", ctx.confirmPasswordField ? "off" : ctx.autocomplete);
          i0.ɵɵattribute("aria-describedby", ctx.id + "-description");
          i0.ɵɵadvance(5);
          i0.ɵɵconditional(ctx.isInvalid ? 7 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.description !== undefined && !ctx.isStrengthMeter ? 8 : -1);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 14, "it.form.caps-inserted"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx.isStrengthMeter ? 12 : -1);
        }
      },
      dependencies: [ReactiveFormsModule, i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.FormControlDirective, ItIconComponent, AsyncPipe, TranslateModule, i1.TranslatePipe],
      styles: [".form-group[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus:not(.focus--mouse){box-shadow:inherit!important;border-color:inherit!important}.form-group[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]:not(.active):has( + input[_ngcontent-%COMP%]:-webkit-autofill){transform:translateY(-75%)}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItPasswordInputComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-password-input',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [ReactiveFormsModule, ItIconComponent, AsyncPipe, TranslateModule],
      template: "<div class=\"form-group\">\n  @if (label) {\n    <label [for]=\"id\" [class.active]=\"!!control.value || !!placeholder\">{{ label }}</label>\n  }\n  <input\n    #input\n    [id]=\"id\"\n    type=\"password\"\n    class=\"form-control input-password\"\n    [class.is-invalid]=\"isInvalid\"\n    [class.is-valid]=\"isValid\"\n    [formControl]=\"control\"\n    [placeholder]=\"placeholder\"\n    [attr.aria-describedby]=\"id + '-description'\"\n    [autocomplete]=\"confirmPasswordField ? 'off' : autocomplete\" />\n\n  <span class=\"password-icon\" aria-hidden=\"true\">\n    <it-icon name=\"password-visible\" size=\"sm\" class=\"password-icon-visible\"></it-icon>\n    <it-icon name=\"password-invisible\" size=\"sm\" class=\"password-icon-invisible d-none\"></it-icon>\n  </span>\n\n  @if (isInvalid) {\n    <div [id]=\"id + '-error'\" class=\"form-feedback just-validate-error-label\">\n      <div #customError>\n        <ng-content select=\"[error]\"></ng-content>\n      </div>\n      @if (!customError.hasChildNodes()) {\n        {{ invalidMessage | async }}\n      }\n    </div>\n  }\n\n  @if (description !== undefined && !isStrengthMeter) {\n    <small [id]=\"id + '-description'\" class=\"form-text\">\n      {{ description !== true ? description : (strengthMeterDescription | async) }}\n    </small>\n  }\n\n  <small class=\"password-caps form-text text-warning position-absolute bg-white w-100\">\n    {{ 'it.form.caps-inserted' | translate }}\n  </small>\n\n  @if (isStrengthMeter) {\n    <div class=\"password-strength-meter\">\n      <small\n        [id]=\"id + '-description'\"\n        class=\"form-text text-muted\"\n        [attr.data-bs-short-pass]=\"'it.form.password-strength-meter.password-short' | translate\"\n        [attr.data-bs-bad-pas]=\"'it.form.password-strength-meter.password-bad' | translate\"\n        [attr.data-bs-good-pass]=\"'it.form.password-strength-meter.password-good' | translate\"\n        [attr.data-bs-strong-pass]=\"'it.form.password-strength-meter.password-strong' | translate\">\n        {{ description !== undefined && description !== true ? description : (strengthMeterDescription | async) }}\n      </small>\n      <div class=\"password-meter progress rounded-0 position-absolute\">\n        <div class=\"row position-absolute w-100 m-0\">\n          <div class=\"col-3 border-start border-end border-white\"></div>\n          <div class=\"col-3 border-start border-end border-white\"></div>\n          <div class=\"col-3 border-start border-end border-white\"></div>\n          <div class=\"col-3 border-start border-end border-white\"></div>\n        </div>\n        <div class=\"progress-bar bg-muted\" role=\"progressbar\" aria-valuenow=\"0\" aria-valuemin=\"0\" aria-valuemax=\"100\"></div>\n      </div>\n    </div>\n  }\n</div>\n",
      styles: [".form-group input:focus:not(.focus--mouse){box-shadow:inherit!important;border-color:inherit!important}.form-group label:not(.active):has(+input:-webkit-autofill){transform:translateY(-75%)}\n"]
    }]
  }], null, {
    required: [{
      type: Input
    }],
    minLength: [{
      type: Input
    }],
    useNumber: [{
      type: Input
    }],
    useCapitalCase: [{
      type: Input
    }],
    useSmallCase: [{
      type: Input
    }],
    useSpecialCharacters: [{
      type: Input
    }],
    placeholder: [{
      type: Input
    }],
    description: [{
      type: Input
    }],
    showStrengthMeter: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    confirmPasswordField: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    autocomplete: [{
      type: Input
    }],
    inputElement: [{
      type: ViewChild,
      args: ['input']
    }]
  });
})();
class ItRadioButtonComponent extends ItAbstractFormComponent {
  get name() {
    if (this.forceRadioName) {
      return this.forceRadioName;
    }
    let name = '';
    if (this._ngControl) {
      name = this._ngControl.name?.toString() || '';
      // Retrieve parent name, prevent duplicate name inside FormArray or nested FormGroup
      let control = this._ngControl.control?.parent;
      while (control?.parent) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const controls = control?.parent?.controls || {};
        const parentName = Object.keys(controls).find(name => control === controls[name]) || null;
        if (!parentName) {
          break;
        }
        name = `${parentName}.${name}`; // parent.0.radioName
        control = control.parent;
      }
    }
    return name;
  }
  ngOnInit() {
    super.ngOnInit();
    if (this.control.value || !this.value || !this.checked) {
      return;
    }
    this.writeValue(this.value);
    return this.onChange(this.value);
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵItRadioButtonComponent_BaseFactory;
      return function ItRadioButtonComponent_Factory(__ngFactoryType__) {
        return (ɵItRadioButtonComponent_BaseFactory || (ɵItRadioButtonComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ItRadioButtonComponent)))(__ngFactoryType__ || ItRadioButtonComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItRadioButtonComponent,
      selectors: [["it-radio-button"]],
      inputs: {
        value: "value",
        inline: [2, "inline", "inline", inputToBoolean],
        group: [2, "group", "group", inputToBoolean],
        checked: [2, "checked", "checked", inputToBoolean],
        forceRadioName: "forceRadioName"
      },
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c41,
      decls: 11,
      vars: 18,
      consts: [["customLabel", ""], ["customError", ""], [1, "form-check"], ["type", "radio", 1, "form-check-input", 3, "id", "value", "name", "formControl"], [1, "form-check-label", 3, "for"], [1, "form-text", 3, "id"], [1, "form-feedback", "just-validate-error-label", 3, "id"]],
      template: function ItRadioButtonComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c40);
          i0.ɵɵelementContainerStart(0);
          i0.ɵɵelementStart(1, "div", 2);
          i0.ɵɵelement(2, "input", 3);
          i0.ɵɵelementStart(3, "label", 4)(4, "div", null, 0);
          i0.ɵɵprojection(6);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(7, ItRadioButtonComponent_Conditional_7_Template, 1, 1);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(8, ItRadioButtonComponent_Conditional_8_Template, 2, 1, "small", 5)(9, ItRadioButtonComponent_Conditional_9_Template, 5, 2, "div", 6);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(10, ItRadioButtonComponent_Conditional_10_Template, 5, 2, "div", 6);
          i0.ɵɵelementContainerEnd();
        }
        if (rf & 2) {
          const customLabel_r4 = i0.ɵɵreference(5);
          i0.ɵɵadvance();
          i0.ɵɵclassProp("form-check-group", ctx.group)("form-check-inline", ctx.inline);
          i0.ɵɵadvance();
          i0.ɵɵclassProp("is-invalid", ctx.isInvalid)("is-valid", ctx.isValid);
          i0.ɵɵproperty("id", ctx.id)("value", ctx.value)("name", ctx.name)("formControl", ctx.control);
          i0.ɵɵattribute("aria-describedby", ctx.id + "-help");
          i0.ɵɵadvance();
          i0.ɵɵproperty("for", ctx.id);
          i0.ɵɵadvance(4);
          i0.ɵɵconditional(!customLabel_r4.hasChildNodes() ? 7 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.group ? 8 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.isInvalid && ctx.group ? 9 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.isInvalid && !ctx.group ? 10 : -1);
        }
      },
      dependencies: [ReactiveFormsModule, i1$1.DefaultValueAccessor, i1$1.RadioControlValueAccessor, i1$1.NgControlStatus, i1$1.FormControlDirective, AsyncPipe],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItRadioButtonComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-radio-button',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [ReactiveFormsModule, AsyncPipe],
      template: "<ng-container>\n  <div class=\"form-check\" [class.form-check-group]=\"group\" [class.form-check-inline]=\"inline\">\n    <input\n      [id]=\"id\"\n      type=\"radio\"\n      [value]=\"value\"\n      class=\"form-check-input\"\n      [name]=\"name\"\n      [class.is-invalid]=\"isInvalid\"\n      [class.is-valid]=\"isValid\"\n      [formControl]=\"control\"\n      [attr.aria-describedby]=\"id + '-help'\" />\n\n    <label class=\"form-check-label\" [for]=\"id\">\n      <div #customLabel>\n        <ng-content select=\"[label]\"></ng-content>\n      </div>\n      @if (!customLabel.hasChildNodes()) {\n        {{ label }}\n      }\n    </label>\n\n    @if (group) {\n      <small [id]=\"id + '-help'\" class=\"form-text\">\n        <ng-content></ng-content>\n      </small>\n    }\n\n    @if (isInvalid && group) {\n      <div class=\"form-feedback just-validate-error-label\" [id]=\"id + '-error'\">\n        <div #customError>\n          <ng-content select=\"[error]\"></ng-content>\n        </div>\n        @if (!customError.hasChildNodes()) {\n          {{ invalidMessage | async }}\n        }\n      </div>\n    }\n  </div>\n\n  @if (isInvalid && !group) {\n    <div class=\"form-feedback just-validate-error-label\" [id]=\"id + '-error'\">\n      <div #customError>\n        <ng-content select=\"[error]\"></ng-content>\n      </div>\n      @if (!customError.hasChildNodes()) {\n        {{ invalidMessage | async }}\n      }\n    </div>\n  }\n</ng-container>\n"
    }]
  }], null, {
    value: [{
      type: Input,
      args: [{
        required: true
      }]
    }],
    inline: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    group: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    checked: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    forceRadioName: [{
      type: Input
    }]
  });
})();
class ItRangeComponent extends ItAbstractFormComponent {
  ngOnInit() {
    super.ngOnInit();
    this.subscription = this.control.valueChanges.pipe(distinctUntilChanged(), startWith(undefined)).subscribe(() => this.updateSliderColor());
  }
  ngOnChanges(changes) {
    if (changes['leftColor']) {
      this.slider.nativeElement.style.setProperty('--range-left-color', this.leftColor ?? null);
    }
    if (changes['rightColor']) {
      this.slider.nativeElement.style.setProperty('--range-right-color', this.rightColor ?? null);
    }
  }
  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
  writeValue(value) {
    super.writeValue(value);
    this.updateSliderColor();
  }
  /**
   * Update the percentage of slider color
   * @private
   */
  updateSliderColor() {
    if (!this.leftColor || !this.rightColor) {
      return;
    }
    const max = Number(this.slider.nativeElement.max) || 100;
    const min = Number(this.slider.nativeElement.min) || 0;
    // Calculate visible width
    const diff = max - min;
    const val = ((this.control.value ?? diff / 2) - min) * 100 / diff;
    this.slider.nativeElement.style.setProperty('--range-percentage', `${val}%`);
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵItRangeComponent_BaseFactory;
      return function ItRangeComponent_Factory(__ngFactoryType__) {
        return (ɵItRangeComponent_BaseFactory || (ɵItRangeComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ItRangeComponent)))(__ngFactoryType__ || ItRangeComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItRangeComponent,
      selectors: [["it-range"]],
      viewQuery: function ItRangeComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c42, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.slider = _t.first);
        }
      },
      inputs: {
        max: "max",
        min: "min",
        step: "step",
        leftColor: "leftColor",
        rightColor: "rightColor"
      },
      standalone: true,
      features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c1,
      decls: 5,
      vars: 8,
      consts: [["slider", ""], [1, "d-flex", "justify-content-between", "align-items-center"], [1, "form-label", 3, "for"], ["type", "range", 1, "form-range", 3, "id", "min", "max", "step", "formControl"]],
      template: function ItRangeComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 1);
          i0.ɵɵtemplate(1, ItRangeComponent_Conditional_1_Template, 2, 2, "label", 2);
          i0.ɵɵprojection(2);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(3, "input", 3, 0);
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.label ? 1 : -1);
          i0.ɵɵadvance(2);
          i0.ɵɵclassProp("double-color", !!ctx.leftColor && !!ctx.rightColor);
          i0.ɵɵproperty("id", ctx.id)("min", ctx.min)("max", ctx.max)("step", ctx.step)("formControl", ctx.control);
        }
      },
      dependencies: [ReactiveFormsModule, i1$1.DefaultValueAccessor, i1$1.RangeValueAccessor, i1$1.NgControlStatus, i1$1.FormControlDirective],
      styles: [".form-range.double-color[_ngcontent-%COMP%]::-webkit-slider-runnable-track{background:linear-gradient(to right,var(--range-left-color) var(--range-percentage),var(--range-right-color) var(--range-percentage))}.form-range.double-color[_ngcontent-%COMP%]::-moz-range-track{background:linear-gradient(to right,var(--range-left-color) var(--range-percentage),var(--range-right-color) var(--range-percentage))}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItRangeComponent, [{
    type: Component,
    args: [{
      selector: 'it-range',
      standalone: true,
      imports: [ReactiveFormsModule],
      changeDetection: ChangeDetectionStrategy.OnPush,
      template: "<div class=\"d-flex justify-content-between align-items-center\">\n  @if (label) {\n    <label [for]=\"id\" class=\"form-label\">{{ label }}</label>\n  }\n  <ng-content></ng-content>\n</div>\n\n<input\n  #slider\n  [id]=\"id\"\n  type=\"range\"\n  [min]=\"min\"\n  [max]=\"max\"\n  [step]=\"step\"\n  class=\"form-range\"\n  [class.double-color]=\"!!leftColor && !!rightColor\"\n  [formControl]=\"control\" />\n",
      styles: [".form-range.double-color::-webkit-slider-runnable-track{background:linear-gradient(to right,var(--range-left-color) var(--range-percentage),var(--range-right-color) var(--range-percentage))}.form-range.double-color::-moz-range-track{background:linear-gradient(to right,var(--range-left-color) var(--range-percentage),var(--range-right-color) var(--range-percentage))}\n"]
    }]
  }], null, {
    max: [{
      type: Input
    }],
    min: [{
      type: Input
    }],
    step: [{
      type: Input
    }],
    leftColor: [{
      type: Input
    }],
    rightColor: [{
      type: Input
    }],
    slider: [{
      type: ViewChild,
      args: ['slider', {
        static: true
      }]
    }]
  });
})();
class ItRatingComponent extends ItAbstractFormComponent {
  constructor() {
    super(...arguments);
    /**
     * Number of stars to show
     * @default 5
     */
    this.starCount = 5;
    this.stars = this.generateStars();
  }
  ngOnChanges(changes) {
    super.ngOnChanges(changes);
    if (changes['starCount'] || !this.stars.length) {
      this.stars = this.generateStars();
    }
  }
  ngOnInit() {
    super.ngOnInit();
    if (!this.control.value && !!this.value) {
      this.writeValue(this.value);
      this.onChange(this.value);
    }
  }
  /**
   * Generate the array of stars
   * @private
   */
  generateStars() {
    return Array.from({
      length: this.starCount
    }, (_, i) => i + 1).reverse();
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵItRatingComponent_BaseFactory;
      return function ItRatingComponent_Factory(__ngFactoryType__) {
        return (ɵItRatingComponent_BaseFactory || (ɵItRatingComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ItRatingComponent)))(__ngFactoryType__ || ItRatingComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItRatingComponent,
      selectors: [["it-rating"]],
      inputs: {
        value: "value",
        starCount: "starCount"
      },
      standalone: true,
      features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
      decls: 9,
      vars: 12,
      consts: [[1, "rating"], [1, "visually-hidden"], ["type", "radio", 3, "id", "name", "value", "formControl"], [1, "full", 3, "for"], ["name", "star-full", "size", "sm", "aria-hidden", "true"]],
      template: function ItRatingComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "fieldset", 0)(1, "legend")(2, "span");
          i0.ɵɵtext(3);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(4, "span", 1);
          i0.ɵɵtext(5);
          i0.ɵɵpipe(6, "translate");
          i0.ɵɵelementEnd()();
          i0.ɵɵrepeaterCreate(7, ItRatingComponent_For_8_Template, 6, 13, null, null, i0.ɵɵrepeaterTrackByIdentity);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵclassProp("rating-label", !!ctx.label)("rating-read-only", ctx.control.disabled);
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate(ctx.label);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(6, 6, "it.core.rating-star", i0.ɵɵpureFunction2(9, _c43, ctx.control.value || 0, ctx.stars.length)), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵrepeater(ctx.stars);
        }
      },
      dependencies: [TranslateModule, i1.TranslatePipe, ReactiveFormsModule, i1$1.DefaultValueAccessor, i1$1.RadioControlValueAccessor, i1$1.NgControlStatus, i1$1.FormControlDirective, ItIconComponent],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItRatingComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-rating',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [TranslateModule, ReactiveFormsModule, ItIconComponent],
      template: "<fieldset class=\"rating\" [class.rating-label]=\"!!label\" [class.rating-read-only]=\"control.disabled\">\n  <legend>\n    <span>{{ label }}</span>\n    <span class=\"visually-hidden\">\n      {{ 'it.core.rating-star' | translate: { current: control.value || 0, total: stars.length } }}\n    </span>\n  </legend>\n\n  @for (starValue of stars; track starValue) {\n    <input\n      [id]=\"id + '-' + starValue\"\n      type=\"radio\"\n      [name]=\"id\"\n      [value]=\"starValue\"\n      [attr.aria-hidden]=\"control.disabled\"\n      [formControl]=\"control\" />\n    <label class=\"full\" [for]=\"id + '-' + starValue\">\n      <it-icon name=\"star-full\" size=\"sm\" aria-hidden=\"true\"></it-icon>\n      <span class=\"visually-hidden\">\n        {{ 'it.core.rate-star' | translate: { current: starValue, total: stars.length } }}\n      </span>\n    </label>\n  }\n</fieldset>\n"
    }]
  }], null, {
    value: [{
      type: Input
    }],
    starCount: [{
      type: Input
    }]
  });
})();
class ItSelectComponent extends ItAbstractFormComponent {
  ngOnInit() {
    super.ngOnInit();
    if (this.control.value) {
      return;
    }
    const selectedOption = this.options?.find(this.optionIsSelected);
    if (selectedOption) {
      this.writeValue(selectedOption.value);
      if (this._ngControl?.control && selectedOption.value !== this._ngControl.control.value) {
        this.onChange(selectedOption.value);
      }
      return;
    }
    const selectedGroupOption = this.groups?.flatMap(g => g.options).find(this.optionIsSelected);
    if (selectedGroupOption) {
      this.writeValue(selectedGroupOption.value);
      if (this._ngControl?.control && selectedGroupOption.value !== this._ngControl.control.value) {
        this.onChange(selectedGroupOption.value);
      }
    }
  }
  /**
   * Check if the option is selected
   * @param option the option
   */
  optionIsSelected(option) {
    if (option.selected === true) {
      return true;
    }
    if (typeof option.selected === 'function') {
      return option.selected(this.control.value);
    }
    return false;
  }
  /**
   * Check if the option is disabled
   * @param option the option
   */
  optionIsDisabled(option) {
    if (option.disabled === true) {
      return true;
    }
    if (typeof option.disabled === 'function') {
      return option.disabled(this.control.value);
    }
    return false;
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵItSelectComponent_BaseFactory;
      return function ItSelectComponent_Factory(__ngFactoryType__) {
        return (ɵItSelectComponent_BaseFactory || (ɵItSelectComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ItSelectComponent)))(__ngFactoryType__ || ItSelectComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItSelectComponent,
      selectors: [["it-select"]],
      inputs: {
        options: "options",
        groups: "groups",
        description: "description",
        defaultOption: "defaultOption"
      },
      standalone: true,
      features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c45,
      decls: 9,
      vars: 13,
      consts: [["customError", ""], [1, "select-wrapper"], [3, "for"], [3, "blur", "id", "formControl"], ["disabled", "", "selected", "", 3, "ngValue"], [1, "form-text", 3, "id"], [1, "form-feedback", "just-validate-error-label", 3, "id"], [3, "disabled", "ngValue"], [3, "label"]],
      template: function ItSelectComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c44);
          i0.ɵɵelementStart(0, "div", 1);
          i0.ɵɵtemplate(1, ItSelectComponent_Conditional_1_Template, 2, 2, "label", 2);
          i0.ɵɵelementStart(2, "select", 3);
          i0.ɵɵlistener("blur", function ItSelectComponent_Template_select_blur_2_listener() {
            return ctx.markAsTouched();
          });
          i0.ɵɵtemplate(3, ItSelectComponent_Conditional_3_Template, 2, 2, "option", 4);
          i0.ɵɵprojection(4);
          i0.ɵɵtemplate(5, ItSelectComponent_Conditional_5_Template, 2, 0)(6, ItSelectComponent_Conditional_6_Template, 2, 0);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(7, ItSelectComponent_Conditional_7_Template, 2, 2, "small", 5)(8, ItSelectComponent_Conditional_8_Template, 5, 2, "div", 6);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.label ? 1 : -1);
          i0.ɵɵadvance();
          i0.ɵɵclassProp("is-invalid", ctx.isInvalid)("is-valid", ctx.isValid);
          i0.ɵɵproperty("id", ctx.id)("formControl", ctx.control);
          i0.ɵɵattribute("aria-describedby", ctx.id + "-description");
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.defaultOption ? 3 : -1);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx.options ? 5 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.groups ? 6 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.description ? 7 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.isInvalid ? 8 : -1);
        }
      },
      dependencies: [ReactiveFormsModule, i1$1.NgSelectOption, i1$1.ɵNgSelectMultipleOption, i1$1.SelectControlValueAccessor, i1$1.NgControlStatus, i1$1.FormControlDirective, AsyncPipe],
      styles: [".select-wrapper[_ngcontent-%COMP%]{margin-bottom:1.7rem}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItSelectComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-select',
      imports: [ReactiveFormsModule, AsyncPipe],
      template: "<div class=\"select-wrapper\">\n  @if (label) {\n    <label [for]=\"id\">{{ label }}</label>\n  }\n  <select\n    [id]=\"id\"\n    [formControl]=\"control\"\n    [class.is-invalid]=\"isInvalid\"\n    [class.is-valid]=\"isValid\"\n    (blur)=\"markAsTouched()\"\n    [attr.aria-describedby]=\"id + '-description'\">\n    @if (defaultOption) {\n      <option [ngValue]=\"null\" disabled selected>\n        {{ defaultOption }}\n      </option>\n    }\n\n    <ng-content></ng-content>\n\n    @if (options) {\n      @for (option of options; track option.value) {\n        <option [disabled]=\"optionIsDisabled(option)\" [ngValue]=\"option.value\">\n          {{ option.text ?? option.value }}\n        </option>\n      }\n    }\n\n    @if (groups) {\n      @for (group of groups; track group) {\n        <optgroup [label]=\"group.label\">\n          @for (option of group.options; track option.value) {\n            <option [disabled]=\"optionIsDisabled(option)\" [ngValue]=\"option.value\">\n              {{ option.text ?? option.value }}\n            </option>\n          }\n        </optgroup>\n      }\n    }\n  </select>\n  @if (description) {\n    <small [id]=\"id + '-description'\" class=\"form-text\">{{ description }}</small>\n  }\n\n  @if (isInvalid) {\n    <div class=\"form-feedback just-validate-error-label\" [id]=\"id + '-error'\">\n      <div #customError>\n        <ng-content select=\"[error]\"></ng-content>\n      </div>\n      @if (!customError.hasChildNodes()) {\n        {{ invalidMessage | async }}\n      }\n    </div>\n  }\n</div>\n",
      styles: [".select-wrapper{margin-bottom:1.7rem}\n"]
    }]
  }], null, {
    options: [{
      type: Input
    }],
    groups: [{
      type: Input
    }],
    description: [{
      type: Input
    }],
    defaultOption: [{
      type: Input
    }]
  });
})();
class ItTextareaComponent extends ItAbstractFormComponent {
  constructor() {
    super(...arguments);
    /**
     * Textarea Rows
     * @default 3
     */
    this.rows = 3;
    /**
     * The textarea placeholder
     */
    this.placeholder = '';
  }
  /**
   * Return the invalid message string from TranslateService
   */
  get invalidMessage() {
    if (this.hasError('maxlength')) {
      const error = this.getError('maxlength');
      return this._translateService.get('it.errors.max-length-invalid', {
        max: error.requiredLength
      });
    }
    if (this.hasError('pattern')) {
      const error = this.getError('pattern');
      return this._translateService.get('it.errors.pattern-invalid', {
        pattern: error.requiredPattern
      });
    }
    return super.invalidMessage;
  }
  /**
   * Check is readonly field
   */
  get isReadonly() {
    return this.readonly === 'plaintext' || !!this.readonly;
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵItTextareaComponent_BaseFactory;
      return function ItTextareaComponent_Factory(__ngFactoryType__) {
        return (ɵItTextareaComponent_BaseFactory || (ɵItTextareaComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ItTextareaComponent)))(__ngFactoryType__ || ItTextareaComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItTextareaComponent,
      selectors: [["it-textarea"]],
      inputs: {
        rows: "rows",
        placeholder: "placeholder",
        description: "description",
        readonly: "readonly"
      },
      standalone: true,
      features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c39,
      decls: 5,
      vars: 16,
      consts: [["customError", ""], [1, "form-group"], [3, "for", "active"], [3, "blur", "id", "rows", "placeholder", "formControl", "readonly"], [1, "form-text", 3, "id"], [1, "form-feedback", "just-validate-error-label", 3, "id"], [3, "for"]],
      template: function ItTextareaComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c38);
          i0.ɵɵelementStart(0, "div", 1);
          i0.ɵɵtemplate(1, ItTextareaComponent_Conditional_1_Template, 2, 4, "label", 2);
          i0.ɵɵelementStart(2, "textarea", 3);
          i0.ɵɵlistener("blur", function ItTextareaComponent_Template_textarea_blur_2_listener() {
            return ctx.markAsTouched();
          });
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(3, ItTextareaComponent_Conditional_3_Template, 2, 2, "small", 4)(4, ItTextareaComponent_Conditional_4_Template, 5, 2, "div", 5);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.label ? 1 : -1);
          i0.ɵɵadvance();
          i0.ɵɵclassProp("form-control", ctx.readonly !== "plaintext")("form-control-plaintext", ctx.readonly === "plaintext")("is-invalid", ctx.isInvalid)("is-valid", ctx.isValid);
          i0.ɵɵproperty("id", ctx.id)("rows", ctx.rows)("placeholder", ctx.placeholder)("formControl", ctx.control)("readonly", ctx.isReadonly);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.description ? 3 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.isInvalid ? 4 : -1);
        }
      },
      dependencies: [ReactiveFormsModule, i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.FormControlDirective, AsyncPipe],
      styles: ["textarea.is-invalid[_ngcontent-%COMP%]{border-color:#cc334d}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItTextareaComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-textarea',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [ReactiveFormsModule, AsyncPipe],
      template: "<div class=\"form-group\">\n  @if (label) {\n    <label [for]=\"id\" [class.active]=\"!!control.value || !!placeholder\">{{ label }}</label>\n  }\n  <textarea\n    [id]=\"id\"\n    [rows]=\"rows\"\n    [class.form-control]=\"readonly !== 'plaintext'\"\n    [class.form-control-plaintext]=\"readonly === 'plaintext'\"\n    [class.is-invalid]=\"isInvalid\"\n    [class.is-valid]=\"isValid\"\n    [placeholder]=\"placeholder\"\n    [formControl]=\"control\"\n    [readonly]=\"isReadonly\"\n    (blur)=\"markAsTouched()\"></textarea>\n\n  @if (description) {\n    <small [id]=\"id + '-description'\" class=\"form-text\">{{ description }}</small>\n  }\n  @if (isInvalid) {\n    <div class=\"form-feedback just-validate-error-label\" [id]=\"id + '-error'\">\n      <div #customError><ng-content select=\"[error]\"></ng-content></div>\n      @if (!customError.hasChildNodes()) {\n        {{ invalidMessage | async }}\n      }\n    </div>\n  }\n</div>\n",
      styles: ["textarea.is-invalid{border-color:#cc334d}\n"]
    }]
  }], null, {
    rows: [{
      type: Input
    }],
    placeholder: [{
      type: Input
    }],
    description: [{
      type: Input
    }],
    readonly: [{
      type: Input
    }]
  });
})();
class ItFileUtils {
  /**
   * Return the file size string
   * @param file the file
   * @param decimals decimal to show
   */
  static getFileSizeString(file, decimals = 2) {
    const bytes = file.size;
    if (!+bytes) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
  }
  /**
   * Convert a file to base64 string
   * @param file the base64 string
   */
  static fileToBase64(file) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    return new Observable(observer => {
      reader.onload = e => {
        const target = e.target;
        if (!target?.result || target.result instanceof ArrayBuffer) {
          return observer.error('Error on parse');
        }
        observer.next(target.result);
        observer.complete();
      };
      reader.onerror = error => {
        observer.error(error);
      };
    });
  }
  /**
   * Convert base64 to Blob
   * @param base64 the base64 string
   * @param mimeType the <a href="https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types">MIME type</a> (example 'application/pdf')
   */
  static base64ToBlob(base64, mimeType) {
    const byteString = window.atob(base64);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    return new Blob([int8Array], {
      type: mimeType
    });
  }
  /**
   * Convert base64 to File
   * @param base64 the base64 string
   * @param mimeType the <a href="https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types">MIME type</a> (example 'application/pdf')
   * @param filename the file name
   */
  static base64ToFile(base64, mimeType, filename) {
    const fileBlob = ItFileUtils.base64ToBlob(base64, mimeType);
    return new File([fileBlob], filename, {
      type: mimeType
    });
  }
  /**
   * Extract the MIME type from base64 string
   * @param base64 the base64 string
   */
  static getMimeTypeFromBase64(base64) {
    const mime = base64.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/);
    return mime?.length ? mime[1] : undefined;
  }
}
class ItUploadDragDropComponent extends ItAbstractComponent {
  constructor() {
    super();
    /**
     * The accepted file type to upload <br>
     * Possible values: <a href="https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types">MIME Types</a> separated by comma
     * @example application/pdf,image/png
     * @default *
     */
    this.accept = '*';
    /**
     * Fired when file start to upload
     */
    this.fileStartUpload = new EventEmitter();
    this.isDragover = false;
    this.isLoading = false;
    this.isSuccess = false;
    this.assetBasePath = inject(IT_ASSET_BASE_PATH);
  }
  ngAfterViewInit() {
    super.ngAfterViewInit();
    if (this.donutElement) {
      this.donut = ProgressDonut.getOrCreateInstance(this.donutElement.nativeElement);
    }
  }
  // Dragover listener
  onDragOver(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.isDragover = !this.isLoading;
  }
  // Dragleave listener
  onDragLeave(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.isDragover = false;
  }
  // Drop leave listener
  onDrop(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.isDragover = false;
    const files = evt.dataTransfer?.files;
    if (this.isLoading || !files?.length) {
      return;
    }
    this.start(files[0]);
  }
  /**
   * On load file from input
   * @param event
   */
  onLoadFile(event) {
    const files = event.target?.files;
    if (!files?.length) {
      return;
    }
    this.start(files[0]);
  }
  /**
   * Start the upload file
   * @param file
   */
  start(file) {
    if (this.accept !== '*' && !this.accept.includes(file.type)) {
      return;
    }
    this.reset();
    this.isLoading = true;
    const splitName = file.name.split('.');
    this.filename = splitName[0];
    this.extension = splitName[1]?.toUpperCase();
    this.fileSize = ItFileUtils.getFileSizeString(file);
    this.fileStartUpload.emit(file);
  }
  /**
   * Percentage of upload
   * @param value the percentage [0 - 100]
   */
  progress(value) {
    if (!this.isLoading) {
      return;
    }
    if (value >= 100) {
      this.success();
    } else {
      this.donut?.set((value < 0 ? 0 : value) / 100);
    }
  }
  /**
   * Upload success
   */
  success() {
    this.isLoading = false;
    this.isSuccess = true;
    this._changeDetectorRef.detectChanges();
  }
  /**
   * Reset file uploader
   */
  reset() {
    this.isLoading = false;
    this.isSuccess = false;
    this.filename = this.extension = this.fileSize = undefined;
    this.donut?.set(0);
    this._changeDetectorRef.detectChanges();
  }
  static {
    this.ɵfac = function ItUploadDragDropComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItUploadDragDropComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItUploadDragDropComponent,
      selectors: [["it-upload-drag-drop"]],
      viewQuery: function ItUploadDragDropComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c46, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.donutElement = _t.first);
        }
      },
      hostBindings: function ItUploadDragDropComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("dragover", function ItUploadDragDropComponent_dragover_HostBindingHandler($event) {
            return ctx.onDragOver($event);
          })("dragleave", function ItUploadDragDropComponent_dragleave_HostBindingHandler($event) {
            return ctx.onDragLeave($event);
          })("drop", function ItUploadDragDropComponent_drop_HostBindingHandler($event) {
            return ctx.onDrop($event);
          });
        }
      },
      inputs: {
        accept: "accept"
      },
      outputs: {
        fileStartUpload: "fileStartUpload"
      },
      exportAs: ["itUploadDragDrop"],
      standalone: true,
      features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
      decls: 18,
      vars: 17,
      consts: [["donutElement", ""], [1, "upload-dragdrop"], [1, "upload-dragdrop-image"], ["alt", "drag-drop-icon", "aria-hidden", "true", 3, "ngSrc", "width", "height"], [1, "upload-dragdrop-loading"], [1, "progress-donut"], [1, "upload-dragdrop-success"], ["name", "check"], [1, "upload-dragdrop-text"], [1, "upload-dragdrop-weight"], ["name", "file", "size", "xs"], ["type", "file", 1, "upload-dragdrop-input", 3, "change", "id", "accept"], [3, "for"]],
      template: function ItUploadDragDropComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
          i0.ɵɵelement(2, "img", 3);
          i0.ɵɵelementStart(3, "div", 4);
          i0.ɵɵelement(4, "div", 5, 0);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(6, "div", 6);
          i0.ɵɵelement(7, "it-icon", 7);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(8, "div", 8)(9, "p", 9);
          i0.ɵɵelement(10, "it-icon", 10);
          i0.ɵɵtext(11);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(12, "h5");
          i0.ɵɵtext(13);
          i0.ɵɵpipe(14, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(15, ItUploadDragDropComponent_Conditional_15_Template, 3, 3, "p")(16, ItUploadDragDropComponent_Conditional_16_Template, 3, 3, "p")(17, ItUploadDragDropComponent_Conditional_17_Template, 7, 9, "p");
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵclassProp("dragover", ctx.isDragover)("loading", ctx.isLoading)("success", ctx.isSuccess);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngSrc", ctx.assetBasePath + "/dist/assets/upload-drag-drop-icon.svg")("width", 180)("height", 180);
          i0.ɵɵadvance(9);
          i0.ɵɵtextInterpolate2(" ", ctx.extension, " (", ctx.fileSize, ") ");
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(ctx.filename || i0.ɵɵpipeBind1(14, 15, "it.form.upload-drag-file"));
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx.isLoading ? 15 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.isSuccess ? 16 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(!ctx.isLoading && !ctx.isSuccess ? 17 : -1);
        }
      },
      dependencies: [ItIconComponent, TranslateModule, i1.TranslatePipe, NgOptimizedImage],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItUploadDragDropComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-upload-drag-drop',
      exportAs: 'itUploadDragDrop',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [ItIconComponent, TranslateModule, NgOptimizedImage],
      template: "<div class=\"upload-dragdrop\" [class.dragover]=\"isDragover\" [class.loading]=\"isLoading\" [class.success]=\"isSuccess\">\n  <div class=\"upload-dragdrop-image\">\n    <img\n      [ngSrc]=\"assetBasePath + '/dist/assets/upload-drag-drop-icon.svg'\"\n      alt=\"drag-drop-icon\"\n      aria-hidden=\"true\"\n      [width]=\"180\"\n      [height]=\"180\" />\n    <div class=\"upload-dragdrop-loading\">\n      <div class=\"progress-donut\" #donutElement></div>\n    </div>\n    <div class=\"upload-dragdrop-success\">\n      <it-icon name=\"check\"></it-icon>\n    </div>\n  </div>\n  <div class=\"upload-dragdrop-text\">\n    <p class=\"upload-dragdrop-weight\">\n      <it-icon name=\"file\" size=\"xs\"></it-icon>\n      {{ extension }} ({{ fileSize }})\n    </p>\n    <h5>{{ filename || ('it.form.upload-drag-file' | translate) }}</h5>\n    @if (isLoading) {\n      <p>{{ 'it.form.upload-loading' | translate }}</p>\n    }\n    @if (isSuccess) {\n      <p>{{ 'it.form.upload-complete' | translate }}</p>\n    }\n    @if (!isLoading && !isSuccess) {\n      <p>\n        {{ 'it.form.upload-or' | translate }}\n        <input type=\"file\" [id]=\"id\" class=\"upload-dragdrop-input\" [accept]=\"accept\" (change)=\"onLoadFile($event)\" />\n        <label [for]=\"id\">{{ 'it.form.upload-select-device' | translate }}</label>\n      </p>\n    }\n  </div>\n</div>\n"
    }]
  }], () => [], {
    accept: [{
      type: Input
    }],
    fileStartUpload: [{
      type: Output
    }],
    donutElement: [{
      type: ViewChild,
      args: ['donutElement']
    }],
    onDragOver: [{
      type: HostListener,
      args: ['dragover', ['$event']]
    }],
    onDragLeave: [{
      type: HostListener,
      args: ['dragleave', ['$event']]
    }],
    onDrop: [{
      type: HostListener,
      args: ['drop', ['$event']]
    }]
  });
})();
class ItUploadFileListComponent extends ItAbstractComponent {
  constructor() {
    super(...arguments);
    /**
     * The accepted file type to upload <br>
     * Possible values: <a href="https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types">MIME Types</a> separated by comma
     * @example application/pdf,image/png
     * @default *
     */
    this.accept = '*';
    /**
     * If upload multiple files
     * @default true
     */
    this.multiple = true;
    /**
     * Fired when upload new files
     */
    this.uploadFiles = new EventEmitter();
    /**
     * Fired on delete item button click
     */
    this.deleteItem = new EventEmitter();
    /**
     * Cache to preview image
     */
    this.previewImages = new Map();
  }
  ngOnInit() {
    if (!!this.images && this.accept === '*') {
      this.accept = 'image/*';
    }
  }
  ngOnChanges(changes) {
    if (changes['fileList'] && !!this.images) {
      const images$ = this.fileList.map(item => ItFileUtils.fileToBase64(item.file).pipe(take(1), tap(base64 => this.previewImages.set(item.id, base64))));
      forkJoin(images$).subscribe(() => {
        this._changeDetectorRef.detectChanges();
        super.ngOnChanges(changes);
      });
    } else {
      super.ngOnChanges(changes);
    }
  }
  /**
   * On load file from input
   * @param event
   */
  onLoadFiles(event) {
    const input = event.target;
    const files = input?.files;
    if (!files?.length) {
      return;
    }
    const newFiles = Array.from(files).filter(file => !this.fileList.some(item => {
      return item.file.name === file.name && item.file.size === file.size && item.file.type === file.type;
    }));
    const fileList = new DataTransfer();
    newFiles.forEach(file => fileList.items.add(file));
    this.uploadFiles.emit(fileList.files);
    input.value = '';
  }
  /**
   * Get the file size string
   * @param file
   */
  getFileSize(file) {
    return ItFileUtils.getFileSizeString(file);
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵItUploadFileListComponent_BaseFactory;
      return function ItUploadFileListComponent_Factory(__ngFactoryType__) {
        return (ɵItUploadFileListComponent_BaseFactory || (ɵItUploadFileListComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ItUploadFileListComponent)))(__ngFactoryType__ || ItUploadFileListComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItUploadFileListComponent,
      selectors: [["it-upload-file-list"]],
      inputs: {
        fileList: "fileList",
        accept: "accept",
        multiple: [2, "multiple", "multiple", inputToBoolean],
        images: [2, "images", "images", inputToBoolean],
        hideLoadButton: [2, "hideLoadButton", "hideLoadButton", inputToBoolean]
      },
      outputs: {
        uploadFiles: "uploadFiles",
        deleteItem: "deleteItem"
      },
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
      decls: 2,
      vars: 2,
      consts: [[1, "upload-file-list", 3, "upload-file-list-image"], ["type", "file", 1, "upload", 3, "change", "id", "accept", "multiple"], [3, "for"], ["name", "upload", "size", "sm"], [1, "upload-file-list"], [1, "upload-file", 3, "error", "uploading", "success"], [1, "upload-file"], [1, "upload-image"], ["name", "file", "size", "sm", 3, "color"], [3, "itTooltip"], [1, "visually-hidden"], [1, "upload-file-weight"], ["type", "button"], ["type", "button", "disabled", ""], [3, "value"], [3, "alt"], ["type", "button", 3, "click"], ["name", "close"], ["name", "check"]],
      template: function ItUploadFileListComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ItUploadFileListComponent_Conditional_0_Template, 6, 7)(1, ItUploadFileListComponent_Conditional_1_Template, 3, 2, "ul", 0);
        }
        if (rf & 2) {
          i0.ɵɵconditional(!ctx.hideLoadButton ? 0 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.fileList.length ? 1 : -1);
        }
      },
      dependencies: [ItIconComponent, TranslateModule, i1.TranslatePipe, ItTooltipDirective, ItProgressBarComponent],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItUploadFileListComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-upload-file-list',
      imports: [ItIconComponent, TranslateModule, ItTooltipDirective, ItProgressBarComponent],
      template: "@if (!hideLoadButton) {\n  <input type=\"file\" [id]=\"id\" class=\"upload\" [accept]=\"accept\" [multiple]=\"multiple\" (change)=\"onLoadFiles($event)\" />\n  <label [for]=\"id\">\n    <it-icon name=\"upload\" size=\"sm\"></it-icon>\n    <span>{{ 'it.form.upload' | translate }}</span>\n  </label>\n}\n\n@if (fileList.length) {\n  <ul class=\"upload-file-list\" [class.upload-file-list-image]=\"images\">\n    @for (item of fileList; track item.id) {\n      <li\n        class=\"upload-file\"\n        [class.error]=\"item.error\"\n        [class.uploading]=\"!item.error && item.progress !== undefined && item.progress > 0 && item.progress < 100\"\n        [class.success]=\"!item.error && (!item.progress || item.progress >= 100)\">\n        @if (images) {\n          <div class=\"upload-image\">\n            <img [attr.src]=\"previewImages.get(item.id)\" [alt]=\"item.file.name\" />\n          </div>\n        } @else {\n          <it-icon name=\"file\" size=\"sm\" [color]=\"!item.error ? (item.progress ? 'secondary' : 'primary') : 'danger'\"></it-icon>\n        }\n        <p [itTooltip]=\"item.tooltip\">\n          <span class=\"visually-hidden\">{{ 'it.form.uploaded-file' | translate: { name: item.file.name } }}</span>\n          {{ item.file.name }} <span class=\"upload-file-weight\">{{ getFileSize(item.file) }}</span>\n        </p>\n        @if (item.removable && (!item.progress || item.progress < 100)) {\n          <button type=\"button\" (click)=\"deleteItem.emit(item)\">\n            <span class=\"visually-hidden\">{{ 'it.form.delete-file' | translate: { name: item.file.name } }}</span>\n            <it-icon name=\"close\"></it-icon>\n          </button>\n        }\n        @if ((!item.removable && !item.progress) || (item.progress !== undefined && item.progress >= 100)) {\n          <button type=\"button\" disabled>\n            <span class=\"visually-hidden\">{{ 'it.form.upload-complete' | translate }}</span>\n            <it-icon name=\"check\"></it-icon>\n          </button>\n        }\n        @if (!item.error && item.progress !== undefined && item.progress > 0 && item.progress < 100) {\n          <it-progress-bar [value]=\"item.progress!\"></it-progress-bar>\n        }\n      </li>\n    }\n  </ul>\n}\n"
    }]
  }], null, {
    fileList: [{
      type: Input,
      args: [{
        required: true
      }]
    }],
    accept: [{
      type: Input
    }],
    multiple: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    images: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    hideLoadButton: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    uploadFiles: [{
      type: Output
    }],
    deleteItem: [{
      type: Output
    }]
  });
})();

/**
 * Allows you to highlight text with the <mark> tag
 */
class ItMarkMatchingTextPipe {
  constructor(domSanitizer) {
    this.domSanitizer = domSanitizer;
  }
  /**
   * Allows you to highlight text with the <mark> tag
   * @param allString the full text to search from
   * @param searchString the string to search
   */
  transform(allString, searchString) {
    if (!searchString) {
      return allString;
    } else if (!allString) {
      return '';
    }
    if (typeof searchString === 'number') {
      searchString = searchString.toString();
    }
    // Check if search string is a substring of pivot string (no case-sensitive)
    const idxOfMatchString = allString.toLowerCase().indexOf(searchString.toLowerCase());
    if (idxOfMatchString !== -1) {
      // retrieve the exactly substring
      const matchingString = allString.substring(idxOfMatchString, idxOfMatchString + searchString.length);
      // Replace original string marking as <strong> (bold) the matchinng substring
      const regEx = new RegExp('(' + matchingString + ')', 'gi');
      const res = allString.replace(regEx, '<mark>$1</mark>');
      return this.domSanitizer.bypassSecurityTrustHtml(res);
    }
    return allString;
  }
  static {
    this.ɵfac = function ItMarkMatchingTextPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItMarkMatchingTextPipe)(i0.ɵɵdirectiveInject(i1$2.DomSanitizer, 16));
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "itMarkMatchingText",
      type: ItMarkMatchingTextPipe,
      pure: true,
      standalone: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItMarkMatchingTextPipe, [{
    type: Pipe,
    args: [{
      standalone: true,
      name: 'itMarkMatchingText'
    }]
  }], () => [{
    type: i1$2.DomSanitizer
  }], null);
})();
class ItAutocompleteComponent extends ItAbstractFormComponent {
  constructor() {
    super(...arguments);
    /**
     * Time span [ms] has passed without another source emission, to delay data filtering.
     * Useful when the user is typing multiple letters
     * @default 300 [ms]
     */
    this.debounceTime = 300;
    /**
     * The input placeholder
     */
    this.placeholder = '';
    /**
     * The input label even get labelWaria icon
     */
    this.labelWaria = undefined;
    /**
     * Show the label
     */
    this.forceShowLabel = true;
    /**
     * Fired when the Autocomplete Item has been selected
     */
    this.autocompleteSelectedEvent = new EventEmitter();
    this.showAutocompletion = false;
    /** Observable da cui vengono emessi i risultati dell'auto completamento */
    this.autocompleteResults$ = new Observable();
  }
  ngOnInit() {
    super.ngOnInit();
    this.autocompleteResults$ = this.getAutocompleteResults$();
  }
  /**
   * Create the autocomplete list
   */
  getAutocompleteResults$() {
    return this.control.valueChanges.pipe(debounceTime(this.debounceTime),
    // Delay filter data after time span has passed without another source emission, useful when the user is typing multiple letters
    distinctUntilChanged(),
    // Only if searchValue is distinct in comparison to the last value
    switchMap(searchedValue => {
      if (!this.autocompleteData) {
        return of({
          searchedValue,
          relatedEntries: []
        });
      }
      const autoCompleteData$ = Array.isArray(this.autocompleteData) ? of(this.autocompleteData) : this.autocompleteData(searchedValue);
      return autoCompleteData$.pipe(map(autocompleteData => {
        if (!searchedValue || typeof searchedValue === 'number') {
          return {
            searchedValue,
            relatedEntries: []
          };
        }
        const lowercaseValue = searchedValue.toLowerCase();
        const relatedEntries = autocompleteData.filter(item => item.value?.toLowerCase().includes(lowercaseValue));
        return {
          searchedValue,
          relatedEntries
        };
      }));
    }));
  }
  onEntryClick(entry, event) {
    // Se non è stato definito un link associato all'elemento dell'autocomplete, probabilmente il desiderata
    // non è effettuare la navigazione al default '#', pertanto in tal caso meglio annullare la navigazione.
    if (!entry.link) {
      event.preventDefault();
    }
    this.autocompleteSelectedEvent.next(entry);
    this.control.setValue(entry.value);
    this.showAutocompletion = false;
  }
  autocompleteItemTrackByValueFn(index, item) {
    return item.value;
  }
  onKeyDown() {
    this.showAutocompletion = true;
  }
  get isActiveLabel() {
    const value = this.control.value;
    return this.forceShowLabel && (!!value || !!this.placeholder);
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵItAutocompleteComponent_BaseFactory;
      return function ItAutocompleteComponent_Factory(__ngFactoryType__) {
        return (ɵItAutocompleteComponent_BaseFactory || (ɵItAutocompleteComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ItAutocompleteComponent)))(__ngFactoryType__ || ItAutocompleteComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItAutocompleteComponent,
      selectors: [["it-autocomplete"]],
      inputs: {
        autocompleteData: "autocompleteData",
        big: [2, "big", "big", inputToBoolean],
        debounceTime: "debounceTime",
        placeholder: "placeholder",
        labelWaria: "labelWaria",
        forceShowLabel: [2, "forceShowLabel", "forceShowLabel", inputToBoolean]
      },
      outputs: {
        autocompleteSelectedEvent: "autocompleteSelectedEvent"
      },
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c39,
      decls: 8,
      vars: 15,
      consts: [["customError", ""], [1, "form-group"], [3, "for", "visually-hidden", "active"], ["type", "search", 1, "autocomplete", "form-control", 3, "blur", "keydown", "id", "placeholder", "formControl"], ["aria-hidden", "true", 1, "autocomplete-icon"], ["name", "search", "size", "sm", 3, "labelWaria"], [1, "autocomplete-list", 3, "autocomplete-list-show"], [1, "form-feedback", "just-validate-error-label", 3, "id"], [3, "for"], [1, "autocomplete-list"], [3, "click", "href"], [1, "avatar", "size-sm"], ["size", "sm", 3, "name"], [1, "autocomplete-list-text"], [3, "innerHTML"], [3, "src", "alt"]],
      template: function ItAutocompleteComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c38);
          i0.ɵɵelementStart(0, "div", 1);
          i0.ɵɵtemplate(1, ItAutocompleteComponent_Conditional_1_Template, 2, 6, "label", 2);
          i0.ɵɵelementStart(2, "input", 3);
          i0.ɵɵlistener("blur", function ItAutocompleteComponent_Template_input_blur_2_listener() {
            return ctx.markAsTouched();
          })("keydown", function ItAutocompleteComponent_Template_input_keydown_2_listener() {
            return ctx.onKeyDown();
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(3, "span", 4);
          i0.ɵɵelement(4, "it-icon", 5);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(5, ItAutocompleteComponent_Conditional_5_Template, 3, 2, "ul", 6);
          i0.ɵɵpipe(6, "async");
          i0.ɵɵtemplate(7, ItAutocompleteComponent_Conditional_7_Template, 5, 2, "div", 7);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          let tmp_8_0;
          i0.ɵɵclassProp("autocomplete-wrapper-big", ctx.big);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.label ? 1 : -1);
          i0.ɵɵadvance();
          i0.ɵɵclassProp("is-invalid", ctx.isInvalid)("is-valid", ctx.isValid);
          i0.ɵɵproperty("id", ctx.id)("placeholder", ctx.placeholder)("formControl", ctx.control);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("labelWaria", ctx.labelWaria);
          i0.ɵɵadvance();
          i0.ɵɵconditional((tmp_8_0 = i0.ɵɵpipeBind1(6, 13, ctx.autocompleteResults$)) ? 5 : -1, tmp_8_0);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx.isInvalid ? 7 : -1);
        }
      },
      dependencies: [AsyncPipe, ItIconComponent, ItMarkMatchingTextPipe, ReactiveFormsModule, i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.FormControlDirective],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItAutocompleteComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-autocomplete',
      imports: [AsyncPipe, ItIconComponent, ItMarkMatchingTextPipe, NgTemplateOutlet, ReactiveFormsModule],
      changeDetection: ChangeDetectionStrategy.OnPush,
      template: "<div class=\"form-group\" [class.autocomplete-wrapper-big]=\"big\">\n  @if (label) {\n    <label [for]=\"id\" [class.visually-hidden]=\"!isActiveLabel\" [class.active]=\"isActiveLabel\">\n      {{ label }}\n    </label>\n  }\n\n  <input\n    [id]=\"id\"\n    type=\"search\"\n    class=\"autocomplete form-control\"\n    [placeholder]=\"placeholder\"\n    [formControl]=\"control\"\n    [class.is-invalid]=\"isInvalid\"\n    [class.is-valid]=\"isValid\"\n    (blur)=\"markAsTouched()\"\n    (keydown)=\"onKeyDown()\" />\n\n  <span class=\"autocomplete-icon\" aria-hidden=\"true\">\n    <it-icon [labelWaria]=\"labelWaria\" name=\"search\" size=\"sm\"></it-icon>\n  </span>\n\n  @if (autocompleteResults$ | async; as autocomplete) {\n    <ul class=\"autocomplete-list\" [class.autocomplete-list-show]=\"autocomplete.relatedEntries?.length && showAutocompletion\">\n      @for (entry of autocomplete.relatedEntries; track autocompleteItemTrackByValueFn($index, entry)) {\n        <li>\n          <a [href]=\"entry.link\" (click)=\"onEntryClick(entry, $event)\">\n            @if (entry.avatarSrcPath) {\n              <div class=\"avatar size-sm\">\n                <img [src]=\"entry.avatarSrcPath\" [alt]=\"entry.avatarAltText\" />\n              </div>\n            }\n            @if (entry.icon) {\n              <it-icon [name]=\"entry.icon\" size=\"sm\"></it-icon>\n            }\n            <span class=\"autocomplete-list-text\">\n              <span [innerHTML]=\"entry.value | itMarkMatchingText: autocomplete.searchedValue\"></span>\n              @if (entry.label) {\n                <em>{{ entry.label }}</em>\n              }\n            </span>\n          </a>\n        </li>\n      }\n    </ul>\n  }\n\n  @if (isInvalid) {\n    <div class=\"form-feedback just-validate-error-label\" [id]=\"id + '-error'\">\n      <div #customError>\n        <ng-content select=\"[error]\"></ng-content>\n      </div>\n      @if (!customError.hasChildNodes()) {\n        {{ invalidMessage | async }}\n      }\n    </div>\n  }\n</div>\n"
    }]
  }], null, {
    autocompleteData: [{
      type: Input,
      args: [{
        required: true
      }]
    }],
    big: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    debounceTime: [{
      type: Input
    }],
    placeholder: [{
      type: Input
    }],
    labelWaria: [{
      type: Input
    }],
    forceShowLabel: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    autocompleteSelectedEvent: [{
      type: Output
    }]
  });
})();

//#region private utility functions
const generateSelectAll = (checked, items) => {
  const selected = new Set();
  if (checked) {
    items.forEach(item => selected.add(item));
  }
  return selected;
};
const updateSelected = (set, item) => {
  if (set.has(item)) {
    set.delete(item);
  } else {
    set.add(item);
  }
  return set;
};
//#endregion
//#region reducers
const init = (state, {
  source,
  target
}) => ({
  ...state,
  initialItems: {
    source: [...source],
    target: [...target]
  },
  current: {
    source: [...source],
    target: [...target]
  }
});
const transfer = state => {
  return {
    ...state,
    current: {
      ...state.current,
      source: state.current.source.filter(i => !state.selections.source.has(i)),
      target: Array.from(new Set([...state.current.target, ...Array.from(state.selections.source)]))
    },
    selections: {
      ...state.selections,
      source: new Set()
    },
    operationsEnabled: {
      ...state.operationsEnabled,
      transfer: false,
      reset: true
    }
  };
};
const backtransfer = state => {
  return {
    ...state,
    current: {
      ...state.current,
      target: state.current.target.filter(i => !state.selections.target.has(i)),
      source: Array.from(new Set([...state.current.source, ...Array.from(state.selections.target)]))
    },
    selections: {
      ...state.selections,
      target: new Set()
    },
    operationsEnabled: {
      ...state.operationsEnabled,
      backtransfer: false,
      reset: true
    }
  };
};
const reset = state => {
  return {
    ...state,
    current: {
      source: [...state.initialItems.source],
      target: [...state.initialItems.target]
    },
    operationsEnabled: {
      ...state.operationsEnabled,
      reset: false
    }
  };
};
const selectAllSource = (state, {
  checked
}) => {
  const items = state.current.source;
  const selected = generateSelectAll(checked, items);
  const transfer = Boolean(selected.size);
  return {
    ...state,
    selections: {
      ...state.selections,
      source: selected
    },
    operationsEnabled: {
      ...state.operationsEnabled,
      transfer
    }
  };
};
const selectAllTarget = (state, {
  checked
}) => {
  const items = state.current.target;
  const selected = generateSelectAll(checked, items);
  const backtransfer = Boolean(selected.size);
  return {
    ...state,
    selections: {
      ...state.selections,
      target: selected
    },
    operationsEnabled: {
      ...state.operationsEnabled,
      backtransfer
    }
  };
};
const selectionItemSource = (previousState, {
  item
}) => {
  const selected = updateSelected(previousState.selections.source, item);
  const selectedItems = Array.from(selected);
  const transfer = Boolean(selectedItems.length);
  const source = new Set([...selectedItems]);
  const state = {
    ...previousState,
    selections: {
      ...previousState.selections,
      source
    },
    operationsEnabled: {
      ...previousState.operationsEnabled,
      transfer
    }
  };
  return state;
};
const selectionItemTarget = (previousState, {
  item
}) => {
  const selected = updateSelected(previousState.selections.target, item);
  const selectedItems = Array.from(selected);
  const backtransfer = Boolean(selectedItems.length);
  const target = new Set([...selectedItems]);
  const state = {
    ...previousState,
    selections: {
      ...previousState.selections,
      target
    },
    operationsEnabled: {
      ...previousState.operationsEnabled,
      backtransfer
    }
  };
  return state;
};
//#endregion reducers
//#region public reducers
const initialStateFn = () => ({
  initialItems: {
    source: [],
    target: []
  },
  current: {
    source: [],
    target: []
  },
  selections: {
    source: new Set(),
    target: new Set()
  },
  operationsEnabled: {
    transfer: false,
    backtransfer: false,
    reset: false
  }
});
const initFn = payload => state => init(state, payload);
const transferFn = () => state => transfer(state);
const backtransferFn = () => state => backtransfer(state);
const resetFn = () => state => reset(state);
const selectAllSourceFn = ({
  checked
}) => state => selectAllSource(state, {
  checked
});
const selectAllTargetFn = ({
  checked
}) => state => selectAllTarget(state, {
  checked
});
const selectionItemSourceFn = ({
  item
}) => state => selectionItemSource(state, {
  item
});
const selectionItemTargetFn = ({
  item
}) => state => selectionItemTarget(state, {
  item
});
//#endregion
var reducers = {
  initialStateFn,
  initFn,
  transferFn,
  backtransferFn,
  resetFn,
  selectAllSourceFn,
  selectAllTargetFn,
  selectionItemSourceFn,
  selectionItemTargetFn
};
class TransferStore {
  constructor() {
    this._state = new BehaviorSubject(reducers.initialStateFn());
    this.sourceItems = this._state.pipe(map(state => state.current.source));
    this.targetItems = this._state.pipe(map(state => state.current.target));
    this.valueChanged = this._state.pipe(map(state => state.current.target), distinctUntilChanged());
    this.selectItems = sourceType => {
      if (sourceType === 'source') {
        return this.sourceItems;
      }
      if (sourceType === 'target') {
        return this.targetItems;
      }
      return of([]);
    };
    this.selectSelectedItems = sourceType => {
      if (sourceType === 'source') {
        return this._state.pipe(map(state => state.selections.source));
      }
      if (sourceType === 'target') {
        return this._state.pipe(map(state => state.selections.target));
      }
      return of(new Set());
    };
    this.transferEnabled = this._state.pipe(map(state => state.operationsEnabled.transfer));
    this.backtransferEnabled = this._state.pipe(map(state => state.operationsEnabled.backtransfer));
    this.resetEnabled = this._state.pipe(map(state => state.operationsEnabled.reset));
  }
  init({
    source,
    target
  }) {
    this.updateState(reducers.initFn({
      source,
      target
    }));
  }
  transfer() {
    this.updateState(reducers.transferFn());
  }
  backtransfer() {
    this.updateState(reducers.backtransferFn());
  }
  reset() {
    this.updateState(reducers.resetFn());
  }
  checkboxSelection(item, sourceType) {
    if (sourceType === 'source') {
      this.updateState(reducers.selectionItemSourceFn({
        item
      }));
    }
    if (sourceType === 'target') {
      this.updateState(reducers.selectionItemTargetFn({
        item
      }));
    }
  }
  selectAllSelection(checked, sourceType) {
    if (sourceType === 'source') {
      this.updateState(reducers.selectAllSourceFn({
        checked
      }));
    }
    if (sourceType === 'target') {
      this.updateState(reducers.selectAllTargetFn({
        checked
      }));
    }
  }
  updateState(reducerFn) {
    this._state.next(reducerFn(this._state.value));
  }
  static {
    this.ɵfac = function TransferStore_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TransferStore)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: TransferStore,
      factory: TransferStore.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TransferStore, [{
    type: Injectable
  }], null, null);
})();
class ItTransferListComponent extends ItAbstractComponent {
  constructor(store) {
    super();
    this.store = store;
    /**
     * Widget title
     */
    this.title = inject(new HostAttributeToken('title'), {
      optional: true
    });
    this.sourceType = inject(new HostAttributeToken('sourceType'), {
      optional: true
    });
    this.items = this.store.selectItems(this.sourceType).pipe(distinctUntilChanged(), shareReplay());
    this.selected = this.store.selectSelectedItems(this.sourceType).pipe(distinctUntilChanged(), shareReplay());
    this.numberOfItems$ = this.items.pipe(map(items => ({
      length: items.length
    })), startWith({
      length: 0
    }));
    this.selectAllDisabled = this.items.pipe(map(items => items.length === 0));
    /**
     * Items of the list
     * @default []
     */
    this.items$ = combineLatest([this.items, this.selected]).pipe(map(([items, selected]) => items.map(item => {
      item.selected = selected.has(item);
      return item;
    })));
    this.instanceId = this.getInstanceId();
    this.onItemsUpdate();
  }
  /**
   * Checkbox selection click handler
   */
  checkboxSelectionHandler(item) {
    this.store.checkboxSelection(item, this.sourceType);
  }
  /**
   * Checkbox select all selection handler
   */
  checkboxSelectAllHandler(event) {
    const checked = event.target.checked;
    this.store.selectAllSelection(checked, this.sourceType);
  }
  /**
   * Items update subscription
   */
  onItemsUpdate() {
    this.items.pipe(takeUntilDestroyed(), skip(1), tap(() => {
      if (this.selectAllCheckboxRef) {
        this.selectAllCheckboxRef.nativeElement.checked = false;
      }
    })).subscribe();
  }
  getInstanceId() {
    return Math.floor(Math.random() * 100000000).toString();
  }
  static {
    this.ɵfac = function ItTransferListComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItTransferListComponent)(i0.ɵɵdirectiveInject(TransferStore));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItTransferListComponent,
      selectors: [["it-transfer-list"]],
      viewQuery: function ItTransferListComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c48, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.selectAllCheckboxRef = _t.first);
        }
      },
      standalone: true,
      features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
      decls: 18,
      vars: 17,
      consts: [["selectAllCheckbox", ""], [1, "it-transfer-wrapper", "source"], [1, "transfer-header"], [1, "form-check"], ["type", "checkbox", 3, "click", "id", "disabled"], [3, "for"], [1, "descr"], [1, "transfer-scroll"], [1, "transfer-group"], [1, "num"], ["type", "checkbox", 3, "click", "id", "checked"]],
      template: function ItTransferListComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "div", 3)(3, "input", 4, 0);
          i0.ɵɵpipe(5, "async");
          i0.ɵɵlistener("click", function ItTransferListComponent_Template_input_click_3_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.checkboxSelectAllHandler($event));
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(6, "label", 5)(7, "span");
          i0.ɵɵtemplate(8, ItTransferListComponent_Conditional_8_Template, 5, 4);
          i0.ɵɵpipe(9, "async");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(10, "span", 6);
          i0.ɵɵtext(11);
          i0.ɵɵpipe(12, "titlecase");
          i0.ɵɵelementEnd()()()();
          i0.ɵɵelementStart(13, "div", 7)(14, "div", 8);
          i0.ɵɵrepeaterCreate(15, ItTransferListComponent_For_16_Template, 6, 8, "div", 3, _forTrack1);
          i0.ɵɵpipe(17, "async");
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          let tmp_4_0;
          i0.ɵɵadvance(3);
          i0.ɵɵpropertyInterpolate2("id", "", ctx.instanceId, "checkbox", ctx.title, "");
          i0.ɵɵproperty("disabled", i0.ɵɵpipeBind1(5, 9, ctx.selectAllDisabled));
          i0.ɵɵadvance(3);
          i0.ɵɵpropertyInterpolate2("for", "", ctx.instanceId, "checkbox", ctx.title, "");
          i0.ɵɵadvance(2);
          i0.ɵɵconditional((tmp_4_0 = i0.ɵɵpipeBind1(9, 11, ctx.numberOfItems$)) ? 8 : -1, tmp_4_0);
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(12, 13, ctx.title));
          i0.ɵɵadvance(4);
          i0.ɵɵrepeater(i0.ɵɵpipeBind1(17, 15, ctx.items$));
        }
      },
      dependencies: [TranslateModule, i1.TranslatePipe, AsyncPipe, TitleCasePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItTransferListComponent, [{
    type: Component,
    args: [{
      selector: 'it-transfer-list',
      standalone: true,
      imports: [TranslateModule, AsyncPipe, TitleCasePipe],
      changeDetection: ChangeDetectionStrategy.OnPush,
      template: "<div class=\"it-transfer-wrapper source\">\n  <div class=\"transfer-header\">\n    <div class=\"form-check\">\n      <input\n        #selectAllCheckbox\n        type=\"checkbox\"\n        id=\"{{ instanceId }}checkbox{{ title }}\"\n        [disabled]=\"selectAllDisabled | async\"\n        (click)=\"checkboxSelectAllHandler($event)\" />\n      <label for=\"{{ instanceId }}checkbox{{ title }}\">\n        <span>\n          @if (numberOfItems$ | async; as numberOfItems) {\n            <span class=\"num\"> {{ numberOfItems.length }}</span>\n            <span> {{ (numberOfItems.length === 1 ? 'it.transfer.item' : 'it.transfer.items') | translate }}</span>\n          }\n        </span>\n        <span class=\"descr\">{{ title | titlecase }}</span>\n      </label>\n    </div>\n    <!-- form check -->\n  </div>\n  <!-- transfer-header -->\n  <div class=\"transfer-scroll\">\n    <div class=\"transfer-group\">\n      @for (item of items$ | async; track item.value) {\n        <div class=\"form-check\">\n          <input\n            type=\"checkbox\"\n            id=\"{{ instanceId }}-{{ item.value }}\"\n            [checked]=\"item.selected\"\n            (click)=\"checkboxSelectionHandler(item)\" />\n          <label for=\"{{ instanceId }}-{{ item.value }}\">\n            <span>\n              <span>{{ item.text }}</span>\n            </span>\n          </label>\n        </div>\n      }\n    </div>\n  </div>\n</div>\n<!-- it-transfer-wrapper -->\n"
    }]
  }], () => [{
    type: TransferStore
  }], {
    selectAllCheckboxRef: [{
      type: ViewChild,
      args: ['selectAllCheckbox']
    }]
  });
})();

/**
 * Transfer
 * @description Component that allows the creation of checkbox lists.
 */
class ItTransferComponent extends ItAbstractFormComponent {
  constructor(_ngControl, _translateService, store) {
    super(_translateService, _ngControl);
    this._ngControl = _ngControl;
    this._translateService = _translateService;
    this.store = store;
    /**
     * The select options (left side)
     */
    this.options = [];
    /**
     * The selected options (right side)
     */
    this.selected = [];
    /**
     * Fired when there is a transfer, a backtransfer or a reset event
     */
    this.transferChanges = new EventEmitter();
    /**
     * Enable transfer button
     * @default false
     */
    this.transferEnabled = this.store.transferEnabled;
    /**
     * Enable backtransfer button
     * @default false
     */
    this.backtransferEnabled = this.store.backtransferEnabled;
    /**
     * Enable reset button
     * @default false
     */
    this.resetEnabled = this.store.resetEnabled;
    this.destroyRef = inject(DestroyRef);
  }
  ngOnInit() {
    super.ngOnInit();
    this.storeInit();
    this.onStoreValueChanged();
  }
  /**
   * Transfer button click handler
   */
  transferClickHandler(event) {
    this.buttonEventHandler(event, () => this.store.transfer());
  }
  /**
   * Transfer button keypress handler
   */
  transferKeyPressHandler(event) {
    this.buttonEventHandler(event, () => this.store.transfer());
  }
  /**
   * Backtransfer button click handler
   */
  backtransferClickHandler(event) {
    this.buttonEventHandler(event, () => this.store.backtransfer());
  }
  /**
   * Backtransfer button keypress handler
   */
  backtransferKeyPressHandler(event) {
    this.buttonEventHandler(event, () => this.store.backtransfer());
  }
  /**
   * Reset button click handler
   */
  resetClickHandler(event) {
    this.buttonEventHandler(event, () => this.store.reset());
  }
  /**
   * Reset button keypress handler
   */
  resetKeyPressHandler(event) {
    this.buttonEventHandler(event, () => this.store.reset());
  }
  buttonEventHandler(event, updateStoreCb) {
    event.preventDefault();
    updateStoreCb();
  }
  storeInit() {
    let target = [];
    const ngControl = this._ngControl;
    const isNgControlDefined = Boolean(this._ngControl);
    // if ngControl is defined, take values from it. Input() target will be ignored
    if (isNgControlDefined) {
      console.debug('ngControl instanceof NgModel:', ngControl instanceof NgModel);
      console.debug('ngControl instanceof FormControlName:', ngControl instanceof FormControlName);
      // if ngControl is an ngModel (template-driven form use case), take values from it
      if (ngControl instanceof NgModel) {
        console.debug('ngControl instanceof NgModel');
        const model = ngControl.model;
        target = Array.isArray(model) ? model : [];
      }
      // if ngControl is an FormControlName (reactive form use case), take values from it
      if (ngControl instanceof FormControlName) {
        console.debug('ngControl instanceof FormControlName');
        const model = ngControl.control.value;
        target = Array.isArray(model) ? model : [];
      }
      console.debug('ngControl is defined. Input() target will be ignored');
    } else if (this.selected && Array.isArray(this.selected)) {
      target = [...this.selected];
    }
    console.debug('target:', this.selected, 'formControl:', this.control.value, 'ngModel:', this._ngControl);
    this.store.init({
      source: [...this.options],
      target
    });
  }
  onStoreValueChanged() {
    this.store.valueChanged.pipe(takeUntilDestroyed(this.destroyRef), tap(value => this.writeValue(value)), tap(value => this.onChange(value)), tap(value => this.transferChanges.emit(value))).subscribe();
  }
  static {
    this.ɵfac = function ItTransferComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItTransferComponent)(i0.ɵɵdirectiveInject(i1$1.NgControl, 10), i0.ɵɵdirectiveInject(i1.TranslateService), i0.ɵɵdirectiveInject(TransferStore));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItTransferComponent,
      selectors: [["it-transfer"]],
      inputs: {
        options: "options",
        selected: "selected"
      },
      outputs: {
        transferChanges: "transferChanges"
      },
      standalone: true,
      features: [i0.ɵɵProvidersFeature([TransferStore]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
      decls: 32,
      vars: 40,
      consts: [[3, "for", "active"], [1, "row"], [1, "col-xs-12", "col-md-5"], ["sourceType", "source", 3, "title"], [1, "col-xs-12", "col-md-2"], [1, "it-transfer-buttons"], ["role", "button", "href", "#", 1, "transfer", 3, "click", "keypress", "ngClass"], ["name", "arrow-right"], [1, "visually-hidden"], ["role", "button", "href", "#", 1, "backtransfer", 3, "click", "keypress", "ngClass"], ["name", "arrow-left"], ["role", "button", "href", "#", 1, "reset", 3, "click", "keypress", "ngClass"], ["name", "restore"], ["sourceType", "target", 3, "title"], [3, "for"]],
      template: function ItTransferComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div");
          i0.ɵɵtemplate(1, ItTransferComponent_Conditional_1_Template, 2, 4, "label", 0);
          i0.ɵɵelementStart(2, "div", 1)(3, "div", 2);
          i0.ɵɵelement(4, "it-transfer-list", 3);
          i0.ɵɵpipe(5, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(6, "div", 4)(7, "div", 5)(8, "a", 6);
          i0.ɵɵpipe(9, "async");
          i0.ɵɵpipe(10, "translate");
          i0.ɵɵlistener("click", function ItTransferComponent_Template_a_click_8_listener($event) {
            return ctx.transferClickHandler($event);
          })("keypress", function ItTransferComponent_Template_a_keypress_8_listener($event) {
            return ctx.transferKeyPressHandler($event);
          });
          i0.ɵɵelement(11, "it-icon", 7);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(12, "span", 8);
          i0.ɵɵtext(13);
          i0.ɵɵpipe(14, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(15, "a", 9);
          i0.ɵɵpipe(16, "async");
          i0.ɵɵpipe(17, "translate");
          i0.ɵɵlistener("click", function ItTransferComponent_Template_a_click_15_listener($event) {
            return ctx.backtransferClickHandler($event);
          })("keypress", function ItTransferComponent_Template_a_keypress_15_listener($event) {
            return ctx.backtransferKeyPressHandler($event);
          });
          i0.ɵɵelement(18, "it-icon", 10);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(19, "span", 8);
          i0.ɵɵtext(20);
          i0.ɵɵpipe(21, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(22, "a", 11);
          i0.ɵɵpipe(23, "async");
          i0.ɵɵpipe(24, "translate");
          i0.ɵɵlistener("click", function ItTransferComponent_Template_a_click_22_listener($event) {
            return ctx.resetClickHandler($event);
          })("keypress", function ItTransferComponent_Template_a_keypress_22_listener($event) {
            return ctx.resetKeyPressHandler($event);
          });
          i0.ɵɵelement(25, "it-icon", 12);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(26, "span", 8);
          i0.ɵɵtext(27);
          i0.ɵɵpipe(28, "translate");
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(29, "div", 2);
          i0.ɵɵelement(30, "it-transfer-list", 13);
          i0.ɵɵpipe(31, "translate");
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.label ? 1 : -1);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("title", i0.ɵɵpipeBind1(5, 12, "it.transfer.source"));
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(34, _c49, i0.ɵɵpipeBind1(9, 14, ctx.transferEnabled)));
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(10, 16, "it.transfer.aria-label-move-forward"));
          i0.ɵɵadvance(5);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(14, 18, "it.transfer.label-move-forward"));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(36, _c49, i0.ɵɵpipeBind1(16, 20, ctx.backtransferEnabled)));
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(17, 22, "it.transfer.aria-label-move-backward"));
          i0.ɵɵadvance(5);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(21, 24, "it.transfer.label-move-backward"));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(38, _c49, i0.ɵɵpipeBind1(23, 26, ctx.resetEnabled)));
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(24, 28, "it.transfer.aria-label-reset"));
          i0.ɵɵadvance(5);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(28, 30, "it.transfer.label-reset"));
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("title", i0.ɵɵpipeBind1(31, 32, "it.transfer.target"));
        }
      },
      dependencies: [TranslateModule, i1.TranslatePipe, ItIconComponent, ItTransferListComponent, NgClass, AsyncPipe, ReactiveFormsModule],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItTransferComponent, [{
    type: Component,
    args: [{
      selector: 'it-transfer',
      standalone: true,
      imports: [TranslateModule, ItIconComponent, ItTransferListComponent, NgClass, AsyncPipe, ReactiveFormsModule],
      providers: [TransferStore],
      changeDetection: ChangeDetectionStrategy.OnPush,
      template: "<div>\n  @if (label) {\n    <label [for]=\"id\" [class.active]=\"!!control.value\">{{ label }}</label>\n  }\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-5\">\n      <it-transfer-list sourceType=\"source\" [title]=\"'it.transfer.source' | translate\"></it-transfer-list>\n    </div>\n    <!-- col -->\n    <div class=\"col-xs-12 col-md-2\">\n      <!-- transfer buttons-->\n      <div class=\"it-transfer-buttons\">\n        <a\n          class=\"transfer\"\n          role=\"button\"\n          href=\"#\"\n          [ngClass]=\"{ active: transferEnabled | async }\"\n          (click)=\"transferClickHandler($event)\"\n          (keypress)=\"transferKeyPressHandler($event)\"\n          [attr.aria-label]=\"'it.transfer.aria-label-move-forward' | translate\">\n          <it-icon name=\"arrow-right\"></it-icon>\n        </a>\n        <span class=\"visually-hidden\">{{ 'it.transfer.label-move-forward' | translate }}</span>\n        <a\n          class=\"backtransfer\"\n          role=\"button\"\n          href=\"#\"\n          [ngClass]=\"{ active: backtransferEnabled | async }\"\n          (click)=\"backtransferClickHandler($event)\"\n          (keypress)=\"backtransferKeyPressHandler($event)\"\n          [attr.aria-label]=\"'it.transfer.aria-label-move-backward' | translate\">\n          <it-icon name=\"arrow-left\"></it-icon>\n        </a>\n        <span class=\"visually-hidden\">{{ 'it.transfer.label-move-backward' | translate }}</span>\n        <a\n          class=\"reset\"\n          role=\"button\"\n          href=\"#\"\n          [ngClass]=\"{ active: resetEnabled | async }\"\n          (click)=\"resetClickHandler($event)\"\n          (keypress)=\"resetKeyPressHandler($event)\"\n          [attr.aria-label]=\"'it.transfer.aria-label-reset' | translate\">\n          <it-icon name=\"restore\"></it-icon>\n        </a>\n        <span class=\"visually-hidden\">{{ 'it.transfer.label-reset' | translate }}</span>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-5\">\n      <it-transfer-list sourceType=\"target\" [title]=\"'it.transfer.target' | translate\"></it-transfer-list>\n    </div>\n  </div>\n</div>\n"
    }]
  }], () => [{
    type: i1$1.NgControl,
    decorators: [{
      type: Self
    }, {
      type: Optional
    }]
  }, {
    type: i1.TranslateService
  }, {
    type: TransferStore
  }], {
    options: [{
      type: Input
    }],
    selected: [{
      type: Input
    }],
    transferChanges: [{
      type: Output
    }]
  });
})();
const formComponents = [ItAutocompleteComponent, ItCheckboxComponent, ItInputComponent, ItPasswordInputComponent, ItRadioButtonComponent, ItRangeComponent, ItRatingComponent, ItSelectComponent, ItTextareaComponent, ItTransferComponent, ItUploadDragDropComponent, ItUploadFileListComponent];
class ItFormModule {
  static {
    this.ɵfac = function ItFormModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItFormModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ItFormModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [formComponents]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItFormModule, [{
    type: NgModule,
    args: [{
      imports: formComponents,
      exports: formComponents
    }]
  }], null, null);
})();
class ItBackButtonComponent {
  constructor(_location) {
    this._location = _location;
    /**
     * Back button style
     * - <b>link</b>: use a link with icon and text
     * - <b>button</b>: use a button with icon and text
     * @default button
     */
    this.buttonStyle = 'button';
    /**
     * Button direction
     * - <b>left</b>: Back direction
     * - <b>up</b>: Upper direction
     * @default left
     */
    this.direction = 'left';
    /**
     * Show/Hide icon
     * @default true
     */
    this.showIcon = true;
    /**
     * Show/Hide text
     * @default true
     */
    this.showText = true;
  }
  /**
   * Go back function
   */
  goBack(event) {
    event.preventDefault();
    if (this.backFn) {
      return this.backFn(this._location);
    }
    this._location.back();
  }
  static {
    this.ɵfac = function ItBackButtonComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItBackButtonComponent)(i0.ɵɵdirectiveInject(i1$3.Location));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItBackButtonComponent,
      selectors: [["it-back-button"]],
      inputs: {
        buttonStyle: "buttonStyle",
        direction: "direction",
        showIcon: [2, "showIcon", "showIcon", inputToBoolean],
        showText: [2, "showText", "showText", inputToBoolean],
        backFn: "backFn"
      },
      exportAs: ["itBackButton"],
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵStandaloneFeature],
      decls: 4,
      vars: 2,
      consts: [["content", ""], ["href", "#", 1, "go-back"], ["itButton", "primary", 1, "go-back"], ["href", "#", 1, "go-back", 3, "click"], [4, "ngTemplateOutlet"], ["itButton", "primary", 1, "go-back", 3, "click"], ["size", "sm", 3, "name", "color", "me-2"], ["size", "sm", 3, "name", "color"]],
      template: function ItBackButtonComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ItBackButtonComponent_Conditional_0_Template, 2, 1, "a", 1)(1, ItBackButtonComponent_Conditional_1_Template, 2, 1, "button", 2)(2, ItBackButtonComponent_ng_template_2_Template, 4, 6, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx.buttonStyle === "link" ? 0 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.buttonStyle === "button" ? 1 : -1);
        }
      },
      dependencies: [NgTemplateOutlet, ItButtonDirective, ItIconComponent, TranslateModule, i1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItBackButtonComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-back-button',
      exportAs: 'itBackButton',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [NgTemplateOutlet, ItButtonDirective, ItIconComponent, TranslateModule],
      template: "@if (buttonStyle === 'link') {\n  <a href=\"#\" class=\"go-back\" (click)=\"goBack($event)\">\n    <ng-container *ngTemplateOutlet=\"content\"></ng-container>\n  </a>\n}\n\n@if (buttonStyle === 'button') {\n  <button itButton=\"primary\" class=\"go-back\" (click)=\"goBack($event)\">\n    <ng-container *ngTemplateOutlet=\"content\"></ng-container>\n  </button>\n}\n\n<ng-template #content>\n  @if (showIcon) {\n    <it-icon\n      size=\"sm\"\n      [name]=\"direction === 'left' ? 'arrow-left' : 'arrow-up'\"\n      [color]=\"buttonStyle === 'link' ? 'primary' : 'white'\"\n      [class.me-2]=\"showText\"></it-icon>\n  }\n\n  <span [class.visually-hidden]=\"!showText\">\n    {{ (direction === 'left' ? 'it.navigation.go-back' : 'it.navigation.upper-level') | translate }}\n  </span>\n</ng-template>\n"
    }]
  }], () => [{
    type: i1$3.Location
  }], {
    buttonStyle: [{
      type: Input
    }],
    direction: [{
      type: Input
    }],
    showIcon: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    showText: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    backFn: [{
      type: Input
    }]
  });
})();
class ItBackToTopComponent extends ItAbstractComponent {
  constructor() {
    super(...arguments);
    /**
     * Aria label for the component
     * @default 'Torna su'
     */
    this.ariaLabel = 'Torna su';
  }
  ngAfterViewInit() {
    super.ngAfterViewInit();
    if (this.backToTopElement) {
      const element = this.backToTopElement.nativeElement;
      this.backToTop = BackToTop.getOrCreateInstance(element);
    }
  }
  /**
   * Show button
   */
  show() {
    this.backToTop?.show();
  }
  /**
   * Hide the button
   */
  hide() {
    this.backToTop?.hide();
  }
  /**
   * Activates the scroll animation towards the Y coordinate indicated by the positionTop option
   */
  scrollToTop() {
    this.backToTop?.scrollToTop();
  }
  /**
   * Eliminate component features
   */
  dispose() {
    this.backToTop?.dispose();
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵItBackToTopComponent_BaseFactory;
      return function ItBackToTopComponent_Factory(__ngFactoryType__) {
        return (ɵItBackToTopComponent_BaseFactory || (ɵItBackToTopComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ItBackToTopComponent)))(__ngFactoryType__ || ItBackToTopComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItBackToTopComponent,
      selectors: [["it-back-to-top"]],
      viewQuery: function ItBackToTopComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c50, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.backToTopElement = _t.first);
        }
      },
      inputs: {
        ariaLabel: "ariaLabel",
        small: [2, "small", "small", inputToBoolean],
        shadow: [2, "shadow", "shadow", inputToBoolean],
        dark: [2, "dark", "dark", inputToBoolean]
      },
      exportAs: ["itBackToTop"],
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
      decls: 3,
      vars: 9,
      consts: [["backToTop", ""], ["href", "#", 1, "back-to-top", 3, "id"], ["name", "arrow-up", 3, "color"]],
      template: function ItBackToTopComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "a", 1, 0);
          i0.ɵɵelement(2, "it-icon", 2);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵclassProp("back-to-top-small", ctx.small)("shadow", ctx.shadow)("dark", ctx.dark);
          i0.ɵɵproperty("id", ctx.id);
          i0.ɵɵattribute("aria-label", ctx.ariaLabel);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("color", ctx.dark ? "secondary" : "light");
        }
      },
      dependencies: [ItIconComponent],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItBackToTopComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-back-to-top',
      exportAs: 'itBackToTop',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [ItIconComponent],
      template: "<a\n  #backToTop\n  [id]=\"id\"\n  href=\"#\"\n  [attr.aria-label]=\"ariaLabel\"\n  class=\"back-to-top\"\n  [class.back-to-top-small]=\"small\"\n  [class.shadow]=\"shadow\"\n  [class.dark]=\"dark\">\n  <it-icon name=\"arrow-up\" [color]=\"dark ? 'secondary' : 'light'\"></it-icon>\n</a>\n"
    }]
  }], null, {
    ariaLabel: [{
      type: Input
    }],
    small: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    shadow: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    dark: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    backToTopElement: [{
      type: ViewChild,
      args: ['backToTop']
    }]
  });
})();
class ItBreadcrumbItemComponent extends ItLinkComponent {
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵItBreadcrumbItemComponent_BaseFactory;
      return function ItBreadcrumbItemComponent_Factory(__ngFactoryType__) {
        return (ɵItBreadcrumbItemComponent_BaseFactory || (ɵItBreadcrumbItemComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ItBreadcrumbItemComponent)))(__ngFactoryType__ || ItBreadcrumbItemComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItBreadcrumbItemComponent,
      selectors: [["it-breadcrumb-item"]],
      viewQuery: function ItBreadcrumbItemComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(TemplateRef, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.htmlContent = _t.first);
        }
      },
      inputs: {
        active: [2, "active", "active", inputToBoolean],
        iconName: "iconName"
      },
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function ItBreadcrumbItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, ItBreadcrumbItemComponent_ng_template_0_Template, 1, 0, "ng-template");
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItBreadcrumbItemComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-breadcrumb-item',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [],
      template: "<ng-template>\n  <ng-content></ng-content>\n</ng-template>\n"
    }]
  }], null, {
    active: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    iconName: [{
      type: Input
    }],
    htmlContent: [{
      type: ViewChild,
      args: [TemplateRef]
    }]
  });
})();
class ItBreadcrumbComponent {
  constructor(_changeDetectorRef) {
    this._changeDetectorRef = _changeDetectorRef;
    /**
     * The character to use as separator
     * @default /
     */
    this.separator = '/';
  }
  ngAfterViewInit() {
    this.items?.changes.pipe(
    // When breadcrumb items changes (dynamic add/remove)
    startWith(undefined)).subscribe(() => {
      this.itemSubscriptions?.forEach(sub => sub.unsubscribe()); // Remove old subscriptions
      this.itemSubscriptions = this.items?.map(item => item.valueChanges.subscribe(() => {
        this._changeDetectorRef.detectChanges(); // DetectChanges when breadcrumb item attributes changes
      }));
      this._changeDetectorRef.detectChanges(); // Force update html render
    });
  }
  ngOnDestroy() {
    this.itemSubscriptions?.forEach(item => item.unsubscribe());
  }
  static {
    this.ɵfac = function ItBreadcrumbComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItBreadcrumbComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItBreadcrumbComponent,
      selectors: [["it-breadcrumb"]],
      contentQueries: function ItBreadcrumbComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, ItBreadcrumbItemComponent, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.items = _t);
        }
      },
      inputs: {
        separator: "separator",
        dark: [2, "dark", "dark", inputToBoolean]
      },
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵStandaloneFeature],
      decls: 3,
      vars: 4,
      consts: [[1, "breadcrumb-container"], [1, "breadcrumb", 3, "dark", "px-3"], [1, "breadcrumb"], [1, "breadcrumb-item", 3, "active"], [1, "breadcrumb-item"], ["size", "sm", "svgClass", "align-top me-1", 3, "name", "color"], [3, "href", "class", "externalLink", "disabled"], [1, "separator"], [3, "href", "externalLink", "disabled"], [4, "ngTemplateOutlet"]],
      template: function ItBreadcrumbComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "nav", 0);
          i0.ɵɵpipe(1, "translate");
          i0.ɵɵtemplate(2, ItBreadcrumbComponent_Conditional_2_Template, 3, 4, "ol", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 2, "it.navigation.navigation-path"));
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx.items ? 2 : -1);
        }
      },
      dependencies: [TranslateModule, i1.TranslatePipe, ItIconComponent, ItLinkComponent, NgTemplateOutlet],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItBreadcrumbComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-breadcrumb',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [TranslateModule, ItIconComponent, ItLinkComponent, NgTemplateOutlet],
      template: "<nav class=\"breadcrumb-container\" [attr.aria-label]=\"'it.navigation.navigation-path' | translate\">\n  @if (items) {\n    <ol class=\"breadcrumb\" [class.dark]=\"dark\" [class.px-3]=\"dark\">\n      @for (item of items; track item; let isLast = $last) {\n        <li class=\"breadcrumb-item\" [class.active]=\"item.active\" [attr.aria-current]=\"item.active ? 'page' : null\">\n          @if (item.iconName) {\n            <it-icon [name]=\"item.iconName\" [color]=\"dark ? 'white' : 'secondary'\" size=\"sm\" svgClass=\"align-top me-1\"></it-icon>\n          }\n          @if (!item.active && !isLast) {\n            <it-link [href]=\"item.href\" [class]=\"item.class\" [externalLink]=\"item.externalLink\" [disabled]=\"item.disabled\">\n              <ng-container *ngTemplateOutlet=\"item.htmlContent\"></ng-container>\n            </it-link>\n          } @else {\n            <ng-container *ngTemplateOutlet=\"item.htmlContent\"></ng-container>\n          }\n          @if (!isLast) {\n            <span class=\"separator\">{{ separator }}</span>\n          }\n        </li>\n      }\n    </ol>\n  }\n</nav>\n"
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }], {
    separator: [{
      type: Input
    }],
    dark: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    items: [{
      type: ContentChildren,
      args: [ItBreadcrumbItemComponent]
    }]
  });
})();
const breadcrumb = [ItBreadcrumbComponent, ItBreadcrumbItemComponent];
class ItBreadcrumbsModule {
  static {
    this.ɵfac = function ItBreadcrumbsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItBreadcrumbsModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ItBreadcrumbsModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [ItBreadcrumbComponent]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItBreadcrumbsModule, [{
    type: NgModule,
    args: [{
      imports: breadcrumb,
      exports: breadcrumb
    }]
  }], null, null);
})();
class ItNavBarComponent {
  constructor() {
    this.expand = true;
  }
  ngAfterViewInit() {
    if (this.collapseButton && this.collapseView) {
      this.navbar = NavBarCollapsible.getOrCreateInstance(this.collapseView.nativeElement);
    }
  }
  toggleCollapse() {
    this.navbar?.toggle(this.collapseButton?.nativeElement);
  }
  static {
    this.ɵfac = function ItNavBarComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItNavBarComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItNavBarComponent,
      selectors: [["it-navbar"]],
      viewQuery: function ItNavBarComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c51, 5);
          i0.ɵɵviewQuery(_c52, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.collapseButton = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.collapseView = _t.first);
        }
      },
      inputs: {
        megamenu: [2, "megamenu", "megamenu", inputToBoolean],
        expand: [2, "expand", "expand", inputToBoolean]
      },
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c54,
      decls: 18,
      vars: 13,
      consts: [["collapseButton", ""], ["collapseView", ""], [1, "navbar"], ["type", "button", 1, "custom-navbar-toggler", 3, "click"], ["name", "burger"], [1, "navbar-collapsable", 2, "display", "none"], [1, "overlay", 2, "display", "none"], [1, "close-div"], ["type", "button", 1, "btn", "close-menu"], [1, "visually-hidden"], ["name", "close-big"], [1, "menu-wrapper"], [1, "navbar-nav"]],
      template: function ItNavBarComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵprojectionDef(_c53);
          i0.ɵɵelementStart(0, "nav", 2);
          i0.ɵɵpipe(1, "translate");
          i0.ɵɵelementStart(2, "button", 3, 0);
          i0.ɵɵpipe(4, "translate");
          i0.ɵɵlistener("click", function ItNavBarComponent_Template_button_click_2_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.toggleCollapse());
          });
          i0.ɵɵelement(5, "it-icon", 4);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(6, "div", 5, 1);
          i0.ɵɵelement(8, "div", 6);
          i0.ɵɵelementStart(9, "div", 7)(10, "button", 8)(11, "span", 9);
          i0.ɵɵtext(12);
          i0.ɵɵpipe(13, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelement(14, "it-icon", 10);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(15, "div", 11)(16, "ul", 12);
          i0.ɵɵprojection(17);
          i0.ɵɵelementEnd()()()();
        }
        if (rf & 2) {
          i0.ɵɵclassProp("navbar-expand-lg", ctx.expand)("has-megamenu", ctx.megamenu);
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 7, "it.navbar.aria-label-main"));
          i0.ɵɵadvance(2);
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(4, 9, "it.navbar.aria-label-toggle"));
          i0.ɵɵadvance(10);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(13, 11, "it.navbar.hide"));
        }
      },
      dependencies: [TranslateModule, i1.TranslatePipe, ItIconComponent],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItNavBarComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-navbar',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [TranslateModule, ItIconComponent, ItButtonDirective],
      template: "<nav\n  class=\"navbar\"\n  [class.navbar-expand-lg]=\"expand\"\n  [class.has-megamenu]=\"megamenu\"\n  [attr.aria-label]=\"'it.navbar.aria-label-main' | translate\">\n  <button\n    (click)=\"toggleCollapse()\"\n    #collapseButton\n    class=\"custom-navbar-toggler\"\n    type=\"button\"\n    [attr.aria-label]=\"'it.navbar.aria-label-toggle' | translate\">\n    <it-icon name=\"burger\"></it-icon>\n  </button>\n  <div #collapseView class=\"navbar-collapsable\" style=\"display: none\">\n    <div class=\"overlay\" style=\"display: none\"></div>\n    <div class=\"close-div\">\n      <button class=\"btn close-menu\" type=\"button\">\n        <span class=\"visually-hidden\">{{ 'it.navbar.hide' | translate }}</span>\n        <it-icon name=\"close-big\"></it-icon>\n      </button>\n    </div>\n    <div class=\"menu-wrapper\">\n      <ul class=\"navbar-nav\">\n        <ng-content select=\"[navItems]\"></ng-content>\n      </ul>\n    </div>\n  </div>\n</nav>\n"
    }]
  }], null, {
    megamenu: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    expand: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    collapseButton: [{
      type: ViewChild,
      args: ['collapseButton']
    }],
    collapseView: [{
      type: ViewChild,
      args: ['collapseView']
    }]
  });
})();
class ItNavBarItemComponent {
  static {
    this.ɵfac = function ItNavBarItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItNavBarItemComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItNavBarItemComponent,
      selectors: [["it-navbar-item"]],
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c1,
      decls: 2,
      vars: 0,
      consts: [[1, "nav-item"]],
      template: function ItNavBarItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "li", 0);
          i0.ɵɵprojection(1);
          i0.ɵɵelementEnd();
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItNavBarItemComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-navbar-item',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [],
      template: "<li class=\"nav-item\">\n  <ng-content></ng-content>\n</li>\n"
    }]
  }], null, null);
})();
const navbarComponents = [ItNavBarComponent, ItNavBarItemComponent];
class ItNavBarModule {
  static {
    this.ɵfac = function ItNavBarModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItNavBarModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ItNavBarModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [ItNavBarComponent]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItNavBarModule, [{
    type: NgModule,
    args: [{
      imports: navbarComponents,
      exports: navbarComponents
    }]
  }], null, null);
})();
class ItHeaderComponent {
  constructor() {
    this.showSlim = true;
    this.smallHeader = true;
    this.showSearch = true;
    this.slimTitleLink = '#';
    this.loginStyle = 'none';
    this.expand = true;
    this.loginClick = new EventEmitter();
    this.searchClick = new EventEmitter();
  }
  ngAfterViewInit() {
    this.updateListeners();
  }
  ngOnChanges(changes) {
    if (changes['sticky'] && changes['sticky'].currentValue == true && !changes['sticky'].firstChange) {
      this.updateListeners();
    }
    if (changes['sticky'] && changes['sticky'].currentValue == false) {
      this.stickyHeader?._elementObj?._unsetSticky();
      this.stickyHeader?._elementObj?.dispose();
      delete this.stickyHeader;
      this.stickyHeader = undefined;
    }
  }
  updateListeners() {
    if (!this.stickyHeader && this.headerWrapper && this.sticky) {
      this.stickyHeader = new HeaderSticky(this.headerWrapper.nativeElement);
    }
  }
  emitLoginClick(event) {
    event.preventDefault();
    this.loginClick.emit(event);
  }
  emitSearchClick(event) {
    event.preventDefault();
    this.searchClick.emit(event);
  }
  toggleCollapse() {
    this.itNavBarComponent?.toggleCollapse();
  }
  static {
    this.ɵfac = function ItHeaderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItHeaderComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItHeaderComponent,
      selectors: [["it-header"]],
      viewQuery: function ItHeaderComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c55, 5);
          i0.ɵɵviewQuery(ItNavBarComponent, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerWrapper = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.itNavBarComponent = _t.first);
        }
      },
      inputs: {
        light: [2, "light", "light", inputToBoolean],
        sticky: [2, "sticky", "sticky", inputToBoolean],
        showSlim: [2, "showSlim", "showSlim", inputToBoolean],
        smallHeader: [2, "smallHeader", "smallHeader", inputToBoolean],
        showSearch: [2, "showSearch", "showSearch", inputToBoolean],
        slimTitle: "slimTitle",
        slimTitleLink: "slimTitleLink",
        loginStyle: "loginStyle",
        megamenu: [2, "megamenu", "megamenu", inputToBoolean],
        expand: [2, "expand", "expand", inputToBoolean]
      },
      outputs: {
        loginClick: "loginClick",
        searchClick: "searchClick"
      },
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c57,
      decls: 21,
      vars: 12,
      consts: [["headerWrapper", ""], ["data-bs-position-type", "fixed", "data-bs-sticky-class-name", "is-sticky", "data-bs-target", "#header-nav-wrapper", 1, "it-header-wrapper"], [1, "it-header-slim-wrapper", 3, "theme-light"], [1, "it-nav-wrapper"], [1, "it-header-center-wrapper"], [1, "container"], [1, "row"], [1, "col-12"], [1, "it-header-center-content-wrapper"], [1, "it-brand-wrapper"], [1, "it-right-zone"], [1, "it-search-wrapper"], ["id", "header-nav-wrapper", 1, "it-header-navbar-wrapper"], [3, "megamenu", "expand"], ["navItems", ""], [1, "it-header-slim-wrapper"], [1, "container-xxl"], [1, "it-header-slim-wrapper-content"], [1, "d-none", "d-lg-block", "navbar-brand", 3, "href", "target"], [1, "nav-mobile"], ["data-bs-toggle", "collapse", "href", "#menuC1", "role", "button", "aria-expanded", "false", "aria-controls", "menuC1", 1, "it-opener", "d-lg-none"], ["name", "expand"], ["id", "menuC1", 1, "link-list-wrapper", "collapse"], [1, "it-header-slim-right-zone"], [1, "it-access-top-wrapper"], ["itButton", "primary", "href", "#", 1, "btn-full", "btn-icon"], ["href", "#", 1, "btn", "btn-primary", "btn-sm", 3, "click"], ["itButton", "primary", "href", "#", 1, "btn-full", "btn-icon", 3, "click"], [1, "rounded-icon"], ["name", "user", "color", "primary"], [1, "d-none", "d-lg-block"], [1, "d-none", "d-md-block"], ["href", "#", 1, "search-link", "rounded-icon", 3, "click"], ["name", "search"]],
      template: function ItHeaderComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c56);
          i0.ɵɵelementStart(0, "header", 1, 0);
          i0.ɵɵtemplate(2, ItHeaderComponent_Conditional_2_Template, 20, 11, "div", 2);
          i0.ɵɵelementStart(3, "div", 3)(4, "div", 4)(5, "div", 5)(6, "div", 6)(7, "div", 7)(8, "div", 8)(9, "div", 9);
          i0.ɵɵprojection(10);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(11, "div", 10);
          i0.ɵɵprojection(12, 1);
          i0.ɵɵtemplate(13, ItHeaderComponent_Conditional_13_Template, 7, 6, "div", 11);
          i0.ɵɵelementEnd()()()()()();
          i0.ɵɵelementStart(14, "div", 12)(15, "div", 5)(16, "div", 6)(17, "div", 7)(18, "it-navbar", 13);
          i0.ɵɵelementContainerStart(19, 14);
          i0.ɵɵprojection(20, 2);
          i0.ɵɵelementContainerEnd();
          i0.ɵɵelementEnd()()()()()()();
        }
        if (rf & 2) {
          i0.ɵɵclassProp("it-header-sticky", ctx.sticky);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx.showSlim ? 2 : -1);
          i0.ɵɵadvance(2);
          i0.ɵɵclassProp("it-small-header", ctx.smallHeader)("theme-light", ctx.light);
          i0.ɵɵadvance(9);
          i0.ɵɵconditional(ctx.showSearch ? 13 : -1);
          i0.ɵɵadvance();
          i0.ɵɵclassProp("theme-light-desk", ctx.light);
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("megamenu", ctx.megamenu)("expand", ctx.expand);
        }
      },
      dependencies: [TranslateModule, i1.TranslatePipe, ItIconComponent, ItButtonDirective, ItNavBarModule, ItNavBarComponent],
      styles: [".nav-mobile[_ngcontent-%COMP%]:has(.link-list-wrapper:empty){display:none}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItHeaderComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-header',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [TranslateModule, ItIconComponent, ItButtonDirective, ItNavBarModule],
      template: "<header\n  #headerWrapper\n  class=\"it-header-wrapper\"\n  [class.it-header-sticky]=\"sticky\"\n  data-bs-position-type=\"fixed\"\n  data-bs-sticky-class-name=\"is-sticky\"\n  data-bs-target=\"#header-nav-wrapper\">\n  @if (showSlim) {\n    <div class=\"it-header-slim-wrapper\" [class.theme-light]=\"light\">\n      <div class=\"container-xxl\">\n        <div class=\"row\">\n          <div class=\"col-12\">\n            <div class=\"it-header-slim-wrapper-content\">\n              <a class=\"d-none d-lg-block navbar-brand\" [href]=\"slimTitleLink\" [target]=\"slimTitleLink !== '#' ? '_blank' : '_self'\">\n                {{ slimTitle }}\n              </a>\n              <div class=\"nav-mobile\">\n                <nav [attr.aria-label]=\"'it.navigation.secondary-navigation' | translate\">\n                  <a\n                    class=\"it-opener d-lg-none\"\n                    data-bs-toggle=\"collapse\"\n                    href=\"#menuC1\"\n                    role=\"button\"\n                    aria-expanded=\"false\"\n                    aria-controls=\"menuC1\">\n                    <span>{{ slimTitle }}</span>\n                    <it-icon name=\"expand\"></it-icon>\n                  </a>\n                  <div class=\"link-list-wrapper collapse\" id=\"menuC1\">\n                    <ng-content select=\"[slimLinkList]\"></ng-content>\n                  </div>\n                </nav>\n              </div>\n              <div class=\"it-header-slim-right-zone\">\n                <ng-content select=\"[slimRightZone]\"></ng-content>\n                @if (loginStyle === 'default') {\n                  <div class=\"it-access-top-wrapper\">\n                    <a class=\"btn btn-primary btn-sm\" (click)=\"emitLoginClick($event)\" href=\"#\">\n                      {{ 'it.navigation.login' | translate }}\n                    </a>\n                  </div>\n                }\n                @if (loginStyle === 'full') {\n                  <a itButton=\"primary\" class=\"btn-full btn-icon\" (click)=\"emitLoginClick($event)\" href=\"#\">\n                    <span class=\"rounded-icon\">\n                      <it-icon name=\"user\" color=\"primary\"></it-icon>\n                    </span>\n                    <span class=\"d-none d-lg-block\">{{ 'it.navigation.full-login' | translate }}</span>\n                  </a>\n                }\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  }\n  <div class=\"it-nav-wrapper\">\n    <div class=\"it-header-center-wrapper\" [class.it-small-header]=\"smallHeader\" [class.theme-light]=\"light\">\n      <div class=\"container\">\n        <div class=\"row\">\n          <div class=\"col-12\">\n            <div class=\"it-header-center-content-wrapper\">\n              <div class=\"it-brand-wrapper\">\n                <ng-content select=\"[brand]\"></ng-content>\n              </div>\n              <div class=\"it-right-zone\">\n                <ng-content select=\"[rightZone]\"></ng-content>\n\n                @if (showSearch) {\n                  <div class=\"it-search-wrapper\">\n                    <span class=\"d-none d-md-block\">{{ 'it.navigation.search' | translate }}</span>\n                    <a\n                      href=\"#\"\n                      class=\"search-link rounded-icon\"\n                      [attr.aria-label]=\"'it.navigation.website-search' | translate\"\n                      (click)=\"emitSearchClick($event)\">\n                      <it-icon name=\"search\"></it-icon>\n                    </a>\n                  </div>\n                }\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"it-header-navbar-wrapper\" [class.theme-light-desk]=\"light\" id=\"header-nav-wrapper\">\n      <div class=\"container\">\n        <div class=\"row\">\n          <div class=\"col-12\">\n            <it-navbar [megamenu]=\"megamenu\" [expand]=\"expand\">\n              <ng-container navItems>\n                <ng-content select=\"[navItems]\"></ng-content>\n              </ng-container>\n            </it-navbar>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</header>\n",
      styles: [".nav-mobile:has(.link-list-wrapper:empty){display:none}\n"]
    }]
  }], () => [], {
    light: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    sticky: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    showSlim: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    smallHeader: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    showSearch: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    slimTitle: [{
      type: Input
    }],
    slimTitleLink: [{
      type: Input
    }],
    loginStyle: [{
      type: Input
    }],
    loginClick: [{
      type: Output
    }],
    searchClick: [{
      type: Output
    }],
    headerWrapper: [{
      type: ViewChild,
      args: ['headerWrapper']
    }],
    itNavBarComponent: [{
      type: ViewChild,
      args: [ItNavBarComponent]
    }],
    megamenu: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    expand: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }]
  });
})();
class ItMegamenuComponent {
  constructor() {
    /**
     * Megamenu mode
     */
    this.mode = 'normal';
  }
  static {
    this.ɵfac = function ItMegamenuComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItMegamenuComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItMegamenuComponent,
      selectors: [["it-megamenu"]],
      inputs: {
        mode: "mode",
        header: [2, "header", "header", inputToBoolean],
        footer: [2, "footer", "footer", inputToBoolean]
      },
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c59,
      decls: 8,
      vars: 5,
      consts: [[1, "megamenu", "pb-5", "pt-3", "py-lg-0"], [1, "row"], [1, "col-xs-12", "col-lg-4", "px-0"], [1, "col-12"], [1, "it-heading-link-wrapper"], [3, "col-xs-12", "col-lg-4", "px-0"], [1, "col-12", "it-vertical", "it-description", "pb-lg-3"], [1, "description-content", "ps-4", "ps-sm-5", "ms-3"], [1, "d-flex", "flex-column", "justify-content-around"]],
      template: function ItMegamenuComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c58);
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
          i0.ɵɵtemplate(2, ItMegamenuComponent_Conditional_2_Template, 5, 0, "div", 2);
          i0.ɵɵelementStart(3, "div", 3);
          i0.ɵɵtemplate(4, ItMegamenuComponent_Conditional_4_Template, 2, 0, "div", 4);
          i0.ɵɵelementStart(5, "div", 1);
          i0.ɵɵprojection(6);
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(7, ItMegamenuComponent_Conditional_7_Template, 4, 12, "div", 5);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx.mode === "left-section" ? 2 : -1);
          i0.ɵɵadvance();
          i0.ɵɵclassProp("col-lg-8", ctx.mode !== "normal");
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.header ? 4 : -1);
          i0.ɵɵadvance(3);
          i0.ɵɵconditional(ctx.footer || ctx.mode === "right-section" ? 7 : -1);
        }
      },
      styles: [".theme-light-desk .nav-link:before{background-color:#06c}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItMegamenuComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-megamenu',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [NgTemplateOutlet],
      template: "<div class=\"megamenu pb-5 pt-3 py-lg-0\">\n  <div class=\"row\">\n    @if (mode === 'left-section') {\n      <div class=\"col-xs-12 col-lg-4 px-0\">\n        <div class=\"row\">\n          <div class=\"col-12 it-vertical it-description pb-lg-3\">\n            <div class=\"description-content ps-4 ps-sm-5 ms-3\">\n              <ng-content select=\"[megamenuLeftZone]\"></ng-content>\n            </div>\n          </div>\n        </div>\n      </div>\n    }\n    <div class=\"col-12\" [class.col-lg-8]=\"mode !== 'normal'\">\n      @if (header) {\n        <div class=\"it-heading-link-wrapper\">\n          <ng-content select=\"[megamenuHeadingLink]\"></ng-content>\n        </div>\n      }\n      <div class=\"row\">\n        <ng-content select=\"[megamenuLinkList]\"></ng-content>\n      </div>\n    </div>\n    @if (footer || mode === 'right-section') {\n      <div [class.col-xs-12]=\"mode === 'right-section'\" [class.col-lg-4]=\"mode === 'right-section'\" [class.px-0]=\"mode === 'right-section'\">\n        <div [class.it-footer-link-wrapper]=\"footer\" [class.it-footer-link-wrapper-vertical]=\"mode === 'right-section'\">\n          <div class=\"d-flex flex-column justify-content-around\" [class.flex-lg-row]=\"mode !== 'right-section'\">\n            <ng-content select=\"[megamenuFooter]\"></ng-content>\n          </div>\n        </div>\n      </div>\n    }\n  </div>\n</div>\n",
      styles: ["::ng-deep .theme-light-desk .nav-link:before{background-color:#06c}\n"]
    }]
  }], null, {
    mode: [{
      type: Input
    }],
    header: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    footer: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }]
  });
})();
function searchFn(items, item) {
  //ricerca
  const nodes = Array.from(items);
  const parent = nodes.find(i => i.childs.includes(item));
  const ancestors = parent?.childs?.length ? searchFn(items, parent) : [];
  return [item, ...ancestors];
}
function flattenNavscrollItemsFn(items) {
  const result = [];
  function flatten(items) {
    for (const item of items) {
      result.push(item);
      if (item.childs && item.childs.length > 0) {
        flatten(item.childs);
      }
    }
  }
  flatten(items);
  return result;
}
const search = searchFn;
const flattenNavscrollItems = flattenNavscrollItemsFn;
class NavscrollStore {
  constructor() {
    this.#state = new BehaviorSubject({
      items: new Set(),
      active: [],
      selected: undefined,
      progressBar: 0,
      isMobile: false
    });
    this.#state$ = this.#state.asObservable();
    this.selected = this.#state$.pipe(map(({
      selected
    }) => selected), distinctUntilChanged());
    this.progressBar = this.#state$.pipe(map(({
      progressBar
    }) => progressBar), distinctUntilChanged());
    this.isMobile = this.#state$.pipe(map(({
      isMobile
    }) => isMobile), distinctUntilChanged());
    this.#menuItemSelected = new Subject();
    this.menuItemSelected = this.#menuItemSelected.asObservable();
  }
  #state;
  #state$;
  #menuItemSelected;
  init(navscrollItems) {
    const flattenItems = flattenNavscrollItems(navscrollItems);
    //the first item is selected by default
    const selected = (flattenItems && flattenItems.length && flattenItems[0]) ?? undefined;
    const state = {
      items: new Set(flattenItems),
      active: selected ? [selected] : [],
      selected: selected,
      progressBar: 0,
      isMobile: false
    };
    this.#state.next(state);
  }
  setActive(item) {
    const {
      items
    } = this.#state.value;
    const active = search(items, item);
    const state = this.#state.value;
    this.#state.next({
      ...state,
      items,
      selected: item,
      active
    });
  }
  isActive$(item) {
    return this.#state.asObservable().pipe(map(state => state.active.includes(item)));
  }
  updateProgressBar(container) {
    if (!container) {
      return;
    }
    const offset = Math.abs(container.getBoundingClientRect().top);
    const height = container.getBoundingClientRect().height;
    const scrollAmount = offset / height * 100;
    const scrollValue = Math.min(100, Math.max(0, scrollAmount));
    const state = this.#state.value;
    this.#state.next({
      ...state,
      progressBar: scrollValue
    });
  }
  selectMenuItem() {
    this.#menuItemSelected.next(undefined);
  }
  setMobile({
    innerWidth
  }) {
    const isLessThan992px = innerWidth < 992;
    const isMobile = isLessThan992px;
    const state = this.#state.value;
    this.#state.next({
      ...state,
      isMobile
    });
  }
}
const ROUTER_LINK_ACTIVE_OPTIONS = {
  fragment: 'exact',
  paths: 'exact',
  queryParams: 'exact',
  matrixParams: 'exact'
};
class ItNavscrollListItemComponent {
  constructor() {
    this.checkActive = new EventEmitter();
    this.routerLinkActiveOptions = ROUTER_LINK_ACTIVE_OPTIONS;
    this.#initIsActive = new AsyncSubject();
    this.active = this.#initIsActive.asObservable().pipe(switchMap(item => this.#store.isActive$(item)));
    this.#router = inject(Router);
    this.#store = inject(NavscrollStore);
    this.#destroyRef = inject(DestroyRef);
  }
  #initIsActive;
  #router;
  #store;
  #destroyRef;
  ngOnInit() {
    this.#initIsActiveSub();
    this.#router.events.pipe(takeUntilDestroyed(this.#destroyRef), filter(event => {
      const isNavigationEndEvent = event instanceof NavigationEnd;
      const isScrollEvent = event instanceof Scroll && event.routerEvent instanceof NavigationEnd;
      return isNavigationEndEvent || isScrollEvent;
    }), tap(() => {
      if (this.rtl?.isActive) {
        this.#store.setActive(this.item);
      }
    })).subscribe();
  }
  clickHandler(event) {
    event.preventDefault();
    this.#store.selectMenuItem();
    this.#router.navigate([], {
      fragment: this.item.href
    });
  }
  #initIsActiveSub() {
    this.#initIsActive.next(this.item);
    this.#initIsActive.complete();
  }
  static {
    this.ɵfac = function ItNavscrollListItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItNavscrollListItemComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItNavscrollListItemComponent,
      selectors: [["it-navscroll-list-item"]],
      viewQuery: function ItNavscrollListItemComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c60, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rtl = _t.first);
        }
      },
      inputs: {
        item: "item"
      },
      outputs: {
        checkActive: "checkActive"
      },
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      decls: 5,
      vars: 9,
      consts: [["rtl", "routerLinkActive"], ["routerLinkActive", "", "ariaCurrentWhenActive", "page", 1, "nav-link", 3, "click", "routerLink", "fragment", "routerLinkActiveOptions"]],
      template: function ItNavscrollListItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "a", 1, 0);
          i0.ɵɵpipe(2, "async");
          i0.ɵɵlistener("click", function ItNavscrollListItemComponent_Template_a_click_0_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.clickHandler($event));
          });
          i0.ɵɵelementStart(3, "span");
          i0.ɵɵtext(4);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵclassProp("active", i0.ɵɵpipeBind1(2, 6, ctx.active));
          i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction0(8, _c61))("fragment", ctx.item == null ? null : ctx.item.href)("routerLinkActiveOptions", ctx.routerLinkActiveOptions);
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate(ctx.item == null ? null : ctx.item.title);
        }
      },
      dependencies: [RouterLink, RouterLinkActive, AsyncPipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItNavscrollListItemComponent, [{
    type: Component,
    args: [{
      selector: 'it-navscroll-list-item',
      standalone: true,
      imports: [RouterLink, RouterLinkActive, RouterLinkWithHref, ItNavscrollListItemsComponent, AsyncPipe],
      changeDetection: ChangeDetectionStrategy.OnPush,
      template: `
    <a
      class="nav-link"
      [class.active]="active | async"
      [routerLink]="[]"
      routerLinkActive
      [fragment]="item?.href"
      [routerLinkActiveOptions]="routerLinkActiveOptions"
      ariaCurrentWhenActive="page"
      #rtl="routerLinkActive"
      (click)="clickHandler($event)"
      ><span>{{ item?.title }}</span></a
    >
  `
    }]
  }], null, {
    item: [{
      type: Input
    }],
    checkActive: [{
      type: Output
    }],
    rtl: [{
      type: ViewChild,
      args: ['rtl']
    }]
  });
})();
class ItNavscrollListItemsComponent {
  static {
    this.ɵfac = function ItNavscrollListItemsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItNavscrollListItemsComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItNavscrollListItemsComponent,
      selectors: [["it-navscroll-list-items"]],
      inputs: {
        items: "items"
      },
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      decls: 3,
      vars: 0,
      consts: [[1, "link-list"], [1, "nav-item"], [3, "item"], [3, "items"]],
      template: function ItNavscrollListItemsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "ul", 0);
          i0.ɵɵrepeaterCreate(1, ItNavscrollListItemsComponent_For_2_Template, 3, 2, "li", 1, _forTrack2);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵrepeater(ctx.items);
        }
      },
      dependencies: [ItNavscrollListItemsComponent, ItNavscrollListItemComponent],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItNavscrollListItemsComponent, [{
    type: Component,
    args: [{
      selector: 'it-navscroll-list-items',
      standalone: true,
      imports: [NgTemplateOutlet, RouterLink, RouterLinkActive, RouterLinkWithHref, JsonPipe, ItNavscrollListItemComponent],
      changeDetection: ChangeDetectionStrategy.OnPush,
      template: `
    <ul class="link-list">
      @for (item of items; track item.href) {
        <li class="nav-item">
          <it-navscroll-list-item [item]="item"></it-navscroll-list-item>
          @if (item.childs?.length) {
            <it-navscroll-list-items [items]="item.childs"></it-navscroll-list-items>
          }
        </li>
      }
    </ul>
  `
    }]
  }], null, {
    items: [{
      type: Input
    }]
  });
})();

/**
 * Navscroll
 * @description Show a list of links to anchor of the document.
 */
class ItNavscrollComponent {
  onScroll() {
    const sectionContainer = this.#elementRef.nativeElement.querySelector('.it-page-sections-container');
    this.#store.updateProgressBar(sectionContainer);
  }
  onResize() {
    this.#setMobile();
  }
  #store;
  #scroller;
  #destroyRef;
  #elementRef;
  constructor() {
    /**
     * Header of the Navscroll
     */
    this.header = '';
    /**
     * Border position
     * @default left
     */
    this.borderPosition = 'left';
    /**
     * Alignment
     * @default top
     */
    this.alignment = 'top';
    /**
     * Theme
     * @default light
     */
    this.theme = 'light';
    this.#store = inject(NavscrollStore);
    this.#scroller = inject(ViewportScroller);
    this.#destroyRef = inject(DestroyRef);
    this.#elementRef = inject(ElementRef);
    this.selectedTitle = this.#store.selected.pipe(map(selected => selected?.title ?? ''));
    this.progressBarValue = this.#store.progressBar;
    this.isMobile = this.#store.isMobile;
    this.#store.menuItemSelected.pipe(takeUntilDestroyed(), withLatestFrom(this.isMobile), tap(v => {
      const isMobile = v[1];
      if (isMobile) {
        this.toggleButtonRef.nativeElement.click();
      }
    })).subscribe();
  }
  ngOnInit() {
    this.#initViewScrollerSubscription();
    this.#store.init(this.items);
    this.#setMobile();
  }
  #initViewScrollerSubscription() {
    this.#store.selected.pipe(takeUntilDestroyed(this.#destroyRef), filter(selected => Boolean(selected)), map(v => v), delay(0),
    //WA
    tap({
      next: ({
        href
      }) => {
        this.#scroller.scrollToAnchor(href);
      }
    })).subscribe();
  }
  #setMobile() {
    this.#store.setMobile(window);
  }
  static {
    this.ɵfac = function ItNavscrollComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItNavscrollComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItNavscrollComponent,
      selectors: [["it-navscroll"]],
      viewQuery: function ItNavscrollComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c62, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.toggleButtonRef = _t.first);
        }
      },
      hostBindings: function ItNavscrollComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("scroll", function ItNavscrollComponent_scroll_HostBindingHandler($event) {
            return ctx.onScroll($event);
          }, false, i0.ɵɵresolveWindow)("resize", function ItNavscrollComponent_resize_HostBindingHandler($event) {
            return ctx.onResize($event);
          }, false, i0.ɵɵresolveWindow);
        }
      },
      inputs: {
        header: "header",
        items: "items",
        borderPosition: "borderPosition",
        alignment: "alignment",
        theme: "theme",
        pageSectionsTemplate: "pageSectionsTemplate"
      },
      standalone: true,
      features: [i0.ɵɵProvidersFeature([NavscrollStore]), i0.ɵɵStandaloneFeature],
      decls: 41,
      vars: 40,
      consts: [["toggleButtonRef", ""], ["defaultPageSectionsTemplate", ""], ["paragraphTemplate", ""], [1, "container", "py-lg-5"], [1, "row"], [1, "col-12", "col-lg-4"], ["data-bs-stackable", "true", 1, "it-navscroll-sticky", 3, "ngClass"], [1, "navbar", "it-navscroll-wrapper", "navbar-expand-lg"], ["type", "button", "aria-controls", "navbarNav", "aria-expanded", "false", "aria-label", "Toggle navigation", "data-bs-toggle", "navbarcollapsible", "data-bs-target", "#navbarNav", 1, "custom-navbar-toggler"], [1, "it-list"], [1, "progress", "custom-navbar-progressbar"], ["role", "progressbar", "aria-valuemin", "0", "aria-valuemax", "100", 1, "progress-bar", "it-navscroll-progressbar"], ["id", "navbarNav", 1, "navbar-collapsable"], [1, "overlay"], [1, "close-div", "visually-hidden"], ["type", "button", 1, "btn", "close-menu"], [1, "it-close"], ["type", "button", 1, "it-back-button", "btn", "w-100", "text-start"], [1, "icon", "icon-sm", "icon-primary", "align-top"], ["href", "/bootstrap-italia/dist/svg/sprites.svg#it-chevron-left", 0, "xlink", "href", "/bootstrap-italia/dist/svg/sprites.svg#it-chevron-left"], [1, "menu-wrapper"], [1, "link-list-wrapper"], [1, "progress"], [3, "items"], [1, "col-12", "col-lg-8", "it-page-sections-container"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "it-page-section", 3, "id"]],
      template: function ItNavscrollComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 3)(1, "div", 4)(2, "div", 5)(3, "div", 6);
          i0.ɵɵpipe(4, "async");
          i0.ɵɵelementStart(5, "nav", 7)(6, "button", 8, 0);
          i0.ɵɵelement(8, "span", 9);
          i0.ɵɵtext(9);
          i0.ɵɵpipe(10, "async");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(11, "div", 10);
          i0.ɵɵelement(12, "div", 11);
          i0.ɵɵpipe(13, "async");
          i0.ɵɵpipe(14, "async");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(15, "div", 12);
          i0.ɵɵelement(16, "div", 13);
          i0.ɵɵelementStart(17, "div", 14)(18, "button", 15);
          i0.ɵɵelement(19, "span", 16);
          i0.ɵɵtext(20, "Chiudi");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(21, "button", 17);
          i0.ɵɵnamespaceSVG();
          i0.ɵɵelementStart(22, "svg", 18);
          i0.ɵɵelement(23, "use", 19);
          i0.ɵɵelementEnd();
          i0.ɵɵnamespaceHTML();
          i0.ɵɵelementStart(24, "span");
          i0.ɵɵtext(25, "Indietro");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(26, "div", 20)(27, "div", 21)(28, "h3");
          i0.ɵɵtext(29);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(30, "div", 22);
          i0.ɵɵelement(31, "div", 11);
          i0.ɵɵpipe(32, "async");
          i0.ɵɵpipe(33, "async");
          i0.ɵɵelementEnd();
          i0.ɵɵelement(34, "it-navscroll-list-items", 23);
          i0.ɵɵelementEnd()()()()()();
          i0.ɵɵelementStart(35, "div", 24);
          i0.ɵɵtemplate(36, ItNavscrollComponent_ng_container_36_Template, 1, 0, "ng-container", 25);
          i0.ɵɵelementEnd()()();
          i0.ɵɵtemplate(37, ItNavscrollComponent_ng_template_37_Template, 2, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(39, ItNavscrollComponent_ng_template_39_Template, 9, 2, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          const defaultPageSectionsTemplate_r8 = i0.ɵɵreference(38);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(36, _c63, i0.ɵɵpipeBind1(4, 24, ctx.isMobile)));
          i0.ɵɵadvance(2);
          i0.ɵɵclassProp("it-top-navscroll", ctx.alignment === "top")("it-bottom-navscroll", ctx.alignment === "bottom")("it-left-side", ctx.borderPosition === "left")("it-right-side", ctx.borderPosition === "right")("theme-dark-mobile", ctx.theme === "dark")("theme-dark-desktop", ctx.theme === "dark");
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(10, 26, ctx.selectedTitle), " ");
          i0.ɵɵadvance(3);
          i0.ɵɵstyleProp("width", i0.ɵɵpipeBind1(13, 28, ctx.progressBarValue), "%");
          i0.ɵɵattribute("aria-valuenow", i0.ɵɵpipeBind1(14, 30, ctx.progressBarValue));
          i0.ɵɵadvance(17);
          i0.ɵɵtextInterpolate(ctx.header);
          i0.ɵɵadvance(2);
          i0.ɵɵstyleProp("width", i0.ɵɵpipeBind1(32, 32, ctx.progressBarValue), "%");
          i0.ɵɵattribute("aria-valuenow", i0.ɵɵpipeBind1(33, 34, ctx.progressBarValue));
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("items", ctx.items);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngTemplateOutlet", ctx.pageSectionsTemplate ? ctx.pageSectionsTemplate : defaultPageSectionsTemplate_r8)("ngTemplateOutletContext", i0.ɵɵpureFunction1(38, _c64, ctx.items));
        }
      },
      dependencies: [ItNavscrollListItemsComponent, AsyncPipe, NgTemplateOutlet, NgClass],
      styles: [".it-navscroll-sticky[_ngcontent-%COMP%]{position:sticky;top:0}.it-navscroll-sticky-mobile[_ngcontent-%COMP%]{z-index:1020}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItNavscrollComponent, [{
    type: Component,
    args: [{
      selector: 'it-navscroll',
      standalone: true,
      imports: [ItNavscrollListItemsComponent, AsyncPipe, NgTemplateOutlet, RouterLink, RouterLinkActive, RouterLinkWithHref, AsyncPipe, NgClass],
      changeDetection: ChangeDetectionStrategy.OnPush,
      providers: [NavscrollStore],
      template: "<div class=\"container py-lg-5\">\n  <div class=\"row\">\n    <div class=\"col-12 col-lg-4\">\n      <div class=\"it-navscroll-sticky\" [ngClass]=\"{ 'it-navscroll-sticky-mobile': isMobile | async }\" data-bs-stackable=\"true\">\n        <nav\n          class=\"navbar it-navscroll-wrapper navbar-expand-lg\"\n          [class.it-top-navscroll]=\"alignment === 'top'\"\n          [class.it-bottom-navscroll]=\"alignment === 'bottom'\"\n          [class.it-left-side]=\"borderPosition === 'left'\"\n          [class.it-right-side]=\"borderPosition === 'right'\"\n          [class.theme-dark-mobile]=\"theme === 'dark'\"\n          [class.theme-dark-desktop]=\"theme === 'dark'\">\n          <button\n            class=\"custom-navbar-toggler\"\n            type=\"button\"\n            aria-controls=\"navbarNav\"\n            aria-expanded=\"false\"\n            aria-label=\"Toggle navigation\"\n            data-bs-toggle=\"navbarcollapsible\"\n            data-bs-target=\"#navbarNav\"\n            #toggleButtonRef>\n            <span class=\"it-list\"></span>{{ selectedTitle | async }}\n          </button>\n          <div class=\"progress custom-navbar-progressbar\">\n            <div\n              class=\"progress-bar it-navscroll-progressbar\"\n              role=\"progressbar\"\n              [style.width.%]=\"progressBarValue | async\"\n              [attr.aria-valuenow]=\"progressBarValue | async\"\n              aria-valuemin=\"0\"\n              aria-valuemax=\"100\"></div>\n          </div>\n          <div class=\"navbar-collapsable\" id=\"navbarNav\">\n            <div class=\"overlay\"></div>\n            <div class=\"close-div visually-hidden\">\n              <button class=\"btn close-menu\" type=\"button\"><span class=\"it-close\"></span>Chiudi</button>\n            </div>\n            <button type=\"button\" class=\"it-back-button btn w-100 text-start\">\n              <svg class=\"icon icon-sm icon-primary align-top\">\n                <use\n                  href=\"/bootstrap-italia/dist/svg/sprites.svg#it-chevron-left\"\n                  xlink:href=\"/bootstrap-italia/dist/svg/sprites.svg#it-chevron-left\"></use>\n              </svg>\n              <span>Indietro</span>\n            </button>\n            <div class=\"menu-wrapper\">\n              <div class=\"link-list-wrapper\">\n                <h3>{{ header }}</h3>\n                <div class=\"progress\">\n                  <div\n                    class=\"progress-bar it-navscroll-progressbar\"\n                    role=\"progressbar\"\n                    [style.width.%]=\"progressBarValue | async\"\n                    [attr.aria-valuenow]=\"progressBarValue | async\"\n                    aria-valuemin=\"0\"\n                    aria-valuemax=\"100\"></div>\n                </div>\n                <it-navscroll-list-items [items]=\"items\"></it-navscroll-list-items>\n              </div>\n            </div>\n          </div>\n        </nav>\n      </div>\n    </div>\n    <div class=\"col-12 col-lg-8 it-page-sections-container\">\n      <ng-container\n        *ngTemplateOutlet=\"pageSectionsTemplate ? pageSectionsTemplate : defaultPageSectionsTemplate; context: { items: items }\">\n      </ng-container>\n    </div>\n  </div>\n</div>\n\n<ng-template #defaultPageSectionsTemplate let-items=\"items\">\n  @for (item of items; track item.href) {\n    <ng-container *ngTemplateOutlet=\"paragraphTemplate; context: { item: item, level: 1 }\"></ng-container>\n  }\n</ng-template>\n\n<ng-template #paragraphTemplate let-item=\"item\" let-level=\"level\" let-nextLevel=\"level+1\">\n  @switch (level) {\n    @case (1) {\n      <h2 class=\"it-page-section\" id=\"{{ item.href }}\">{{ item.title }}</h2>\n    }\n    @case (2) {\n      <h3 class=\"it-page-section\" id=\"{{ item.href }}\">{{ item.title }}</h3>\n    }\n    @case (3) {\n      <h4 class=\"it-page-section\" id=\"{{ item.href }}\">{{ item.title }}</h4>\n    }\n    @case (4) {\n      <h5 class=\"it-page-section\" id=\"{{ item.href }}\">{{ item.title }}</h5>\n    }\n    @default {\n      <h6 class=\"it-page-section\" id=\"{{ item.href }}\">{{ item.title }}</h6>\n    }\n  }\n  <p>{{ item.text }}</p>\n  @for (item of item.childs; track item.href) {\n    <ng-container *ngTemplateOutlet=\"paragraphTemplate; context: { item: item, level: nextLevel }\"></ng-container>\n  }\n</ng-template>\n",
      styles: [".it-navscroll-sticky{position:sticky;top:0}.it-navscroll-sticky-mobile{z-index:1020}\n"]
    }]
  }], () => [], {
    header: [{
      type: Input
    }],
    items: [{
      type: Input
    }],
    borderPosition: [{
      type: Input
    }],
    alignment: [{
      type: Input
    }],
    theme: [{
      type: Input
    }],
    pageSectionsTemplate: [{
      type: Input
    }],
    onScroll: [{
      type: HostListener,
      args: ['window:scroll', ['$event']]
    }],
    onResize: [{
      type: HostListener,
      args: ['window:resize', ['$event']]
    }],
    toggleButtonRef: [{
      type: ViewChild,
      args: ['toggleButtonRef']
    }]
  });
})();
class ItSidebarComponent {
  constructor() {
    /**
     * Per creare una sidebar con linea separatrice a destra è sufficiente aggiungere la classe
     */
    this.withRightLine = false;
    /**
     * Per creare una sidebar con linea separatrice a sinistra è sufficiente aggiungere la classe
     */
    this.withLeftLine = false;
    /**
     * Per cambiare il tema della sidebar e renderla scura
     */
    this.dark = false;
    this.componentClass = 'd-block sidebar-wrapper';
  }
  static {
    this.ɵfac = function ItSidebarComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItSidebarComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItSidebarComponent,
      selectors: [["it-sidebar"]],
      hostVars: 8,
      hostBindings: function ItSidebarComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.componentClass);
          i0.ɵɵclassProp("it-line-right-side", ctx.withRightLine)("it-line-left-side", ctx.withLeftLine)("theme-dark", ctx.dark);
        }
      },
      inputs: {
        withRightLine: [2, "withRightLine", "withRightLine", inputToBoolean],
        withLeftLine: [2, "withLeftLine", "withLeftLine", inputToBoolean],
        dark: [2, "dark", "dark", inputToBoolean],
        header: "header"
      },
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c68,
      decls: 5,
      vars: 1,
      consts: [[1, "sidebar-linklist-wrapper"], [1, "sidebar-linklist-wrapper", "linklist-secondary"]],
      template: function ItSidebarComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c67);
          i0.ɵɵtemplate(0, ItSidebarComponent_Conditional_0_Template, 2, 1, "h3");
          i0.ɵɵelementStart(1, "div", 0);
          i0.ɵɵprojection(2);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(3, "div", 1);
          i0.ɵɵprojection(4, 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx.header ? 0 : -1);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItSidebarComponent, [{
    type: Component,
    args: [{
      selector: 'it-sidebar',
      standalone: true,
      imports: [],
      changeDetection: ChangeDetectionStrategy.OnPush,
      template: "@if (header) {\n  <h3>{{ header }}</h3>\n}\n<div class=\"sidebar-linklist-wrapper\">\n  <!--TODO: wrap ng-content with it-list -> inside content use a list of it-list-item directives-->\n  <ng-content></ng-content>\n</div>\n<div class=\"sidebar-linklist-wrapper linklist-secondary\">\n  <!--TODO: wrap ng-content with it-list -> inside content use a list of it-list-item directives-->\n  <ng-content select=\"[secondary]\"></ng-content>\n</div>\n"
    }]
  }], null, {
    withRightLine: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }, {
      type: HostBinding,
      args: ['class.it-line-right-side']
    }],
    withLeftLine: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }, {
      type: HostBinding,
      args: ['class.it-line-left-side']
    }],
    dark: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }, {
      type: HostBinding,
      args: ['class.theme-dark']
    }],
    header: [{
      type: Input
    }],
    componentClass: [{
      type: HostBinding,
      args: ['class']
    }]
  });
})();
class ItErrorPageComponent {
  constructor(route) {
    this.route = route;
    /**
     * Show/Hide error code
     * @default true - show
     */
    this.showErrorCode = true;
    /**
     * Show/Hide back button
     * @default true - show
     */
    this.showBackButton = true;
    /**
     * Show/Hide home button
     * @default true - show
     */
    this.showHomeButton = true;
    this.route.data.subscribe(data => {
      if (!this.errorCode && data['errorCode']) {
        this.errorCode = data['errorCode']; // Get errorCode from route data
      }
      if (data['showErrorCode'] !== undefined) {
        this.showErrorCode = data['showErrorCode']; // Get showErrorCode from route data
      }
      if (!this.errorTitle && data['errorTitle']) {
        this.errorTitle = data['errorTitle']; // Get errorTitle from route data
      }
      if (!this.errorDescription && data['errorDescription']) {
        this.errorDescription = data['errorDescription']; // Get errorDescription from route data
      }
      if (data['showBackButton'] !== undefined) {
        this.showBackButton = data['showBackButton']; // Get showBackButton from route data
      }
      if (data['showHomeButton'] !== undefined) {
        this.showHomeButton = data['showHomeButton']; // Get showHomeButton from route data
      }
    });
  }
  get isDefaultErrorCode() {
    return this.errorCode === 404 || this.errorCode === 403 || this.errorCode === 500;
  }
  static {
    this.ɵfac = function ItErrorPageComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItErrorPageComponent)(i0.ɵɵdirectiveInject(i1$4.ActivatedRoute));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItErrorPageComponent,
      selectors: [["it-error-page"]],
      inputs: {
        errorCode: "errorCode",
        showErrorCode: [2, "showErrorCode", "showErrorCode", inputToBoolean],
        errorTitle: "errorTitle",
        errorDescription: "errorDescription",
        showBackButton: [2, "showBackButton", "showBackButton", inputToBoolean],
        showHomeButton: [2, "showHomeButton", "showHomeButton", inputToBoolean]
      },
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵStandaloneFeature],
      decls: 9,
      vars: 4,
      consts: [[1, "container", "text-center", "mt-5"], [1, "mt-3", "w-75", "mx-auto"], [1, "mt-5"], ["itButton", "outline-primary", "routerLink", "/", 1, "ms-3", 3, "title"]],
      template: function ItErrorPageComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, ItErrorPageComponent_Conditional_1_Template, 2, 1, "h1");
          i0.ɵɵelementStart(2, "h2");
          i0.ɵɵtemplate(3, ItErrorPageComponent_Conditional_3_Template, 2, 3)(4, ItErrorPageComponent_Conditional_4_Template, 2, 3);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(5, "p", 1);
          i0.ɵɵtemplate(6, ItErrorPageComponent_Conditional_6_Template, 2, 3)(7, ItErrorPageComponent_Conditional_7_Template, 2, 3);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(8, ItErrorPageComponent_Conditional_8_Template, 3, 2, "div", 2);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.errorCode && ctx.showErrorCode ? 1 : -1);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(!ctx.errorTitle && ctx.isDefaultErrorCode ? 3 : 4);
          i0.ɵɵadvance(3);
          i0.ɵɵconditional(!ctx.errorDescription && ctx.isDefaultErrorCode ? 6 : 7);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx.showBackButton || ctx.showHomeButton ? 8 : -1);
        }
      },
      dependencies: [TranslateModule, i1.TranslatePipe, RouterLink, ItBackButtonComponent, ItButtonDirective],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItErrorPageComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-error-page',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [TranslateModule, RouterLink, ItBackButtonComponent, ItButtonDirective],
      template: "<div class=\"container text-center mt-5\">\n  @if (errorCode && showErrorCode) {\n    <h1>{{ errorCode }}</h1>\n  }\n  <h2>\n    @if (!errorTitle && isDefaultErrorCode) {\n      {{ 'it.utils.error-page.' + errorCode + '.title' | translate }}\n    } @else {\n      {{ errorTitle || 'it.errors.generic' | translate }}\n    }\n  </h2>\n\n  <p class=\"mt-3 w-75 mx-auto\">\n    @if (!errorDescription && isDefaultErrorCode) {\n      {{ 'it.utils.error-page.' + errorCode + '.description' | translate }}\n    } @else {\n      {{ errorDescription || 'it.errors.generic-support-message' | translate }}\n    }\n  </p>\n\n  @if (showBackButton || showHomeButton) {\n    <div class=\"mt-5\">\n      @if (showBackButton) {\n        <it-back-button></it-back-button>\n      }\n      @if (showHomeButton) {\n        <a itButton=\"outline-primary\" class=\"ms-3\" routerLink=\"/\" title=\"{{ 'it.utils.error-page.go-to-homepage' | translate }}\">\n          {{ 'it.utils.error-page.go-to-homepage' | translate }}\n        </a>\n      }\n    </div>\n  }\n</div>\n"
    }]
  }], () => [{
    type: i1$4.ActivatedRoute
  }], {
    errorCode: [{
      type: Input
    }],
    showErrorCode: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    errorTitle: [{
      type: Input
    }],
    errorDescription: [{
      type: Input
    }],
    showBackButton: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }],
    showHomeButton: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }]
  });
})();
class ItLanguageSwitcherComponent {
  constructor(translateService) {
    this.translateService = translateService;
    /**
     * Dropdown mode
     */
    this.mode = 'link';
    this.currentLang$ = this.translateService.onLangChange.pipe(startWith({
      lang: translateService.currentLang
    }), map(event => this.availableLanguages?.find(l => l.code === event.lang)));
  }
  ngOnInit() {
    if (!this.availableLanguages) {
      this.availableLanguages = this.translateService.getLangs().map(lang => ({
        code: lang,
        label: lang,
        ...(lang === 'it' && {
          label: 'ITA'
        }),
        ...(lang === 'en' && {
          label: 'ENG'
        })
      }));
    } else {
      this.translateService.addLangs(this.availableLanguages.map(l => l.code)); // Adds custom languages
    }
  }
  /**
   * Change the current language
   * @param lang the language code
   */
  changeLanguage(lang) {
    this.translateService.use(lang);
  }
  static {
    this.ɵfac = function ItLanguageSwitcherComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItLanguageSwitcherComponent)(i0.ɵɵdirectiveInject(i1.TranslateService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItLanguageSwitcherComponent,
      selectors: [["it-language-switcher"]],
      inputs: {
        availableLanguages: "availableLanguages",
        mode: "mode"
      },
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      decls: 11,
      vars: 15,
      consts: [[3, "mode"], ["button", ""], [1, "visually-hidden"], ["list", ""], [3, "active"], [3, "click", "active"]],
      template: function ItLanguageSwitcherComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "it-dropdown", 0);
          i0.ɵɵelementContainerStart(1, 1);
          i0.ɵɵelementStart(2, "span", 2);
          i0.ɵɵtext(3);
          i0.ɵɵpipe(4, "async");
          i0.ɵɵpipe(5, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(6, "span");
          i0.ɵɵtext(7);
          i0.ɵɵpipe(8, "async");
          i0.ɵɵpipe(9, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementContainerEnd();
          i0.ɵɵtemplate(10, ItLanguageSwitcherComponent_Conditional_10_Template, 3, 0, "ng-container", 3);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          let tmp_1_0;
          let tmp_2_0;
          i0.ɵɵproperty("mode", ctx.mode);
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(5, 6, "it.utils.selected", i0.ɵɵpureFunction1(13, _c69, (tmp_1_0 = i0.ɵɵpipeBind1(4, 4, ctx.currentLang$)) == null ? null : tmp_1_0.label)));
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate(((tmp_2_0 = i0.ɵɵpipeBind1(8, 9, ctx.currentLang$)) == null ? null : tmp_2_0.label) || i0.ɵɵpipeBind1(9, 11, "it.utils.select-language"));
          i0.ɵɵadvance(3);
          i0.ɵɵconditional(ctx.availableLanguages ? 10 : -1);
        }
      },
      dependencies: [AsyncPipe, TranslateModule, i1.TranslatePipe, ItDropdownModule, ItDropdownComponent, ItDropdownItemComponent],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItLanguageSwitcherComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-language-switcher',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [AsyncPipe, TranslateModule, ItDropdownModule],
      template: "<it-dropdown [mode]=\"mode\">\n  <ng-container button>\n    <span class=\"visually-hidden\">{{ 'it.utils.selected' | translate: { lang: (currentLang$ | async)?.label } }}</span>\n    <span>{{ (currentLang$ | async)?.label || ('it.utils.select-language' | translate) }}</span>\n  </ng-container>\n\n  @if (availableLanguages) {\n    <ng-container list>\n      @for (lang of availableLanguages; track lang.code) {\n        <it-dropdown-item (click)=\"changeLanguage(lang.code)\" [active]=\"lang.code === (currentLang$ | async)?.code\">\n          {{ lang.label }}\n          @if (lang.code === (currentLang$ | async)?.code) {\n            <span class=\"visually-hidden\">\n              {{ 'it.utils.selected' | translate }}\n            </span>\n          }\n        </it-dropdown-item>\n      }\n    </ng-container>\n  }\n</it-dropdown>\n"
    }]
  }], () => [{
    type: i1.TranslateService
  }], {
    availableLanguages: [{
      type: Input
    }],
    mode: [{
      type: Input
    }]
  });
})();

/**
 * Indicates in a textual way how much time has passed since the indicated date
 * @example 2 hours ago
 */
class ItDateAgoPipe extends TranslatePipe {
  /**
   * Indicates in a textual way how much time has passed since the indicated date
   * @example 2 hours ago
   * @param value the Date or date string
   */
  transform(value) {
    if (!value) {
      return '';
    }
    const seconds = Math.floor((+new Date() - +new Date(value)) / 1000);
    if (isNaN(seconds)) {
      return '';
    }
    // less than 30 seconds ago will show as 'Just now'
    if (seconds < 29) {
      return super.transform('it.date-ago-pipe.just-now');
    }
    const intervals = new Map([['year', 31536000], ['month', 2592000], ['week', 604800], ['day', 86400], ['hour', 3600], ['minute', 60], ['second', 1]]);
    for (const interval of intervals) {
      const counter = Math.floor(seconds / interval[1]);
      if (counter > 0) {
        return super.transform(`it.date-ago-pipe.${counter === 1 ? 'singular-' : ''}${interval[0]}-ago`, {
          count: counter
        });
      }
    }
    return '';
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵItDateAgoPipe_BaseFactory;
      return function ItDateAgoPipe_Factory(__ngFactoryType__) {
        return (ɵItDateAgoPipe_BaseFactory || (ɵItDateAgoPipe_BaseFactory = i0.ɵɵgetInheritedFactory(ItDateAgoPipe)))(__ngFactoryType__ || ItDateAgoPipe);
      };
    })();
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "itDateAgo",
      type: ItDateAgoPipe,
      pure: false,
      standalone: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItDateAgoPipe, [{
    type: Pipe,
    args: [{
      name: 'itDateAgo',
      pure: false,
      standalone: true
    }]
  }], null, null);
})();

/**
 * Transform a number into a duration.
 * Is necessary indicate the value expressed by the number, for example 'day'.
 * @example
 *  - 1, 'day' -> 1 day
 *  - 5, 'day' -> 5 days
 *  - 7, 'day' -> 1 week
 *  - 365, 'day' -> 1 year
 *  - 2, 'week' -> 2 weeks
 *  ...
 */
class ItDurationPipe extends TranslatePipe {
  /**
   * Transform a number into a duration.
   * Is necessary indicate the value expressed by the number, for example 'day'.
   * @example
   *  - 1, 'day' -> 1 day
   *  - 5, 'day' -> 5 days
   *  - 7, 'day' -> 1 week
   *  - 8, 'day' -> 1 week
   *  - 365, 'day' -> 1 year
   *  - 2, 'week' -> 2 weeks
   *  - 24, 'month' -> 1 year
   *  ...
   * @param value the number
   * @param type the number expressed type
   */
  transform(value, type) {
    let valueAdjust = Number(value);
    if (isNaN(valueAdjust)) {
      return '';
    }
    switch (type) {
      // eslint-disable-next-line no-fallthrough,@typescript-eslint/ban-ts-comment
      // @ts-ignore
      case 'second':
        if (valueAdjust < 60) {
          return super.transform(`it.duration.${type}${valueAdjust === 1 ? '' : 's'}`, {
            count: valueAdjust
          });
        }
        valueAdjust = Math.round(valueAdjust / 60);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      // eslint-disable-next-line no-fallthrough
      case 'minute':
        if (valueAdjust < 60) {
          return super.transform(`it.duration.${type}${valueAdjust === 1 ? '' : 's'}`, {
            count: valueAdjust
          });
        }
        valueAdjust = Math.round(valueAdjust / 60);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      // eslint-disable-next-line no-fallthrough
      case 'hour':
        if (valueAdjust < 24) {
          return super.transform(`it.duration.${type}${valueAdjust === 1 ? '' : 's'}`, {
            count: valueAdjust
          });
        }
        valueAdjust = Math.round(valueAdjust / 24);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      // eslint-disable-next-line no-fallthrough
      case 'day':
        if (valueAdjust < 7) {
          return super.transform(`it.duration.${type}${valueAdjust === 1 ? '' : 's'}`, {
            count: valueAdjust
          });
        }
        valueAdjust = Math.round(valueAdjust / 7);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      // eslint-disable-next-line no-fallthrough
      case 'week':
        if (valueAdjust < 5) {
          return super.transform(`it.duration.${type}${valueAdjust === 1 ? '' : 's'}`, {
            count: valueAdjust
          });
        }
        valueAdjust = Math.round(valueAdjust / 5);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      // eslint-disable-next-line no-fallthrough
      case 'month':
        if (valueAdjust < 24) {
          return super.transform(`it.duration.${type}${valueAdjust === 1 ? '' : 's'}`, {
            count: valueAdjust
          });
        }
        valueAdjust = Math.round(valueAdjust / 24);
      // eslint-disable-next-line no-fallthrough
      case 'year':
        return super.transform(`it.duration.${type}${valueAdjust === 1 ? '' : 's'}`, {
          count: valueAdjust
        });
      default:
        return '';
    }
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵItDurationPipe_BaseFactory;
      return function ItDurationPipe_Factory(__ngFactoryType__) {
        return (ɵItDurationPipe_BaseFactory || (ɵItDurationPipe_BaseFactory = i0.ɵɵgetInheritedFactory(ItDurationPipe)))(__ngFactoryType__ || ItDurationPipe);
      };
    })();
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "itDuration",
      type: ItDurationPipe,
      pure: true,
      standalone: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItDurationPipe, [{
    type: Pipe,
    args: [{
      name: 'itDuration',
      standalone: true
    }]
  }], null, null);
})();
class ItSkiplinkComponent {
  constructor() {
    /**
     * Aria label for `nav` mode
     * @default 'Scorciatoie di navigazione'
     */
    this.ariaLabel = 'Scorciatoie di navigazione';
  }
  static {
    this.ɵfac = function ItSkiplinkComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItSkiplinkComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItSkiplinkComponent,
      selectors: [["it-skiplink"]],
      inputs: {
        ariaLabel: "ariaLabel",
        nav: [2, "nav", "nav", inputToBoolean]
      },
      exportAs: ["itSkipLink"],
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c1,
      decls: 4,
      vars: 1,
      consts: [["linkContent", ""], [1, "skiplinks"], [4, "ngTemplateOutlet"]],
      template: function ItSkiplinkComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, ItSkiplinkComponent_Conditional_0_Template, 3, 1, "nav", 1)(1, ItSkiplinkComponent_Conditional_1_Template, 2, 1, "div", 1)(2, ItSkiplinkComponent_ng_template_2_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx.nav ? 0 : 1);
        }
      },
      dependencies: [NgTemplateOutlet, TranslateModule],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItSkiplinkComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-skiplink',
      exportAs: 'itSkipLink',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [NgTemplateOutlet, TranslateModule, ItLinkComponent],
      template: "@if (nav) {\n  <nav class=\"skiplinks\">\n    <ul>\n      <ng-container *ngTemplateOutlet=\"linkContent\"></ng-container>\n    </ul>\n  </nav>\n} @else {\n  <div class=\"skiplinks\">\n    <ng-container *ngTemplateOutlet=\"linkContent\"></ng-container>\n  </div>\n}\n\n<ng-template #linkContent>\n  <ng-content></ng-content>\n</ng-template>\n"
    }]
  }], null, {
    ariaLabel: [{
      type: Input
    }],
    nav: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }]
  });
})();
class ItSkiplinkItemComponent {
  constructor(parent) {
    this.inNav = parent.nav ? true : false;
  }
  static {
    this.ɵfac = function ItSkiplinkItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItSkiplinkItemComponent)(i0.ɵɵdirectiveInject(ItSkiplinkComponent, 1));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItSkiplinkItemComponent,
      selectors: [["it-skiplink-item"]],
      inputs: {
        href: "href",
        externalLink: [2, "externalLink", "externalLink", inputToBoolean]
      },
      exportAs: ["itSkipLinkItem"],
      standalone: true,
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c1,
      decls: 4,
      vars: 1,
      consts: [["linkContent", ""], [1, "visually-hidden-focusable"], [1, "visually-hidden-focusable", 3, "href", "externalLink"], [3, "href", "externalLink"], [4, "ngTemplateOutlet"]],
      template: function ItSkiplinkItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, ItSkiplinkItemComponent_Conditional_0_Template, 3, 3, "li", 1)(1, ItSkiplinkItemComponent_Conditional_1_Template, 2, 3, "it-link", 2)(2, ItSkiplinkItemComponent_ng_template_2_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx.inNav ? 0 : 1);
        }
      },
      dependencies: [NgTemplateOutlet, TranslateModule, ItLinkComponent],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItSkiplinkItemComponent, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'it-skiplink-item',
      exportAs: 'itSkipLinkItem',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [NgTemplateOutlet, TranslateModule, ItLinkComponent],
      template: "@if (inNav) {\n  <li class=\"visually-hidden-focusable\">\n    <it-link [href]=\"href\" [externalLink]=\"externalLink\">\n      <ng-container *ngTemplateOutlet=\"linkContent\"></ng-container>\n    </it-link>\n  </li>\n} @else {\n  <it-link class=\"visually-hidden-focusable\" [href]=\"href\" [externalLink]=\"externalLink\">\n    <ng-container *ngTemplateOutlet=\"linkContent\"></ng-container>\n  </it-link>\n}\n\n<ng-template #linkContent>\n  <ng-content></ng-content>\n</ng-template>\n"
    }]
  }], () => [{
    type: ItSkiplinkComponent,
    decorators: [{
      type: Host
    }]
  }], {
    href: [{
      type: Input
    }],
    externalLink: [{
      type: Input,
      args: [{
        transform: inputToBoolean
      }]
    }]
  });
})();
const skiplinkComponents = [ItSkiplinkComponent, ItSkiplinkItemComponent];
class ItSkiplinkModule {
  static {
    this.ɵfac = function ItSkiplinkModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItSkiplinkModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ItSkiplinkModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [skiplinkComponents]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItSkiplinkModule, [{
    type: NgModule,
    args: [{
      imports: skiplinkComponents,
      exports: skiplinkComponents
    }]
  }], null, null);
})();

/**
 * Configures DesignAngularKit library
 * @param config the DesignAngularKit config
 */
function provideDesignAngularKit(config) {
  let assetBasePath = './bootstrap-italia';
  if (config?.assetBasePath) {
    assetBasePath = config.assetBasePath.endsWith('/') ? config.assetBasePath.substring(0, config.assetBasePath.lastIndexOf('/')) : config.assetBasePath;
  }
  const providers = [{
    provide: IT_ASSET_BASE_PATH,
    useValue: assetBasePath
  }, provideAnimationsAsync(), provideHttpClient()];
  if (config?.loadFont !== false) {
    // Add provider to initialize the bootstrap-italia font
    providers.push({
      provide: APP_INITIALIZER,
      useFactory: () => {
        return () => {
          loadFonts(`${assetBasePath}/dist/fonts`);
        };
      },
      multi: true
    });
  }
  // Add provider to initialize the TranslateModule
  const langPrefix = `${assetBasePath}/i18n/`;
  const langSuffix = `.json`; // TODO: add ?v${version} to prevent cache loading on version change
  providers.push(importProvidersFrom(TranslateModule.forRoot({
    loader: config?.translateLoader?.(langPrefix, langSuffix) ?? {
      provide: TranslateLoader,
      useFactory: http => new TranslateHttpLoader(http, langPrefix, langSuffix),
      deps: [HttpClient]
    },
    defaultLanguage: 'it',
    useDefaultLang: true
  })));
  // Add provider to initialize library default languages
  providers.push({
    provide: APP_INITIALIZER,
    useFactory: translateService => {
      return () => {
        translateService.addLangs(['it', 'en']); // Adds 'it' and 'en' as available languages.
      };
    },
    multi: true,
    deps: [TranslateService]
  });
  return makeEnvironmentProviders(providers);
}

/**
 * Core components
 */
const core = [ItAccordionComponent, ItAlertComponent, ItAvatarModule, ItBadgeDirective, ItButtonDirective, ItCalloutComponent, ItCardComponent, ItCarouselModule, ItChipComponent, ItCollapseComponent, ItDimmerModule, ItDropdownModule, ItForwardDirective, ItLinkComponent, ItListModule, ItModalComponent, ItNotificationsComponent, ItPaginationComponent, ItPopoverDirective, ItProgressBarComponent, ItProgressButtonComponent, ItSpinnerComponent, ItSteppersModule, ItTabModule, ItTableModule, ItTooltipDirective, ItTimelineModule];
/**
 * Navigation Components
 */
const navigation = [ItBackButtonComponent, ItBackToTopComponent, ItBreadcrumbsModule, ItHeaderComponent, ItNavBarModule, ItSidebarComponent, ItMegamenuComponent, ItSkiplinkModule, ItNavscrollComponent];
/**
 * Utils components
 */
const utils = [ItErrorPageComponent, ItIconComponent, ItLanguageSwitcherComponent];
/**
 * Library pipes
 */
const pipes = [ItDateAgoPipe, ItDurationPipe, ItMarkMatchingTextPipe];
const components = [...core,
// Core components
ItFormModule,
// Form components
...navigation,
// Navigation Components
...utils,
// Utils components
...pipes // Library pipes
];
class DesignAngularKitModule {
  static forRoot(config) {
    return {
      ngModule: DesignAngularKitModule,
      providers: [provideDesignAngularKit(config)]
    };
  }
  static forChild() {
    return {
      ngModule: DesignAngularKitModule
    };
  }
  static {
    this.ɵfac = function DesignAngularKitModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DesignAngularKitModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DesignAngularKitModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [ItAlertComponent, ItAvatarModule, ItCarouselModule, ItChipComponent, ItDimmerModule, ItDropdownModule, ItListModule, ItModalComponent, ItNotificationsComponent, ItPaginationComponent, ItProgressBarComponent, ItProgressButtonComponent, ItSpinnerComponent, ItSteppersModule, ItTabModule, ItTableModule, ItTimelineModule,
      // Core components
      ItFormModule, ItBackButtonComponent, ItBreadcrumbsModule, ItHeaderComponent, ItNavBarModule, ItSkiplinkModule, ItErrorPageComponent, ItLanguageSwitcherComponent, ItAvatarModule, ItCarouselModule, ItDimmerModule, ItDropdownModule, ItListModule, ItSteppersModule, ItTabModule, ItTableModule, ItTimelineModule,
      // Core components
      ItFormModule, ItBreadcrumbsModule, ItNavBarModule, ItSkiplinkModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DesignAngularKitModule, [{
    type: NgModule,
    args: [{
      imports: components,
      exports: components
    }]
  }], null, null);
})();

//Qs
//Aria hidden?
//state management with service?
//interface?

const IconNameArray = ['arrow-down', 'arrow-down-circle', 'arrow-down-triangle', 'arrow-left', 'arrow-left-circle', 'arrow-left-triangle', 'arrow-right', 'arrow-right-circle', 'arrow-right-triangle', 'arrow-up', 'arrow-up-circle', 'arrow-up-triangle', 'ban', 'bookmark', 'box', 'burger', 'calendar', 'camera', 'card', 'chart-line', 'check', 'check-circle', 'chevron-left', 'chevron-right', 'clip', 'clock', 'close', 'close-big', 'close-circle', 'code-circle', 'comment', 'copy', 'delete', 'download', 'error', 'exchange-circle', 'expand', 'external-link', 'flag', 'folder', 'fullscreen', 'funnel', 'hearing', 'help', 'help-circle', 'horn', 'inbox', 'info-circle', 'key', 'link', 'list', 'locked', 'logout', 'mail', 'mail-open', 'map-marker', 'map-marker-circle', 'map-marker-minus', 'map-marker-plus', 'maximize', 'maximize-alt', 'minimize', 'minus', 'minus-circle', 'more-actions', 'more-items', 'note', 'pa', 'password-invisible', 'password-visible', 'pencil', 'piattaforme', 'pin', 'plug', 'plus', 'plus-circle', 'presentation', 'print', 'refresh', 'restore', 'rss', 'rss-square', 'search', 'settings', 'share', 'software', 'star-full', 'star-outline', 'telephone', 'tool', 'unlocked', 'upload', 'user', 'video', 'warning', 'warning-circle', 'wifi', 'zoom-in', 'zoom-out',
// Files
'file', 'files', 'file-audio', 'file-compressed', 'file-csv', 'file-json', 'file-odp', 'file-ods', 'file-odt', 'file-pdf', 'file-pdf-ext', 'file-sheet', 'file-slides', 'file-ppt', 'file-txt', 'file-video', 'file-xml',
// Platforms
'behance', 'facebook', 'facebook-square', 'figma', 'figma-square', 'flickr', 'flickr-square', 'github', 'instagram', 'linkedin', 'linkedin-square', 'mastodon', 'mastodon-square', 'medium', 'medium-square', 'moodle', 'moodle-square', 'pinterest', 'pinterest-square', 'quora', 'quora-square', 'reddit', 'reddit-square', 'slack', 'slack-square', 'snapchat', 'snapchat-square', 'stackexchange', 'stackexchange-square', 'stackoverflow', 'stackoverflow-square', 'telegram', 'threads', 'threads-square', 'tiktok', 'tiktok-square', 'twitter', 'twitter-square', 'vimeo', 'vimeo-square', 'whatsapp', 'whatsapp-square', 'youtube', 'google',
// Extra
'designers-italia', 'team-digitale'];
class ItDateUtils {
  /**
   * Add seconds to date
   * @param date the date
   * @param seconds seconds to add
   */
  static addSeconds(date, seconds) {
    const newDate = new Date(date.valueOf());
    newDate.setSeconds(date.getSeconds() + seconds);
    return newDate;
  }
  /**
   * Add minutes to date
   * @param date the date
   * @param minutes minutes to add
   */
  static addMinutes(date, minutes) {
    const newDate = new Date(date.valueOf());
    newDate.setMinutes(date.getMinutes() + minutes);
    return newDate;
  }
  /**
   * Add hours to date
   * @param date the date
   * @param hours hours to add
   */
  static addHours(date, hours) {
    const newDate = new Date(date.valueOf());
    newDate.setHours(date.getHours() + hours);
    return newDate;
  }
  /**
   * Add days to date
   * @param date the date
   * @param days days to add
   */
  static addDays(date, days) {
    const newDate = new Date(date.valueOf());
    newDate.setDate(date.getDate() + days);
    return newDate;
  }
  /**
   * Add years to date
   * @param date the date
   * @param months months to add
   */
  static addMonths(date, months) {
    const newDate = new Date(date.valueOf());
    newDate.setMonth(date.getMonth() + months);
    return newDate;
  }
  /**
   * Add years to date
   * @param date the date
   * @param years years to add
   */
  static addYears(date, years) {
    const newDate = new Date(date.valueOf());
    newDate.setFullYear(date.getFullYear() + years);
    return newDate;
  }
  /**
   * Calculate number of days between two date
   * @param startDate
   * @param endDate
   * @param absolute return unsigned result
   */
  static countDays(startDate, endDate, absolute = false) {
    const differenceInTime = endDate.getTime() - startDate.getTime();
    const diff = absolute ? Math.abs(differenceInTime) : differenceInTime;
    return Math.ceil(diff / (1000 * 3600 * 24));
  }
  /**
   * Check if string is a date with iso format
   * @param value the string
   */
  static isIsoString(value) {
    if (!value || !/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(value)) {
      return false;
    }
    const d = new Date(value);
    return !!d && !isNaN(d.getTime()) && d.toISOString() === value;
  }
  /**
   * Convert iso string to Date
   * @param isoString the iso string
   */
  static isoStringToDate(isoString) {
    return isoString ? new Date(Date.parse(isoString)) : null;
  }
  /**
   * Remove time from an iso date string
   * @param isoString the iso string
   */
  static isoStringRemoveTime(isoString) {
    let date = ItDateUtils.isoStringToDate(isoString);
    if (!date) {
      return isoString;
    }
    const offset = date.getTimezoneOffset();
    date = new Date(date.getTime() - offset * 60 * 1000);
    return date.toISOString().substring(0, isoString.indexOf('T'));
  }
  /**
   * Set iso string hours to 0 and format correctly the date (consider timezone offset)
   * @example '2024-03-04T23:00:00.000Z' -> '2024-03-05T00:00:00.000Z'
   * @param isoString the iso string
   */
  static isoStringSetZeroTime(isoString) {
    let date = ItDateUtils.isoStringToDate(isoString);
    if (!date) {
      return isoString;
    }
    const offset = date.getTimezoneOffset();
    date = new Date(date.getTime() - offset * 60 * 1000);
    date.setUTCHours(0, 0, 0, 0);
    return date.toISOString();
  }
  /**
   * Calculate the date time left and return the string format [d h m s]
   * @param endDate
   */
  static timeLeftString(endDate) {
    const endTime = endDate.getTime();
    return timer(0, 1000).pipe(map$1(() => Math.floor((endTime - new Date().getTime()) / 1000)), takeWhile(delta => delta >= 0), map$1(delta => {
      const arrayResult = [];
      const days = Math.floor(delta / 60 / 60 / 24);
      if (days > 0) {
        arrayResult.push(days + 'd');
      }
      delta -= days * 60 * 60 * 24;
      const hours = Math.floor(delta / 60 / 60) % 24;
      if (hours > 0) {
        arrayResult.push(hours + 'h');
      }
      delta -= hours * 60 * 60;
      const minutes = Math.floor(delta / 60) % 60;
      arrayResult.push(minutes + 'm');
      delta -= minutes * 60;
      const seconds = delta % 60;
      arrayResult.push(seconds + 's');
      return arrayResult.join(' ');
    }), shareReplay(1));
  }
  /**
   * Calculate the next day of week
   * @param dayOfWeek Day of week 0=Sunday, 1=Monday...4=Thursday...
   * @param hour the specif hour
   * @param minute the specific minute
   */
  static nextWeekDayAndTime(dayOfWeek, hour = 0, minute = 0) {
    const now = new Date();
    const result = new Date(now.getFullYear(), now.getMonth(), now.getDate() + (7 + dayOfWeek - now.getDay()) % 7, hour, minute, 0, 0);
    if (result < now) {
      result.setDate(result.getDate() + 7);
    }
    return result;
  }
}

/*
 * Public API Surface of design-angular-kit
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CAP_REGEX, DesignAngularKitModule, EMAIL_REGEX, IBAN_REGEX, ITALIAN_TAX_CODE_REGEX, IT_ASSET_BASE_PATH, IT_SORT_DEFAULT_OPTIONS, IconNameArray, ItAccordionComponent, ItAlertComponent, ItAutocompleteComponent, ItAvatarDirective, ItAvatarDropdownComponent, ItAvatarDropdownItemComponent, ItAvatarGroupComponent, ItAvatarGroupItemComponent, ItAvatarModule, ItBackButtonComponent, ItBackToTopComponent, ItBadgeDirective, ItBreadcrumbComponent, ItBreadcrumbItemComponent, ItBreadcrumbsModule, ItButtonDirective, ItCalloutComponent, ItCardComponent, ItCarouselComponent, ItCarouselItemComponent, ItCarouselModule, ItCheckboxComponent, ItChipComponent, ItCollapseComponent, ItDateAgoPipe, ItDateUtils, ItDimmerButtonsComponent, ItDimmerComponent, ItDimmerIconComponent, ItDimmerModule, ItDropdownComponent, ItDropdownItemComponent, ItDropdownModule, ItDurationPipe, ItErrorPageComponent, ItFileUtils, ItFormModule, ItForwardDirective, ItHeaderComponent, ItIconComponent, ItInputComponent, ItLanguageSwitcherComponent, ItLinkComponent, ItListComponent, ItListItemComponent, ItListModule, ItMarkMatchingTextPipe, ItMegamenuComponent, ItModalComponent, ItNavBarComponent, ItNavBarItemComponent, ItNavBarModule, ItNavscrollComponent, ItNotificationService, ItNotificationsComponent, ItPaginationComponent, ItPasswordInputComponent, ItPopoverDirective, ItProgressBarComponent, ItProgressButtonComponent, ItRadioButtonComponent, ItRangeComponent, ItRatingComponent, ItSelectComponent, ItSidebarComponent, ItSkiplinkComponent, ItSkiplinkItemComponent, ItSkiplinkModule, ItSortDirective, ItSortHeaderComponent, ItSpinnerComponent, ItSteppersContainerComponent, ItSteppersItemComponent, ItSteppersModule, ItTabContainerComponent, ItTabItemComponent, ItTabModule, ItTableComponent, ItTableModule, ItTextareaComponent, ItTimelineComponent, ItTimelineItemComponent, ItTimelineModule, ItTooltipDirective, ItTransferComponent, ItUploadDragDropComponent, ItUploadFileListComponent, ItValidators, NotificationPosition, NotificationType, PHONE_NUMBER_REGEX, PLATE_REGEX, URL_REGEX, VAT_NUMBER_REGEX, provideDesignAngularKit };
